import { jsxs, jsx } from 'react/jsx-runtime';

// src/utils/createIcon.ts
var ICON_SYMBOL = Symbol("$$shopl.isShoplIcon");
function isShoplIcon(arg) {
  return typeof arg === "function" && arg[ICON_SYMBOL] === true;
}
function createIcon(source) {
  source[ICON_SYMBOL] = true;
  return source;
}
function SvgIcAbnormalA(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#ic-abnormal-a_svg__a)", children: [
          /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#777" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "m11.154 10.77-.88-2.405a5.296 5.296 0 0 1-.135-.38 12.51 12.51 0 0 1-.14-.475c-.044.17-.089.33-.135.48a6.14 6.14 0 0 1-.135.385l-.875 2.395h2.3Zm2.375 2.73h-1.04a.453.453 0 0 1-.285-.085.565.565 0 0 1-.165-.22l-.54-1.475H8.504l-.54 1.475a.479.479 0 0 1-.155.21.432.432 0 0 1-.285.095h-1.05l2.845-7.23h1.37l2.84 7.23Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "ic-abnormal-a_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M2 2h16v16H2z" }) }) })
      ]
    }
  );
}
var IcAbnormalA_default = createIcon(SvgIcAbnormalA);
function SvgIcAbnormalD(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#406588" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M13.603 9.95c0 .51-.085.976-.255 1.402a3.22 3.22 0 0 1-.715 1.1 3.2 3.2 0 0 1-1.109.714 3.91 3.91 0 0 1-1.44.255H7.44V6.48h2.645c.528 0 1.008.086 1.44.26a3.2 3.2 0 0 1 1.11.714c.306.304.545.67.714 1.095.17.425.255.893.255 1.401Zm-1.325 0c0-.38-.051-.721-.154-1.022-.099-.304-.245-.56-.437-.768a1.866 1.866 0 0 0-.69-.485 2.352 2.352 0 0 0-.913-.168H8.735v4.887h1.35c.338 0 .642-.056.911-.168.272-.112.503-.272.691-.48.193-.212.338-.468.437-.768.103-.304.154-.647.154-1.028Z"
          }
        )
      ]
    }
  );
}
var IcAbnormalD_default = createIcon(SvgIcAbnormalD);
function SvgIcAbnormalEarlyleave(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 2, y: 2, fill: "#FB0", rx: 8 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M10 5.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Zm0 .9a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8Zm.446 2.039a.45.45 0 0 0-.896.061v2.16l.005.063a.45.45 0 0 0 .1.225l1.2 1.44.046.048a.45.45 0 0 0 .587.01l.048-.047a.45.45 0 0 0 .01-.587l-1.096-1.315V8.2l-.004-.061Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcAbnormalEarlyleave_default = createIcon(SvgIcAbnormalEarlyleave);
function SvgIcAbnormalLate(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 2, y: 2, fill: "#4DC9AA", rx: 8 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M10 5.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Zm0 .9a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8Zm.446 2.039a.45.45 0 0 0-.896.061v2.16l.005.063a.45.45 0 0 0 .1.225l1.2 1.44.046.048a.45.45 0 0 0 .587.01l.048-.047a.45.45 0 0 0 .01-.587l-1.096-1.315V8.2l-.004-.061Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcAbnormalLate_default = createIcon(SvgIcAbnormalLate);
function SvgIcAbnormalM(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#F66" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M9.723 10.86c.054.103.104.21.149.322.048.11.094.22.14.332.044-.116.09-.23.138-.341.048-.112.1-.22.154-.322l2.054-3.845a.597.597 0 0 1 .077-.115.273.273 0 0 1 .091-.062.433.433 0 0 1 .116-.024c.041-.003.09-.005.148-.005h.975v6.94h-1.138V9.259c0-.084.002-.175.005-.274.006-.1.014-.2.024-.302l-2.098 3.936a.573.573 0 0 1-.187.21.497.497 0 0 1-.269.073h-.177a.497.497 0 0 1-.27-.072.573.573 0 0 1-.186-.211l-2.127-3.95c.013.105.021.209.024.311.007.1.01.192.01.279v4.483H6.238V6.8h.975c.057-.001.107 0 .148.004a.374.374 0 0 1 .11.024.262.262 0 0 1 .097.062.485.485 0 0 1 .081.115l2.074 3.855Z"
          }
        )
      ]
    }
  );
}
var IcAbnormalM_default = createIcon(SvgIcAbnormalM);
function SvgIcAbnormalN(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#3299FE" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M12.925 6.48v6.94h-.662a.625.625 0 0 1-.26-.047.642.642 0 0 1-.196-.173L8.183 8.573a6.5 6.5 0 0 1 .029.585v4.263H7.074V6.48h.677c.054 0 .1.003.14.01a.256.256 0 0 1 .105.028.273.273 0 0 1 .091.063c.029.025.06.06.096.105l3.638 4.647c-.01-.112-.017-.223-.024-.331a5.174 5.174 0 0 1-.01-.303V6.48h1.138Z"
          }
        )
      ]
    }
  );
}
var IcAbnormalN_default = createIcon(SvgIcAbnormalN);
function SvgIcAbnormalW(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#ic-abnormal-w_svg__a)", children: [
          /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#6979F8" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "m14.654 6.993-2.02 6.507H11.54l-1.422-4.446a3.032 3.032 0 0 1-.108-.396 7.25 7.25 0 0 1-.054.211 2.237 2.237 0 0 1-.059.185L8.462 13.5H7.364L5.348 6.993H6.36c.105 0 .192.025.261.076.072.048.12.114.144.198l1.107 3.893c.024.096.047.2.068.315.024.11.048.228.072.35.024-.125.05-.244.076-.355.03-.11.062-.214.095-.31L9.46 7.267a.431.431 0 0 1 .14-.189.408.408 0 0 1 .26-.085h.356a.408.408 0 0 1 .405.274l1.273 3.893c.063.186.12.4.171.643.04-.237.083-.451.13-.643l1.108-3.893a.34.34 0 0 1 .135-.193.442.442 0 0 1 .265-.081h.95Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "ic-abnormal-w_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M2 2h16v16H2z" }) }) })
      ]
    }
  );
}
var IcAbnormalW_default = createIcon(SvgIcAbnormalW);
function SvgIcAddXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6.861 1.6c0-.331-.336-.6-.75-.6s-.75.269-.75.6v3.539H1.6c-.331 0-.6.336-.6.75s.269.75.6.75h3.761V10.4c0 .331.336.6.75.6s.75-.269.75-.6V6.639H10.4c.331 0 .6-.336.6-.75s-.269-.75-.6-.75H6.861V1.6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAddXsmall_default = createIcon(SvgIcAddXsmall);
function SvgIcAdd(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M11 4a1 1 0 1 0-2 0v5H4a1 1 0 0 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5V4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAdd_default = createIcon(SvgIcAdd);
function SvgIcAdminLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 15,
            cy: 15,
            r: 14,
            fill: "#FFA800",
            stroke: "#fff",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M15.934 9.1c-.326-.8-1.544-.8-1.87 0L11 15.744l-3.085-4.736c-.276-.38-.915-.199-.915.26l.846 8.653c.087.893.9 1.578 1.875 1.578h10.63c.98 0 1.796-.692 1.877-1.591l.772-8.64c0-.459-.639-.64-.915-.26L19 15.746l-3.066-6.647Z"
          }
        )
      ]
    }
  );
}
var IcAdminLarge_default = createIcon(SvgIcAdminLarge);
function SvgIcAiChatBot(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-ai-chat-bot_svg__a",
            width: 20,
            height: 21,
            x: 2,
            y: 2,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M2 2h20v21H2z" }),
              /* @__PURE__ */ jsx(
                "path",
                {
                  fillRule: "evenodd",
                  d: "M12 20a8 8 0 1 0-5.956-2.659l-.439 2.489a.5.5 0 0 0 .664.557l2.441-.889a.5.5 0 0 0 .189-.121A7.976 7.976 0 0 0 12 20Z",
                  clipRule: "evenodd"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "m6.044 17.341 1.97.348.169-.96-.65-.724-1.489 1.336Zm-.439 2.489-1.97-.347 1.97.347Zm.664.557-.684-1.88.684 1.88Zm2.441-.889.684 1.88-.684-1.88Zm.189-.121.776-1.844-1.26-.53-.952.982 1.436 1.392ZM18 12a6 6 0 0 1-6 6v4c5.523 0 10-4.477 10-10h-4Zm-6-6a6 6 0 0 1 6 6h4c0-5.523-4.477-10-10-10v4Zm-6 6a6 6 0 0 1 6-6V2C6.477 2 2 6.477 2 12h4Zm1.533 4.005A5.97 5.97 0 0 1 6 12H2a9.97 9.97 0 0 0 2.556 6.677l2.977-2.672Zm.042 4.172.439-2.488-3.94-.695-.438 2.489 3.939.694Zm-1.99-1.67a1.5 1.5 0 0 1 1.99 1.67l-3.94-.694c-.334 1.895 1.51 3.441 3.318 2.783l-1.368-3.759Zm2.441-.888-2.441.888 1.368 3.76 2.441-.89-1.368-3.758Zm-.563.366c.158-.164.351-.29.563-.366l1.368 3.759c.362-.132.682-.342.94-.61l-2.871-2.783ZM12 18a5.975 5.975 0 0 1-2.325-.467L8.123 21.22A9.975 9.975 0 0 0 12 22v-4Z",
            mask: "url(#ic-ai-chat-bot_svg__a)"
          }
        ),
        /* @__PURE__ */ jsx("ellipse", { cx: 11.188, cy: 9.484, fill: "#333", rx: 1.188, ry: 1.484 }),
        /* @__PURE__ */ jsx("ellipse", { cx: 15.938, cy: 9.484, fill: "#333", rx: 1.188, ry: 1.484 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M14.605 12.947c.494 0 .912.42.698.866a2 2 0 0 1-3.606 0c-.214-.446.204-.866.698-.866h2.21Z"
          }
        )
      ]
    }
  );
}
var IcAiChatBot_default = createIcon(SvgIcAiChatBot);
function SvgIcAlbumXlarge(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#406588",
          fillRule: "evenodd",
          d: "M4 5a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v26a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5Zm9.333 10.667a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667ZM28 28.5H7.5l6.272-7.318a1 1 0 0 1 1.49-.031L18 24.085l6.215-7.445a1 1 0 0 1 1.57.044l2.517 3.384a1 1 0 0 1 .198.596V28a.5.5 0 0 1-.5.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAlbumXlarge_default = createIcon(SvgIcAlbumXlarge);
function SvgIcAlertLine(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M9.25 6.2c0-.11.09-.2.2-.2h1.1c.11 0 .2.09.2.2v4.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V6.2ZM10.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10 1.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM2.75 10a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcAlertLine_default = createIcon(SvgIcAlertLine);
function SvgIcAlertPopupXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 18, cy: 18, r: 15, fill: "#FFEFEF" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F66",
            fillRule: "evenodd",
            d: "M18 11.314c-.852 0-1.543.691-1.543 1.543v6.172a1.543 1.543 0 0 0 3.086 0v-6.172c0-.852-.691-1.543-1.543-1.543Zm0 14.4a1.543 1.543 0 1 0 0-3.085 1.543 1.543 0 0 0 0 3.085Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcAlertPopupXlarge_default = createIcon(SvgIcAlertPopupXlarge);
function SvgIcAlert(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9 6.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v4.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2V6.2Zm2 6.8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAlert_default = createIcon(SvgIcAlert);
function SvgIcAnnualMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14,
            height: 16,
            x: 5,
            y: 4,
            stroke: "#333",
            strokeWidth: 2,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 4, x: 8, y: 2, fill: "#333", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 8, height: 2, x: 8, y: 8, fill: "#333", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 5, height: 2, x: 8, y: 11, fill: "#333", rx: 0.5 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 2,
            height: 2,
            fill: "#333",
            rx: 0.5,
            transform: "matrix(-1 0 0 1 16 15)"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 4, x: 14, y: 2, fill: "#333", rx: 1 })
      ]
    }
  );
}
var IcAnnualMedium_default = createIcon(SvgIcAnnualMedium);
function SvgIcApprovalMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 5H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3v1.63a.37.37 0 0 1-.37.37h-3.26a.37.37 0 0 1-.37-.37V5Zm3.732-2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h3.268a2 2 0 0 1 3.464 0Zm1.965 5.783a1 1 0 0 1 .02 1.414l-3.555 3.657c-.5.514-1.328.513-1.826-.004L8.28 11.716a1 1 0 1 1 1.44-1.388l1.533 1.59 3.03-3.116a1 1 0 0 1 1.414-.02Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcApprovalMedium_default = createIcon(SvgIcApprovalMedium);
function SvgIcArticleMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M10 10h4v4h-4v-4Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 6, height: 1, x: 9, y: 16, fill: "#fff", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 14, height: 16, x: 5, y: 4, fill: "#C1E0FE", rx: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            d: "M7 6h10v4H7zM7 12h10v1H7zM7 14h10v1H7zM7 16h5v1H7zM13 16h2v1h-2z"
          }
        )
      ]
    }
  );
}
var IcArticleMedium_default = createIcon(SvgIcArticleMedium);
function SvgIcAsc(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4.5 3.5A.5.5 0 0 1 5 3h1a.5.5 0 0 1 .5.5v9.833h1a.5.5 0 0 1 .4.8l-2 2.667a.5.5 0 0 1-.8 0l-2-2.667a.5.5 0 0 1 .4-.8h1V3.5Zm12 13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6.5Zm-1-4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5.5ZM10 9a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 10 7h4.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H10Zm3.5-4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAsc_default = createIcon(SvgIcAsc);
function SvgIcAttachment(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#555",
          strokeWidth: 1.5,
          d: "M10.348 3.652 5.762 8.238c-5.016 5.016 1.348 11.38 6.364 6.364l3.822-3.822a3.012 3.012 0 0 0-4.243-4.242L7.12 11.124a1.506 1.506 0 0 0 2.121 2.121l5.35-5.35"
        }
      )
    }
  );
}
var IcAttachment_default = createIcon(SvgIcAttachment);
function SvgIcAttendanceMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 12a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-1.142 8.221a.5.5 0 0 1-.146.354l-2.508 2.508a.5.5 0 0 0 0 .707l.864.864a.5.5 0 0 0 .707 0l3.16-3.159a.5.5 0 0 0 .146-.353V7.944a.5.5 0 0 0-.5-.5h-1.223a.5.5 0 0 0-.5.5v3.277Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAttendanceMedium_default = createIcon(SvgIcAttendanceMedium);
function SvgIcBackMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          d: "m8.15 5.337-5.876 6.001a.935.935 0 0 0 0 1.323l5.876 6.002a.5.5 0 0 0 .686.027l.764-.665a.5.5 0 0 0 .03-.727L5.42 13H21.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H5.42l4.21-4.298a.5.5 0 0 0-.03-.727l-.764-.666a.5.5 0 0 0-.686.028Z"
        }
      )
    }
  );
}
var IcBackMedium_default = createIcon(SvgIcBackMedium);
function SvgIcBadgeAdminLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 15,
            cy: 15,
            r: 14,
            fill: "#FFA800",
            stroke: "#fff",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M15.934 9.1c-.326-.8-1.544-.8-1.87 0L11 15.744l-3.085-4.736c-.276-.38-.915-.199-.915.26l.846 8.653c.087.893.9 1.578 1.875 1.578h10.63c.98 0 1.796-.692 1.877-1.591l.772-8.64c0-.459-.639-.64-.915-.26L19 15.746l-3.066-6.647Z"
          }
        )
      ]
    }
  );
}
var IcBadgeAdminLarge_default = createIcon(SvgIcBadgeAdminLarge);
function SvgIcBadgeLeaderAppovalLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 15,
            cy: 15,
            r: 14,
            fill: "#35485B",
            stroke: "#FFD000",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFD000",
            d: "M14.249 7.488a.822.822 0 0 1 1.502 0l1.823 3.864a.841.841 0 0 0 .631.48l4.077.619c.687.104.961.987.464 1.494l-2.95 3.007a.901.901 0 0 0-.24.775l.696 4.247c.117.716-.601 1.261-1.216.923l-3.646-2.005a.805.805 0 0 0-.78 0l-3.646 2.005c-.615.338-1.333-.207-1.216-.923l.697-4.247a.901.901 0 0 0-.241-.775l-2.95-3.007c-.497-.507-.223-1.39.464-1.494l4.077-.62a.841.841 0 0 0 .63-.48l1.824-3.863Z"
          }
        )
      ]
    }
  );
}
var IcBadgeLeaderAppovalLarge_default = createIcon(SvgIcBadgeLeaderAppovalLarge);
function SvgIcBadgeLeaderLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 15,
            cy: 15,
            r: 14,
            fill: "#35485B",
            stroke: "#fff",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M14.249 7.488a.822.822 0 0 1 1.502 0l1.823 3.864a.841.841 0 0 0 .631.48l4.077.619c.687.104.961.987.464 1.494l-2.95 3.007a.901.901 0 0 0-.24.775l.696 4.247c.117.716-.601 1.261-1.216.923l-3.646-2.005a.805.805 0 0 0-.78 0l-3.646 2.005c-.615.338-1.333-.207-1.216-.923l.697-4.247a.901.901 0 0 0-.241-.775l-2.95-3.007c-.497-.507-.223-1.39.464-1.494l4.077-.62a.841.841 0 0 0 .63-.48l1.824-3.863Z"
          }
        )
      ]
    }
  );
}
var IcBadgeLeaderLarge_default = createIcon(SvgIcBadgeLeaderLarge);
function SvgIcBellMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8.211 20.598c1.155.667 2.623.416 3.72-.51.284-.24.242-.667-.045-.832l-4.35-2.512c-.287-.165-.678.012-.743.378-.254 1.413.264 2.81 1.418 3.476ZM14.56 3.094c.585-.234 1.137.01 1.49.214s.84.56.931 1.184c.044.301-.025.553-.09.718a2.09 2.09 0 0 1-.098.21c1.724 1.732 2.35 4.35 1.113 6.491l-.855 1.482c-.434.75-.49 1.71-.077 2.658l.003.006c.246.578.245 1.247-.087 1.821-.633 1.096-2.014 1.232-2.966.683l-10.02-5.786c-.952-.55-1.525-1.813-.892-2.91.33-.57.906-.91 1.526-.984h.006c1.036-.118 1.84-.647 2.272-1.397l.856-1.482C8.908 3.86 11.487 3.093 13.85 3.72a2.06 2.06 0 0 1 .132-.189c.11-.14.294-.325.577-.437Zm-.108 2.982-.535-.225c-1.85-.778-3.74-.188-4.513 1.151l-.856 1.482c-.78 1.352-2.174 2.2-3.773 2.383a.17.17 0 0 0-.021.004l.003.01a.32.32 0 0 0 .147.162l10.02 5.786a.32.32 0 0 0 .215.046l.009-.002a.221.221 0 0 0-.01-.028c-.638-1.47-.6-3.101.18-4.452l.856-1.482c.773-1.34.339-3.272-1.26-4.484l-.462-.351Zm.718 10.788-.002.002.002-.002ZM4.75 10.848v.003-.003Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcBellMedium_default = createIcon(SvgIcBellMedium);
function SvgIcBmMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 6H5v9.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7V4.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5ZM7 17a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Zm10 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM8.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9ZM11 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1ZM8.5 11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcBmMedium_default = createIcon(SvgIcBmMedium);
function SvgIcBoardMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M19 5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-.785l-2.517-.674a2 2 0 0 1-1.414-2.45l2.588-9.659a2 2 0 0 1 2.45-1.414L10.771 5H13a3 3 0 1 1 6 0Zm-4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm1 3c.889 0 1.687-.386 2.236-1H19v12H8V7h5.764l.046.05-.597 1.07c-.27.482-.1 1.097.378 1.373a.983.983 0 0 0 1.354-.374l.64-1.147c.136.018.274.028.415.028ZM6 8.147 4 15.61l2 .536V8.147ZM10.5 11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-6Zm0 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcBoardMedium_default = createIcon(SvgIcBoardMedium);
function SvgIcBoardProfileXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 18, cy: 18, r: 15, fill: "#EAF5FF" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#84C2FC",
            fillRule: "evenodd",
            d: "M23.95 14.4a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7Zm-2.205-.9H15.1a1.5 1.5 0 0 0-1.5 1.5v6.9a1.5 1.5 0 0 0 1.5 1.5h5.3a4 4 0 0 0 4-4v-4.145a2.254 2.254 0 0 1-1.199-.082l-1.411 1.882a.675.675 0 0 1-1.134-.726l.054-.084 1.412-1.883a2.238 2.238 0 0 1-.377-.862ZM15.4 17.55h4.5v.9h-4.5v-.9Zm0 1.8h2.7v.9h-2.7v-.9Zm8.1.45h-2.7v2.7a2.7 2.7 0 0 0 2.7-2.7Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcBoardProfileXlarge_default = createIcon(SvgIcBoardProfileXlarge);
function SvgIcBoardProfile(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 15, cy: 15, r: 15, fill: "#EAF5FF" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#84C2FC",
            fillRule: "evenodd",
            d: "M20.95 11.4a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7Zm-2.205-.9H12.1a1.5 1.5 0 0 0-1.5 1.5v6.9a1.5 1.5 0 0 0 1.5 1.5h5.3a4 4 0 0 0 4-4v-4.145a2.254 2.254 0 0 1-1.199-.082l-1.411 1.882a.675.675 0 0 1-1.134-.726l.054-.084 1.412-1.883a2.238 2.238 0 0 1-.377-.862ZM12.4 14.55h4.5v.9h-4.5v-.9Zm0 1.8h2.7v.9h-2.7v-.9Zm8.1.45h-2.7v2.7a2.7 2.7 0 0 0 2.7-2.7Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcBoardProfile_default = createIcon(SvgIcBoardProfile);
function SvgIcBookmarkFilledMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          stroke: "#333",
          strokeWidth: 2,
          d: "M5 4.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v13.904a1 1 0 0 1-1.63.777l-4.74-3.838a1 1 0 0 0-1.26 0L6.63 19.18A1 1 0 0 1 5 18.404V4.5Z"
        }
      )
    }
  );
}
var IcBookmarkFilledMedium_default = createIcon(SvgIcBookmarkFilledMedium);
function SvgIcBookmarkMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#333",
          strokeWidth: 2,
          d: "M5 4.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v13.904a1 1 0 0 1-1.63.777l-4.74-3.838a1 1 0 0 0-1.26 0L6.63 19.18A1 1 0 0 1 5 18.404V4.5Z"
        }
      )
    }
  );
}
var IcBookmarkMedium_default = createIcon(SvgIcBookmarkMedium);
function SvgIcByEmployeeMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 10, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            fillRule: "evenodd",
            d: "M13.592 10.428a2.5 2.5 0 1 0-3.184 0A5.04 5.04 0 0 0 7 15.208V16.6c0 .59.478 1.067 1.067 1.067h7.867c.589 0 1.066-.478 1.066-1.067v-1.392a5.04 5.04 0 0 0-3.408-4.78Zm.908 2.239h-1.667v.833H14.5v-.833Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcByEmployeeMedium_default = createIcon(SvgIcByEmployeeMedium);
function SvgIcByPlaceOfWorkMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 10, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            fillRule: "evenodd",
            d: "M7.71 8a2 2 0 0 1 2-2h4.571a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9.71a2 2 0 0 1-2-2V8Zm1.714.571h1.714v1.715H9.424V8.57Zm0 2.572h1.714v1.714H9.424v-1.714ZM13.71 8.57h-1.714v1.715h1.714V8.57Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcByPlaceOfWorkMedium_default = createIcon(SvgIcByPlaceOfWorkMedium);
function SvgIcCamera(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 3, height: 2, x: 16, y: 8, fill: "#3299FE", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M18 5h-.385l-.771-1.928A2.5 2.5 0 0 0 14.523 1.5H9.477a2.5 2.5 0 0 0-2.321 1.572L6.384 5H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4Zm-2.549-1.371L16 5H8l.548-1.371A1 1 0 0 1 9.477 3h5.046a1 1 0 0 1 .928.629ZM3.5 9A2.5 2.5 0 0 1 6 6.5h12A2.5 2.5 0 0 1 20.5 9v8a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 17V9Zm6.25 4a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 9.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcCamera_default = createIcon(SvgIcCamera);
function SvgIcCategory(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4.75 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm2-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-8Zm-.5 5.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-1Zm.5 4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCategory_default = createIcon(SvgIcCategory);
function SvgIcChannel(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM8 4a.5.5 0 0 0-.5.5v2A.5.5 0 0 0 8 7h6.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H8Zm-.5 5a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V9Zm-3-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm3 5A.5.5 0 0 1 8 13h8.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-2Zm-3-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcChannel_default = createIcon(SvgIcChannel);
function SvgIcChanneltalkMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M12.5 12.5a.5.5 0 0 0 .5-.5v-.057c0-.553.03-.584.568-1.06l.3-.26c.813-.697 1.277-1.095 1.277-2.304 0-1.703-1.427-3.069-3.269-3.069-1.97 0-2.88 1.395-3.215 2.101-.106.225.006.478.231.581l.666.307c.27.125.596-.013.753-.266.265-.427.762-.973 1.565-.973.768 0 1.428.598 1.428 1.32 0 .59-.122.688-.478.973-.078.064-.168.136-.271.225l-.281.24c-.79.67-1.1.934-1.1 1.832V12a.5.5 0 0 0 .5.5h.826ZM12.1 15.45c.613 0 1.1-.487 1.1-1.1 0-.613-.487-1.1-1.1-1.1-.613 0-1.1.487-1.1 1.1 0 .613.487 1.1 1.1 1.1Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10.2 1.5A8.2 8.2 0 0 0 2 9.7v1.2c0 3.352 1.674 6.104 4.626 7.339.008.21-.007.49-.056.835a12.07 12.07 0 0 1-.355 1.585c-.257.888.39 1.841 1.375 1.841.838 0 1.648-.283 2.348-.64.707-.362 1.366-.833 1.92-1.285a17 17 0 0 0 1.583-1.475h.959c4.64 0 7.6-3.79 7.6-8.2V9.7a8.2 8.2 0 0 0-8.2-8.2h-3.6Zm2.341 15.6-.298.347-.005.006-.02.023a13.603 13.603 0 0 1-.427.455c-.296.3-.712.699-1.197 1.094-.488.398-1.026.777-1.566 1.053-.235.12-.458.215-.669.284.073-.315.141-.658.19-1.005.094-.656.153-1.523-.117-2.218l-.169-.437-.444-.15C5.42 15.743 4 13.688 4 10.9V9.7a6.2 6.2 0 0 1 6.2-6.2h3.6A6.2 6.2 0 0 1 20 9.7v1.2c0 3.543-2.287 6.2-5.6 6.2h-1.859Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcChanneltalkMedium_default = createIcon(SvgIcChanneltalkMedium);
function SvgIcChatActivityMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M16.214 3.3A2.286 2.286 0 0 1 18.5 5.586v6.857a2.286 2.286 0 0 1-2.286 2.285H12.56l-3.078 2.053c-1.519 1.012-3.553-.077-3.553-1.902v-.15H4.786A2.286 2.286 0 0 1 2.5 12.442V5.586A2.286 2.286 0 0 1 4.786 3.3h11.428Zm0 2.286H4.786v6.857h3.428v2.436l3.654-2.436h4.346V5.586Zm-3.393 10L10.5 17.134v.832a1 1 0 0 0 1 1h3.758l2.187 1.458A1 1 0 0 0 19 19.593v-.627h1.5a1 1 0 0 0 1-1V13.3a1 1 0 0 0-1-1h-1.142v.143a3.143 3.143 0 0 1-3.143 3.143h-3.394Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcChatActivityMedium_default = createIcon(SvgIcChatActivityMedium);
function SvgIcChatLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 15, cy: 15, r: 15, fill: "#3299FE" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M16 8a6 6 0 0 1 6 6v1a6 6 0 0 1-6 6h-2c-.499 0-.984-.06-1.447-.176-.664.636-1.55 1.176-2.644 1.176-1.17 0-1.022-.154-.596-.597.336-.35.846-.88 1.017-1.656A5.99 5.99 0 0 1 8 15v-1a6 6 0 0 1 6-6h2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#3299FE", d: "M18 12.5h-7V14h7zM16 15h-5v1.5h5z" })
      ]
    }
  );
}
var IcChatLarge_default = createIcon(SvgIcChatLarge);
function SvgIcChattingMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M13.286 6H11a6 6 0 1 0 0 12h8v-6.286A5.714 5.714 0 0 0 13.286 6ZM11 4a8 8 0 1 0 0 16h9.5a.5.5 0 0 0 .5-.5v-7.786A7.714 7.714 0 0 0 13.286 4H11Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#333", d: "M7 11h2v2H7zM11 11h2v2h-2zM15 11h2v2h-2z" })
      ]
    }
  );
}
var IcChattingMedium_default = createIcon(SvgIcChattingMedium);
function SvgIcChattingSolidMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M12.5 7a5.5 5.5 0 1 0 0 11H15s1.106 2 3.175 2c.908 0 .793-.096.463-.373-.38-.318-1.045-.875-.77-1.798A5.5 5.5 0 0 0 16.5 7h-4Z",
            clipRule: "evenodd",
            opacity: 0.3
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 12, x: 2, y: 4, fill: "#3299FE", rx: 6 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcChattingSolidMedium_default = createIcon(SvgIcChattingSolidMedium);
function SvgIcCheckXlarge(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4DC9AA",
          fillRule: "evenodd",
          d: "M18 33c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15Zm7.006-18.57a.2.2 0 0 1 0 .283l-8.808 8.808a.2.2 0 0 1-.283 0l-.622-.622a.2.2 0 0 1-.05-.036l-4.92-4.92a.2.2 0 0 1 0-.283l1.535-1.536a.2.2 0 0 1 .283 0l3.909 3.909 7.138-7.139a.2.2 0 0 1 .283 0l1.535 1.536Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCheckXlarge_default = createIcon(SvgIcCheckXlarge);
function SvgIcCheckXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.547 2.987a.75.75 0 0 1-.034 1.06l-5.333 5a.75.75 0 0 1-1.026 0l-2.667-2.5a.75.75 0 1 1 1.026-1.094l2.154 2.019 4.82-4.52a.75.75 0 0 1 1.06.035Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCheckXsmall_default = createIcon(SvgIcCheckXsmall);
function SvgIcCheck(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15.288 5.298a1 1 0 0 1 1.506 1.31l-.082.094-7.895 8a1 1 0 0 1-1.338.078l-.094-.087-4.106-4.266a1 1 0 0 1 1.349-1.472l.093.085 3.393 3.527 7.174-7.27Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCheck_default = createIcon(SvgIcCheck);
function SvgIcCheckbox(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6 3.5h8A2.5 2.5 0 0 1 16.5 6v8a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 14V6A2.5 2.5 0 0 1 6 3.5ZM2 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Zm12.064 1.994a.75.75 0 1 0-1.128-.988l-3.811 4.355-2.06-2.355a.75.75 0 1 0-1.13.988l2.626 3a.75.75 0 0 0 1.128 0l4.375-5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCheckbox_default = createIcon(SvgIcCheckbox);
function SvgIcCloseMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M5.692 4.29A.991.991 0 0 0 4.29 5.692L10.598 12 4.29 18.308a.991.991 0 1 0 1.402 1.401L12 13.402l6.308 6.307a.991.991 0 1 0 1.401-1.401L13.402 12l6.308-6.308a.991.991 0 1 0-1.402-1.402L12 10.598 5.692 4.29Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCloseMedium_default = createIcon(SvgIcCloseMedium);
function SvgIcCloseSmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m5.613 4.21.094.083L10 8.585l4.293-4.292a1 1 0 0 1 1.497 1.32l-.083.094L11.415 10l4.292 4.293a1 1 0 0 1-1.32 1.497l-.094-.083L10 11.415l-4.293 4.292a1 1 0 0 1-1.497-1.32l.083-.094L8.585 10 4.293 5.707A1 1 0 0 1 5.51 4.14l.102.07Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCloseSmall_default = createIcon(SvgIcCloseSmall);
function SvgIcClose(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m5.613 4.21.094.083L10 8.585l4.293-4.292a1 1 0 0 1 1.497 1.32l-.083.094L11.415 10l4.292 4.293a1 1 0 0 1-1.32 1.497l-.094-.083L10 11.415l-4.293 4.292a1 1 0 0 1-1.497-1.32l.083-.094L8.585 10 4.293 5.707A1 1 0 0 1 5.51 4.14l.102.07Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcClose_default = createIcon(SvgIcClose);
function SvgIcClosingMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M15 4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V5h1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1v-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V5h6v-.5ZM5 17V9h14v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M15.697 10.783a1 1 0 0 1 .02 1.414l-3.555 3.657c-.5.514-1.328.513-1.826-.004L8.28 13.716a1 1 0 1 1 1.44-1.388l1.533 1.59 3.03-3.116a1 1 0 0 1 1.414-.02Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcClosingMedium_default = createIcon(SvgIcClosingMedium);
function SvgIcCloudMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m6.578 11.122 1.281-.348.177-1.315a4.001 4.001 0 0 1 7.68-.945l.356.89.918.28A4.25 4.25 0 0 1 15.75 18H7.5a3.5 3.5 0 0 1-.922-6.879ZM12 4a6.002 6.002 0 0 1 5.572 3.77A6.25 6.25 0 0 1 15.75 20H7.5A5.5 5.5 0 0 1 6.054 9.192 6.001 6.001 0 0 1 12 4Zm.45 4.5a.3.3 0 0 1 .3.3v4.92l1.366-1.366a.5.5 0 0 1 .707 0l.354.353a.5.5 0 0 1 0 .707l-2.427 2.427v.034h-.034l-.362.362a.5.5 0 0 1-.707 0l-.363-.362h-.034v-.034l-2.427-2.427a.5.5 0 0 1 0-.707l.354-.353a.5.5 0 0 1 .707 0l1.366 1.366V8.8a.3.3 0 0 1 .3-.3h.9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCloudMedium_default = createIcon(SvgIcCloudMedium);
function SvgIcComment(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("mask", { id: "ic-comment_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M5.5 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.475l4.028 3.58c.968.86 2.497.174 2.497-1.12V17h2a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-13Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "m9.975 17 1.329-1.495-.568-.505h-.76v2Zm4.028 3.58-1.328 1.496 1.328-1.495Zm2.497-1.12h2-2Zm0-2.46v-2h-2v2h2ZM4.5 6a1 1 0 0 1 1-1V1a5 5 0 0 0-5 5h4Zm0 8V6h-4v8h4Zm1 1a1 1 0 0 1-1-1h-4a5 5 0 0 0 5 5v-4Zm4.475 0H5.5v4h4.475v-4Zm-1.329 3.495 4.029 3.58 2.657-2.99-4.028-3.58-2.658 2.99Zm4.029 3.58c2.257 2.007 5.825.405 5.825-2.615h-4a.5.5 0 0 1 .832-.374l-2.657 2.99ZM18.5 19.46V17h-4v2.46h4Zm0-4.46h-2v4h2v-4Zm1-1a1 1 0 0 1-1 1v4a5 5 0 0 0 5-5h-4Zm0-8v8h4V6h-4Zm-1-1a1 1 0 0 1 1 1h4a5 5 0 0 0-5-5v4Zm-13 0h13V1h-13v4Z",
            mask: "url(#ic-comment_svg__a)"
          }
        )
      ]
    }
  );
}
var IcComment_default = createIcon(SvgIcComment);
function SvgIcConfirmPopupXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 18, cy: 18, r: 15, fill: "#EAF5FF" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M26.033 12.913c.6.57.625 1.52.054 2.12l-8.552 9a1.5 1.5 0 0 1-2.188-.014l-4.447-4.8a1.5 1.5 0 0 1 2.2-2.039l3.361 3.628 7.452-7.841a1.5 1.5 0 0 1 2.12-.054Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcConfirmPopupXlarge_default = createIcon(SvgIcConfirmPopupXlarge);
function SvgIcCopy(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M16.244 4.856A1.75 1.75 0 0 0 14.5 3.25h-6l-.144.006A1.75 1.75 0 0 0 6.75 5v.75h1.5V5l.007-.057A.25.25 0 0 1 8.5 4.75h6l.057.007A.25.25 0 0 1 14.75 5v7l-.007.057a.25.25 0 0 1-.243.193h-.25v1.5h.25l.143-.006A1.75 1.75 0 0 0 16.25 12V5l-.006-.144ZM11.75 6.25a1.75 1.75 0 0 1 1.744 1.606L13.5 8v7a1.75 1.75 0 0 1-1.607 1.744l-.143.006h-6a1.75 1.75 0 0 1-1.744-1.607L4 15V8a1.75 1.75 0 0 1 1.606-1.744l.144-.006h6Zm0 1.5h-6a.25.25 0 0 0-.243.193L5.5 8v7a.25.25 0 0 0 .193.243l.057.007h6a.25.25 0 0 0 .243-.193L12 15V8a.25.25 0 0 0-.193-.243l-.057-.007Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCopy_default = createIcon(SvgIcCopy);
function SvgIcCustomText(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M12 11.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V13h-.5v-.583a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V17.1c0 .22.18.4.4.4a.1.1 0 0 1 .1.1v.233a.167.167 0 0 1-.167.167h-2.666a.167.167 0 0 1-.167-.167V17.6a.1.1 0 0 1 .1-.1.4.4 0 0 0 .4-.4v-4.683a.25.25 0 0 0-.25-.25h-.977a.25.25 0 0 0-.25.25V13H12v-1.5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8.25 6.5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM10 3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Zm-3.93 8.48c1.053-.65 2.45-.98 3.93-.98v1.5c-1.28 0-2.385.288-3.141.756-.744.46-1.109 1.053-1.109 1.729v.699c0 .174.142.316.317.316H12v1.5H6.067a1.817 1.817 0 0 1-1.817-1.816v-.7c0-1.322.754-2.346 1.82-3.004Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcCustomText_default = createIcon(SvgIcCustomText);
function SvgIcDeadline(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 18, height: 18, x: 3, y: 3, fill: "#E3E8EB", rx: 6 }),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 2, x: 7, y: 11, fill: "#406588", rx: 1 })
      ]
    }
  );
}
var IcDeadline_default = createIcon(SvgIcDeadline);
function SvgIcDeleteLine(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M6.823 12.823a.5.5 0 0 1 0-.707L8.94 10 6.823 7.884a.5.5 0 0 1 0-.707l.354-.354a.5.5 0 0 1 .707 0L10 8.94l2.116-2.116a.5.5 0 0 1 .707 0l.354.354a.5.5 0 0 1 0 .707L11.06 10l2.116 2.116a.5.5 0 0 1 0 .707l-.354.354a.5.5 0 0 1-.707 0L10 11.06l-2.116 2.116a.5.5 0 0 1-.707 0l-.354-.354Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcDeleteLine_default = createIcon(SvgIcDeleteLine);
function SvgIcDelete(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.142 7.059a.2.2 0 0 0 0 .282l2.664 2.665-2.653 2.652a.2.2 0 0 0 0 .283l.917.917a.2.2 0 0 0 .283 0l2.653-2.652 2.653 2.652a.2.2 0 0 0 .283 0l.917-.917a.2.2 0 0 0 0-.283l-2.653-2.652L13.87 7.34a.2.2 0 0 0 0-.282l-.917-.918a.2.2 0 0 0-.283 0l-2.664 2.665L7.342 6.14a.2.2 0 0 0-.283 0l-.917.918Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDelete_default = createIcon(SvgIcDelete);
function SvgIcDesc(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4.5 3.5A.5.5 0 0 1 5 3h1a.5.5 0 0 1 .5.5v9.833h1a.5.5 0 0 1 .4.8l-2 2.667a.5.5 0 0 1-.8 0l-2-2.667a.5.5 0 0 1 .4-.8h1V3.5Zm9 13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3.5Zm1-4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4.5ZM10 9a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 10 7h5.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H10Zm6.5-4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDesc_default = createIcon(SvgIcDesc);
function SvgIcDisplayMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14,
            height: 16,
            x: 5,
            y: 4,
            stroke: "#333",
            strokeWidth: 2,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M5 11h14v2H5zM8 8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11H8V8.5ZM8 16.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V19H8v-2.5ZM11 8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11h-2V8.5ZM11 16.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V19h-2v-2.5ZM14 8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11h-2V8.5ZM14 16.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V19h-2v-2.5Z"
          }
        )
      ]
    }
  );
}
var IcDisplayMedium_default = createIcon(SvgIcDisplayMedium);
function SvgIcDocMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M4 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8.843 11.907a.5.5 0 0 0-.14.274l-.136.843a.5.5 0 0 0 .574.573l.843-.136a.5.5 0 0 0 .274-.14l4.917-4.917a.5.5 0 0 0 0-.707l-.708-.707a.5.5 0 0 0-.707 0l-4.917 4.917ZM8.75 15a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-6.5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcDocMedium_default = createIcon(SvgIcDocMedium);
function SvgIcDownArrowSolidXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6.416 8.376a.5.5 0 0 1-.832 0L2.518 3.777A.5.5 0 0 1 2.934 3h6.132a.5.5 0 0 1 .416.777L6.416 8.376Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownArrowSolidXsmall_default = createIcon(SvgIcDownArrowSolidXsmall);
function SvgIcDownArrowXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6 6.94 2.53 3.47a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0 0-1.06Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownArrowXsmall_default = createIcon(SvgIcDownArrowXsmall);
function SvgIcDownArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.267 6.27a.906.906 0 0 1 1.19-.089l.102.09L10 11.77l5.441-5.5a.906.906 0 0 1 1.19-.09l.102.09a.93.93 0 0 1 .088 1.201l-.088.104-6.087 6.154a.906.906 0 0 1-1.19.089l-.102-.09-6.087-6.153a.93.93 0 0 1 0-1.306Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownArrow_default = createIcon(SvgIcDownArrow);
function SvgIcDownloadMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M11 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v12.086l4.94-4.94a.5.5 0 0 1 .706 0l.708.708a.5.5 0 0 1 0 .707l-6.647 6.646a1 1 0 0 1-1.414 0l-6.646-6.646a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0L11 15.085V3ZM4 20a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 4 21v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownloadMedium_default = createIcon(SvgIcDownloadMedium);
function SvgIcDownload(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M9 3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7.2l2.78-2.836a.5.5 0 0 1 .714 0l.663.676a.5.5 0 0 1 0 .7l-4.8 4.896a.5.5 0 0 1-.714 0l-4.8-4.896a.5.5 0 0 1 0-.7l.663-.676a.5.5 0 0 1 .714 0L9 10.7V3.5Zm-4 12a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownload_default = createIcon(SvgIcDownload);
function SvgIcDraftsave(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M13.5 2.5a2 2 0 0 1 2 2v2.29a6.976 6.976 0 0 0-1.5-.272V4.5a.5.5 0 0 0-.41-.492L13.5 4h-6v3.5H4v8a.5.5 0 0 0 .41.492L4.5 16h2.46a6.98 6.98 0 0 0 .795 1.5H4.5a2 2 0 0 1-2-2v-9l4-4h7Zm5 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0ZM13 10.5v2.793l1.854 1.853-.708.708L12 13.707V10.5h1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDraftsave_default = createIcon(SvgIcDraftsave);
function SvgIcDrag(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m11.91 4.76-1.613-1.614a.5.5 0 0 0-.707 0L7.977 4.76a.5.5 0 0 0 .353.854h.672v3.381h-3.39V8.33a.5.5 0 0 0-.853-.353L3.146 9.589a.5.5 0 0 0 0 .708l1.613 1.612a.5.5 0 0 0 .854-.353v-.563h3.389v3.394H8.33a.5.5 0 0 0-.353.854l1.613 1.612a.5.5 0 0 0 .707 0l1.613-1.613a.5.5 0 0 0-.354-.853h-.558v-3.394h3.388v.563a.5.5 0 0 0 .854.354l1.613-1.613a.5.5 0 0 0 0-.708L15.24 7.977a.5.5 0 0 0-.854.353v.664h-3.388V5.613h.558a.5.5 0 0 0 .354-.854Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDrag_default = createIcon(SvgIcDrag);
function SvgIcDrawer(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 4.5A.5.5 0 0 1 4 4h7.667a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-1Zm0 5A.5.5 0 0 1 4 9h12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-1ZM4 14a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h10.917a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDrawer_default = createIcon(SvgIcDrawer);
function SvgIcEditLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 15, cy: 15, r: 15, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "m20.65 8.447.89.893c.296.298.46.695.46 1.117 0 .421-.164.818-.46 1.116l-1.091 1.094-3.116-3.126 1.09-1.094c.595-.596 1.631-.596 2.226 0ZM8.943 18.05l7.716-7.716 3.007 3.007-7.717 7.715a.304.304 0 0 1-.14.08l-3.433.856a.303.303 0 0 1-.368-.368l.855-3.433a.307.307 0 0 1 .08-.14Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcEditLarge_default = createIcon(SvgIcEditLarge);
function SvgIcEditLine(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m5.614 14.136.089-.796 7.406-7.406.707.707-7.406 7.406-.796.089Zm9.262-6.434-7.654 7.654a.5.5 0 0 1-.298.143l-2.076.231a.75.75 0 0 1-.828-.828l.23-2.076a.5.5 0 0 1 .144-.298l7.654-7.654 1.414-1.415.177-.176a.75.75 0 0 1 1.06 0l1.769 1.767a.75.75 0 0 1 0 1.061l-.177.177-1.415 1.414Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEditLine_default = createIcon(SvgIcEditLine);
function SvgIcEditSolid(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m15.65 3.447.89.893c.296.298.46.695.46 1.117 0 .421-.164.818-.46 1.116l-1.091 1.094-3.116-3.126 1.09-1.094c.595-.596 1.631-.596 2.226 0ZM3.943 13.05l7.716-7.716 3.007 3.007-7.717 7.715a.304.304 0 0 1-.14.08l-3.433.856a.303.303 0 0 1-.368-.368l.855-3.433a.307.307 0 0 1 .08-.14Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEditSolid_default = createIcon(SvgIcEditSolid);
function SvgIcEditXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 14 14",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m11.842 1.383.763.766c.255.255.395.595.395.957 0 .361-.14.701-.395.957L11.671 5 9 2.32l.934-.937c.51-.51 1.398-.511 1.908 0ZM1.81 9.613 8.423 3 11 5.577 4.386 12.19a.26.26 0 0 1-.12.07l-2.943.732a.26.26 0 0 1-.315-.315l.733-2.943a.264.264 0 0 1 .068-.12Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEditXsmall_default = createIcon(SvgIcEditXsmall);
function SvgIcEdit(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m15.65 3.447.89.893c.296.298.46.695.46 1.117 0 .421-.164.818-.46 1.116l-1.091 1.094-3.116-3.126 1.09-1.094c.595-.596 1.631-.596 2.226 0ZM3.943 13.05l7.716-7.716 3.007 3.007-7.717 7.715a.304.304 0 0 1-.14.08l-3.433.856a.303.303 0 0 1-.368-.368l.855-3.433a.307.307 0 0 1 .08-.14Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEdit_default = createIcon(SvgIcEdit);
function SvgIcEmailXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M6 15.833v11.975c0 1.212.977 2.195 2.182 2.195h19.636A2.188 2.188 0 0 0 30 27.808V15.834L18 22.99 6 15.833Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#84C2FC",
            fillRule: "evenodd",
            d: "M30 14.09 18 21 6 14.09v-1.971C6 10.949 6.977 10 8.182 10h19.636c1.205 0 2.182.948 2.182 2.119v1.971Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 30,
            cy: 10,
            r: 3,
            fill: "#FF7979",
            stroke: "#fff",
            strokeWidth: 2
          }
        )
      ]
    }
  );
}
var IcEmailXlarge_default = createIcon(SvgIcEmailXlarge);
function SvgIcEmojiMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx("path", { fill: "#000", d: "M2 22.4h20v-20H2v20Z" })
    }
  );
}
var IcEmojiMedium_default = createIcon(SvgIcEmojiMedium);
function SvgIcEmojiPlusMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M21.62 9.26c.247.87.38 1.79.38 2.74 0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c.95 0 1.87.133 2.74.38a4.968 4.968 0 0 0-.687 1.886 8 8 0 1 0 5.68 5.68c.684-.1 1.323-.339 1.887-.686Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M18.45 2a.2.2 0 0 0-.2.2v2.05H16.2a.2.2 0 0 0-.2.2v1.1c0 .11.09.2.2.2h2.05V7.8c0 .11.09.2.2.2h1.1a.2.2 0 0 0 .2-.2V5.75h2.05a.2.2 0 0 0 .2-.2v-1.1a.2.2 0 0 0-.2-.2h-2.05V2.2a.2.2 0 0 0-.2-.2h-1.1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M9.667 11.333a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM14.333 11.333a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM9.765 12.76a.583.583 0 0 1 .809-.162c.478.319 1.726.751 2.853 0a.583.583 0 0 1 .647.97c-1.673 1.116-3.459.46-4.148 0a.583.583 0 0 1-.161-.808Z"
          }
        )
      ]
    }
  );
}
var IcEmojiPlusMedium_default = createIcon(SvgIcEmojiPlusMedium);
function SvgIcEndPage(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4.281 4.456a.906.906 0 0 1 .09-1.189.93.93 0 0 1 1.305 0l6.154 6.087.09.103a.906.906 0 0 1-.09 1.189l-6.154 6.087-.104.088a.93.93 0 0 1-1.202-.088l-.089-.103a.906.906 0 0 1 .09-1.189L9.87 10l-5.5-5.441-.09-.103ZM15.001 3a.9.9 0 0 0-.9.9v12.2a.9.9 0 1 0 1.8 0V3.9A.9.9 0 0 0 15 3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEndPage_default = createIcon(SvgIcEndPage);
function SvgIcExclamationXlarge(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F66",
          fillRule: "evenodd",
          d: "M18 33c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15Zm-1.286-20.371c0-.11.09-.2.2-.2h2.172c.11 0 .2.09.2.2v7.314a.2.2 0 0 1-.2.2h-2.172a.2.2 0 0 1-.2-.2V12.63Zm2.572 10.513a1.286 1.286 0 1 1-2.572 0 1.286 1.286 0 0 1 2.572 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcExclamationXlarge_default = createIcon(SvgIcExclamationXlarge);
function SvgIcExitFullScreenMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 18,
            height: 14,
            x: 3,
            y: 5,
            stroke: "#333",
            strokeWidth: 2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#333", d: "M4 14h7a1 1 0 0 1 1 1v3H4v-4Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M16.36 13.396h-3.293a.5.5 0 0 1-.5-.5V9.603a.5.5 0 0 1 .854-.353l.958.957 2.56-2.56a.5.5 0 0 1 .707 0l.708.706a.5.5 0 0 1 0 .708l-2.561 2.56.92.921a.5.5 0 0 1-.353.854Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcExitFullScreenMedium_default = createIcon(SvgIcExitFullScreenMedium);
function SvgIcExpected(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 18, height: 18, x: 3, y: 3, fill: "#DDD", rx: 6 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            fillRule: "evenodd",
            d: "M9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcExpected_default = createIcon(SvgIcExpected);
function SvgIcExpenseMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.935 5.804c0-.516.418-.935.935-.935h10.26c.517 0 .935.419.935.935V17.87a1.122 1.122 0 0 0-1.264.215l-.6.591-.615-.603a1.122 1.122 0 0 0-1.572 0l-.614.603-.614-.603a1.122 1.122 0 0 0-1.572 0l-.614.603-.614-.603a1.122 1.122 0 0 0-1.572 0l-.614.603-.601-.59a1.122 1.122 0 0 0-1.264-.216V5.804Zm12.023 14.673-.42-.495-.552.542a1.122 1.122 0 0 1-1.572 0l-.614-.604-.614.604a1.122 1.122 0 0 1-1.572 0L12 19.92l-.614.604a1.122 1.122 0 0 1-1.572 0L9.2 19.92l-.614.604a1.122 1.122 0 0 1-1.572 0l-.552-.542-.42.495c-.675.796-1.977.319-1.977-.726V5.804A2.804 2.804 0 0 1 6.87 3h10.26a2.804 2.804 0 0 1 2.805 2.804v13.947c0 1.045-1.302 1.522-1.977.726ZM8 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM11.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4Zm-.5 4.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcExpenseMedium_default = createIcon(SvgIcExpenseMedium);
function SvgIcFeedView(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Zm8 8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Zm-8.5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5ZM11.5 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcFeedView_default = createIcon(SvgIcFeedView);
function SvgIcFilter(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 14, height: 1.5, x: 3, y: 4.25, fill: "#333", rx: 0.75 }),
        /* @__PURE__ */ jsx("rect", { width: 14, height: 1.5, x: 3, y: 9.25, fill: "#333", rx: 0.75 }),
        /* @__PURE__ */ jsx("rect", { width: 14, height: 1.5, x: 3, y: 14.25, fill: "#333", rx: 0.75 }),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M8.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M7 4.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM4.75 5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M14.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M13 9.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M9.5 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8 14.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM5.75 15a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcFilter_default = createIcon(SvgIcFilter);
function SvgIcFilterdeleteXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.419 2.64a.75.75 0 0 0-1.06-1.06l-3.36 3.358L2.642 1.58a.75.75 0 0 0-1.06 1.06L4.938 6 1.58 9.358a.75.75 0 0 0 1.06 1.06L6 7.06l3.358 3.359a.75.75 0 0 0 1.061-1.061L7.06 5.999 10.42 2.64Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcFilterdeleteXsmall_default = createIcon(SvgIcFilterdeleteXsmall);
function SvgIcFirstPage(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15.719 4.456a.906.906 0 0 0-.09-1.189.93.93 0 0 0-1.305 0L8.17 9.354l-.09.103a.906.906 0 0 0 .09 1.189l6.154 6.087.104.088a.93.93 0 0 0 1.201-.088l.09-.103a.906.906 0 0 0-.09-1.189L10.13 10l5.5-5.441.09-.103ZM5 3a.9.9 0 0 0-.9.9v12.2a.9.9 0 1 0 1.8 0V3.9A.9.9 0 0 0 5 3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcFirstPage_default = createIcon(SvgIcFirstPage);
function SvgIcFullScreenMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 18,
            height: 14,
            x: 3,
            y: 5,
            stroke: "#333",
            strokeWidth: 2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#333", d: "M4 14h7a1 1 0 0 1 1 1v3H4v-4Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M14.707 7.5H18a.5.5 0 0 1 .5.5v3.293a.5.5 0 0 1-.854.353l-.957-.957-2.561 2.56a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707l2.56-2.56-.92-.921a.5.5 0 0 1 .353-.854Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcFullScreenMedium_default = createIcon(SvgIcFullScreenMedium);
function SvgIcFullscreen(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.958 3H3v5.194h1.355V5.313L7.47 8.429l.958-.958-3.116-3.116h2.88V3H3.959Zm7.848 1.355h3.84v3.839H17V3h-5.194v1.355Zm-3.612 11.29h-3.84v-3.838H3V17h5.194v-1.355ZM16.042 17h-4.236v-1.355h2.88l-3.115-3.116.958-.958 3.116 3.116v-2.88H17V17h-.958Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcFullscreen_default = createIcon(SvgIcFullscreen);
function SvgIcGps(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          d: "M14.47 4.557a.746.746 0 0 1 .973.973l-4.28 10.505c-.272.667-1.236.6-1.414-.097l-1.046-4.102a.746.746 0 0 0-.539-.54l-4.102-1.045c-.697-.178-.764-1.142-.097-1.414l10.505-4.28Z"
        }
      )
    }
  );
}
var IcGps_default = createIcon(SvgIcGps);
function SvgIcGrade1(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#88D4E2", d: "M4.5 4.5h16v16h-16z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#AAF6FD",
            fillRule: "evenodd",
            d: "m12.5 1.5 11 11-11 11-11-11 11-11Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8BE8F4",
            fillRule: "evenodd",
            d: "m23.5 12.5-11 11-11-11h22Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#C1FAFF",
            fillRule: "evenodd",
            d: "M12.5 1.5v11h-11l11-11Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8C4CF6",
            stroke: "#fff",
            d: "m12.929 7.243-.429-.715-.429.715-3 5-.154.257.154.257 3 5 .429.715.429-.715 3-5 .154-.257-.154-.257-3-5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.5,
            fillRule: "evenodd",
            d: "m12.5 7.5-3 5h3v-5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.25,
            fillRule: "evenodd",
            d: "m12.5 7.5 3 5h-3v-5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.15,
            fillRule: "evenodd",
            d: "m12.5 17.5-3-5h3v5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 23.5, cy: 12.5, r: 1, fill: "#8BE8F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 1.5, cy: 12.5, r: 1, fill: "#8BE8F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 1.5, r: 1, fill: "#8BE8F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 23.5, r: 1, fill: "#8BE8F4" })
      ]
    }
  );
}
var IcGrade1_default = createIcon(SvgIcGrade1);
function SvgIcGrade2(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FC0",
            fillRule: "evenodd",
            d: "m3.6 6.001 5.218 4.667 3.837-6.222 3.815 6.222L21.6 6l-2 12.445h-14L3.6 6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFD933",
            fillRule: "evenodd",
            d: "m12.6 4.536-3.782 6.132L3.6 6.001l2 12.445h7V4.536Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#FC0", d: "M5.6 18.446h14v3h-14z" }),
        /* @__PURE__ */ jsx("path", { fill: "#FF5757", d: "M5.6 21.446h14v1h-14z" }),
        /* @__PURE__ */ jsx("circle", { cx: 3.6, cy: 5.446, r: 1, fill: "#FC0" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.6, cy: 3.6, r: 1, fill: "#FC0" }),
        /* @__PURE__ */ jsx("circle", { cx: 21.399, cy: 5.446, r: 1, fill: "#FC0" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F64C4C",
            stroke: "#FFBA00",
            d: "m9.242 14.64 1.322 1.356-.313 1.924-.165 1.015.9-.497 1.614-.891 1.613.89.9.498-.165-1.015-.313-1.924 1.323-1.357.678-.695-.96-.148-1.811-.278-.813-1.73-.452-.964-.453.963-.814 1.731-1.81.278-.96.148.679.695Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.3,
            fillRule: "evenodd",
            d: "M11.672 13.972 12.6 12v3l-1.508.861.006-.034L9.6 14.29l2.072-.318Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade2_default = createIcon(SvgIcGrade2);
function SvgIcGrade31(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 1H7v5l5.5 3L18 6V1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 1v6.455L12.5 8 11 7.455V1h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 8.5, fill: "#FFD45F" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 5.5, fill: "#FFE458", stroke: "#FFC321" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFBA00",
            d: "M13.426 14.472 12.5 12.5l-.927 1.972-2.073.319 1.498 1.536-.353 2.173 1.855-1.025 1.855 1.025-.353-2.173L15.5 14.79l-2.074-.318Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.3,
            fillRule: "evenodd",
            d: "m9.3 18.664 6.364-6.364A4.5 4.5 0 0 0 9.3 18.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade31_default = createIcon(SvgIcGrade31);
function SvgIcGrade32(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 1H7v5l5.5 3L18 6V1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 1v6.455L12.5 8 11 7.455V1h3Z",
            clipRule: "evenodd",
            opacity: 0.4
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 8.5, fill: "#FFD45F" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 5.5, fill: "#FFE458", stroke: "#FFC321" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.3,
            fillRule: "evenodd",
            d: "m9.3 18.664 6.364-6.364A4.5 4.5 0 0 0 9.3 18.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade32_default = createIcon(SvgIcGrade32);
function SvgIcGrade3(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 0H7v5l5.5 3L18 5V0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 0v6.455L12.5 7 11 6.455V0h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFC321",
            d: "m13.75 4.449 1.708 1.408c.302.25.672.402 1.061.44l2.205.212c.936.09 1.677.83 1.767 1.767l.212 2.204c.038.39.19.76.44 1.062l1.408 1.709a1.964 1.964 0 0 1 0 2.498l-1.408 1.71a1.964 1.964 0 0 0-.44 1.06l-.212 2.205a1.964 1.964 0 0 1-1.767 1.767l-2.205.212c-.39.038-.759.19-1.06.44l-1.71 1.409a1.964 1.964 0 0 1-2.498 0l-1.71-1.41a1.967 1.967 0 0 0-1.06-.439l-2.205-.212a1.964 1.964 0 0 1-1.767-1.767l-.212-2.205c-.038-.39-.19-.759-.44-1.06l-1.408-1.71a1.964 1.964 0 0 1 0-2.498l1.408-1.71c.25-.301.402-.67.44-1.06l.212-2.205c.09-.936.83-1.677 1.767-1.767l2.204-.212c.39-.038.76-.19 1.061-.44l1.71-1.408a1.964 1.964 0 0 1 2.498 0Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 14.5, r: 8.5, fill: "#FFD45F" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 14.5, r: 5.5, fill: "#FFE458", stroke: "#FFC321" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFBA00",
            d: "M13.426 13.472 12.5 11.5l-.927 1.972-2.073.319 1.498 1.536-.353 2.173 1.855-1.025 1.855 1.025-.353-2.173L15.5 13.79l-2.074-.318Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.4,
            fillRule: "evenodd",
            d: "m9.3 17.664 6.364-6.364A4.5 4.5 0 0 0 9.3 17.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade3_default = createIcon(SvgIcGrade3);
function SvgIcGrade41(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 1H7v5l5.5 3L18 6V1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 1v6.455L12.5 8 11 7.455V1h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 8.5, fill: "#E5E5E5" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 5.5, fill: "#F0EFEF", stroke: "#CACACA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#CACACA",
            d: "M13.426 14.472 12.5 12.5l-.927 1.972-2.073.319 1.498 1.536-.353 2.173 1.855-1.025 1.855 1.025-.353-2.173L15.5 14.79l-2.074-.318Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.4,
            fillRule: "evenodd",
            d: "m9.3 18.664 6.364-6.364A4.5 4.5 0 0 0 9.3 18.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade41_default = createIcon(SvgIcGrade41);
function SvgIcGrade42(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 1H7v5l5.5 3L18 6V1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 1v6.455L12.5 8 11 7.455V1h3Z",
            clipRule: "evenodd",
            opacity: 0.4
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 8.5, fill: "#E5E5E5" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 5.5, fill: "#F0EFEF", stroke: "#CACACA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.4,
            fillRule: "evenodd",
            d: "m9.3 18.664 6.364-6.364A4.5 4.5 0 0 0 9.3 18.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade42_default = createIcon(SvgIcGrade42);
function SvgIcGrade4(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 0H7v5l5.5 3L18 5V0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 0v6.455L12.5 7 11 6.455V0h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#DDD",
            d: "m13.75 4.449 1.708 1.408c.302.25.672.402 1.061.44l2.205.212c.936.09 1.677.83 1.767 1.767l.212 2.204c.038.39.19.76.44 1.062l1.408 1.709a1.964 1.964 0 0 1 0 2.498l-1.408 1.71a1.964 1.964 0 0 0-.44 1.06l-.212 2.205a1.964 1.964 0 0 1-1.767 1.767l-2.205.212c-.39.038-.759.19-1.06.44l-1.71 1.409a1.964 1.964 0 0 1-2.498 0l-1.71-1.41a1.967 1.967 0 0 0-1.06-.439l-2.205-.212a1.964 1.964 0 0 1-1.767-1.767l-.212-2.205c-.038-.39-.19-.759-.44-1.06l-1.408-1.71a1.964 1.964 0 0 1 0-2.498l1.408-1.71c.25-.301.402-.67.44-1.06l.212-2.205c.09-.936.83-1.677 1.767-1.767l2.204-.212c.39-.038.76-.19 1.061-.44l1.71-1.408a1.964 1.964 0 0 1 2.498 0Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 14.5, r: 8.5, fill: "#E5E5E5" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 14.5, r: 5.5, fill: "#F0EFEF", stroke: "#C4C4C4" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#C4C4C4",
            d: "M13.426 13.472 12.5 11.5l-.927 1.972-2.073.319 1.498 1.536-.353 2.173 1.855-1.025 1.855 1.025-.353-2.173L15.5 13.79l-2.074-.318Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.4,
            fillRule: "evenodd",
            d: "m9.3 17.664 6.364-6.364A4.5 4.5 0 0 0 9.3 17.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade4_default = createIcon(SvgIcGrade4);
function SvgIcGrade51(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 1H7v5l5.5 3L18 6V1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 1v6.455L12.5 8 11 7.455V1h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 8.5, fill: "#EE9046" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 5.5, fill: "#F9A059", stroke: "#D07731" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#D07731",
            d: "M13.426 14.472 12.5 12.5l-.927 1.972-2.073.319 1.498 1.536-.353 2.173 1.855-1.025 1.855 1.025-.353-2.173L15.5 14.79l-2.074-.318Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.2,
            fillRule: "evenodd",
            d: "m9.3 18.664 6.364-6.364A4.5 4.5 0 0 0 9.3 18.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade51_default = createIcon(SvgIcGrade51);
function SvgIcGrade52(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 1H7v5l5.5 3L18 6V1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.4,
            fillRule: "evenodd",
            d: "M14 1v6.455L12.5 8 11 7.455V1h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 8.5, fill: "#EE9046" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 15.5, r: 5.5, fill: "#F9A059", stroke: "#D07731" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.2,
            fillRule: "evenodd",
            d: "m9.3 18.664 6.364-6.364A4.5 4.5 0 0 0 9.3 18.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade52_default = createIcon(SvgIcGrade52);
function SvgIcGrade5(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M18 0H7v5l5.5 3L18 5V0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14 0v6.455L12.5 7 11 6.455V0h3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#EE9046",
            d: "m13.75 4.449 1.708 1.408c.302.25.672.402 1.061.44l2.205.212c.936.09 1.677.83 1.767 1.767l.212 2.204c.038.39.19.76.44 1.062l1.408 1.709a1.964 1.964 0 0 1 0 2.498l-1.408 1.71a1.964 1.964 0 0 0-.44 1.06l-.212 2.205a1.964 1.964 0 0 1-1.767 1.767l-2.205.212c-.39.038-.759.19-1.06.44l-1.71 1.409a1.964 1.964 0 0 1-2.498 0l-1.71-1.41a1.967 1.967 0 0 0-1.06-.439l-2.205-.212a1.964 1.964 0 0 1-1.767-1.767l-.212-2.205c-.038-.39-.19-.759-.44-1.06l-1.408-1.71a1.964 1.964 0 0 1 0-2.498l1.408-1.71c.25-.301.402-.67.44-1.06l.212-2.205c.09-.936.83-1.677 1.767-1.767l2.204-.212c.39-.038.76-.19 1.061-.44l1.71-1.408a1.964 1.964 0 0 1 2.498 0Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 14.5, r: 8.5, fill: "#F9A059" }),
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 14.5, r: 5.5, fill: "#F9A059", stroke: "#D07731" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#D07731",
            d: "M13.426 13.472 12.5 11.5l-.927 1.972-2.073.319 1.498 1.536-.353 2.173 1.855-1.025 1.855 1.025-.353-2.173L15.5 13.79l-2.074-.318Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillOpacity: 0.2,
            fillRule: "evenodd",
            d: "m9.3 17.664 6.364-6.364A4.5 4.5 0 0 0 9.3 17.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcGrade5_default = createIcon(SvgIcGrade5);
function SvgIcGradeBadge(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M13.659 3.304a.2.2 0 0 0-.351 0l-1.034 1.89a.2.2 0 0 1-.08.08l-1.89 1.034a.2.2 0 0 0 0 .35l1.89 1.034a.2.2 0 0 1 .08.08l1.034 1.89a.2.2 0 0 0 .35 0l1.035-1.89a.2.2 0 0 1 .08-.08l1.89-1.033a.2.2 0 0 0 0-.351l-1.89-1.034a.2.2 0 0 1-.08-.08l-1.034-1.89Zm-5.5 4a.2.2 0 0 0-.351 0l-1.564 2.86a.2.2 0 0 1-.08.08l-2.86 1.564a.2.2 0 0 0 0 .35l2.86 1.565a.2.2 0 0 1 .08.08l1.564 2.86a.2.2 0 0 0 .35 0l1.565-2.86a.2.2 0 0 1 .08-.08l2.86-1.564a.2.2 0 0 0 0-.351l-2.86-1.565a.2.2 0 0 1-.08-.079L8.16 7.304Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcGradeBadge_default = createIcon(SvgIcGradeBadge);
function SvgIcGradientAttendance(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#ic-gradient-attendance_svg__a)", children: [
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 12,
              cy: 12,
              r: 9.75,
              fill: "url(#ic-gradient-attendance_svg__b)",
              stroke: "url(#ic-gradient-attendance_svg__c)",
              strokeWidth: 0.5
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M10.854 11.732A.5.5 0 0 0 11 11.38V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.707a.5.5 0 0 1-.146.354l-2.793 2.793a.5.5 0 0 1-.707 0l-.707-.708a.5.5 0 0 1 0-.707l2.207-2.207Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 5,
              cy: 12,
              r: 1,
              fill: "url(#ic-gradient-attendance_svg__d)"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 12,
              cy: 5,
              r: 1,
              fill: "url(#ic-gradient-attendance_svg__e)"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 12,
              cy: 19,
              r: 1,
              fill: "url(#ic-gradient-attendance_svg__f)"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 18.25,
              cy: 18.25,
              r: 5.25,
              fill: "url(#ic-gradient-attendance_svg__g)",
              stroke: "#F9F9F9",
              strokeWidth: 1.177
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              stroke: "#2D89E4",
              strokeLinecap: "round",
              strokeWidth: 1.333,
              d: "m16.25 17.953 1.302 1.4a.271.271 0 0 0 .397.002L20.25 16.9"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-attendance_svg__b",
              x1: -1.125,
              x2: 12.625,
              y1: -1.125,
              y2: 12.625,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#D6E9FB" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#3693ED" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-attendance_svg__c",
              x1: 12,
              x2: 12,
              y1: 2,
              y2: 22,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff", stopOpacity: 0.3 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopOpacity: 0.2 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-attendance_svg__d",
              x1: 3.688,
              x2: 5.333,
              y1: 10.688,
              y2: 12.333,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#EAF5FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#B4DAFF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-attendance_svg__e",
              x1: 10.688,
              x2: 12.333,
              y1: 3.688,
              y2: 5.333,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#EAF5FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#B4DAFF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-attendance_svg__f",
              x1: 10.688,
              x2: 12.333,
              y1: 17.688,
              y2: 19.333,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#9ECEFD" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#52A4F4" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-attendance_svg__g",
              x1: 13,
              x2: 23.631,
              y1: 12.934,
              y2: 23.566,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#EAF5FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#84C2FC" })
              ]
            }
          ),
          /* @__PURE__ */ jsx("clipPath", { id: "ic-gradient-attendance_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
        ] })
      ]
    }
  );
}
var IcGradientAttendance_default = createIcon(SvgIcGradientAttendance);
function SvgIcGradientBoard(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14.34,
            height: 15.45,
            fill: "url(#ic-gradient-board_svg__a)",
            fillOpacity: 0.7,
            rx: 2,
            transform: "matrix(.99027 .13917 -.13523 .99081 4.34 3.5)"
          }
        ),
        /* @__PURE__ */ jsxs("g", { filter: "url(#ic-gradient-board_svg__b)", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "url(#ic-gradient-board_svg__c)",
              d: "M5.74 7.5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-12Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#4272CE",
              d: "M5.74 5.5h14-14Zm14 14a2.29 2.29 0 0 1-2.291 2.29h-9.42a2.29 2.29 0 0 1-2.29-2.29c0 .944.896 1.71 2 1.71h10c1.105 0 2-.766 2-1.71Zm-14 2v-16 16Zm14-16v16-16Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 1,
            height: 4.7,
            fill: "url(#ic-gradient-board_svg__d)",
            rx: 0.5,
            transform: "matrix(.7071 -.7071 -.69678 -.71729 19.55 10.5)"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 1, x: 7.739, y: 11, fill: "#8092AA", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 7, height: 1, x: 7.739, y: 13, fill: "#8092AA", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 4, height: 2, x: 7.739, y: 8, fill: "#3299FE", rx: 1 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 1.13,
            height: 3.61,
            fill: "url(#ic-gradient-board_svg__e)",
            rx: 0.565,
            transform: "matrix(.7071 .7071 -.69678 .71729 18.74 4.5)"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 19.739,
            cy: 4.5,
            r: 2,
            fill: "url(#ic-gradient-board_svg__f)"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-board_svg__a",
              x1: 2.689,
              x2: 14.489,
              y1: -2.272,
              y2: 15.35,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#0688FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#0057FF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-board_svg__c",
              x1: 8.364,
              x2: 20.844,
              y1: 3.147,
              y2: 20.715,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.552, stopColor: "#F8FAFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.963, stopColor: "#DDE9FF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-board_svg__d",
              x1: -0.108,
              x2: 1.654,
              y1: 4.77,
              y2: 1.478,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopOpacity: 0.3 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-board_svg__e",
              x1: -0.662,
              x2: 2.103,
              y1: 1.805,
              y2: 2.3,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#8E8E8E" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4B4B4B" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "radialGradient",
            {
              id: "ic-gradient-board_svg__f",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(1.5 2 -2 1.5 19.74 4.5)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#548EFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.766, stopColor: "#226DFF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "ic-gradient-board_svg__b",
              width: 17.636,
              height: 19.927,
              x: 3.921,
              y: 3.455,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: -0.227 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 0.909 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.458056 0 0 0 0 0.57715 0 0 0 0 0.808333 0 0 0 1 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_4513"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_4513",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientBoard_default = createIcon(SvgIcGradientBoard);
function SvgIcGradientDisplay(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-gradient-display_svg__b",
            width: 16,
            height: 19,
            x: 4,
            y: 2,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4 2h16v19H4z" }),
              /* @__PURE__ */ jsx("path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2h11A2.5 2.5 0 0 1 20 4.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-13Z" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-display_svg__a)",
            d: "M4 4.5A2.5 2.5 0 0 1 6.5 2h11A2.5 2.5 0 0 1 20 4.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-13Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#6D78CD",
            d: "M4 2h16H4Zm16 15.5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3c0 1.105 1.12 2 2.5 2h11c1.38 0 2.5-.895 2.5-2ZM4 20V2v18ZM20 2v18V2Z",
            mask: "url(#ic-gradient-display_svg__b)"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-display_svg__c)",
            d: "M5 6.5A1.5 1.5 0 0 1 6.5 5h11A1.5 1.5 0 0 1 19 6.5v2a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 8.5v-2Z",
            opacity: 0.8
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-display_svg__d)",
            d: "M5 13.5A1.5 1.5 0 0 1 6.5 12h11a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 15.5v-2Z",
            opacity: 0.8
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6,
            height: 3,
            fill: "url(#ic-gradient-display_svg__e)",
            rx: 0.5,
            transform: "matrix(-1 0 0 1 14 6.5)"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 2,
            height: 3,
            fill: "url(#ic-gradient-display_svg__f)",
            rx: 0.5,
            transform: "matrix(-1 0 0 1 10 13.5)"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 5,
            height: 3,
            fill: "url(#ic-gradient-display_svg__g)",
            rx: 0.5,
            transform: "matrix(-1 0 0 1 16 13.5)"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-display_svg__a",
              x1: 4,
              x2: 21.897,
              y1: 2,
              y2: 17.86,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#C7E3FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#8A97E0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-display_svg__c",
              x1: 5,
              x2: 8.054,
              y1: 5.938,
              y2: 14.097,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#2C2C2C" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#626262" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-display_svg__d",
              x1: 5,
              x2: 8.054,
              y1: 12.938,
              y2: 21.097,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#2C2C2C" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#626262" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-display_svg__e",
              x1: 3,
              x2: 3,
              y1: 0,
              y2: 3,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E4EDFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#AAB8D2" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-display_svg__f",
              x1: 1,
              x2: 1,
              y1: 0,
              y2: 3,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E4EDFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#AAB8D2" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-display_svg__g",
              x1: 2.5,
              x2: 2.5,
              y1: 0,
              y2: 3,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E4EDFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#AAB8D2" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientDisplay_default = createIcon(SvgIcGradientDisplay);
function SvgIcGradientDoc(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-doc_svg__a)",
            d: "M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-doc_svg__b)",
            stroke: "#C3C3C3",
            strokeWidth: 0.5,
            d: "M7 4.25h8.5A3.75 3.75 0 0 1 19.25 8v9.5A2.25 2.25 0 0 1 17 19.75H7a2.25 2.25 0 0 1-2.25-2.25v-11A2.25 2.25 0 0 1 7 4.25Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "url(#ic-gradient-doc_svg__c)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 13.999c3.75-.996 5.625-6.475 3.75-6.973-2.067-.549-2.034 7.69.75 6.473 1-.438 2.5-2 2.5-2s-.552 1.447 0 2c.5.5 1.5.001 2.5-.999"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 4, height: 1, x: 6, y: 16, fill: "#D9D9D9", rx: 0.5 }),
        /* @__PURE__ */ jsx("path", { fill: "#C3C3C3", d: "M15.5 4a4 4 0 0 1 4 4h-3a1 1 0 0 1-1-1V4Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M19 16v-4.5l2-2v6l-2 2V16Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-doc_svg__d)",
            d: "M15.947 16.384a1 1 0 0 1 .278-.538l5.493-5.492a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707L17.64 17.26a1 1 0 0 1-.538.279l-1.045.18a.25.25 0 0 1-.289-.29l.18-1.045Z"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-doc_svg__a",
              x1: 3,
              x2: 21.027,
              y1: 3,
              y2: 20.972,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#9E9E9E" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#434343" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-doc_svg__b",
              x1: 4.5,
              x2: 19.293,
              y1: 7,
              y2: 20.232,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFFBF4" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-doc_svg__c",
              x1: 7.5,
              x2: 15,
              y1: 5,
              y2: 16,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#A4A4A4" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#595959" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-doc_svg__d",
              x1: 17.651,
              x2: 18.988,
              y1: 15.192,
              y2: 16.171,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#666" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#222" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientDoc_default = createIcon(SvgIcGradientDoc);
function SvgIcGradientGps(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { clipPath: "url(#ic-gradient-gps_svg__a)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-gps_svg__b)",
            d: "M18.541 4.081c.867-.353 1.731.511 1.378 1.378l-6.064 14.883c-.384.944-1.75.85-2.003-.138l-1.481-5.812a1.057 1.057 0 0 0-.763-.763l-5.812-1.481c-.988-.252-1.082-1.619-.138-2.003L18.541 4.08Z"
          }
        ) }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-gps_svg__b",
              x1: 0,
              x2: 20,
              y1: 1,
              y2: 21,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#406588", stopOpacity: 0.32 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#35485B" })
              ]
            }
          ),
          /* @__PURE__ */ jsx("clipPath", { id: "ic-gradient-gps_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
        ] })
      ]
    }
  );
}
var IcGradientGps_default = createIcon(SvgIcGradientGps);
function SvgIcGradientInventory(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-inventory_svg__a)",
            d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5V6Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-inventory_svg__b)",
            d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18V6Z"
          }
        ),
        /* @__PURE__ */ jsxs("g", { opacity: 0.3, children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "url(#ic-gradient-inventory_svg__c)",
              fillOpacity: 0.8,
              d: "M15 16h4v2h-4v-2Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              stroke: "url(#ic-gradient-inventory_svg__d)",
              strokeOpacity: 0.2,
              strokeWidth: 0.458,
              d: "M15.23 16.23h3.54v1.54h-3.54v-1.54Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-inventory_svg__e)",
            fillOpacity: 0.8,
            d: "M10 5h4v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "url(#ic-gradient-inventory_svg__f)",
            strokeOpacity: 0.2,
            strokeWidth: 0.458,
            d: "M10.23 5.23h3.54V11a.77.77 0 0 1-.77.77h-2a.77.77 0 0 1-.77-.77V5.23Z"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-inventory_svg__a",
              x1: 8,
              x2: 15.035,
              y1: 0.5,
              y2: 23.489,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E6B977" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D6A163" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-inventory_svg__b",
              x1: 8,
              x2: 13.335,
              y1: 2.847,
              y2: 23.092,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#FFE091" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.526, stopColor: "#EFB759" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.804, stopColor: "#FDB850" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#EAD87A" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-inventory_svg__c",
              x1: 15,
              x2: 16.53,
              y1: 16.375,
              y2: 19.294,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#666" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#303030" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-inventory_svg__d",
              x1: 17,
              x2: 17,
              y1: 16,
              y2: 18,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", {}),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#959595" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-inventory_svg__e",
              x1: 10,
              x2: 15.474,
              y1: 6.313,
              y2: 9.297,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#666" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#303030" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-inventory_svg__f",
              x1: 12,
              x2: 12,
              y1: 5,
              y2: 12,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#CAC598" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientInventory_default = createIcon(SvgIcGradientInventory);
function SvgIcGradientJp(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#ic-gradient-jp_svg__a)", children: [
          /* @__PURE__ */ jsx("g", { filter: "url(#ic-gradient-jp_svg__b)", children: /* @__PURE__ */ jsx("ellipse", { cx: 12, cy: 21.5, fill: "#CCC", rx: 4, ry: 1.5 }) }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "url(#ic-gradient-jp_svg__c)",
              d: "M21 9.67c0 7.076-6.974 11.255-8.633 12.149a.733.733 0 0 1-.703 0C10.001 20.927 3 16.753 3 9.67 3 4.881 7.03 1 12 1s9 3.881 9 8.67Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 12,
              cy: 10,
              r: 6,
              fill: "#fff",
              stroke: "url(#ic-gradient-jp_svg__d)",
              strokeWidth: 0.5
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              stroke: "#17706F",
              strokeLinecap: "round",
              strokeWidth: 1.5,
              d: "m9.5 10.184 1.719 1.665a.226.226 0 0 0 .313 0L14.5 9"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-jp_svg__c",
              x1: 5.652,
              x2: 13.123,
              y1: -3.011,
              y2: 22.354,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.09, stopColor: "#63E7C6" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.873, stopColor: "#3EAE92" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4DC9AA" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-jp_svg__d",
              x1: 8.063,
              x2: 16.5,
              y1: 4,
              y2: 17.875,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#53A5A3" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#7EDCC5" })
              ]
            }
          ),
          /* @__PURE__ */ jsx("clipPath", { id: "ic-gradient-jp_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "ic-gradient-jp_svg__b",
              width: 11,
              height: 6,
              x: 6.5,
              y: 18.5,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx("feBlend", { in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                /* @__PURE__ */ jsx(
                  "feGaussianBlur",
                  {
                    result: "effect1_foregroundBlur_286_4543",
                    stdDeviation: 0.75
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientJp_default = createIcon(SvgIcGradientJp);
function SvgIcGradientMobile(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-mobile_svg__a)",
            d: "M5 19h14v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14,
            height: 19,
            x: 5,
            y: 2,
            fill: "url(#ic-gradient-mobile_svg__b)",
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#EAF5FF",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "m9 10.579 2.085 2.244c.09.096.241.096.33 0L15 9"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6,
            height: 1.5,
            x: 9,
            y: 3.5,
            fill: "#4C6882",
            opacity: 0.4,
            rx: 0.5
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-mobile_svg__a",
              x1: 5,
              x2: 5.504,
              y1: 19,
              y2: 23.509,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#7FAFDA", stopOpacity: 0.88 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#557694" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-mobile_svg__b",
              x1: 5.5,
              x2: 24.176,
              y1: 3,
              y2: 30.451,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#A1CDF5" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#6789AB" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientMobile_default = createIcon(SvgIcGradientMobile);
function SvgIcGradientNotice(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-notice_svg__a)",
            d: "M7.9 12.888a1.5 1.5 0 0 1 1.838 1.06l1.553 5.796a1.5 1.5 0 0 1-2.898.777L6.84 14.725a1.5 1.5 0 0 1 1.06-1.837Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-notice_svg__b)",
            d: "M17.5 8.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-notice_svg__c)",
            d: "M4 9.3a3 3 0 0 1 3-3v9a3 3 0 0 1-3-3v-3Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-notice_svg__d)",
            d: "M7 6.333 16 4v14l-9-2.722V6.333Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-notice_svg__e)",
            d: "M16 18V4l-1 .26V17.7l1 .3Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-notice_svg__f)",
            d: "M16 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V4Z"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-notice_svg__a",
              x1: 9.631,
              x2: 6.961,
              y1: 16.448,
              y2: 21.159,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#0881F8" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.286, stopColor: "#2592FD" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#0F85F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-notice_svg__b",
              x1: 16.667,
              x2: 20.833,
              y1: 9.125,
              y2: 11.625,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#0680F8" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#3299FE" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-notice_svg__c",
              x1: 5.5,
              x2: 5.5,
              y1: 6.3,
              y2: 15.3,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.088, stopColor: "#057FF7" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.579, stopColor: "#2F98FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#057FF7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-notice_svg__d",
              x1: 11.109,
              x2: 11.535,
              y1: 4.389,
              y2: 17.999,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#CCE5FD" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.483, stopColor: "#D0E3FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#A6D1FD" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-notice_svg__e",
              x1: 15.5,
              x2: 15.5,
              y1: 3.417,
              y2: 18,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff", stopOpacity: 0.2 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.349, stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#fff", stopOpacity: 0.2 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-notice_svg__f",
              x1: 16.889,
              x2: 17.037,
              y1: 5.615,
              y2: 18.5,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#CDE5FE" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.531, stopColor: "#DFEDFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#AED5FE" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientNotice_default = createIcon(SvgIcGradientNotice);
function SvgIcGradientOvertime(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 12,
            cy: 12,
            r: 9.75,
            fill: "url(#ic-gradient-overtime_svg__a)",
            stroke: "url(#ic-gradient-overtime_svg__b)",
            strokeWidth: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M10.854 11.732A.5.5 0 0 0 11 11.38V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.707a.5.5 0 0 1-.146.354l-2.793 2.793a.5.5 0 0 1-.707 0l-.707-.708a.5.5 0 0 1 0-.707l2.207-2.207Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 5, cy: 12, r: 1, fill: "url(#ic-gradient-overtime_svg__c)" }),
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 5, r: 1, fill: "url(#ic-gradient-overtime_svg__d)" }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 12,
            cy: 19,
            r: 1,
            fill: "url(#ic-gradient-overtime_svg__e)",
            fillOpacity: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 18.25,
            cy: 18.25,
            r: 5.25,
            fill: "url(#ic-gradient-overtime_svg__f)",
            stroke: "#F9F9F9",
            strokeWidth: 1.177
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#2D5274",
            fillRule: "evenodd",
            d: "M16.16 17.998a.5.5 0 0 1 0-.707l1.681-1.682a.5.5 0 0 1 .707 0l1.687 1.686a.5.5 0 0 1 0 .707l-.01.01a.5.5 0 0 1-.707 0l-.804-.805V20.5a.5.5 0 0 1-.5.5h-.069a.5.5 0 0 1-.5-.5v-3.263l-.77.77a.5.5 0 0 1-.707 0l-.009-.01Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-overtime_svg__a",
              x1: 2.5,
              x2: 15,
              y1: -7,
              y2: 15.5,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#BFD4ED" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#426F9A" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-overtime_svg__b",
              x1: 12,
              x2: 12,
              y1: 2,
              y2: 22,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff", stopOpacity: 0.3 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopOpacity: 0.2 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-overtime_svg__c",
              x1: 3.688,
              x2: 5.333,
              y1: 10.688,
              y2: 12.333,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D3D3D3" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-overtime_svg__d",
              x1: 10.688,
              x2: 12.333,
              y1: 3.688,
              y2: 5.333,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D3D3D3" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-overtime_svg__e",
              x1: 10.688,
              x2: 12.333,
              y1: 17.688,
              y2: 19.333,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0.224, stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D3D3D3" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-overtime_svg__f",
              x1: 13,
              x2: 23.631,
              y1: 12.934,
              y2: 23.566,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#F1F1F1" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#A4AEBE" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientOvertime_default = createIcon(SvgIcGradientOvertime);
function SvgIcGradientPrice(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("mask", { id: "ic-gradient-price_svg__c", fill: "#fff", children: /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M7.642 3.97A3.12 3.12 0 0 1 9.95 2.435l5.823-.74a3.113 3.113 0 0 1 3.264 1.885l2.271 5.413a3.119 3.119 0 0 1-.175 2.766L16.68 19.47a4.675 4.675 0 0 1-6.386 1.714L4.9 18.07A4.675 4.675 0 0 1 3.19 11.68l4.452-7.71Zm7.352 3.651a1.285 1.285 0 1 0 0-2.57 1.285 1.285 0 0 0 0 2.57Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-price_svg__a)",
            fillRule: "evenodd",
            d: "M7.642 3.97A3.12 3.12 0 0 1 9.95 2.435l5.823-.74a3.113 3.113 0 0 1 3.264 1.885l2.271 5.413a3.119 3.119 0 0 1-.175 2.766L16.68 19.47a4.675 4.675 0 0 1-6.386 1.714L4.9 18.07A4.675 4.675 0 0 1 3.19 11.68l4.452-7.71Zm7.352 3.651a1.285 1.285 0 1 0 0-2.57 1.285 1.285 0 0 0 0 2.57Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-price_svg__b)",
            d: "m9.95 2.435.063.496-.063-.496ZM7.642 3.97l.433.25-.433-.25Zm8.131-2.274L15.71 1.2l.063.496Zm3.264 1.884-.461.194.46-.194Zm2.271 5.413-.46.193.46-.193Zm-.175 2.766-.433-.25.433.25ZM16.68 19.47l.433.25-.433-.25Zm-6.386 1.714.25-.433-.25.433ZM4.9 18.07l-.25.433.25-.433ZM3.19 11.68l.433.25-.433-.25Zm13.09-5.345h-.5.5Zm-1.286-1.285v-.5.5ZM9.887 1.939A3.62 3.62 0 0 0 7.21 3.72l.866.5a2.62 2.62 0 0 1 1.938-1.289l-.126-.992Zm5.823-.74-5.823.74.126.992 5.823-.74-.126-.991Zm3.788 2.188A3.613 3.613 0 0 0 15.71 1.2l.126.992a2.613 2.613 0 0 1 2.74 1.582l.922-.387Zm2.271 5.412-2.271-5.412-.922.387 2.271 5.412.922-.387Zm-.203 3.21a3.62 3.62 0 0 0 .203-3.21l-.922.387a2.62 2.62 0 0 1-.147 2.323l.866.5Zm-4.452 7.711 4.452-7.71-.866-.5-4.452 7.71.866.5Zm-7.069 1.897a5.175 5.175 0 0 0 7.07-1.897l-.867-.5a4.175 4.175 0 0 1-5.703 1.531l-.5.866ZM4.65 18.502l5.396 3.115.5-.866-5.396-3.115-.5.866Zm-1.892-7.07a5.175 5.175 0 0 0 1.892 7.07l.5-.866a4.175 4.175 0 0 1-1.526-5.705l-.866-.5ZM7.21 3.72l-4.452 7.711.866.5 4.452-7.71-.866-.5Zm8.57 2.616a.785.785 0 0 1-.785.785v1c.986 0 1.785-.799 1.785-1.785h-1Zm-.785-.785c.434 0 .785.351.785.785h1c0-.986-.799-1.785-1.785-1.785v1Zm-.785.785c0-.434.351-.785.785-.785v-1c-.986 0-1.785.799-1.785 1.785h1Zm.785.785a.785.785 0 0 1-.785-.785h-1c0 .986.799 1.785 1.785 1.785v-1Z",
            mask: "url(#ic-gradient-price_svg__c)"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-price_svg__d)",
            fillRule: "evenodd",
            d: "M11.444 10.418a1.174 1.174 0 1 1-2.347 0 1.174 1.174 0 0 1 2.347 0Zm1.741 5.682a1.174 1.174 0 1 1-2.347 0 1.174 1.174 0 0 1 2.347 0Zm-4.898-2.887a.783.783 0 0 0 .405 1.512l5.292-1.418a.782.782 0 1 0-.405-1.512l-5.292 1.418Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-price_svg__a",
              x1: 7.202,
              x2: 19.275,
              y1: 1.029,
              y2: 23.228,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#86EFDC" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#6DBBA8" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-price_svg__b",
              x1: 13.341,
              x2: 13.823,
              y1: -0.55,
              y2: 23.572,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff", stopOpacity: 0.25 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#41ACAB" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-price_svg__d",
              x1: 11.136,
              x2: 11.136,
              y1: 9.244,
              y2: 17.273,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#17706F" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#208684" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientPrice_default = createIcon(SvgIcGradientPrice);
function SvgIcGradientReport(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-report_svg__a)",
            d: "M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 19.5v-13Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#395F77",
            d: "M4 4h16H4Zm16 15.5a2.875 2.875 0 0 1-2.875 2.875H6.875A2.875 2.875 0 0 1 4 19.5c0 1.173 1.12 2.125 2.5 2.125h11c1.38 0 2.5-.952 2.5-2.125ZM4 22V4v18ZM20 4v18V4Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-report_svg__b)",
            d: "M6 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#B6C8D3",
            d: "M6 5h12H6Zm12 12c0 1.22-.99 2.21-2.21 2.21H8.21A2.21 2.21 0 0 1 6 17c0 .988.895 1.79 2 1.79h8c1.105 0 2-.802 2-1.79ZM6 19V5v14ZM18 5v14V5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6,
            height: 2.5,
            x: 9,
            y: 3,
            fill: "url(#ic-gradient-report_svg__c)",
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            fillRule: "evenodd",
            d: "M8.5 8.5A.5.5 0 0 1 9 8h6a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Zm0 2A.5.5 0 0 1 9 10h6a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5ZM9 12a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H9Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-report_svg__a",
              x1: 12,
              x2: 20.733,
              y1: 0.062,
              y2: 21.704,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#5291CC" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#1864AC" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-report_svg__b",
              x1: 12,
              x2: 18.971,
              y1: 1.938,
              y2: 18.594,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.62, stopColor: "#F8FAFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D9E2EB" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-report_svg__c",
              x1: 12,
              x2: 12.765,
              y1: 3,
              y2: 6.059,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#6291BD" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#346089" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientReport_default = createIcon(SvgIcGradientReport);
function SvgIcGradientSales(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-gradient-sales_svg__b",
            width: 18,
            height: 19,
            x: 3,
            y: 3,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M3 3h18v19H3z" }),
              /* @__PURE__ */ jsx("path", { d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13Z" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-sales_svg__a)",
            d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#658FB4",
            d: "M3 3h18H3Zm18 15.5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3c0 1.105 1.12 2 2.5 2h13c1.38 0 2.5-.895 2.5-2ZM3 21V3v18ZM21 3v18V3Z",
            mask: "url(#ic-gradient-sales_svg__b)"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-sales_svg__c)",
            d: "M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "url(#ic-gradient-sales_svg__d)",
            strokeOpacity: 0.2,
            strokeWidth: 0.458,
            d: "M4.23 7c0-.978.792-1.77 1.77-1.77h12c.978 0 1.77.792 1.77 1.77v10A1.77 1.77 0 0 1 18 18.77H6A1.77 1.77 0 0 1 4.23 17V7Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            fillRule: "evenodd",
            d: "M16.5 12a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1ZM13 14.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2Zm-3 1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-sales_svg__e)",
            fillRule: "evenodd",
            d: "M16.28 7.25a.234.234 0 0 0-.25-.25l-3.12.224a.234.234 0 0 0-.15.399l.994.994-2.598 2.598L9.832 9.89a.676.676 0 0 0-.956 0l-3.153 3.153.955.956 2.676-2.676 1.324 1.325a.676.676 0 0 0 .956 0l3.076-3.077.947.948a.234.234 0 0 0 .4-.149l.224-3.121Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-sales_svg__a",
              x1: 3,
              x2: 21.027,
              y1: 3,
              y2: 20.972,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#9ABFE0" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#769EC7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-sales_svg__c",
              x1: 4,
              x2: 16.976,
              y1: 7.625,
              y2: 21.773,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFFBF4" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-sales_svg__d",
              x1: 12,
              x2: 12,
              y1: 5,
              y2: 19,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#98BBCA" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-sales_svg__e",
              x1: 9.242,
              x2: 12.762,
              y1: 4.652,
              y2: 11.692,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#96CBFF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#3378FF" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientSales_default = createIcon(SvgIcGradientSales);
function SvgIcGradientSchedule(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-gradient-schedule_svg__b",
            width: 18,
            height: 19,
            x: 3,
            y: 3,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M3 3h18v19H3z" }),
              /* @__PURE__ */ jsx("path", { d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13Z" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-schedule_svg__a)",
            d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            d: "M3 3h18H3Zm18 15.5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3c0 1.105 1.12 2 2.5 2h13c1.38 0 2.5-.895 2.5-2ZM3 21V3v18ZM21 3v18V3Z",
            mask: "url(#ic-gradient-schedule_svg__b)"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-schedule_svg__c)",
            d: "M4 5.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 .75.75v12.375c0 1.035-.84 1.875-1.875 1.875H5.875A1.875 1.875 0 0 1 4 17.625V5.25Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "url(#ic-gradient-schedule_svg__d)",
            strokeOpacity: 0.2,
            strokeWidth: 0.375,
            d: "M4.188 5.25c0-.31.251-.563.562-.563h14.5c.31 0 .563.252.563.563v12.375c0 .932-.756 1.688-1.688 1.688H5.875a1.687 1.687 0 0 1-1.688-1.688V5.25Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-schedule_svg__e)",
            d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5V8H3V5.5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 7.75,
            cy: 5.75,
            r: 0.75,
            fill: "#fff",
            stroke: "url(#ic-gradient-schedule_svg__f)",
            strokeWidth: 0.188
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 16.25,
            cy: 5.75,
            r: 0.75,
            fill: "#fff",
            stroke: "url(#ic-gradient-schedule_svg__g)",
            strokeWidth: 0.188
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-schedule_svg__h)",
            fillRule: "evenodd",
            d: "M8 10.375c0-.207.168-.375.375-.375h1.25c.207 0 .375.168.375.375v1.25a.375.375 0 0 1-.375.375h-1.25A.375.375 0 0 1 8 11.625v-1.25Zm0 3c0-.207.168-.375.375-.375h1.25c.207 0 .375.168.375.375v1.25a.375.375 0 0 1-.375.375h-1.25A.375.375 0 0 1 8 14.625v-1.25ZM11.375 10a.375.375 0 0 0-.375.375v1.25c0 .207.168.375.375.375h1.25a.375.375 0 0 0 .375-.375v-1.25a.375.375 0 0 0-.375-.375h-1.25ZM11 13.375c0-.207.168-.375.375-.375h1.25c.207 0 .375.168.375.375v1.25a.375.375 0 0 1-.375.375h-1.25a.375.375 0 0 1-.375-.375v-1.25ZM14.375 13a.375.375 0 0 0-.375.375v1.25c0 .207.168.375.375.375h1.25a.375.375 0 0 0 .375-.375v-1.25a.375.375 0 0 0-.375-.375h-1.25Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 2, x: 14, y: 10, fill: "#8092AA", rx: 0.375 }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__a",
              x1: 3,
              x2: 21.027,
              y1: 3,
              y2: 20.972,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#D0DBE6" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#B0BCC8" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__c",
              x1: 4,
              x2: 17.953,
              y1: 7.313,
              y2: 21.512,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFFBF4" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__d",
              x1: 12,
              x2: 12,
              y1: 4.5,
              y2: 19.5,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#CAC598" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__e",
              x1: 10.929,
              x2: 11.944,
              y1: 3,
              y2: 8.011,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#FFDE62" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFBD0C" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__f",
              x1: 7.188,
              x2: 8.5,
              y1: 4.813,
              y2: 6.688,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#FFC700" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFEBB6" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__g",
              x1: 15.688,
              x2: 17,
              y1: 4.813,
              y2: 6.688,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#FFC700" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFEBB6" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-schedule_svg__h",
              x1: 9.75,
              x2: 12,
              y1: 9.188,
              y2: 15.75,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#97AFC4" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#C1D0DE" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientSchedule_default = createIcon(SvgIcGradientSchedule);
function SvgIcGradientStaff(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-staff_svg__a)",
            d: "M16.286 7.235c0 2.34-1.92 4.236-4.286 4.236-2.367 0-4.286-1.897-4.286-4.236C7.714 4.896 9.634 3 12 3c2.367 0 4.286 1.896 4.286 4.235Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-staff_svg__b)",
            d: "M4.5 18.214c0-3.14 2.558-5.685 5.714-5.685h3.572c3.156 0 5.714 2.545 5.714 5.685v.891A1.9 1.9 0 0 1 17.595 21H6.405A1.9 1.9 0 0 1 4.5 19.105v-.891Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-staff_svg__c)",
            d: "M4.5 18.088c0-3.07 2.502-5.559 5.588-5.559h3.824c3.086 0 5.588 2.49 5.588 5.56a1.858 1.858 0 0 1-1.863 1.852H6.363A1.858 1.858 0 0 1 4.5 18.088Z"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-staff_svg__a",
              x1: 4.5,
              x2: 22.4,
              y1: 1.875,
              y2: 17.724,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#9ABFE0" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.719, stopColor: "#76A1C7" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#93B7FF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-staff_svg__b",
              x1: 6.844,
              x2: 21.982,
              y1: 3,
              y2: 5.972,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#76A1C7" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#658FB4" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-staff_svg__c",
              x1: 12,
              x2: 13.861,
              y1: 10.588,
              y2: 22.83,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#9ABFE0" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.922, stopColor: "#769EC7" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientStaff_default = createIcon(SvgIcGradientStaff);
function SvgIcGradientTarget(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12.5, r: 10, fill: "#4F5DC8" }),
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 10, fill: "url(#ic-gradient-target_svg__a)" }),
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 7.5, fill: "url(#ic-gradient-target_svg__b)" }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 12,
            cy: 12,
            r: 5,
            fill: "url(#ic-gradient-target_svg__c)",
            opacity: 0.8
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 11.751, r: 1.75, fill: "#4C5BD1" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-target_svg__d)",
            d: "M15.137 15.673c.192.198.507.2.702.005l.714-.714a.509.509 0 0 0 .013-.705l-3.311-3.555a.983.983 0 0 0-1.374-.068l-.085.075a1.017 1.017 0 0 0-.055 1.467l3.396 3.495Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-target_svg__e)",
            fillRule: "evenodd",
            d: "M18.657 2.564a.218.218 0 0 0-.06.197l.187.935-7.177 7.177a.873.873 0 0 0 1.235 1.235l7.193-7.193.894.179a.218.218 0 0 0 .198-.06l1.326-1.327a.218.218 0 0 0-.076-.358l-1.38-.53a.219.219 0 0 1-.125-.126l-.53-1.38a.218.218 0 0 0-.359-.076l-1.326 1.327Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-target_svg__a",
              x1: 4.727,
              x2: 20.182,
              y1: 3.818,
              y2: 20.637,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#96A0EE" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#6773CF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-target_svg__b",
              x1: 10.333,
              x2: 19.917,
              y1: 9.495,
              y2: 21.167,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.691, stopColor: "#CFDEEC" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#fff" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-target_svg__d",
              x1: 10.781,
              x2: 15.694,
              y1: 11.5,
              y2: 13.788,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopOpacity: 0.3 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-target_svg__e",
              x1: 16.894,
              x2: 21.259,
              y1: 2.942,
              y2: 7.747,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#8593FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 0.849, stopColor: "#4251C5" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#98A0DD" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "radialGradient",
            {
              id: "ic-gradient-target_svg__c",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "rotate(54.462 -4.665 15.611) scale(7.16858 7.16859)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#7391FC" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#6773CF" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientTarget_default = createIcon(SvgIcGradientTarget);
function SvgIcGradientTodo(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-gradient-todo_svg__b",
            width: 16,
            height: 19,
            x: 4,
            y: 3,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4 3h16v19H4z" }),
              /* @__PURE__ */ jsx("path", { d: "M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 18.5v-13Z" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-todo_svg__a)",
            d: "M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 18.5v-13Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#5C68C9",
            d: "M4 3h16H4Zm16 15.5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3c0 1.105 1.12 2 2.5 2h11c1.38 0 2.5-.895 2.5-2ZM4 21V3v18ZM20 3v18V3Z",
            mask: "url(#ic-gradient-todo_svg__b)"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-todo_svg__c)",
            d: "M5.5 7a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V7Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "url(#ic-gradient-todo_svg__d)",
            strokeOpacity: 0.2,
            strokeWidth: 0.5,
            d: "M5.75 7c0-.966.784-1.75 1.75-1.75h9c.966 0 1.75.784 1.75 1.75v3a1.75 1.75 0 0 1-1.75 1.75h-9A1.75 1.75 0 0 1 5.75 10V7Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#61647C",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "m8 8.237 1.323 1.335a.25.25 0 0 0 .355 0L12 7.25"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-todo_svg__e)",
            fillRule: "evenodd",
            d: "M6 14a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1A.5.5 0 0 0 7 14H6Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H9Zm-.5 3.5A.5.5 0 0 1 9 17h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-1ZM6 17a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1A.5.5 0 0 0 7 17H6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-todo_svg__a",
              x1: 0,
              x2: 13.111,
              y1: 1.2,
              y2: 10.42,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#EFF1FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#6773CF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-todo_svg__c",
              x1: 5.5,
              x2: 11.075,
              y1: 6.313,
              y2: 16.191,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#EFF1FF" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-todo_svg__d",
              x1: 12,
              x2: 12,
              y1: 5,
              y2: 12,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#98B7CA" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-todo_svg__e",
              x1: 5,
              x2: 27.5,
              y1: 13,
              y2: 24.5,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#A8B0E5" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcGradientTodo_default = createIcon(SvgIcGradientTodo);
function SvgIcGradientWifi(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { clipPath: "url(#ic-gradient-wifi_svg__a)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-wifi_svg__b)",
            fillRule: "evenodd",
            d: "M21.87 8.973a.488.488 0 0 0 0-.67C19.318 5.64 15.84 4 12.005 4c-3.838 0-7.32 1.643-9.871 4.312a.488.488 0 0 0 0 .67l1.137 1.224c.2.216.542.212.748 0C6.1 8.08 8.91 6.775 12.005 6.775c3.091 0 5.9 1.302 7.978 3.426.206.21.548.214.748-.002l1.138-1.225ZM5.67 12.09a.482.482 0 0 0-.016.68l1.144 1.232c.193.208.52.212.734.025 1.218-1.066 2.772-1.705 4.464-1.705 1.694 0 3.248.64 4.467 1.706a.529.529 0 0 0 .734-.025l1.145-1.232a.482.482 0 0 0-.016-.68c-1.695-1.584-3.908-2.543-6.328-2.543-2.42 0-4.633.958-6.328 2.542Zm9.25 4.366c.218-.236.162-.614-.13-.748a6.632 6.632 0 0 0-5.582.001c-.292.135-.348.513-.13.748l2.554 2.75a.5.5 0 0 0 .732 0l2.556-2.752Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-gradient-wifi_svg__b",
              x1: 2.002,
              x2: 12.002,
              y1: 4,
              y2: 15,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#66B9A2", stopOpacity: 0.64 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#38957E" })
              ]
            }
          ),
          /* @__PURE__ */ jsx("clipPath", { id: "ic-gradient-wifi_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
        ] })
      ]
    }
  );
}
var IcGradientWifi_default = createIcon(SvgIcGradientWifi);
function SvgIcGradientWorkplace(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-gradient-workplace_svg__b",
            width: 16,
            height: 19,
            x: 4,
            y: 3,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4 3h16v19H4z" }),
              /* @__PURE__ */ jsx("path", { d: "M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 18.5v-13Z" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-gradient-workplace_svg__a)",
            d: "M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 18.5v-13Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            d: "M4 3h16H4Zm16 15.5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3c0 1.105 1.12 2 2.5 2h11c1.38 0 2.5-.895 2.5-2ZM4 21V3v18ZM20 3v18V3Z",
            mask: "url(#ic-gradient-workplace_svg__b)"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 3, height: 3, x: 7, y: 6, fill: "#fff", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 3, height: 3, x: 7, y: 10, fill: "#fff", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 3, height: 3, x: 11, y: 6, fill: "#fff", rx: 0.5 }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "ic-gradient-workplace_svg__a",
            x1: 4,
            x2: 21.897,
            y1: 3,
            y2: 18.86,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#BEC8D5" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#98A7B7" })
            ]
          }
        ) })
      ]
    }
  );
}
var IcGradientWorkplace_default = createIcon(SvgIcGradientWorkplace);
function SvgIcGraph(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 3.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1.5A.5.5 0 0 0 7 14V4a.5.5 0 0 0-.5-.5H5Zm4.25 6.2a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5v-3.8a.5.5 0 0 0-.5-.5h-1.5ZM13 7.8a.5.5 0 0 1 .5-.5H15a.5.5 0 0 1 .5.5V14a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5V7.8Zm-9.8 7.7a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h13.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2H3.2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcGraph_default = createIcon(SvgIcGraph);
function SvgIcGroupMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.5 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm13 16H15v-2h5v-1a2 2 0 0 0-2-2h-3c-.136 0-.27.014-.399.04a5.011 5.011 0 0 0-1.202-1.707A3.988 3.988 0 0 1 15 13h3a4 4 0 0 1 4 4v1.5a1.5 1.5 0 0 1-1.5 1.5Zm-4-14a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM6 13a4 4 0 0 0-4 4v1.5A1.5 1.5 0 0 0 3.5 20h8a1.5 1.5 0 0 0 1.5-1.5V17a4 4 0 0 0-4-4H6Zm-2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1H4v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcGroupMedium_default = createIcon(SvgIcGroupMedium);
function SvgIcGroupSolidMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.994 3.343 4.616 8.234c-.39.299-.616.752-.616 1.23v9.963C4 20.296 4.732 21 5.635 21h12.73c.903 0 1.635-.704 1.635-1.573V9.463c0-.478-.226-.93-.614-1.229l-6.352-4.89a1.685 1.685 0 0 0-2.04-.001Zm-1.92 12.55a.71.71 0 0 0 0 1.42h5.852a.71.71 0 0 0 0-1.42H9.074Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcGroupSolidMedium_default = createIcon(SvgIcGroupSolidMedium);
function SvgIcHelpCenterMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12 20.064a1.099 1.099 0 0 1-.667-.142c-1.12-.648-2.61-1.36-3.833-1.422-1.29-.065-2.628.525-3.66 1.148-.747.451-1.84-.063-1.84-.935V7.708c0-.466.105-.93.388-1.299C3.057 5.535 4.638 4 7.5 4c2.309 0 3.696.79 4.5 1.559C12.804 4.789 14.191 4 16.5 4c2.861 0 4.443 1.535 5.112 2.409.283.37.388.833.388 1.3v11.004c0 .872-1.093 1.386-1.84.935-1.032-.623-2.37-1.213-3.66-1.148-1.222.061-2.712.774-3.833 1.422a1.099 1.099 0 0 1-.667.142Zm1-12.6v10.022c1.016-.483 2.233-.925 3.4-.983 1.321-.067 2.577.323 3.6.796v-9.59a.726.726 0 0 0-.01-.127C19.539 7.006 18.487 6 16.5 6c-1.757 0-2.645.567-3.08.97a2.56 2.56 0 0 0-.42.494Zm-2 10.022c-1.016-.483-2.233-.925-3.4-.983-1.321-.067-2.577.323-3.6.796v-9.59c0-.062.005-.104.01-.127C4.461 7.006 5.513 6 7.5 6c1.757 0 2.645.567 3.08.97.199.182.334.36.42.494v10.022Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcHelpCenterMedium_default = createIcon(SvgIcHelpCenterMedium);
function SvgIcHelpLine(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M10.749 11.602v-.563c0-.398.022-.42.409-.763.718-.63 1.226-1.094 1.226-2.066 0-1.227-1.027-2.21-2.354-2.21C8.13 6 7.6 7.801 7.6 7.801l1.127.52S9.08 7.26 10.03 7.26c.553 0 1.028.43 1.028.95s-.22.73-.63 1.083l-.202.173c-.568.482-.792.672-.792 1.319v.817h1.315ZM10.097 14a.868.868 0 0 0 .873-.873.868.868 0 0 0-.873-.873.868.868 0 0 0-.873.873c0 .486.387.873.873.873Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcHelpLine_default = createIcon(SvgIcHelpLine);
function SvgIcHelpMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm.54 12.225a.5.5 0 0 0 .5-.5v-.282c0-.553.031-.584.568-1.06.998-.874 1.704-1.519 1.704-2.87 0-1.703-1.427-3.069-3.269-3.069-1.971 0-2.881 1.395-3.216 2.102-.106.224.007.477.232.58l.666.308c.27.124.595-.014.753-.267.265-.427.761-.973 1.565-.973.767 0 1.427.598 1.427 1.32 0 .721-.307 1.013-.875 1.504l-.28.24c-.79.67-1.1.934-1.1 1.832v.635a.5.5 0 0 0 .5.5h.825Zm-.405 3.33c.675 0 1.213-.536 1.213-1.212 0-.675-.538-1.212-1.213-1.212s-1.212.537-1.212 1.212c0 .676.537 1.213 1.212 1.213Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcHelpMedium_default = createIcon(SvgIcHelpMedium);
function SvgIcHelp(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CCC",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.913-5.665v-.663c0-.468.026-.494.481-.897.845-.741 1.443-1.287 1.443-2.431 0-1.443-1.209-2.6-2.769-2.6-2.236 0-2.86 2.119-2.86 2.119l1.326.611s.416-1.248 1.534-1.248c.65 0 1.209.507 1.209 1.118 0 .611-.26.858-.741 1.274l-.238.203c-.669.568-.932.792-.932 1.552v.962h1.547Zm-.767 2.821a1.02 1.02 0 0 0 1.027-1.027 1.02 1.02 0 0 0-1.027-1.027 1.02 1.02 0 0 0-1.027 1.027 1.02 1.02 0 0 0 1.027 1.027Z",
          clipRule: "evenodd",
          opacity: 0.8
        }
      )
    }
  );
}
var IcHelp_default = createIcon(SvgIcHelp);
function SvgIcHideMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#333", d: "m3 12 3-3v6l-3-3Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8 7a1 1 0 0 1 1-1h6.667a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h9.917a1 1 0 1 0 0-2H9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcHideMedium_default = createIcon(SvgIcHideMedium);
function SvgIcHistory(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.75 5.765V8.25h1.5V3.5H2.5V5h1.91A7.502 7.502 0 0 0 8.965 17.43a5.997 5.997 0 0 1-1.082-1.813A6.002 6.002 0 0 1 5.75 5.765ZM10 2.5a7.502 7.502 0 0 1 7.43 6.465 5.997 5.997 0 0 0-1.814-1.081A6.002 6.002 0 0 0 9.5 4.02V2.516A7.61 7.61 0 0 1 10 2.5Zm8.5 11a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-4.5-3v2.793l1.854 1.853-.708.708L13 13.707V10.5h1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcHistory_default = createIcon(SvgIcHistory);
function SvgIcHomeMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("mask", { id: "ic-home-medium_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m4.616 8.234 6.378-4.891a1.685 1.685 0 0 1 2.04.002l6.352 4.89c.388.298.614.75.614 1.228v9.964c0 .869-.732 1.573-1.635 1.573H5.635C4.732 21 4 20.296 4 19.427V9.465c0-.48.227-.932.616-1.23Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M4.616 8.234 3.4 6.647l1.217 1.587Zm6.378-4.891 1.217 1.587-1.217-1.587Zm2.04.002-1.22 1.585 1.22-1.585Zm6.352 4.89-1.22 1.584 1.22-1.585ZM4 19.426H2h2ZM5.833 9.82l6.378-4.891-2.434-3.174-6.378 4.891 2.434 3.174Zm6.378-4.891a.327.327 0 0 1-.198.07.328.328 0 0 1-.199-.07l2.44-3.17a3.685 3.685 0 0 0-4.477-.004l2.434 3.174Zm-.397 0 6.352 4.89 2.44-3.17-6.352-4.89-2.44 3.17Zm6.352 4.89A.449.449 0 0 1 18 9.462h4a3.552 3.552 0 0 0-1.394-2.814l-2.44 3.17ZM18 9.462v9.964h4V9.463h-4Zm0 9.964c0-.308.236-.427.365-.427v4C20.3 23 22 21.472 22 19.427h-4Zm.365-.427H5.635v4h12.73v-4Zm-12.73 0c.129 0 .365.12.365.427H2C2 21.471 3.7 23 5.635 23v-4Zm.365.427V9.465H2v9.962h4Zm0-9.962c0 .16-.077.287-.167.356L3.4 6.647A3.552 3.552 0 0 0 2 9.465h4Z",
            mask: "url(#ic-home-medium_svg__a)"
          }
        )
      ]
    }
  );
}
var IcHomeMedium_default = createIcon(SvgIcHomeMedium);
function SvgIcImport(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M14.806 3.75c1.31 0 2.356 1.084 2.438 2.427l.005.17v8.307c0 1.363-.994 2.502-2.28 2.59l-.163.006H7.191c-1.31 0-2.356-1.084-2.437-2.427l-.005-.17V12.5h1.5v2.154c0 .578.38 1.032.842 1.09l.1.006h7.615c.472 0 .884-.415.937-.974l.006-.122V6.346c0-.578-.381-1.032-.843-1.09l-.1-.006v-1.5ZM9.683 2.5 14.5 7.507 9.683 12.5V9.504l-.18-.035-.18-.024-.149-.015-.172-.012-.193-.007h-.213l-.23.01-.249.02c-.127.013-.261.031-.4.055l-.283.055c-1.449.318-3.34 1.284-4.867 3.949l-.031-.231-.02-.228-.015-.293-.001-.354.01-.264.02-.286.033-.305c.167-1.306.721-3.047 2.324-4.527l.31-.276.11-.086.147-.105.185-.12.107-.063.243-.132c.744-.38 1.96-.788 3.694-.733V2.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcImport_default = createIcon(SvgIcImport);
function SvgIcInactiveBell(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12.003 2.6c-.407 0-.977.066-1.347.534a1.327 1.327 0 0 0-.267.635c-.015.102-.02.204-.02.281-2.379.62-4.243 2.575-4.243 5.045v1.725c0 .9-.449 1.79-1.312 2.429l-.005.003a1.957 1.957 0 0 0-.804 1.565c0 .387.11.73.293 1.019l3.385-3.385a4.6 4.6 0 0 0 .299-1.631V9.095c0-1.609 1.392-3.103 3.43-3.36l.59-.074.592.074c.51.065.98.206 1.397.408l1.36-1.36a6.247 6.247 0 0 0-1.714-.733 2.172 2.172 0 0 0-.02-.282 1.33 1.33 0 0 0-.268-.634c-.37-.468-.94-.534-1.346-.534Zm5.763 5.456L16.024 9.8v1.02c0 1.546.774 2.966 2.054 3.914a.207.207 0 0 1 .06.065c.006.011.006.017.006.019 0 .003 0 .008-.004.017a.166.166 0 0 1-.042.05.403.403 0 0 1-.263.088H10.85l-1.856 1.855h8.84c1.074 0 2.165-.788 2.165-2.01 0-.64-.322-1.203-.81-1.57l-.005-.003c-.856-.633-1.306-1.523-1.306-2.424V9.095c0-.358-.039-.705-.113-1.039ZM4.18 18.114a.619.619 0 0 1 0-.875L17.533 3.887a.618.618 0 0 1 .875 0l.547.547a.619.619 0 0 1 0 .875L5.603 18.66a.619.619 0 0 1-.875 0l-.547-.547Zm10.858.908c-.49 1.358-1.642 2.314-2.983 2.314-1.34 0-2.493-.956-2.983-2.314-.127-.352.125-.703.458-.703h5.05c.334 0 .585.351.458.703Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInactiveBell_default = createIcon(SvgIcInactiveBell);
function SvgIcInfo1(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#DDD" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-.5 6h-1v-1H9v-3h-.5V9h2a.5.5 0 0 1 .5.5V13h.5v1h-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcInfo1_default = createIcon(SvgIcInfo1);
function SvgIcInfoAlbum(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm4.667 4.833a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333Zm7.083 6.417h-10l2.772-3.234a1 1 0 0 1 1.49-.032L10 13.043l2.701-3.236a1 1 0 0 1 1.57.044l.781 1.05a1 1 0 0 1 .198.597v3.252a.5.5 0 0 1-.5.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoAlbum_default = createIcon(SvgIcInfoAlbum);
function SvgIcInfoApp(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M14 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8Zm-2 2.536a1 1 0 0 0-1.302.268l-.064.098-.22.379A2.771 2.771 0 0 0 10 7.25l-.21.008-.205.023-.219-.38a1 1 0 0 0-1.785.897l.053.104.219.38a2.75 2.75 0 0 0-.332.526L7.437 9H7a1 1 0 0 0-.117 1.993L7 11h.438c.076.196.174.38.291.552l.123.166-.218.38-.053.104a1 1 0 0 0 1.72.994l.065-.098.22-.379c.135.02.273.031.414.031l.209-.008.205-.023.22.38a1 1 0 0 0 1.784-.897l-.052-.104-.218-.38c.129-.162.24-.338.33-.525l.084-.192L13 11a1 1 0 0 0 .117-1.993L13 9h-.438a2.74 2.74 0 0 0-.291-.552l-.124-.166.219-.38.053-.104A1 1 0 0 0 12 6.536ZM10 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoApp_default = createIcon(SvgIcInfoApp);
function SvgIcInfoBreaktime(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 5.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v.05a2.5 2.5 0 1 1-.108 4.876A4.002 4.002 0 0 1 10.5 13.5h-3a4 4 0 0 1-4-4v-4Zm11 1.634v1.732a1 1 0 1 0 0-1.732ZM5 14.5a.5.5 0 0 0-.5.5v.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V15a.5.5 0 0 0-.5-.5H5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoBreaktime_default = createIcon(SvgIcInfoBreaktime);
function SvgIcInfoCity(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10h1V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v6h.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H4V5Zm3.5 3V6h-2v2h2Zm0 1v2h-2V9h2Zm6.5 3h-2v-2h2v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoCity_default = createIcon(SvgIcInfoCity);
function SvgIcInfoDate(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7.083 3c.443 0 .81.287.867.66l.008.104v1.018h4.084V3.764c0-.422.392-.764.875-.764.443 0 .809.287.867.66l.008.104v1.018h2.258a.95.95 0 0 1 .95.95v10.301c0 .534-.496.967-1.108.967H4.108C3.496 17 3 16.567 3 16.033V5.732a.95.95 0 0 1 .95-.95h2.258V3.764c0-.422.392-.764.875-.764Zm8.167 5.855H4.75v6.618h10.5V8.855ZM7.867 10.89a.2.2 0 0 0-.2.2v1.636c0 .11.09.2.2.2h4.266a.2.2 0 0 0 .2-.2v-1.636a.2.2 0 0 0-.2-.2H7.867Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoDate_default = createIcon(SvgIcInfoDate);
function SvgIcInfoDaysoff(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm3-8H7v2h6V9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoDaysoff_default = createIcon(SvgIcInfoDaysoff);
function SvgIcInfoDistributor(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.5 3a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 .5-.5V9.423H9v1.5a.5.5 0 0 0 .5.5H16l-1.888-2.478L16 6.423h-4v-1.5a.5.5 0 0 0-.5-.5h-5V3.5A.5.5 0 0 0 6 3h-.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoDistributor_default = createIcon(SvgIcInfoDistributor);
function SvgIcInfoDocs(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8 3h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7l4-4ZM7 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#333", fillRule: "evenodd", d: "M4 7h4V3", clipRule: "evenodd" })
      ]
    }
  );
}
var IcInfoDocs_default = createIcon(SvgIcInfoDocs);
function SvgIcInfoEmail(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m4 8.56 5.802 3.238.1.047a.75.75 0 0 0 .531 0l.1-.047L16 8.747V14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.56ZM15 5a1 1 0 0 1 1 1v1.029l-5.832 3.255L4 6.842V6a1 1 0 0 1 1-1h10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoEmail_default = createIcon(SvgIcInfoEmail);
function SvgIcInfoEmployee(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 1c2.761 0 5 1.483 5 3.882v1.052c0 .589-.477 1.066-1.066 1.066H6.067A1.067 1.067 0 0 1 5 14.934v-1.052C5 11.483 7.239 10 10 10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoEmployee_default = createIcon(SvgIcInfoEmployee);
function SvgIcInfoEmployeeno(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12.154 4c.297 0 .538.244.538.545v.546h3.231c.595 0 1.077.488 1.077 1.09v8.728c0 .603-.482 1.091-1.077 1.091H4.077A1.084 1.084 0 0 1 3 14.91V6.181c0-.603.482-1.091 1.077-1.091h3.23v-.546c0-.3.242-.545.54-.545h4.307ZM7.5 8a1.5 1.5 0 1 0 0 3c-1.38 0-2.5.74-2.5 1.652V13h5v-.348C10 11.74 8.88 11 7.5 11a1.5 1.5 0 0 0 0-3Zm3.5 2h3v1h-3v-1Zm3 2h-3v1h3v-1Zm-3-4h3v1h-3V8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoEmployeeno_default = createIcon(SvgIcInfoEmployeeno);
function SvgIcInfoGrade(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 18 18",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M13 5.5v-3H5v3l1.425.713a5 5 0 1 0 5.15 0L13 5.5Zm-7.5 5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm6 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M10 2.5v3.1A5.023 5.023 0 0 0 8 5.6V2.5h2Z",
            clipRule: "evenodd",
            opacity: 0.5
          }
        )
      ]
    }
  );
}
var IcInfoGrade_default = createIcon(SvgIcInfoGrade);
function SvgIcInfoGroup(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.5 6.75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-7 7a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1Zm8.5-4.5c-.455 0-.882-.122-1.25-.335.47-.595.75-1.347.75-2.165 0-.818-.28-1.57-.75-2.165A2.5 2.5 0 1 1 12 9.25Zm3.5 6.5h-2.301a1.36 1.36 0 0 0 .301-.856v-.822c0-1.423-.507-2.664-1.477-3.322H13.5a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoGroup_default = createIcon(SvgIcInfoGroup);
function SvgIcInfoLeader(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m12.161 7.1-1.502-3.196a.729.729 0 0 0-1.319 0L7.837 7.1 4.4 7.629a.729.729 0 0 0-.412 1.23l2.508 2.57-.584 3.591a.729.729 0 0 0 1.072.755L10 14.11l3.016 1.666a.729.729 0 0 0 1.072-.755l-.584-3.59 2.508-2.572A.729.729 0 0 0 15.6 7.63l-3.439-.528Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoLeader_default = createIcon(SvgIcInfoLeader);
function SvgIcInfoLogin(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6 3a2 2 0 0 0-2 2v4.25h5.19l-.72-.72a.75.75 0 0 1-.073-.976l.073-.084a.75.75 0 0 1 .976-.073l.084.073 2 2a.75.75 0 0 1 .073.976l-.073.084-2 2a.75.75 0 0 1-1.133-.976l.073-.084.72-.72H4V15a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoLogin_default = createIcon(SvgIcInfoLogin);
function SvgIcInfoPhoneCheck(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M11.158 11.798 9.204 9.863a.692.692 0 0 1 0-.982.7.7 0 0 1 .988 0l1.5 1.484 4.162-4.168a.67.67 0 1 1 .95.95l-4.65 4.657a.668.668 0 0 1-.436.196h-.107a.697.697 0 0 1-.453-.202Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M6.5 2.5A1.5 1.5 0 0 0 5 4v12a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 15 16v-4.924l-1.5 1.502V14a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V4.5A.5.5 0 0 1 7 4h6a.5.5 0 0 1 .5.5v1.931l1.293-1.294c.066-.066.135-.127.207-.183V4a1.5 1.5 0 0 0-1.5-1.5h-7Zm2.2 13a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h2.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2H8.7Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcInfoPhoneCheck_default = createIcon(SvgIcInfoPhoneCheck);
function SvgIcInfoPhoneNoCheck(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 4.5A1.5 1.5 0 0 1 6.5 3h7A1.5 1.5 0 0 1 15 4.5v12a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5v-12Zm3.5 11.7c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H8.7a.2.2 0 0 1-.2-.2v-.6ZM7 4.5a.5.5 0 0 0-.5.5v9.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoPhoneNoCheck_default = createIcon(SvgIcInfoPhoneNoCheck);
function SvgIcInfoPhone(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7Zm0 2h6v8H7V5Zm2 9h2v1H9v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoPhone_default = createIcon(SvgIcInfoPhone);
function SvgIcInfoPosition(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7 6a3 3 0 0 1 6 0v3.563a.438.438 0 0 1-.438.437H7.439A.438.438 0 0 1 7 9.562V6Zm-1.874 5.177a.995.995 0 0 0-.126.487v.5a1 1 0 0 0 1 1h3.25v.991H6.5l-.128.007a1.251 1.251 0 0 0-1.072.893.734.734 0 0 0-.3.592v.53c0 .406.33.735.735.735h.53c.406 0 .735-.33.735-.736v-.521h6v.521c0 .407.33.736.735.736h.53c.406 0 .735-.33.735-.736v-.529a.734.734 0 0 0-.3-.592 1.25 1.25 0 0 0-1.2-.9h-2.75v-.991H14a1 1 0 0 0 1-1v-.5a.998.998 0 0 0-.071-.37V9.401h.642v-.018a.737.737 0 0 0 .164.019h.53c.406 0 .735-.33.735-.735V8.64a.735.735 0 0 0-.735-.736h-.53a.738.738 0 0 0-.164.019v-.021h-.892a1.25 1.25 0 0 0-1.244 1.122l-.006.128v1.511H6.627V9.153l-.007-.128a1.25 1.25 0 0 0-1.243-1.122H4.373v.01a.741.741 0 0 0-.108-.008h-.53A.735.735 0 0 0 3 8.641v.027c0 .406.33.735.735.735h.53a.741.741 0 0 0 .108-.008v.008l.753-.001v1.775Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoPosition_default = createIcon(SvgIcInfoPosition);
function SvgIcInfoProperties(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12 3a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h4Zm0 1.5H8a2.5 2.5 0 0 0-2.495 2.336L5.5 7v6a2.5 2.5 0 0 0 2.336 2.495L8 15.5h4a2.5 2.5 0 0 0 2.495-2.336L14.5 13V7a2.5 2.5 0 0 0-2.336-2.495L12 4.5ZM11 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2.5 6v1h3v-1H11V9.5a.5.5 0 0 0-.5-.5h-2v1H9v3h-.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoProperties_default = createIcon(SvgIcInfoProperties);
function SvgIcInfoPunch(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12 7c.323 0 .638.03.944.089-.602-1.31-2.027-2.26-3.73-2.334L9 4.75v-1.5c2.905 0 5.331 1.964 5.701 4.542.341.219.653.478.93.771l-3.667 3.927-1.912-1.986a.6.6 0 0 0-.871 0 .66.66 0 0 0 0 .908l2.312 2.401a.604.604 0 0 0 .4.187h.094a.58.58 0 0 0 .384-.18l3.992-4.265a5 5 0 0 1-8.587 5.12c-2.573-.44-4.526-2.774-4.526-5.573 0-1.482.55-2.868 1.496-3.902H4V4h3v3H5.8v-.729a4.28 4.28 0 0 0-1.05 2.83c0 1.701.961 3.155 2.33 3.797A5 5 0 0 1 12 7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoPunch_default = createIcon(SvgIcInfoPunch);
function SvgIcInfoRadius(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M9.75 4a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5Zm0 1.5a4.25 4.25 0 1 1 0 8.5 4.25 4.25 0 0 1 0-8.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M4 9.75A5.75 5.75 0 0 1 15.451 9h.299a.75.75 0 0 1 .102 1.493l-.102.007h-3.095a3.001 3.001 0 0 1-5.905-.75A3 3 0 0 1 12.655 9h1.279a4.251 4.251 0 1 0-4.184 5 .75.75 0 0 1 0 1.5A5.75 5.75 0 0 1 4 9.75Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcInfoRadius_default = createIcon(SvgIcInfoRadius);
function SvgIcInfoRegion(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12.27 13.71a.482.482 0 0 1 .48-.136c1.356.382 2.25 1.04 2.25 1.787 0 1.181-2.239 2.139-5 2.139s-5-.958-5-2.14c0-.745.893-1.402 2.246-1.785a.49.49 0 0 1 .485.139c.643.67 1.4 1.362 2.269 2.075.816-.67 1.533-1.32 2.15-1.951l.12-.128ZM10.002 2.5C12.84 2.5 15 4.95 15 7.651c0 1.801-1.666 4.084-4.998 6.849C6.667 11.735 5 9.452 5 7.651 5 4.95 7.163 2.5 10.002 2.5Zm.003 2.553c-1.262 0-2.285 1-2.285 2.236 0 1.235 1.023 2.236 2.285 2.236 1.262 0 2.284-1 2.284-2.236 0-1.235-1.022-2.236-2.284-2.236Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoRegion_default = createIcon(SvgIcInfoRegion);
function SvgIcInfoStarBadge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 7, fill: "#333", stroke: "#fff", strokeWidth: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "m11.235 8.129-.783-1.666a.5.5 0 0 0-.905 0l-.783 1.666-1.804.277a.5.5 0 0 0-.282.844l1.32 1.353-.306 1.882a.5.5 0 0 0 .735.518l1.573-.87 1.573.87a.5.5 0 0 0 .736-.518l-.306-1.882 1.319-1.353a.5.5 0 0 0-.282-.844l-1.805-.277Z"
          }
        )
      ]
    }
  );
}
var IcInfoStarBadge_default = createIcon(SvgIcInfoStarBadge);
function SvgIcInfoState(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m8.5 8.25.477.159 2.523 3.162v4.679h-.012L8.5 15.098V8.25Zm-1 0v6.848l-3 1.152V9.584l3-1.334Zm8 0v6.666l-3 1.334v-4.588l2.477-3.179.523-.233ZM12 3.75a2.5 2.5 0 0 1 2.053 3.927l-.11.146-1.94 2.726-1.946-2.726A2.5 2.5 0 0 1 12 3.75Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoState_default = createIcon(SvgIcInfoState);
function SvgIcInfoVisit(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12.736 6.353 9.333 3l-3.59 3.539-.797.785L3.5 8.748l1.446 1.425 3.658 3.605.226.222H3.5v1h6.345l1.014 1H5.5v1h11v-1.646a2.01 2.01 0 0 0 0-.278V15h-.007a1.992 1.992 0 0 0-.584-1.21l-4.722-4.653 1.55-2.784ZM4.5 12h-1v1h1v-1Zm-1 4h1v1h-1v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoVisit_default = createIcon(SvgIcInfoVisit);
function SvgIcInfoWorking(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm.75-6.129V7h-1.5v3.327L7.424 12.52l1.152.96 2.174-2.609Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoWorking_default = createIcon(SvgIcInfoWorking);
function SvgIcInfoWorkplace(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Zm2 1h2v2H7V6Zm0 3h2v2H7V9Zm5-3h-2v2h2V6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoWorkplace_default = createIcon(SvgIcInfoWorkplace);
function SvgIcInfo(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8 3a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H8Zm3 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2.5 6v1h3v-1H11V9.5a.5.5 0 0 0-.5-.5h-2v1H9v3h-.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfo_default = createIcon(SvgIcInfo);
function SvgIcInventoryMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 6.5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11Zm3-1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1H14v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2H6.5Zm2.5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInventoryMedium_default = createIcon(SvgIcInventoryMedium);
function SvgIcInvitation(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 4A1.5 1.5 0 0 0 2 5.5v9A1.5 1.5 0 0 0 3.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16.5 4h-13Zm-.507 2.73 6.373 4.249c.384.256.884.256 1.268 0l6.374-4.25a.2.2 0 0 0 .056-.277l-.413-.618a.2.2 0 0 0-.277-.055l-6.263 4.175a.2.2 0 0 1-.222 0L3.627 5.78a.2.2 0 0 0-.278.055l-.412.618a.2.2 0 0 0 .056.278Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInvitation_default = createIcon(SvgIcInvitation);
function SvgIcInviteBefore(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "m3.526 3.965 6.301 6.002a.25.25 0 0 0 .345 0l6.302-6.002A2.496 2.496 0 0 0 14.5 3h-9c-.802 0-1.516.378-1.974.965ZM17 5.535l-5.793 5.518a1.75 1.75 0 0 1-2.414 0L3 5.535V14.5A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5V5.536Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M8.25 13.5h3.5"
          }
        )
      ]
    }
  );
}
var IcInviteBefore_default = createIcon(SvgIcInviteBefore);
function SvgIcInviteCompleted(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.766-9.634a.8.8 0 0 0-1.132-1.132L9.2 10.67 7.366 8.834a.8.8 0 0 0-1.132 1.132l2.4 2.4a.8.8 0 0 0 1.132 0l4-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInviteCompleted_default = createIcon(SvgIcInviteCompleted);
function SvgIcIssue(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 5.5, cy: 10.5, r: 1.5, fill: "#333" }),
        /* @__PURE__ */ jsx("circle", { cx: 10.5, cy: 10.5, r: 1.5, fill: "#333", opacity: 0.6 }),
        /* @__PURE__ */ jsx("circle", { cx: 15.5, cy: 10.5, r: 1.5, fill: "#333", opacity: 0.3 })
      ]
    }
  );
}
var IcIssue_default = createIcon(SvgIcIssue);
function SvgIcJpMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.5 10.621C5.5 6.95 8.425 4 12 4s6.5 2.95 6.5 6.621c0 2.748-1.266 4.883-2.76 6.454-1.414 1.488-2.99 2.42-3.728 2.81-.74-.39-2.322-1.32-3.743-2.808C6.771 15.507 5.5 13.37 5.5 10.62ZM12 2c-4.71 0-8.5 3.875-8.5 8.621 0 3.421 1.594 6.025 3.323 7.837 1.722 1.804 3.627 2.877 4.405 3.273a1.725 1.725 0 0 0 1.572-.002c.776-.397 2.674-1.471 4.39-3.276 1.723-1.812 3.31-4.415 3.31-7.832C20.5 5.875 16.71 2 12 2Zm4.217 7.876a1 1 0 1 0-1.434-1.394l-3.655 3.76-1.908-1.98a1 1 0 0 0-1.44 1.387l2.398 2.489a1.316 1.316 0 0 0 1.892.004l4.147-4.266Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcJpMedium_default = createIcon(SvgIcJpMedium);
function SvgIcLanguageMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          stroke: "#333",
          strokeWidth: 0.4,
          d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm1.248-.746a7.743 7.743 0 0 1 1.26-3.558c.8.138 1.625.252 2.473.341a16.202 16.202 0 0 0-.443 3.217h-3.29Zm4.088-4.4A37.97 37.97 0 0 1 6.38 6.61a7.793 7.793 0 0 1 3.184-2.008c-.392.467-.718 1.03-.983 1.637a9.966 9.966 0 0 0-.245.617Zm.416 4.4c.049-1.128.208-2.183.452-3.106a43.382 43.382 0 0 0 5.607.059c.236.91.389 1.943.437 3.047H8.752Zm3.714-4.197c.664 0 1.318-.015 1.962-.045C13.83 5.494 12.964 4.54 12 4.54c-.953 0-1.81.933-2.407 2.421.934.064 1.894.097 2.873.097Zm3.996 4.197a16.28 16.28 0 0 0-.422-3.131 40.65 40.65 0 0 0 2.539-.292 7.739 7.739 0 0 1 1.173 3.423h-3.29Zm-.77-4.32a39.415 39.415 0 0 0 2.037-.209 7.793 7.793 0 0 0-3.293-2.124c.392.467.717 1.03.983 1.637.097.222.188.455.273.697ZM6.376 17.388a7.79 7.79 0 0 0 3.188 2.012c-.392-.467-.718-1.03-.983-1.637a9.913 9.913 0 0 1-.247-.621c-.668.067-1.322.149-1.958.246Zm-.87-1.087a7.745 7.745 0 0 1-1.28-3.834H7.53c.032 1.244.188 2.43.45 3.493-.847.089-1.673.203-2.473.34Zm4.085.736c.597 1.49 1.455 2.425 2.409 2.425.965 0 1.832-.956 2.43-2.477a42.634 42.634 0 0 0-4.839.052Zm5.221-1.247a43.76 43.76 0 0 0-5.61.059 14.975 14.975 0 0 1-.46-3.382h6.516a15.04 15.04 0 0 1-.446 3.323Zm.881 1.272c-.085.244-.177.477-.274.7-.266.608-.591 1.17-.983 1.638a7.794 7.794 0 0 0 3.297-2.128 39.33 39.33 0 0 0-2.04-.21Zm2.888-.896a39.831 39.831 0 0 0-2.54-.292c.25-1.04.4-2.196.43-3.407h3.303a7.744 7.744 0 0 1-1.193 3.699Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcLanguageMedium_default = createIcon(SvgIcLanguageMedium);
function SvgIcLeaderAppovalLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 15,
            cy: 15,
            r: 14,
            fill: "#35485B",
            stroke: "#FFD000",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFD000",
            d: "M14.249 7.488a.822.822 0 0 1 1.502 0l1.823 3.864a.841.841 0 0 0 .631.48l4.077.619c.687.104.961.987.464 1.494l-2.95 3.007a.901.901 0 0 0-.24.775l.696 4.247c.117.716-.601 1.261-1.216.923l-3.646-2.005a.805.805 0 0 0-.78 0l-3.646 2.005c-.615.338-1.333-.207-1.216-.923l.697-4.247a.901.901 0 0 0-.241-.775l-2.95-3.007c-.497-.507-.223-1.39.464-1.494l4.077-.62a.841.841 0 0 0 .63-.48l1.824-3.863Z"
          }
        )
      ]
    }
  );
}
var IcLeaderAppovalLarge_default = createIcon(SvgIcLeaderAppovalLarge);
function SvgIcLeaderLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 15,
            cy: 15,
            r: 14,
            fill: "#35485B",
            stroke: "#fff",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M14.249 7.488a.822.822 0 0 1 1.502 0l1.823 3.864a.841.841 0 0 0 .631.48l4.077.619c.687.104.961.987.464 1.494l-2.95 3.007a.901.901 0 0 0-.24.775l.696 4.247c.117.716-.601 1.261-1.216.923l-3.646-2.005a.805.805 0 0 0-.78 0l-3.646 2.005c-.615.338-1.333-.207-1.216-.923l.697-4.247a.901.901 0 0 0-.241-.775l-2.95-3.007c-.497-.507-.223-1.39.464-1.494l4.077-.62a.841.841 0 0 0 .63-.48l1.824-3.863Z"
          }
        )
      ]
    }
  );
}
var IcLeaderLarge_default = createIcon(SvgIcLeaderLarge);
function SvgIcLeaveMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M6.43 4.25a.5.5 0 0 1 .182-.683l.866-.5a.5.5 0 0 1 .683.183l.96 1.661c2.04-.863 4.244-.921 6.085-.597 1.077.19 2.064.515 2.862.917.762.383 1.484.901 1.858 1.55.457.79.303 1.629-.026 2.303-.323.661-.875 1.306-1.508 1.904-1.06 1.002-2.512 2.028-4.045 2.966l3.312 5.736-1.733 1-3.309-5.732c-1.638.903-3.327 1.69-4.78 2.124-.835.249-1.67.405-2.404.354-.748-.052-1.551-.338-2.007-1.128-.375-.65-.463-1.533-.413-2.385.051-.892.263-1.91.637-2.937.66-1.81 1.863-3.753 3.727-5.095l-.948-1.64ZM5.01 14.04c-.042.717.066 1.126.148 1.269.002.005.047.107.413.133.387.027.954-.055 1.694-.276.267-.08.546-.174.836-.282a16.132 16.132 0 0 1-.95-3.746c-.096-.76-.13-1.541-.052-2.252a9.592 9.592 0 0 0-1.57 2.785c-.315.865-.48 1.692-.52 2.369Zm7.384-1.25c-.826.476-1.657.92-2.455 1.303a14.185 14.185 0 0 1-.804-3.205c-.1-.794-.107-1.5-.013-2.032.1-.564.271-.72.325-.75.054-.032.275-.103.813.093.508.184 1.116.543 1.754 1.027.93.706 1.802 1.582 2.391 2.322-.634.42-1.313.838-2.01 1.241Zm4.624-3.254c-.292.275-.623.558-.987.844a16.083 16.083 0 0 0-2.809-2.748c-.679-.515-1.419-.977-2.146-1.263 1.27-.305 2.59-.294 3.783-.084.907.16 1.705.43 2.31.734.643.322.943.62 1.026.763.003.005.07.095-.092.424-.17.349-.524.8-1.085 1.33Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M9 20.613c0-.89.722-1.613 1.613-1.613h8.774c.89 0 1.613.722 1.613 1.613a.387.387 0 0 1-.387.387H9.387A.387.387 0 0 1 9 20.613Z"
          }
        )
      ]
    }
  );
}
var IcLeaveMedium_default = createIcon(SvgIcLeaveMedium);
function SvgIcLeave(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { filter: "url(#ic-leave_svg__a)", children: /* @__PURE__ */ jsx("ellipse", { cx: 13.5, cy: 20, fill: "#CCC", rx: 7.5, ry: 1 }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1B7776",
            d: "M12 19.6a1.6 1.6 0 0 1 1.6-1.6h3.8a1.6 1.6 0 0 1 1.6 1.6.4.4 0 0 1-.4.4h-6.2a.4.4 0 0 1-.4-.4Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-leave_svg__b)",
            d: "M6.428 4.134a1 1 0 0 1 1.732-1l8.89 15.398-.866.5a1 1 0 0 1-1.366-.366L6.428 4.134Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-leave_svg__c)",
            d: "M18.852 5.652c1 1.732-3.388 4.812-6.558 6.642s-8.03 4.09-9.03 2.358C2.066 12.58 3.49 6.985 7.793 4.5c4.305-2.485 9.862-.92 11.058 1.152Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#ic-leave_svg__d)",
            fillOpacity: 0.8,
            fillRule: "evenodd",
            d: "M15.51 10.228a38.258 38.258 0 0 1-3.216 2.066 38.218 38.218 0 0 1-3.397 1.751 3.18 3.18 0 0 1-.71-.864C7.03 11.177 5.881 5.605 7.794 4.5c1.913-1.105 6.164 2.677 7.321 4.68.209.361.336.711.394 1.048Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-leave_svg__b",
              x1: 6.794,
              x2: 16.184,
              y1: 2.768,
              y2: 19.032,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#2A9996" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#1B7776" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-leave_svg__c",
              x1: 7.794,
              x2: 12.294,
              y1: 4.5,
              y2: 12.294,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#5EDEBE" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#32A88B" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "ic-leave_svg__d",
              x1: 11,
              x2: 12.294,
              y1: 10,
              y2: 12.294,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#fff", stopOpacity: 0.6 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "ic-leave_svg__a",
              width: 18,
              height: 5,
              x: 4.5,
              y: 17.5,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx("feBlend", { in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                /* @__PURE__ */ jsx(
                  "feGaussianBlur",
                  {
                    result: "effect1_foregroundBlur_286_4549",
                    stdDeviation: 0.75
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var IcLeave_default = createIcon(SvgIcLeave);
function SvgIcLeftArrowXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8.53 1.47a.75.75 0 0 1 0 1.06L5.06 6l3.47 3.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcLeftArrowXsmall_default = createIcon(SvgIcLeftArrowXsmall);
function SvgIcLeftArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M13.73 3.267a.906.906 0 0 1 .089 1.19l-.09.102L8.23 10l5.5 5.441a.906.906 0 0 1 .09 1.19l-.09.102a.93.93 0 0 1-1.201.088l-.104-.088-6.154-6.087a.906.906 0 0 1-.089-1.19l.09-.102 6.153-6.087a.93.93 0 0 1 1.306 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcLeftArrow_default = createIcon(SvgIcLeftArrow);
function SvgIcLink(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M10.417 8.4c.294.167.309.564.07.804-.207.206-.532.218-.797.095a2.267 2.267 0 0 0-2.557.454L4.52 12.367a2.266 2.266 0 1 0 3.205 3.205l2.013-2.013a.567.567 0 1 1 .802.801l-2.013 2.013a3.4 3.4 0 1 1-4.808-4.807l2.614-2.614a3.401 3.401 0 0 1 4.085-.552Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M9.51 11.591c-.293-.167-.309-.564-.07-.803.207-.207.532-.219.797-.096.838.39 1.866.238 2.557-.454l2.614-2.614a2.266 2.266 0 0 0-3.205-3.205L10.19 6.432a.567.567 0 0 1-.801-.801l2.013-2.013a3.4 3.4 0 1 1 4.808 4.808l-2.614 2.614a3.401 3.401 0 0 1-4.085.552Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M11.245 3.46a3.622 3.622 0 0 1 5.122 5.123l-2.614 2.614a3.623 3.623 0 0 1-4.352.588c-.448-.255-.438-.834-.117-1.155.291-.291.725-.289 1.047-.14a2.045 2.045 0 0 0 2.306-.409l2.614-2.614a2.044 2.044 0 1 0-2.89-2.89l-2.014 2.012a.789.789 0 0 1-1.115-1.115l2.013-2.013Zm4.807.315a3.177 3.177 0 0 0-4.493 0L9.546 5.788a.344.344 0 0 0 .487.487l2.013-2.013a2.489 2.489 0 0 1 3.52 3.52l-2.615 2.614a2.49 2.49 0 0 1-2.808.497c-.207-.096-.424-.07-.545.052-.158.157-.118.373.022.453a3.179 3.179 0 0 0 3.819-.515l2.613-2.615a3.177 3.177 0 0 0 0-4.493Zm-9.877 5.02a3.623 3.623 0 0 1 4.352-.588c.448.255.438.833.117 1.154-.292.291-.725.29-1.047.14a2.045 2.045 0 0 0-2.307.409l-2.614 2.614a2.044 2.044 0 1 0 2.891 2.89l2.013-2.012a.789.789 0 1 1 1.116 1.115L8.683 16.53a3.622 3.622 0 1 1-5.122-5.122l2.614-2.614Zm4.132-.202a3.179 3.179 0 0 0-3.818.516l-2.614 2.614a3.177 3.177 0 0 0 4.493 4.493l2.014-2.013a.344.344 0 1 0-.487-.487L7.88 15.729a2.488 2.488 0 1 1-3.519-3.52l2.614-2.613a2.49 2.49 0 0 1 2.808-.498c.208.096.425.07.546-.051.158-.158.117-.374-.023-.454Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcLink_default = createIcon(SvgIcLink);
function SvgIcListEdit(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 7, height: 16, x: 12, y: 2, fill: "#EAEAEA", rx: 3.5 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "m13 13 2.5 3 2.5-3h-5ZM13 7l2.5-3L18 7h-5ZM1 4h9v2H1V4Zm0 5h9v2H1V9Zm9 5H1v2h9v-2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { stroke: "#777", strokeLinecap: "square", d: "M14 10h3" })
      ]
    }
  );
}
var IcListEdit_default = createIcon(SvgIcListEdit);
function SvgIcListMove(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#DDD", d: "M0 0h20v20H0z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#D6E9FB",
            d: "M-5710-2008c0-1.1.9-2 2-2h19596c1.1 0 2 .9 2 2v4796c0 1.1-.9 2-2 2H-5708c-1.1 0-2-.9-2-2v-4796Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M-510-1610h2000v4000H-510z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 80,
            height: 80,
            x: -30,
            y: -30,
            fill: "#F9F9F9",
            opacity: 0.8,
            rx: 16
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M2 4.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-1Zm0 5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-1Zm.5 4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-15Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcListMove_default = createIcon(SvgIcListMove);
function SvgIcListview(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-2ZM3 9a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 3 11V9Zm.5 5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcListview_default = createIcon(SvgIcListview);
function SvgIcLocation(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.3 0a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9.65 7.673V15h1.3v2.673a7.702 7.702 0 0 0 7.023-7.023H15v-1.3h2.673a7.702 7.702 0 0 0-7.023-7.023V5h-1.3V2.327A7.703 7.703 0 0 0 2.352 9.1H5v1.3H2.31a7.701 7.701 0 0 0 7.04 7.273Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcLocation_default = createIcon(SvgIcLocation);
function SvgIcMap(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7 5.5 3 4v10.5L7 16V5.5Zm1 0L12 4v10.5L8 16V5.5ZM13 4l4 1.5V16l-4-1.5V4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMap_default = createIcon(SvgIcMap);
function SvgIcMemberMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M9.5 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM12 3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM9 13a5 5 0 0 0-5 5v1.5A1.5 1.5 0 0 0 5.5 21h13a1.5 1.5 0 0 0 1.5-1.5V18a5 5 0 0 0-5-5H9Zm-3 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1H6v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMemberMedium_default = createIcon(SvgIcMemberMedium);
function SvgIcMemberSmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 4.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM6.75 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-.68 5.23c1.053-.65 2.45-.98 3.93-.98s2.877.33 3.93.98c1.066.658 1.82 1.682 1.82 3.005v.699a1.817 1.817 0 0 1-1.816 1.816H6.067a1.817 1.817 0 0 1-1.817-1.816v-.7c0-1.322.754-2.346 1.82-3.004Zm.789 1.276c-.744.46-1.109 1.053-1.109 1.729v.699c0 .174.142.316.317.316h7.867a.316.316 0 0 0 .316-.316v-.7c0-.675-.365-1.269-1.109-1.728-.757-.468-1.86-.756-3.141-.756-1.28 0-2.385.288-3.141.756Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMemberSmall_default = createIcon(SvgIcMemberSmall);
function SvgIcMemo(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.75 4A1.75 1.75 0 0 0 4 5.75v6.5c0 .595.297 1.12.75 1.436v2.877L7.313 14h6.937A1.75 1.75 0 0 0 16 12.25v-6.5A1.75 1.75 0 0 0 14.25 4h-8.5ZM13 7H7v1h6V7Zm0 3H7v1h6v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMemo_default = createIcon(SvgIcMemo);
function SvgIcMention(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.184 3.85c1.639-1.275 3.563-1.633 4.775-1.633 3.5 0 5.611 1.384 6.744 3.263 1.097 1.818 1.203 3.975.99 5.46-.141.995-.653 2.055-1.427 2.752-.394.354-.88.636-1.443.738-.573.104-1.172.011-1.754-.3-.349-.188-.577-.492-.731-.815a2.77 2.77 0 0 1-.528.428c-.505.316-1.122.48-1.85.48-1.52 0-2.517-.748-3.099-1.671-.555-.881-.73-1.906-.73-2.592 0-1.264.416-2.285 1.107-2.993a3.489 3.489 0 0 1 2.504-1.052 3.5 3.5 0 0 1 2.044.655v-.96h1.566v.625c-.001 1.986-.002 3.57.089 4.741.05.647.125 1.118.223 1.438.08.256.148.331.157.342.283.148.52.17.722.133.216-.039.447-.155.675-.361.471-.424.83-1.135.926-1.809.18-1.264.069-3.021-.781-4.43-.814-1.349-2.378-2.506-5.404-2.506-.961 0-2.517.295-3.814 1.303-1.259.98-2.362 2.699-2.362 5.743 0 1.146.385 2.494 1.323 3.545.92 1.03 2.437 1.847 4.853 1.847 1.827 0 2.78-.395 3.565-.787l.7 1.4c-.954.477-2.145.953-4.265.953-2.803 0-4.766-.966-6.02-2.37-1.237-1.384-1.722-3.124-1.722-4.588 0-3.48 1.29-5.675 2.967-6.979Zm3.175 4.21c-.37.378-.661.989-.661 1.9 0 .474.13 1.188.488 1.757.332.527.858.94 1.773.94.49 0 .808-.109 1.02-.242.214-.133.374-.323.496-.572.261-.53.311-1.237.311-1.883 0-.911-.292-1.522-.66-1.9a1.923 1.923 0 0 0-1.384-.58c-.507 0-1.008.195-1.383.58Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMention_default = createIcon(SvgIcMention);
function SvgIcMinusMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM7.5 11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMinusMedium_default = createIcon(SvgIcMinusMedium);
function SvgIcMinus(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          d: "M3 10a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
        }
      )
    }
  );
}
var IcMinus_default = createIcon(SvgIcMinus);
function SvgIcMore(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M11.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM10 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMore_default = createIcon(SvgIcMore);
function SvgIcMother(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FF9D9D",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm2.7-10.821c.256.118.488.29.683.509.196.218.35.476.457.761a2.583 2.583 0 0 1 0 1.796 2.381 2.381 0 0 1-.457.762l-.406.452L10 14l-2.978-2.541-.405-.452A2.49 2.49 0 0 1 6 9.347c0-.622.222-1.22.617-1.66.395-.44.93-.687 1.488-.687.559 0 1.094.247 1.49.688L10 8.14l.406-.452c.195-.218.427-.391.683-.51a1.918 1.918 0 0 1 1.611 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMother_default = createIcon(SvgIcMother);
function SvgIcMoveSolid(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 5.28 17 6.12 17 7.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 17 13.88 17 12.2 17H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 14.72 3 13.88 3 12.2V7.8Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M11.14 5a.5.5 0 0 0-.5.5v.355a.5.5 0 0 0 .5.5h1.547L9.925 9.117a.5.5 0 0 0 0 .707l.25.251a.5.5 0 0 0 .708 0l2.762-2.762V8.86a.5.5 0 0 0 .5.5h.355a.5.5 0 0 0 .5-.5V5.5a.5.5 0 0 0-.5-.5h-3.36Z"
          }
        )
      ]
    }
  );
}
var IcMoveSolid_default = createIcon(SvgIcMoveSolid);
function SvgIcMove(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7.873 4.63a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V7.544L5.69 15.726a.5.5 0 0 1-.708 0l-.707-.707a.5.5 0 0 1 0-.707l8.182-8.182H8.373a.5.5 0 0 1-.5-.5v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMove_default = createIcon(SvgIcMove);
function SvgIcMovie01(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1.25-4.969 4.5-2.598a.5.5 0 0 0 0-.866l-4.5-2.598a.5.5 0 0 0-.75.433v5.196a.5.5 0 0 0 .75.433Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMovie01_default = createIcon(SvgIcMovie01);
function SvgIcNoGrade(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 25 25",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 12.5, cy: 12.5, r: 9.5, stroke: "#DDD" }),
        /* @__PURE__ */ jsx("path", { stroke: "#DDD", strokeLinecap: "square", d: "M6 19 19 6" })
      ]
    }
  );
}
var IcNoGrade_default = createIcon(SvgIcNoGrade);
function SvgIcNormal(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Zm0 4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcNormal_default = createIcon(SvgIcNormal);
function SvgIcNoticeMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("mask", { id: "ic-notice-medium_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M15.891 2.461a.5.5 0 0 0-.353.612l.13.483L3.347 9a2 2 0 0 0-1.122 2.347l1.439 5.372a2 2 0 0 0 2.096 1.476l.738-.06.742 2.767a.5.5 0 0 0 .612.354l.966-.26a.5.5 0 0 0 .353-.611l-.647-2.418 10.766-.888.129.483a.5.5 0 0 0 .612.354l.966-.259a.5.5 0 0 0 .354-.612L17.47 2.555a.5.5 0 0 0-.613-.353l-.966.26Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "m15.891 2.461.518 1.932-.518-1.932Zm-.224 1.095.809 1.83 1.566-.693L17.6 3.04l-1.932.517ZM3.35 9 2.54 7.17 3.349 9Zm2.412 9.195-.164-1.993.164 1.993Zm.738-.06 1.932-.519-.432-1.612-1.664.137.164 1.993Zm1.354 3.12.518 1.933-.518-1.932Zm.966-.258L8.3 19.065l.518 1.932Zm.353-.613 1.932-.517-1.932.517Zm-.647-2.417-.165-1.993-2.387.197.62 2.314 1.932-.518Zm10.766-.888 1.931-.517-.432-1.613-1.664.137.165 1.993ZM16.857 2.202 16.34.27l.517 1.932Zm.613.354a1.5 1.5 0 0 1-1.061 1.837L15.374.529a2.5 2.5 0 0 0-1.768 3.062l3.864-1.035Zm.129.483-.13-.483-3.863 1.035.13.483 3.863-1.035Zm-2.74-1.312L2.54 7.171l1.616 3.658 12.319-5.443-1.617-3.659ZM2.54 7.171a4 4 0 0 0-2.247 4.694l3.863-1.036-1.616-3.658ZM.294 11.865l1.44 5.372 3.863-1.035-1.44-5.373-3.863 1.036Zm1.44 5.372a4 4 0 0 0 4.192 2.951l-.33-3.986-3.863 1.035Zm4.192 2.951.737-.06-.328-3.987-.738.06.329 3.987Zm-1.359-1.536.742 2.768 3.863-1.036-.741-2.768-3.864 1.036Zm.742 2.768a2.5 2.5 0 0 0 3.062 1.768l-1.036-3.864a1.5 1.5 0 0 1 1.837 1.06L5.31 21.42Zm3.062 1.768.965-.26-1.035-3.863-.966.259 1.036 3.864Zm.965-.26a2.5 2.5 0 0 0 1.768-3.061l-3.863 1.035a1.5 1.5 0 0 1 1.06-1.837l1.035 3.864Zm1.768-3.061-.647-2.418-3.864 1.036.648 2.417 3.863-1.035Zm-2.415.093 10.766-.887-.329-3.987-10.766.888.329 3.986Zm12.663-2.915-.13-.483-3.863 1.035.13.483 3.863-1.035Zm-1.837-1.061a1.5 1.5 0 0 1 1.837 1.06l-3.864 1.036a2.5 2.5 0 0 0 3.062 1.768l-1.035-3.864Zm.966-.259-.966.259 1.035 3.864.966-.26-1.035-3.863Zm-1.061 1.837a1.5 1.5 0 0 1 1.06-1.837l1.036 3.864a2.5 2.5 0 0 0 1.768-3.062l-3.864 1.035ZM15.538 3.073l3.882 14.49 3.864-1.036L19.4 2.038l-3.863 1.035Zm1.837 1.061a1.5 1.5 0 0 1-1.837-1.06L19.4 2.037A2.5 2.5 0 0 0 16.34.27l1.035 3.864Zm-.966.259.966-.259L16.34.27l-.966.26 1.035 3.863Z",
            mask: "url(#ic-notice-medium_svg__a)"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M6.56 9.395a.5.5 0 0 1 .354-.612l.966-.26a.5.5 0 0 1 .612.354l2.07 7.728a.5.5 0 0 1-.353.612l-.966.259a.5.5 0 0 1-.612-.354L6.56 9.395Z"
          }
        )
      ]
    }
  );
}
var IcNoticeMedium_default = createIcon(SvgIcNoticeMedium);
function SvgIcNoticeSolidMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#ic-notice-solid-medium_svg__a)", children: [
          /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "#EAEAEA", rx: 12 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              d: "M14.821 7.927a1.5 1.5 0 0 0-2.17-1.342L7.187 9.317c-2.211 1.105-2.211 4.26 0 5.366l5.462 2.732a1.5 1.5 0 0 0 2.171-1.342V7.927ZM18.471 12a2.65 2.65 0 0 0-2.65-2.65v1.3l.13.006a1.35 1.35 0 0 1-.13 2.694v1.3l.168-.005A2.65 2.65 0 0 0 18.47 12Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "ic-notice-solid-medium_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
      ]
    }
  );
}
var IcNoticeSolidMedium_default = createIcon(SvgIcNoticeSolidMedium);
function SvgIcNotice(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#DDD" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-.5 6h-1v-1H9v-3h-.5V9h2a.5.5 0 0 1 .5.5V13h.5v1h-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcNotice_default = createIcon(SvgIcNotice);
function SvgIcOvertimeMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M20.416 8.124a.5.5 0 0 0-.832 0l-2.066 3.099a.5.5 0 0 0 .416.777h4.132a.5.5 0 0 0 .416-.777l-2.066-3.099Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M12.882 3.043A9 9 0 1 0 21 12h-2a7 7 0 1 1-2.05-4.95l1.414-1.414a9 9 0 0 0-5.482-2.593Zm-2.005 8.284a.5.5 0 0 1-.147.354L8.19 14.223a.5.5 0 0 0 0 .707l.881.882a.5.5 0 0 0 .708 0l3.2-3.2a.5.5 0 0 0 .146-.354V8.006a.5.5 0 0 0-.5-.5h-1.247a.5.5 0 0 0-.5.5v3.321Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcOvertimeMedium_default = createIcon(SvgIcOvertimeMedium);
function SvgIcPasswordErrorXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 18, cy: 18, r: 15, fill: "#F4F4F4" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#CCC",
            fillRule: "evenodd",
            d: "M14.25 13a3.75 3.75 0 1 1 7.5 0v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V13a2.25 2.25 0 0 0-4.5 0v3H22a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h.25v-3ZM19 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs(
          "mask",
          {
            id: "ic-password-error-xlarge_svg__a",
            width: 14,
            height: 14,
            x: 21,
            y: 21,
            fill: "#000",
            maskUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M21 21h14v14H21z" }),
              /* @__PURE__ */ jsx(
                "path",
                {
                  fillRule: "evenodd",
                  d: "M28 33a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-.75-7.75a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0v-3Zm1.5 5.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
                  clipRule: "evenodd"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F66",
            fillRule: "evenodd",
            d: "M28 33a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-.75-7.75a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0v-3Zm1.5 5.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M31 28a3 3 0 0 1-3 3v4a7 7 0 0 0 7-7h-4Zm-3-3a3 3 0 0 1 3 3h4a7 7 0 0 0-7-7v4Zm-3 3a3 3 0 0 1 3-3v-4a7 7 0 0 0-7 7h4Zm3 3a3 3 0 0 1-3-3h-4a7 7 0 0 0 7 7v-4Zm0-8.5a2.75 2.75 0 0 0-2.75 2.75h4c0 .69-.56 1.25-1.25 1.25v-4Zm2.75 2.75A2.75 2.75 0 0 0 28 22.5v4c-.69 0-1.25-.56-1.25-1.25h4Zm0 3v-3h-4v3h4ZM28 31a2.75 2.75 0 0 0 2.75-2.75h-4c0-.69.56-1.25 1.25-1.25v4Zm-2.75-2.75A2.75 2.75 0 0 0 28 31v-4c.69 0 1.25.56 1.25 1.25h-4Zm0-3v3h4v-3h-4ZM28 33.5a2.75 2.75 0 0 0 2.75-2.75h-4c0-.69.56-1.25 1.25-1.25v4Zm-2.75-2.75A2.75 2.75 0 0 0 28 33.5v-4c.69 0 1.25.56 1.25 1.25h-4ZM28 28a2.75 2.75 0 0 0-2.75 2.75h4c0 .69-.56 1.25-1.25 1.25v-4Zm2.75 2.75A2.75 2.75 0 0 0 28 28v4c-.69 0-1.25-.56-1.25-1.25h4Z",
            mask: "url(#ic-password-error-xlarge_svg__a)"
          }
        )
      ]
    }
  );
}
var IcPasswordErrorXlarge_default = createIcon(SvgIcPasswordErrorXlarge);
function SvgIcPaste(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M16.244 4.856A1.75 1.75 0 0 0 14.5 3.25h-6l-.144.006A1.75 1.75 0 0 0 6.75 5v.75h1.5V5l.007-.057A.25.25 0 0 1 8.5 4.75h6l.057.007A.25.25 0 0 1 14.75 5v7l-.007.057a.25.25 0 0 1-.243.193h-.25v1.5h.25l.143-.006A1.75 1.75 0 0 0 16.25 12V5l-.006-.144Zm-2.75 3A1.75 1.75 0 0 0 11.75 6.25h-6l-.144.006A1.75 1.75 0 0 0 4 8v7l.006.143A1.75 1.75 0 0 0 5.75 16.75h6l.143-.006A1.75 1.75 0 0 0 13.5 15V8l-.006-.144Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPaste_default = createIcon(SvgIcPaste);
function SvgIcPaymentMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7 4a2 2 0 0 0-2 2v1.17A3.001 3.001 0 0 0 3 10v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1V6a2 2 0 0 0-2-2H7Zm8 3V6h-5v1h5ZM8.5 7V6H7v1h1.5ZM6 9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H6Zm8.5 3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPaymentMedium_default = createIcon(SvgIcPaymentMedium);
function SvgIcPhoto(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M16 5H4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-9A.5.5 0 0 0 16 5ZM4 3.5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2H4Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-5 5v-1.31l2-1.714 2.153 1.845a2 2 0 0 0 2.788-.18L13.5 9.742l3 3.334V14.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5Zm14.5 0v-2l-3.757-4.174a1 1 0 0 0-1.486 0l-3.43 3.811a.5.5 0 0 1-.698.045l-2.478-2.124a1 1 0 0 0-1.302 0L2 12.5v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcPhoto_default = createIcon(SvgIcPhoto);
function SvgIcPinXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            d: "M6 16.032C6 9.338 11.439 4 18 4s12 5.338 12 12.032c0 3.244-1.277 6.288-3.564 8.555l-6.584 6.634-.003.003A2.6 2.6 0 0 1 18 32c-.68 0-1.348-.27-1.849-.775l-.003-.003-6.587-6.638A11.978 11.978 0 0 1 6 16.032Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 18, cy: 16, r: 8, fill: "#fff" })
      ]
    }
  );
}
var IcPinXlarge_default = createIcon(SvgIcPinXlarge);
function SvgIcPin(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 3C6.692 3 4 5.617 4 8.833c0 1.566.63 3.037 1.773 4.139l4.014 3.941a.303.303 0 0 0 .426 0l4.012-3.94A5.715 5.715 0 0 0 16 8.834C16 5.617 13.308 3 10 3Zm0 8a2.503 2.503 0 0 1-2.5-2.5C7.5 7.122 8.621 6 10 6s2.5 1.122 2.5 2.5S11.379 11 10 11Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPin_default = createIcon(SvgIcPin);
function SvgIcPlayXlarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 18, cy: 18, r: 15, fill: "#333" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M24.5 17.134a1 1 0 0 1 0 1.732l-9 5.196a1 1 0 0 1-1.5-.866V12.804a1 1 0 0 1 1.5-.866l9 5.196Z"
          }
        )
      ]
    }
  );
}
var IcPlayXlarge_default = createIcon(SvgIcPlayXlarge);
function SvgIcPlusMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm.5-15a.5.5 0 0 1 .5.5V11h3.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H7.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V7.5a.5.5 0 0 1 .5-.5h1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPlusMedium_default = createIcon(SvgIcPlusMedium);
function SvgIcPopup(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#DDD", d: "M5 8a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1H5V8Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M7 5.25h10A2.75 2.75 0 0 1 19.75 8v9A2.75 2.75 0 0 1 17 19.75H7A2.75 2.75 0 0 1 4.25 17V8A2.75 2.75 0 0 1 7 5.25Zm10 1.5H7c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 8, height: 2, x: 8, y: 11, fill: "#999", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 4, height: 2, x: 8, y: 14, fill: "#999", rx: 1 })
      ]
    }
  );
}
var IcPopup_default = createIcon(SvgIcPopup);
function SvgIcPreview(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M7.5 2.5h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-9l4-4Zm2.5 5c-2.045 0-3.792 1.244-4.5 3 .708 1.756 2.455 3 4.5 3 2.046 0 3.792-1.244 4.5-3-.708-1.756-2.454-3-4.5-3Zm0 5c-1.13 0-2.045-.896-2.045-2s.916-2 2.045-2c1.13 0 2.046.896 2.046 2s-.917 2-2.046 2Zm-1.227-2c0-.664.548-1.2 1.227-1.2.68 0 1.227.536 1.227 1.2 0 .664-.548 1.2-1.227 1.2-.68 0-1.227-.536-1.227-1.2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M3.5 6.5h4v-4",
            clipRule: "evenodd",
            opacity: 0.5
          }
        )
      ]
    }
  );
}
var IcPreview_default = createIcon(SvgIcPreview);
function SvgIcPriceMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M17.872 5.518a1.175 1.175 0 0 1 1.064 1.064l.485 5.334c.032.347-.093.69-.34.937l-6.636 6.636a1.175 1.175 0 0 1-1.662 0L4.965 13.67a1.175 1.175 0 0 1 0-1.661l6.637-6.637c.247-.246.59-.37.937-.339l5.334.485Zm3.056.883a3.175 3.175 0 0 0-2.875-2.875l-5.334-.485a3.175 3.175 0 0 0-2.532.917L3.55 10.595a3.175 3.175 0 0 0 0 4.49l5.82 5.819a3.175 3.175 0 0 0 4.49 0l6.636-6.637a3.175 3.175 0 0 0 .917-2.532L20.928 6.4Zm-7.22 4.159a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPriceMedium_default = createIcon(SvgIcPriceMedium);
function SvgIcProceeding(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 18, height: 18, x: 3, y: 3, fill: "#D6E9FB", rx: 6 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcProceeding_default = createIcon(SvgIcProceeding);
function SvgIcPush(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M14.9 9.662c0 1.286.607 2.5 1.665 3.331.279.222.435.537.435.87C17 14.49 16.45 15 15.775 15H4.225C3.549 15 3 14.49 3 13.862c0-.332.156-.647.428-.863 1.065-.836 1.672-2.05 1.672-3.337V7.85c0-2.287 1.829-4.18 4.2-4.498V2.65c0-.36.314-.65.7-.65.386 0 .7.29.7.65v.702c2.37.317 4.2 2.21 4.2 4.498v1.812ZM13 16c-.284 1.14-1.521 2-3 2s-2.716-.86-3-2h6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPush_default = createIcon(SvgIcPush);
function SvgIcQrcode(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M16 2a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2H16Zm-.5 1.5a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1h2.5ZM7.5 10.5a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3.5a2 2 0 0 1 2-2h3.5ZM7 12a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1H7ZM7.5 2a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3.5ZM7 3.5a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1H7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#555", d: "M7 4.5H4.5V7H7z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M16 10.5a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2v-3.5a2 2 0 0 1 2-2H16Zm-.5 1.5a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#555", d: "M15.5 13H13v2.5h2.5z" })
      ]
    }
  );
}
var IcQrcode_default = createIcon(SvgIcQrcode);
function SvgIcRatioMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.291 15.82a.503.503 0 0 0 0 .711l.712.712a.503.503 0 0 0 .712 0l5.338-5.338 2.49 2.491a.503.503 0 0 0 .713 0l1.067-1.067 3.559-3.559 1.481 1.482a.539.539 0 0 0 .919-.343l.325-4.532a.539.539 0 0 0-.576-.575l-4.532.325a.539.539 0 0 0-.342.918l1.301 1.302-3.558 3.558-2.491-2.49a.503.503 0 0 0-.712 0l-1.068 1.067-5.338 5.338Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcRatioMedium_default = createIcon(SvgIcRatioMedium);
function SvgIcReceiverMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M13.346 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm4.409 7.493a1.07 1.07 0 0 0-1.412-1.292l-7.156 2.744c-.854.328-.93 1.505-.126 1.94l2.305 1.247 3.472-3.795a.5.5 0 0 1 .707-.032l.236.216a.5.5 0 0 1 .031.707l-3.484 3.808 1.408 2.126c.504.762 1.67.581 1.92-.297l2.099-7.372ZM12.608 22a.2.2 0 0 1-.193-.253l.442-1.603a.2.2 0 0 1 .193-.147h5.61c0-2.766-1.886-5.008-4.213-5.008a.13.13 0 0 1-.126-.165l.459-1.665a.195.195 0 0 1 .208-.144c3.004.325 5.358 3.327 5.358 6.982v.462c0 .851-.58 1.541-1.297 1.541h-6.44Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcReceiverMedium_default = createIcon(SvgIcReceiverMedium);
function SvgIcRefresh(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15.133 5.243a7 7 0 1 0 1.536 6.89.473.473 0 0 0-.351-.599l-1.115-.27a.224.224 0 0 0-.27.16 5.133 5.133 0 1 1-.973-4.691H11.9a.5.5 0 0 0-.5.5V8.1a.5.5 0 0 0 .5.5h4.6a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-.867a.5.5 0 0 0-.5.5v1.743Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcRefresh_default = createIcon(SvgIcRefresh);
function SvgIcRepeat(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M6 6.75c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25a.75.75 0 0 1 0 1.5A2.75 2.75 0 0 1 3.25 12V8A2.75 2.75 0 0 1 6 5.25h5.008a.75.75 0 0 1 0 1.5H6ZM13.25 6a.75.75 0 0 1 .75-.75A2.75 2.75 0 0 1 16.75 8v4A2.75 2.75 0 0 1 14 14.75H8.998a.75.75 0 0 1 0-1.5H14c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1-.75-.75Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10.029 3.968A.75.75 0 1 0 8.97 5.032L9.945 6l-.974.968a.75.75 0 0 0 1.058 1.064l1.508-1.5a.75.75 0 0 0 .003-1.06l-.002-.002-.001-.002m0 0-1.508-1.5 1.508 1.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M9.98 11.968a.75.75 0 1 1 1.057 1.064l-.974.968.974.968a.75.75 0 0 1-1.058 1.064l-1.508-1.5a.75.75 0 0 1-.002-1.062"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#333", d: "m9.98 11.968-1.509 1.5 1.508-1.5Z" })
      ]
    }
  );
}
var IcRepeat_default = createIcon(SvgIcRepeat);
function SvgIcReply(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M2 4.5v4a3.75 3.75 0 0 0 3.75 3.75h9.47l-2.397 2.396a.5.5 0 0 0 0 .708l.354.353a.5.5 0 0 0 .707 0l3.823-3.823a.5.5 0 0 0 0-.707l-3.823-3.823a.5.5 0 0 0-.707 0l-.354.353a.5.5 0 0 0 0 .707l2.336 2.336H5.75A2.25 2.25 0 0 1 3.5 8.5v-4A.5.5 0 0 0 3 4h-.5a.5.5 0 0 0-.5.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcReply_default = createIcon(SvgIcReply);
function SvgIcReportMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1Zm1 3a1 1 0 0 1-1-1H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1a1 1 0 0 1-1 1H9ZM8 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1Zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcReportMedium_default = createIcon(SvgIcReportMedium);
function SvgIcRequired(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          d: "M9 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v5.768l4.994-2.884a.5.5 0 0 1 .683.183l.5.866a.5.5 0 0 1-.183.683L12 10l4.995 2.884a.5.5 0 0 1 .183.683l-.5.866a.5.5 0 0 1-.683.183L11 11.732V17.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5.768l-4.996 2.884a.5.5 0 0 1-.683-.183l-.5-.866a.5.5 0 0 1 .183-.683L8 10 3.005 7.116a.5.5 0 0 1-.183-.683l.5-.866a.5.5 0 0 1 .683-.183L9 8.268V2.5Z"
        }
      )
    }
  );
}
var IcRequired_default = createIcon(SvgIcRequired);
function SvgIcResendPushMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8.211 20.598c1.155.667 2.623.416 3.72-.51.284-.24.242-.667-.045-.832l-4.35-2.512c-.287-.165-.678.012-.743.378-.254 1.413.264 2.81 1.418 3.476ZM21.591 16.867a.966.966 0 0 0 0-1.728l-6.19-3.096a.966.966 0 0 0-1.37 1.099l.575 2.296h4.566c.294 0 .531.237.531.53v.13a.531.531 0 0 1-.53.532H14.59l-.558 2.234a.966.966 0 0 0 1.369 1.098l6.19-3.095Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M16.05 3.308c-.353-.204-.905-.448-1.49-.215a1.397 1.397 0 0 0-.578.438c-.05.064-.096.13-.132.189-2.363-.627-4.942.14-6.178 2.282l-.856 1.482c-.433.75-1.236 1.278-2.272 1.396l-.006.001a2.021 2.021 0 0 0-1.526.985c-.633 1.096-.06 2.36.892 2.91l8.864 5.117L13.24 16l-.042-.169-8.295-4.789a.32.32 0 0 1-.147-.163l-.003-.01a.172.172 0 0 1 .02-.003c1.6-.183 2.994-1.031 3.774-2.383l.856-1.482c.773-1.34 2.663-1.93 4.513-1.152l.535.226.463.35c1.555 1.18 2.008 3.042 1.319 4.376l1.789.894c1.077-2.1.437-4.602-1.23-6.277.033-.06.068-.133.098-.209.065-.165.134-.417.09-.718-.091-.624-.578-.98-.931-1.184Zm1.258 9.638-1.791-.896-.198.342a4.752 4.752 0 0 0-.58 3.036h2.03c-.165-.736-.057-1.45.282-2.036l.258-.446Zm-.173 3.691h-2.082a5.54 5.54 0 0 0 .095.236l-.01.002a.32.32 0 0 1-.214-.047l-.331-.191h-.03l-.5 1.998c.944.46 2.225.287 2.827-.757.225-.39.298-.822.245-1.241Zm-1.965.227-.002.002a.007.007 0 0 1 .002-.002ZM4.75 10.848v.003-.003Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcResendPushMedium_default = createIcon(SvgIcResendPushMedium);
function SvgIcResendPush(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M11.36 3.071c.44-.175.854.008 1.119.161.264.153.63.42.698.888.033.226-.019.415-.068.539-.022.057-.049.111-.073.157 1.25 1.256 1.73 3.132.922 4.707l-1.342-.67c.518-1 .177-2.397-.989-3.282l-.347-.263-.401-.169c-1.387-.583-2.805-.141-3.385.864l-.642 1.111c-.585 1.014-1.63 1.65-2.83 1.788h.001l-.089-.745.085.745h.003a.129.129 0 0 0-.016.003l.002.007a.24.24 0 0 0 .11.122l6.222 3.591.032.127-.355 1.419-6.648-3.838C2.655 9.92 2.225 8.973 2.7 8.15c.247-.428.68-.682 1.145-.738h.004c.777-.089 1.38-.486 1.704-1.048l.642-1.111c.927-1.607 2.861-2.182 4.634-1.712.027-.044.06-.094.099-.142.083-.104.22-.243.432-.328Zm.718 6.718 1.345.672-.017.029 3.23 1.615a.724.724 0 0 1 0 1.296l-4.643 2.321a.724.724 0 0 1-1.027-.823l.04-.163-.017-.009.374-1.498h.02l.002-.006h3.436c.22 0 .399-.178.399-.398v-.097a.398.398 0 0 0-.399-.399h-3.425l-.43-1.722a.724.724 0 0 1 1.027-.824l.069.035.016-.03Zm-8.074-.902v.002-.002ZM6.6 16.2c.866.5 1.967.312 2.79-.382.213-.18.181-.5-.034-.625l-3.262-1.884c-.216-.124-.509.009-.558.284-.19 1.06.198 2.107 1.064 2.607Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcResendPush_default = createIcon(SvgIcResendPush);
function SvgIcReturn(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8 3.5 4 7l4 3.5v-2h1.682c1.604.06 2.857 1.522 2.857 3.794 0 2.323-2.77 4.206-2.77 4.206C12.66 16.5 15 14.038 15 11s-2.342-5.5-5.23-5.5H8v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcReturn_default = createIcon(SvgIcReturn);
function SvgIcRightArrowXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.47 1.47a.75.75 0 0 0 0 1.06L6.94 6 3.47 9.47a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06l-4-4a.75.75 0 0 0-1.06 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcRightArrowXsmall_default = createIcon(SvgIcRightArrowXsmall);
function SvgIcRightArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6.27 16.733a.906.906 0 0 1-.089-1.19l.09-.102L11.77 10l-5.5-5.441a.906.906 0 0 1-.09-1.19l.09-.102a.93.93 0 0 1 1.201-.088l.104.088 6.154 6.087a.906.906 0 0 1 .089 1.19l-.09.102-6.153 6.087a.93.93 0 0 1-1.306 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcRightArrow_default = createIcon(SvgIcRightArrow);
function SvgIcSalesMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M20.038 3.012c.326 0 .577.288.531.611l-.636 4.47a.535.535 0 0 1-.934.275l-1.274-1.466-4.884 4.245a1.089 1.089 0 0 1-1.536-.107l-1.98-2.277L5.1 12.435a.5.5 0 0 1-.705-.05l-.773-.888a.5.5 0 0 1 .05-.706l5.046-4.386a1.089 1.089 0 0 1 1.536.107l1.98 2.277 4.062-3.53-1.175-1.352a.535.535 0 0 1 .403-.886l4.514-.009ZM17 11.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8Zm-8 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5ZM5.5 16a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1Zm7.5-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSalesMedium_default = createIcon(SvgIcSalesMedium);
function SvgIcScheduleMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15 4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V5h1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1v-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V5h6v-.5ZM6 7a1 1 0 0 0-1 1v1h14V8a1 1 0 0 0-1-1H6ZM5 17v-6h14v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Zm3.5-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcScheduleMedium_default = createIcon(SvgIcScheduleMedium);
function SvgIcSearch(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.345 3.344a8.005 8.005 0 0 1 11.952 10.61l3.425 3.425a.95.95 0 0 1-1.342 1.343l-3.425-3.425A8.006 8.006 0 0 1 3.345 3.344Zm9.91 1.415a6.009 6.009 0 1 0-8.497 8.498 6.009 6.009 0 0 0 8.497-8.498Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSearch_default = createIcon(SvgIcSearch);
function SvgIcSend(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          d: "M14.885 3.099 3.375 8.937a.735.735 0 0 0 .037 1.3l2.914 1.445a.5.5 0 0 0 .562-.082l5.137-4.76a.278.278 0 0 1 .378.011.272.272 0 0 1 .007.38l-4.067 5.095a1 1 0 0 0-.219.624v2.707a.5.5 0 0 0 .878.327l1.728-1.999 3.56 1.815a.746.746 0 0 0 1.076-.535l.623-11.404c.104-.614-.559-1.07-1.104-.762Z"
        }
      )
    }
  );
}
var IcSend_default = createIcon(SvgIcSend);
function SvgIcSettingMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "m4.287 13.49.554-.832-.554.833Zm-.23-.271.912-.41-.913.41Zm0-2.438.912.41-.913-.41Zm.23-.272-.554-.832.554.832ZM5.49 7.6l-.98.198.98-.197Zm.03-.355.934.356-.935-.356Zm.377-.457-.708-.707.708.707Zm1.346-1.266.355.934-.355-.934Zm.355-.03.197-.98-.197.98Zm2.91-1.204-.832-.554.833.554Zm.273-.23-.41-.913.41.912Zm2.437 0-.41.912.41-.913Zm.272.23.833-.554-.833.554Zm2.91 1.206.197.98-.198-.98Zm.355.03-.356.934.356-.935Zm.457.377.707-.707-.707.707Zm.889.889.78-.625-.034-.043-.039-.04-.707.708Zm0 0-.781.625.035.043.039.039.707-.707Zm.377.457-.934.355.934-.355Zm.03.355.98.197-.98-.197Zm1.205 2.908.554-.832-.554.832Zm.23.272.913-.409-.912.41Zm0 2.438-.912-.41.913.41Zm-.23.272.554.832-.554-.832ZM18.507 16.4l-.98.197.98-.197Zm-.03.355.935.356-.935-.356Zm-1.723 1.723-.356-.934.356.934Zm-.356.03.198-.98-.198.98Zm-2.755.633-.987-.165.987.165Zm-.153.572.833.554-.833-.554Zm-.272.23.41.913-.41-.912Zm-2.437 0-.41.913.41-.912Zm-.272-.23-.833.554.833-.554Zm-2.91-1.204-.196-.98.197.98Zm-.355-.03-.355.936.355-.935Zm-.457-.376-.707.707.707-.707Zm-.889-.89-.707.708.707-.707Zm-.377-.456-.934.355.934-.355Zm-.03-.356.981.197-.98-.197Zm10.082 1.596.484-.874-.484.874Zm-1.93 1.143.986.165-.986-.165Zm.07-.373.962.276-.962-.276Zm-.07-13.908-.987.165.987-.165Zm.07.375-.96.277.96-.277Zm2.174.556.58.814-.58-.814Zm-.315.214-.484-.875.484.875Zm3.569 7.64-.165-.987.165.986Zm-.375.07.276.961-.277-.96Zm-.556 2.173-.814.581.814-.581Zm-.214-.314-.875.484.875-.484Zm-13.137-1.93.165-.986-.165.986Zm.376.071.276-.96-.276.96Zm.554 2.174-.814-.58.814.58Zm.215-.316-.875-.484.875.484Zm4.198-4.563.843.539-.843-.539Zm-.172.416-.976-.215.976.215Zm-4.799-1.139-.275-.961.275.961Zm.556-2.174.814-.58-.814.58ZM6 8.427l.875-.485L6 8.427Zm5.424 1.603-.215-.976.215.976Zm-.416.172.539.843-.539-.843Zm2.96 1.227.977-.215-.976.215Zm-.171-.415.843-.539-.843.539Zm-5.37-5.01.483-.875-.484.875Zm1.928-1.145.987.165-.987-.165Zm-.07.376.96.276-.96-.276ZM8.112 18.212 7.53 17.4l.582.813Zm.314-.214.484.875-.484-.875Zm4.987-7.41.707-.708-.707.707Zm-.43-.387.538-.843-.537.843Zm-.411-.17.217-.977-.217.977Zm1.225 2.955-.843-.538.843.538Zm.172-.415-.977-.215.977.215Zm-1.398 1.399.217.976-.217-.976Zm.842-.557.707.707-.707-.707Zm-.429.386.538.843-.538-.843Zm-1.974 0-.538.842.538-.843Zm.414.17-.215.977.215-.976Zm6.786-5.855-.814-.581.814.581Zm-.214.313.875.485-.875-.485Zm1.143 1.93-.164.986.165-.986Zm-.373-.07-.275.96.275-.96Zm-8.565 2.702.843-.538-.843.538Zm-.172-.414-.976.215.976-.215Zm-6.297 1.748c.192.128.382.188.53.225.136.033.294.059.432.082l.329-1.973-.188-.032-.096-.02c-.033-.008.024.002.1.053l-1.107 1.665Zm-.59-.695c.128.283.332.524.59.695l1.108-1.665c.056.037.1.09.128.151l-1.825.819Zm-.143-1c0 .14 0 .3.01.44.011.152.04.35.134.56l1.825-.819c.038.085.038.142.035.108A13.821 13.821 0 0 1 5 12.63H3Zm0-1.257v1.258h2V11.37H3Zm.144-.999c-.094.21-.123.408-.134.56-.01.14-.01.3-.01.44h2a13.821 13.821 0 0 1 .004-.29c.003-.033.003.024-.035.109l-1.825-.819Zm.59-.695a1.643 1.643 0 0 0-.59.695l1.825.819a.357.357 0 0 1-.128.15L3.733 9.678Zm.961-.307c-.138.023-.296.049-.432.082a1.647 1.647 0 0 0-.53.225l1.108 1.665c-.077.051-.134.06-.101.053.017-.005.046-.01.096-.02l.188-.032-.329-1.973ZM4.51 7.797c.045.225.137.403.216.533.072.12.166.25.247.364L6.601 7.53a13.779 13.779 0 0 1-.165-.237c-.017-.03.016.018.034.108l-1.96.395Zm.075-.909c-.11.29-.137.605-.075.909l1.96-.395a.357.357 0 0 1-.016.198l-1.87-.712Zm.604-.808c-.098.099-.212.212-.303.318-.1.115-.22.275-.301.49l1.869.712c-.033.086-.074.127-.051.101a13.704 13.704 0 0 1 .201-.207L5.189 6.08Zm0 0 1.415 1.414L5.189 6.08Zm.89-.889-.89.89 1.415 1.413.889-.889-1.414-1.414Zm.808-.605a1.647 1.647 0 0 0-.49.301c-.107.092-.22.205-.318.304l1.414 1.414a13.703 13.703 0 0 1 .207-.2c.026-.023-.015.018-.102.05l-.711-1.869Zm.908-.075a1.643 1.643 0 0 0-.908.075l.711 1.87a.357.357 0 0 1-.197.016l.394-1.96Zm.897.464c-.114-.081-.244-.175-.363-.248a1.647 1.647 0 0 0-.534-.216l-.394 1.96c-.09-.017-.138-.05-.109-.033a13.799 13.799 0 0 1 .237.164l1.163-1.627Zm.984-1.242a1.648 1.648 0 0 0-.224.53c-.033.136-.06.294-.082.432l1.973.329.032-.188c.009-.05.015-.079.02-.096.007-.033-.002.024-.053.1L9.675 3.734Zm.696-.59a1.643 1.643 0 0 0-.696.59l1.665 1.108a.357.357 0 0 1-.15.128l-.82-1.825ZM11.37 3c-.14 0-.3 0-.44.01-.151.011-.35.04-.56.134l.82 1.825c-.085.038-.143.038-.109.035l.098-.003.19-.001V3Zm1.257 0h-1.257v2h1.257V3Zm1 .144a1.647 1.647 0 0 0-.56-.134c-.14-.01-.3-.01-.44-.01v2a13.821 13.821 0 0 1 .289.004c.034.003-.024.003-.108-.035l.818-1.825Zm.695.59a1.643 1.643 0 0 0-.696-.59l-.818 1.825a.357.357 0 0 1-.151-.128l1.665-1.108Zm.306.961c-.023-.138-.048-.296-.082-.432a1.648 1.648 0 0 0-.224-.53l-1.665 1.108c-.052-.077-.061-.134-.053-.101l.02.096.031.188 1.973-.329Zm1.573-.182a1.647 1.647 0 0 0-.533.216c-.12.072-.25.166-.364.247l1.163 1.628a14.46 14.46 0 0 1 .237-.165c.03-.017-.018.016-.108.034l-.395-1.96Zm.909.075a1.643 1.643 0 0 0-.909-.075l.395 1.96a.357.357 0 0 1-.198-.016l.712-1.87Zm.808.605c-.099-.1-.212-.213-.318-.304-.115-.1-.275-.22-.49-.301l-.712 1.869c-.086-.033-.127-.074-.101-.051a13.832 13.832 0 0 1 .207.201l1.414-1.414Zm.889.889-.89-.89-1.413 1.415.889.889 1.414-1.414Zm.074.082-1.562 1.25 1.562-1.25Zm.53.726a1.648 1.648 0 0 0-.3-.49c-.091-.107-.205-.22-.304-.318l-1.414 1.414.134.135c.036.037.055.059.067.072.022.026-.018-.015-.051-.102l1.869-.711Zm.076.908a1.644 1.644 0 0 0-.075-.908l-1.87.711a.357.357 0 0 1-.016-.197l1.961.394Zm-.464.897c.081-.114.175-.243.248-.363.079-.13.17-.308.216-.534l-1.96-.394c.018-.09.05-.138.033-.109a13.408 13.408 0 0 1-.164.237l1.627 1.163Zm1.243.982a1.646 1.646 0 0 0-.53-.225c-.136-.033-.294-.059-.432-.082l-.329 1.973.188.032c.05.01.079.015.096.02.033.008-.024-.002-.1-.053l1.107-1.665Zm.59.695a1.644 1.644 0 0 0-.59-.695l-1.108 1.665a.357.357 0 0 1-.128-.151l1.825-.819Zm.143 1c0-.14 0-.3-.01-.44a1.649 1.649 0 0 0-.134-.56l-1.825.819c-.038-.085-.038-.142-.035-.108.001.017.003.047.003.098l.001.19h2Zm0 1.257V11.37h-2v1.258h2Zm-.144.999c.094-.21.123-.408.134-.56.01-.14.01-.3.01-.44h-2v.191l-.004.098c-.003.034-.003-.024.035-.108l1.825.819Zm-.59.695c.259-.171.463-.412.59-.695l-1.825-.819a.357.357 0 0 1 .128-.151l1.108 1.665Zm-.961.307c.138-.023.296-.05.432-.082.148-.037.338-.097.53-.225l-1.108-1.665c.077-.051.134-.06.101-.053l-.096.02-.188.032.329 1.973Zm.182 1.572a1.646 1.646 0 0 0-.216-.533c-.073-.12-.166-.25-.248-.363l-1.627 1.162.11.155c.03.043.045.067.054.082.018.03-.015-.017-.034-.108l1.961-.395Zm-.075.909c.11-.29.136-.605.075-.909l-1.96.395a.358.358 0 0 1 .016-.198l1.869.712Zm-.605.808c.099-.099.213-.211.304-.317.1-.116.219-.276.3-.491l-1.868-.712c.033-.086.073-.127.05-.101a14.511 14.511 0 0 1-.201.207l1.415 1.414Zm-.889.89.89-.89-1.415-1.414-.89.889 1.415 1.414Zm-.808.604a1.65 1.65 0 0 0 .49-.301c.106-.091.22-.205.318-.304l-1.414-1.414a13.358 13.358 0 0 1-.207.201c-.026.022.015-.018.101-.051l.712 1.869Zm-.909.075c.304.061.62.035.909-.075l-.712-1.87a.357.357 0 0 1 .198-.015l-.395 1.96Zm-.896-.463c.113.08.243.174.363.247.13.079.308.17.533.216l.395-1.96c.09.018.137.051.108.033a12.317 12.317 0 0 1-.237-.164l-1.162 1.627Zm-.676.28-1.973-.329 1.973.329Zm-.306.962c.127-.192.188-.382.224-.53.034-.136.06-.294.082-.432l-1.973-.329-.032.188c-.009.05-.015.079-.02.096-.007.033.002-.024.054-.1l1.665 1.107Zm-.696.59c.283-.128.524-.332.696-.59l-1.665-1.108c.037-.056.09-.1.15-.128l.82 1.825Zm-.999.143c.14 0 .3 0 .44-.01.152-.011.35-.04.56-.134l-.82-1.825c.085-.038.143-.038.109-.035a1.697 1.697 0 0 1-.098.003l-.19.001v2Zm-1.257 0h1.257v-2h-1.257v2Zm-1-.144c.21.094.409.123.56.134.14.01.3.01.44.01v-2h-.19l-.099-.004c-.034-.003.024-.003.108.035l-.818 1.825Zm-.695-.59c.172.259.413.463.696.59l.818-1.825a.357.357 0 0 1 .152.128l-1.666 1.108Zm-.306-.961c.023.138.049.296.082.432.036.148.097.338.224.53l1.665-1.108c.052.077.061.134.053.101a1.664 1.664 0 0 1-.02-.096l-.031-.188-1.973.329ZM7.53 17.399a14.997 14.997 0 0 1-.237.164c-.03.018.018-.016.109-.034l.394 1.96c.226-.045.403-.137.534-.216.12-.072.25-.166.363-.247L7.53 17.4Zm-.128.13a.357.357 0 0 1 .197.016l-.711 1.87c.29.11.604.136.908.075l-.394-1.961Zm.197.016c.087.033.128.074.102.052a14.619 14.619 0 0 1-.207-.201L6.08 18.81c.1.099.212.212.318.303.116.1.276.22.49.302l.712-1.87Zm-.105-.15-.89-.889-1.414 1.415.89.889 1.414-1.414Zm-.89-.889a13.832 13.832 0 0 1-.2-.207c-.023-.026.018.015.05.102l-1.868.711c.081.215.201.375.3.491.092.106.206.219.304.318l1.415-1.415Zm-.15-.105c.025.063.03.131.017.197l-1.96-.394c-.062.304-.036.619.075.908l1.869-.711Zm.017.197c-.018.091-.052.138-.034.109.01-.015.025-.04.054-.082l.11-.155-1.627-1.163c-.081.114-.175.244-.247.364-.08.13-.171.307-.217.533l1.961.394Zm9.995.799c-.139-.1-.282-.203-.41-.274l-.97 1.749.037.025c.04.028.095.066.18.128l1.163-1.628Zm-1.838 1.908.037-.219.009-.043-1.923-.551c-.04.14-.068.315-.096.484l1.973.329Zm1.428-2.182a2.286 2.286 0 0 0-3.305 1.369l1.923.551a.286.286 0 0 1 .413-.171l.97-1.75Zm-3.4-12.1c.028.17.055.347.096.488l1.922-.553-.008-.043c-.01-.05-.02-.115-.038-.22l-1.973.329Zm2.648-.047-.18.129-.037.024.969 1.75c.128-.07.271-.176.41-.275l-1.162-1.628Zm-2.552.535a2.286 2.286 0 0 0 3.304 1.368l-.97-1.75a.286.286 0 0 1-.412-.17l-1.922.552Zm6.223 7.146c-.17.028-.346.056-.486.096l.552 1.922c-.012.004-.007.001.043-.008l.22-.037-.329-1.973Zm.047 2.649-.128-.181-.024-.037-1.75.97c.07.128.176.27.275.41l1.627-1.162Zm-.534-2.553a2.286 2.286 0 0 0-1.368 3.304l1.75-.969a.286.286 0 0 1 .17-.413l-.552-1.922ZM4.695 14.63l.22.037c.05.01.055.012.043.008l.553-1.922c-.141-.04-.318-.068-.487-.096l-.329 1.973Zm1.907 1.84c.1-.14.206-.285.277-.414l-1.75-.968-.025.037-.129.182 1.627 1.163Zm-1.644-1.795c.176.051.26.253.171.413l1.75.968a2.286 2.286 0 0 0-1.368-3.303l-.553 1.922Zm4.92-4.798c-.174.174-.37.363-.518.594l1.685 1.077c-.005.007-.001-.001.036-.042a7.97 7.97 0 0 1 .21-.214L9.878 9.877ZM11 12c0-.154 0-.239.003-.303.002-.056.006-.064.004-.056l-1.953-.43c-.06.268-.054.542-.054.79h2Zm-1.64-1.528a2.285 2.285 0 0 0-.306.739l1.953.43a.286.286 0 0 1 .038-.092L9.36 10.47Zm-4.336.872c.168-.028.342-.055.483-.095l-.551-1.923-.043.008c-.049.01-.114.02-.218.037l.329 1.973Zm-.05-2.65.128.182c.029.042.03.048.025.037l1.749-.97c-.07-.128-.176-.271-.275-.41L4.973 8.693Zm.533 2.555a2.286 2.286 0 0 0 1.369-3.306l-1.75.97c.09.16.006.362-.17.413l.55 1.923ZM11.997 9c-.246 0-.52-.005-.787.054l.43 1.953c-.008.002 0-.002.055-.004.064-.003.149-.003.302-.003V9Zm-.705 2.292a7.97 7.97 0 0 1 .214-.21c.041-.038.049-.042.042-.037L10.47 9.36c-.23.147-.42.344-.594.517l1.415 1.415Zm-.082-2.238a2.285 2.285 0 0 0-.739.306l1.077 1.685a.286.286 0 0 1 .092-.038l-.43-1.953ZM15 12c0-.246.005-.518-.054-.786l-1.953.43c-.002-.008.002 0 .004.055.003.064.003.148.003.301h2Zm-2.293-.706c.108.109.168.169.212.216.037.041.04.05.036.042l1.686-1.077c-.148-.23-.345-.42-.52-.595l-1.414 1.414Zm2.24-.08a2.287 2.287 0 0 0-.306-.739l-1.686 1.077c.018.028.031.06.038.092l1.953-.43ZM7.53 6.602c.14.1.284.206.413.277l.968-1.75c.011.006.006.004-.036-.025a14.415 14.415 0 0 1-.183-.13L7.53 6.603Zm1.84-1.907-.038.22-.008.043 1.922.553c.04-.141.068-.318.097-.487L9.37 4.695ZM7.943 6.88a2.286 2.286 0 0 0 3.303-1.368l-1.922-.553a.286.286 0 0 1-.413.171l-.968 1.75Zm3.4 12.097c-.028-.168-.056-.343-.096-.483l-1.922.551c-.004-.012-.001-.006.008.043l.037.218 1.973-.329Zm-2.65.05.182-.128c.042-.029.047-.03.036-.025l-.97-1.75c-.127.072-.27.176-.41.276l1.163 1.627Zm2.554-.533a2.286 2.286 0 0 0-3.305-1.37l.97 1.75a.286.286 0 0 1 .413.171l1.922-.551Zm2.874-8.613c-.175-.175-.366-.374-.6-.522l-1.073 1.687c-.008-.005 0-.002.042.036.047.044.108.104.217.213l1.414-1.414ZM11.997 11c.154 0 .24 0 .304.003.056.002.063.006.055.004l.434-1.953c-.27-.06-.545-.054-.793-.054v2Zm1.525-1.642a2.286 2.286 0 0 0-.732-.304l-.434 1.953c.033.007.064.02.092.038l1.074-1.687Zm.599 4.762c.175-.175.372-.364.52-.595l-1.686-1.077-.036.042a8.025 8.025 0 0 1-.212.216l1.414 1.414ZM13 12c0 .153 0 .237-.003.3-.002.056-.005.064-.004.056l1.953.43c.06-.268.054-.54.054-.786h-2Zm1.64 1.525c.145-.227.249-.477.306-.739l-1.953-.43a.286.286 0 0 1-.038.092l1.686 1.077ZM11.999 15c.247 0 .522.005.79-.054l-.432-1.953c.008-.002 0 .002-.055.004a8.153 8.153 0 0 1-.303.003v2Zm.709-2.294c-.11.109-.17.169-.217.213-.042.038-.05.04-.042.036l1.075 1.687c.232-.148.423-.347.598-.522l-1.414-1.414Zm.082 2.24c.26-.058.508-.16.734-.304l-1.075-1.687a.283.283 0 0 1-.092.038l.433 1.953Zm-2.911-.824c.174.174.363.371.595.52l1.076-1.687-.042-.036a8.005 8.005 0 0 1-.215-.211l-1.414 1.414ZM11.998 13c-.153 0-.238 0-.302-.003-.055-.002-.063-.005-.055-.004l-.431 1.953c.268.06.541.054.788.054v-2Zm-1.525 1.641c.226.144.475.247.737.305l.431-1.953a.285.285 0 0 1-.092-.038l-1.076 1.686Zm6.924-7.108c-.1.138-.203.281-.274.409l1.749.97.025-.037.127-.18-1.627-1.162Zm1.908 1.837-.219-.037c-.05-.01-.055-.012-.043-.008l-.551 1.922c.14.04.315.068.484.096l.329-1.973Zm-2.182-1.428a2.286 2.286 0 0 0 1.369 3.305l.551-1.922a.286.286 0 0 1-.171-.413l-1.75-.97Zm-5.83 4.766a8.005 8.005 0 0 1-.212-.215c-.037-.041-.04-.049-.036-.042l-1.686 1.076c.148.232.345.42.519.595l1.414-1.414ZM9 11.999c0 .248-.005.523.054.791l1.953-.431c.002.008-.002 0-.004-.056A8.245 8.245 0 0 1 11 12H9Zm2.045.452a.285.285 0 0 1-.038-.092l-1.953.431c.058.262.16.511.305.737l1.686-1.076Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 12.001, cy: 12, r: 2.429, stroke: "#333", strokeWidth: 2 })
      ]
    }
  );
}
var IcSettingMedium_default = createIcon(SvgIcSettingMedium);
function SvgIcSetting(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8.399 15.556c.07.138.106.35.177.775.04.238.06.357.119.446a.5.5 0 0 0 .211.18c.098.043.218.043.46.043h1.269c.24 0 .361 0 .459-.044a.5.5 0 0 0 .211-.18c.06-.088.08-.207.119-.445.07-.424.106-.636.177-.774a1 1 0 0 1 1.196-.496c.148.048.323.173.673.423.196.14.294.21.399.231a.5.5 0 0 0 .276-.023c.1-.038.186-.123.356-.293l.898-.898c.17-.17.255-.255.293-.355a.5.5 0 0 0 .023-.277c-.021-.105-.091-.203-.231-.399-.25-.35-.375-.525-.423-.673a1 1 0 0 1 .495-1.196c.139-.071.351-.106.775-.177.238-.04.357-.06.446-.119a.5.5 0 0 0 .18-.211c.043-.098.043-.218.043-.46V9.366c0-.24 0-.361-.044-.459a.5.5 0 0 0-.18-.211c-.088-.06-.207-.08-.445-.119-.424-.07-.637-.106-.775-.177a1 1 0 0 1-.495-1.196c.047-.148.172-.323.422-.673.14-.196.21-.294.231-.4a.5.5 0 0 0-.022-.276c-.039-.1-.124-.185-.294-.355L14.5 4.6c-.17-.17-.255-.255-.355-.293a.5.5 0 0 0-.277-.023c-.104.02-.202.09-.398.23-.35.25-.525.376-.673.423a1 1 0 0 1-1.196-.495c-.071-.139-.106-.35-.177-.775-.04-.237-.06-.356-.119-.445a.5.5 0 0 0-.211-.18C10.996 3 10.876 3 10.634 3H9.366c-.24 0-.361 0-.459.044a.5.5 0 0 0-.211.18c-.06.088-.08.207-.119.444-.07.425-.106.637-.177.776a1 1 0 0 1-1.196.495c-.148-.048-.323-.173-.673-.423-.196-.14-.294-.21-.4-.231a.5.5 0 0 0-.276.023c-.1.038-.185.123-.355.293L4.6 5.5c-.17.17-.255.255-.293.355a.5.5 0 0 0-.023.277c.02.105.09.203.23.399.25.35.376.525.424.673A1 1 0 0 1 4.443 8.4c-.138.071-.35.106-.775.177-.237.04-.356.06-.445.119a.5.5 0 0 0-.18.211C3 9.004 3 9.124 3 9.366v1.269c0 .24 0 .361.044.459a.5.5 0 0 0 .18.211c.088.06.207.08.444.119.424.07.636.106.775.177a1 1 0 0 1 .495 1.196c-.048.148-.173.323-.423.673-.14.196-.21.294-.23.399a.5.5 0 0 0 .022.276c.038.1.124.186.294.356l.897.898c.17.17.256.255.356.293a.5.5 0 0 0 .276.023c.105-.021.203-.091.4-.231.35-.25.525-.376.673-.423a1 1 0 0 1 1.196.495ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSetting_default = createIcon(SvgIcSetting);
function SvgIcShortcutXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 1.5h5.5V7H9V4.121l-6.44 6.44L1.5 9.5 8 3H5V1.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcShortcutXsmall_default = createIcon(SvgIcShortcutXsmall);
function SvgIcShowMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4 7a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcShowMedium_default = createIcon(SvgIcShowMedium);
function SvgIcSign(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 12, height: 1.5, x: 4, y: 17, fill: "#333", rx: 0.75 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M2.708 14.395c3.688-1.986 8.517-9.377 6.152-10.832-2.978-1.832-5.796 10.779-.656 10.832 3.582.037 5.369-3.651 5.709-6.034.425-2.978-1.912-2.225-2.451.806-.403 2.266-.28 5.228 1.618 5.228 1.897 0 2.42-2.895 2.322-2.665-.084.638 1.046 2.322 1.897 2.665"
          }
        )
      ]
    }
  );
}
var IcSign_default = createIcon(SvgIcSign);
function SvgIcSignature(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15.033 2.278a.95.95 0 0 0-1.344 0l-2.017 2.017a.947.947 0 0 0-.278.677c-.085-.003-.17 0-.255.009l-4.966.552A1.664 1.664 0 0 0 4.76 6.717l-2.69 9.148c-.372 1.263.802 2.437 2.065 2.065l9.148-2.69a1.663 1.663 0 0 0 1.184-1.413l.552-4.966c.01-.085.012-.17.009-.255a.948.948 0 0 0 .677-.278l2.017-2.017a.95.95 0 0 0 0-1.344l-2.689-2.689Zm-3.736 4.12a.238.238 0 0 1 .194.068l2.043 2.043a.237.237 0 0 1 .068.194l-.552 4.967a.238.238 0 0 1-.17.202l-8.613 2.533 3.75-3.75a1.902 1.902 0 1 0-.671-.673l-3.751 3.751L6.128 7.12a.238.238 0 0 1 .202-.169l4.967-.552Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSignature_default = createIcon(SvgIcSignature);
function SvgIcSolved(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15.884 6.116a1.25 1.25 0 0 1 0 1.768l-6.25 6.25a1.25 1.25 0 0 1-1.768 0l-3.75-3.75a1.25 1.25 0 0 1 1.768-1.768l2.866 2.866 5.366-5.366a1.25 1.25 0 0 1 1.768 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSolved_default = createIcon(SvgIcSolved);
function SvgIcSortingAtoz(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5.801 3a.5.5 0 0 0-.5.5v9.833h-1a.5.5 0 0 0-.4.8l2 2.667a.5.5 0 0 0 .8 0l2-2.667a.5.5 0 0 0-.4-.8h-1V3.5a.5.5 0 0 0-.5-.5h-1Zm8.156 3.25-.608-1.618-.608 1.618h1.216Zm.507 1.349.409 1.087c.047.126.168.21.303.21h.6a.324.324 0 0 0 .306-.428l-1.584-4.646c-.374-1.096-1.924-1.096-2.297 0l-1.584 4.646a.324.324 0 0 0 .306.428h.6a.324.324 0 0 0 .303-.21l.409-1.087h2.23ZM11.191 11.5a.316.316 0 0 0-.316.316v.684c0 .175.142.316.316.316h2.576l-2.576 2.945a.763.763 0 0 0 .574 1.265h3.794a.316.316 0 0 0 .316-.315v-.685a.316.316 0 0 0-.316-.315h-2.576l2.577-2.945a.763.763 0 0 0-.575-1.266h-3.794Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSortingAtoz_default = createIcon(SvgIcSortingAtoz);
function SvgIcSortingEarly(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.318 2.735c0-.276.224-.502.5-.484a7.75 7.75 0 1 1-7.576 4.572l-1.084-.577a.487.487 0 0 1-.002-.858l3.194-1.72a.487.487 0 0 1 .715.38l.36 3.61a.487.487 0 0 1-.713.478l-1.097-.583a6.2 6.2 0 1 0 6.203-3.748.533.533 0 0 1-.5-.52v-.55Zm-.42 6.982a.5.5 0 0 1-.146.354l-2.28 2.28a.5.5 0 0 0 0 .707l.353.354a.5.5 0 0 0 .707 0l2.72-2.72a.5.5 0 0 0 .147-.354V6.735a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2.982Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSortingEarly_default = createIcon(SvgIcSortingEarly);
function SvgIcSortingLate(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M9.65 2.735a.476.476 0 0 0-.5-.484 7.75 7.75 0 1 0 7.576 4.572l1.084-.577a.487.487 0 0 0 .003-.858l-3.194-1.72a.487.487 0 0 0-.716.38l-.36 3.61c-.038.386.37.66.714.478l1.096-.583A6.2 6.2 0 1 1 9.15 3.805a.533.533 0 0 0 .5-.52v-.55Zm-.085 6.982a.5.5 0 0 1-.147.354l-2.28 2.28a.5.5 0 0 0 0 .707l.353.354a.5.5 0 0 0 .708 0l2.72-2.72a.5.5 0 0 0 .146-.354V6.735a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2.982Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSortingLate_default = createIcon(SvgIcSortingLate);
function SvgIcSortingZtoa(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6.001 3a.5.5 0 0 0-.5.5v9.833h-1a.5.5 0 0 0-.4.8l2 2.667a.5.5 0 0 0 .8 0l2-2.667a.5.5 0 0 0-.4-.8h-1V3.5a.5.5 0 0 0-.5-.5h-1Zm8.157 11.25-.609-1.618-.608 1.618h1.216Zm.506 1.349.409 1.087c.047.126.168.21.303.21h.6a.324.324 0 0 0 .306-.428l-1.584-4.646c-.374-1.096-1.924-1.096-2.297 0l-1.584 4.646a.324.324 0 0 0 .306.428h.6a.324.324 0 0 0 .303-.21l.409-1.087h2.23ZM11.391 3a.316.316 0 0 0-.316.316V4c0 .175.142.316.316.316h2.576L11.391 7.26a.763.763 0 0 0 .574 1.265h3.794a.316.316 0 0 0 .316-.315v-.685a.316.316 0 0 0-.316-.315h-2.576l2.577-2.945A.763.763 0 0 0 15.185 3h-3.794Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSortingZtoa_default = createIcon(SvgIcSortingZtoa);
function SvgIcStamp(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M5 17.75a.75.75 0 0 1 .75-.75h8.786a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M6.25 6a3.75 3.75 0 1 1 6.687 2.332c-.436.549-.687.982-.687 1.396 0 .62.47 1.14 1.088 1.202l1.436.144a2.75 2.75 0 0 1 2.476 2.736V14a1.75 1.75 0 0 1-1.75 1.75h-11A1.75 1.75 0 0 1 2.75 14v-.19a2.75 2.75 0 0 1 2.476-2.736l1.436-.144A1.208 1.208 0 0 0 7.75 9.728c0-.414-.251-.847-.687-1.396A3.737 3.737 0 0 1 6.25 6ZM10 3.75a2.25 2.25 0 0 0-1.763 3.648c.434.546 1.013 1.346 1.013 2.33a2.708 2.708 0 0 1-2.439 2.695l-1.435.143A1.25 1.25 0 0 0 4.25 13.81V14c0 .138.112.25.25.25h11a.25.25 0 0 0 .25-.25v-.19a1.25 1.25 0 0 0-1.126-1.244l-1.435-.143a2.708 2.708 0 0 1-2.439-2.695c0-.984.58-1.784 1.013-2.33A2.25 2.25 0 0 0 10 3.75Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcStamp_default = createIcon(SvgIcStamp);
function SvgIcStar(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M9.16 2.555a.913.913 0 0 1 1.68 0L12.6 6.689l4.558.356a.912.912 0 0 1 .514 1.609l-3.456 2.889 1.058 4.329a.912.912 0 0 1-1.354 1L10 14.533 6.079 16.87a.913.913 0 0 1-1.354-1l1.058-4.328-3.456-2.889a.912.912 0 0 1 .514-1.609l4.557-.356 1.763-4.134Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcStar_default = createIcon(SvgIcStar);
function SvgIcSubtract(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#333" }),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 2, x: 5, y: 9, fill: "#fff", rx: 0.5 })
      ]
    }
  );
}
var IcSubtract_default = createIcon(SvgIcSubtract);
function SvgIcSummeryView(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3.5 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-13Zm0 8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-13Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSummeryView_default = createIcon(SvgIcSummeryView);
function SvgIcSympathyMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 9, stroke: "#333", strokeWidth: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M9.567 11.333a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM14.233 11.333a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM9.665 12.76a.583.583 0 0 1 .809-.162c.478.319 1.725.751 2.852 0a.583.583 0 0 1 .647.97c-1.673 1.116-3.458.46-4.147 0a.583.583 0 0 1-.161-.808Z"
          }
        )
      ]
    }
  );
}
var IcSympathyMedium_default = createIcon(SvgIcSympathyMedium);
function SvgIcTack(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { clipPath: "url(#ic-tack_svg__a)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M12.926 2.75a.5.5 0 0 1 .76-.064l3.382 3.382a.5.5 0 0 1-.063.76l-4.094 2.925a.5.5 0 0 1-.644-.053l-2.212-2.212A.5.5 0 0 1 10 6.843l2.925-4.094ZM6.357 7.13a2 2 0 0 1 2.309.375l3.583 3.583a2 2 0 0 1 .375 2.309l-.45.901a.5.5 0 0 1-.801.13L8.7 11.756l-3.865 3.865a.497.497 0 1 1-.703-.703l3.865-3.865-2.672-2.672a.5.5 0 0 1 .13-.8l.901-.451Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "ic-tack_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M.001 0h20v20h-20z" }) }) })
      ]
    }
  );
}
var IcTack_default = createIcon(SvgIcTack);
function SvgIcTag(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M16.999 4.208 17 9.323c0 .32-.127.627-.353.854l-6.47 6.47a1.206 1.206 0 0 1-1.706 0l-5.118-5.118a1.206 1.206 0 0 1 0-1.706l6.47-6.47c.227-.226.534-.353.854-.353l5.115.001c.666.001 1.206.54 1.207 1.207Zm-2.674 1.467a1.167 1.167 0 1 0-1.65 1.65 1.167 1.167 0 0 0 1.65-1.65Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcTag_default = createIcon(SvgIcTag);
function SvgIcTargetMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M18.646 3.291a.218.218 0 0 1 .06-.197l1.326-1.326a.218.218 0 0 1 .358.076l.531 1.38a.218.218 0 0 0 .126.125l1.38.53a.218.218 0 0 1 .075.359l-1.326 1.326a.218.218 0 0 1-.197.06l-1.11-.222-.902.9.01.013-1.423 1.424-.01-.013-1.43 1.43.008.014-1.455 1.455a1.036 1.036 0 0 0-.008-.014l-2.007 2.007a.873.873 0 1 1-1.235-1.235L18.79 4.01l-.144-.719Zm1.186 4.272-1.484 1.483a7 7 0 1 1-3.302-3.35l1.478-1.478a9 9 0 1 0 3.307 3.344ZM16.8 10.595l-1.83 1.83a3 3 0 1 1-3.24-3.413l1.78-1.78a5 5 0 1 0 3.29 3.362Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcTargetMedium_default = createIcon(SvgIcTargetMedium);
function SvgIcText(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          d: "M4 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v2.65a.35.35 0 0 1-.681.114l-.403-1.176a.5.5 0 0 0-.473-.338H11.7a.5.5 0 0 0-.5.5v8.31c0 .795.645 1.44 1.44 1.44a.36.36 0 0 1 .36.36v.14a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-.14a.36.36 0 0 1 .36-.36 1.44 1.44 0 0 0 1.44-1.44V5.25a.5.5 0 0 0-.5-.5H5.557a.5.5 0 0 0-.473.338l-.403 1.176A.35.35 0 0 1 4 6.15V3.5Z"
        }
      )
    }
  );
}
var IcText_default = createIcon(SvgIcText);
function SvgIcTodoMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeWidth: 2,
            d: "m7 8.184 1.702 1.648a.25.25 0 0 0 .347.001L12 7"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 2, x: 4, y: 16, fill: "#333", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 13, height: 2, x: 7, y: 16, fill: "#333", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 13, height: 2, x: 7, y: 19, fill: "#333", rx: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 2, x: 4, y: 19, fill: "#333", rx: 0.5 })
      ]
    }
  );
}
var IcTodoMedium_default = createIcon(SvgIcTodoMedium);
function SvgIcToggleMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4 7.5A4.5 4.5 0 0 1 8.5 3h7a4.5 4.5 0 1 1 0 9h-7A4.5 4.5 0 0 1 4 7.5ZM8.5 5a2.5 2.5 0 0 0 0 5h7a2.5 2.5 0 0 0 0-5h-7ZM17 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-13 10A4.5 4.5 0 0 1 8.5 13h7a4.5 4.5 0 1 1 0 9h-7A4.5 4.5 0 0 1 4 17.5ZM8.5 15a2.5 2.5 0 0 0 0 5h7a2.5 2.5 0 0 0 0-5h-7Zm1.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcToggleMedium_default = createIcon(SvgIcToggleMedium);
function SvgIcTrash(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M8 3a1 1 0 0 0-1 1v1H5a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2h-2V4a1 1 0 0 0-1-1H8Zm3 2H9V4h2v1ZM5.2 8c-.11 0-.2.065-.2.145V14c0 .602 0 2 1.5 2h7c1.5 0 1.5-1.398 1.5-2V8.145c0-.08-.09-.145-.2-.145H5.2Zm3.6 6a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2h-.6a.2.2 0 0 0-.2.2v4.6c0 .11.09.2.2.2h.6Zm3.2-.2a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V9.2c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2v4.6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcTrash_default = createIcon(SvgIcTrash);
function SvgIcUpArrowSolidXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6.416 3.624a.5.5 0 0 0-.832 0L2.518 8.223A.5.5 0 0 0 2.934 9h6.132a.5.5 0 0 0 .416-.777L6.416 3.624Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcUpArrowSolidXsmall_default = createIcon(SvgIcUpArrowSolidXsmall);
function SvgIcUpArrowXsmall(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10.53 8.53a.75.75 0 0 1-1.06 0L6 5.06 2.53 8.53a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcUpArrowXsmall_default = createIcon(SvgIcUpArrowXsmall);
function SvgIcUpArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M16.733 13.73a.906.906 0 0 1-1.19.089l-.102-.09L10 8.23l-5.441 5.5a.906.906 0 0 1-1.19.09l-.102-.09a.93.93 0 0 1-.088-1.201l.088-.104L9.354 6.27a.906.906 0 0 1 1.19-.089l.102.09 6.087 6.153a.93.93 0 0 1 0 1.306Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcUpArrow_default = createIcon(SvgIcUpArrow);
function SvgIcVideo(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4 5h12a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-9A.5.5 0 0 1 4 5Zm-2 .5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9Zm10 4.933a.5.5 0 0 0 0-.866L9 7.835a.5.5 0 0 0-.75.433v3.464a.5.5 0 0 0 .75.433l3-1.732Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcVideo_default = createIcon(SvgIcVideo);
function SvgIcViewOff(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M15.835 4.167a.561.561 0 0 0-.8 0l-2.293 2.316a6.315 6.315 0 0 0-2.959-.77c-3.997 0-6.588 4.088-6.696 4.262a.576.576 0 0 0 0 .607 11.33 11.33 0 0 0 2.746 2.879l-1.537 1.552a.574.574 0 0 0 .246.969c.2.052.412-.01.553-.162l10.74-10.846a.575.575 0 0 0 0-.807Zm-8.313 6.112a2.272 2.272 0 0 1 2.261-2.284 2.18 2.18 0 0 1 1.137.328l-3.073 3.104a2.24 2.24 0 0 1-.325-1.148ZM14.971 8c.738.636 1.39 1.36 1.939 2.153a.55.55 0 0 1 0 .605C16.796 10.93 14.088 15 9.91 15A6.538 6.538 0 0 1 8 14.703L14.97 8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcViewOff_default = createIcon(SvgIcViewOff);
function SvgIcViewOn(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 5c-3.182 0-5.9 2.073-7 5 1.1 2.927 3.818 5 7 5s5.9-2.073 7-5c-1.1-2.927-3.818-5-7-5Zm0 8.333c-1.756 0-3.182-1.493-3.182-3.333S8.244 6.667 10 6.667 13.182 8.16 13.182 10 11.756 13.333 10 13.333ZM10 8c-1.056 0-1.91.893-1.91 2s.854 2 1.91 2 1.91-.893 1.91-2-.854-2-1.91-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcViewOn_default = createIcon(SvgIcViewOn);
function SvgIcWaitingMedium(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 5.75, cy: 11.75, r: 1.75, fill: "#333" }),
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 11.75, r: 1.75, fill: "#333" }),
        /* @__PURE__ */ jsx("circle", { cx: 18.25, cy: 11.75, r: 1.75, fill: "#333" })
      ]
    }
  );
}
var IcWaitingMedium_default = createIcon(SvgIcWaitingMedium);
function SvgIcWhatsappLarge(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 30",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 15, cy: 15, r: 15, fill: "#4DC95F" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M22 15a7 7 0 0 1-10.978 5.76l-2.834 1.08 1.077-2.825A7 7 0 1 1 22 15Zm-4.68.677c.182.066 1.161.545 1.36.645l.109.053c.139.066.232.111.272.178.05.083.05.48-.116.942-.166.463-.96.885-1.343.942a2.74 2.74 0 0 1-1.254-.079c-.289-.09-.66-.213-1.135-.417-1.866-.802-3.127-2.601-3.365-2.942l-.035-.05-.002-.001C11.706 14.808 11 13.87 11 12.9c0-.912.45-1.39.658-1.61l.039-.042a.733.733 0 0 1 .53-.248c.133 0 .266.001.382.007h.045c.116 0 .26-.001.403.34l.22.532c.171.415.36.873.394.939.05.1.083.215.016.347l-.028.056c-.05.102-.086.176-.17.274l-.103.122a3.283 3.283 0 0 1-.196.226c-.1.098-.204.206-.088.404.116.198.516.847 1.108 1.372.636.565 1.189.804 1.469.925.055.023.099.042.131.058.2.1.316.083.432-.049.116-.132.497-.579.63-.777.133-.198.265-.165.448-.099Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcWhatsappLarge_default = createIcon(SvgIcWhatsappLarge);
function SvgIcWifi(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M16.87 8.354a.483.483 0 0 0-.002-.668c-1.79-1.82-4.204-2.936-6.86-2.936-2.663 0-5.082 1.12-6.873 2.948a.483.483 0 0 0-.002.668l.602.648c.2.216.543.211.753.004 1.455-1.435 3.394-2.311 5.523-2.311 2.122 0 4.055.87 5.509 2.297.21.207.55.21.751-.005l.6-.645Zm-11.233 2.01a.475.475 0 0 0-.019.677l.609.655c.193.209.52.212.74.03a4.751 4.751 0 0 1 3.036-1.106c1.139 0 2.189.41 3.03 1.101.219.18.545.178.739-.03l.605-.653a.474.474 0 0 0-.02-.678c-1.18-1.059-2.7-1.696-4.358-1.696-1.659 0-3.18.638-4.362 1.7Zm6.298 3.304c.219-.236.161-.615-.136-.738a4.673 4.673 0 0 0-3.6.01c-.295.123-.352.501-.134.736L9.63 15.36a.5.5 0 0 0 .733 0l1.572-1.692Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcWifi_default = createIcon(SvgIcWifi);
function SvgIcWindowed(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7.47 8.429h.959V3.235H7.074v2.88L3.958 3 3 3.958l3.116 3.116h-2.88v1.355H7.47Zm4.336-4.074h3.84v3.839H17V3h-5.194v1.355Zm-3.612 11.29h-3.84v-3.838H3V17h5.194v-1.355Zm4.335-4.074h4.236v1.355h-2.88L17 16.042l-.958.958-3.116-3.116v2.881h-1.355v-5.193h.958Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcWindowed_default = createIcon(SvgIcWindowed);
function SvgIcWorkStatus(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M9 16c.34 0 .674-.026 1-.076a4.485 4.485 0 0 1 1.275-3.062 3.5 3.5 0 0 1 4.075-4.758A6.5 6.5 0 1 0 9 16Zm.71-9.25a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2.836a.25.25 0 0 1-.073.177l-1.883 1.883a.5.5 0 0 0 0 .708l.353.353a.5.5 0 0 0 .707 0l1.884-1.884a1.75 1.75 0 0 0 .513-1.237V6.75Zm6.79 4.75c0 .714-.374 1.34-.936 1.694A3.001 3.001 0 0 1 17.5 16v.765c0 .13-.105.235-.235.235h-5.53a.235.235 0 0 1-.235-.235V16c0-1.282.805-2.377 1.936-2.806A2 2 0 1 1 16.5 11.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcWorkStatus_default = createIcon(SvgIcWorkStatus);
function SvgIcWorkplaceMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M7 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H7ZM6 6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6Zm2.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2Zm0 4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2ZM12 7.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcWorkplaceMedium_default = createIcon(SvgIcWorkplaceMedium);
function SvgIcZoomInMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M5 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-8a8 8 0 1 0 4.906 14.32l2.716 2.716a.5.5 0 0 0 .707 0l.707-.708a.5.5 0 0 0 0-.707l-2.716-2.715A8 8 0 0 0 11 3Zm-1 4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V10h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H12v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V12H7.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H10V7.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcZoomInMedium_default = createIcon(SvgIcZoomInMedium);
function SvgIcZoomOutMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M11 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l2.716 2.715a.5.5 0 0 1 0 .707l-.707.708a.5.5 0 0 1-.707 0l-2.716-2.716A8 8 0 0 1 3 11Zm4 .5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcZoomOutMedium_default = createIcon(SvgIcZoomOutMedium);
function SvgImgSettingAttendance(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-attendance_svg__a",
            width: 240,
            height: 140,
            x: 0,
            y: 0,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" })
          }
        ),
        /* @__PURE__ */ jsxs("g", { mask: "url(#img-setting-attendance_svg__a)", children: [
          /* @__PURE__ */ jsxs("g", { opacity: 0.4, children: [
            /* @__PURE__ */ jsx("circle", { cx: 120, cy: 112, r: 94, fill: "#EDF7FF" }),
            /* @__PURE__ */ jsx("circle", { cx: 120, cy: 112, r: 78, fill: "#DCEEFF" }),
            /* @__PURE__ */ jsx("circle", { cx: 120, cy: 112, r: 62, fill: "#AFD9FF", opacity: 0.8 }),
            /* @__PURE__ */ jsx("circle", { cx: 120, cy: 112, r: 46, fill: "#8DCAFF" })
          ] }),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-attendance_svg__b)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 64,
              height: 100,
              x: 88,
              y: 60,
              fill: "url(#img-setting-attendance_svg__c)",
              rx: 8
            }
          ) }),
          /* @__PURE__ */ jsx("circle", { cx: 120, cy: 112, r: 16, fill: "#3299FE" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M127.533 106.396c.601.548.625 1.459.054 2.035l-8.552 8.637a1.528 1.528 0 0 1-1.097.448 1.528 1.528 0 0 1-1.091-.461l-4.447-4.606a1.4 1.4 0 0 1 .081-2.035 1.544 1.544 0 0 1 2.119.078l3.361 3.481 7.452-7.525c.57-.576 1.52-.6 2.12-.052Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-attendance_svg__d)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 44,
              height: 44,
              x: 98,
              y: 2,
              fill: "url(#img-setting-attendance_svg__e)",
              rx: 16
            }
          ) }),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-attendance_svg__f)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 44,
              height: 44,
              x: 166,
              y: 62,
              fill: "url(#img-setting-attendance_svg__g)",
              rx: 16
            }
          ) }),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-attendance_svg__h)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 44,
              height: 44,
              x: 30,
              y: 38,
              fill: "url(#img-setting-attendance_svg__i)",
              rx: 16
            }
          ) }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M51.678 57.417a.75.75 0 0 1 .888.58c.017.081.022.172.024.21v.003a31 31 0 0 1 .01.766c0 .43-.003.95-.008 1.373l-.75-.008.75.006a.616.616 0 0 0 .322.534c.2.117.433.262.617.41.089.072.202.171.293.293.063.083.281.391.162.792a.996.996 0 0 1-.318.467c-.094.08-.198.146-.287.197a5.05 5.05 0 0 1-.578.274 10.834 10.834 0 0 1-.675.25l-.048.015-.013.004-.005.002-.23-.714.23.714a.75.75 0 0 1-.459-1.428l.002-.001.01-.003.038-.013a9.227 9.227 0 0 0 .294-.103 2.103 2.103 0 0 1-.855-1.703v-.002c.005-.422.009-.934.009-1.355a29.73 29.73 0 0 0-.01-.693v-.023a.75.75 0 0 1 .587-.844ZM48.041 64.798c-.314.681-.313.681-.313.682h.002l.004.002.013.006a3.913 3.913 0 0 0 .196.083c.13.053.318.125.553.206.47.16 1.134.355 1.921.494 1.562.276 3.674.345 5.696-.581a.75.75 0 0 0-.625-1.364c-1.64.751-3.407.716-4.81.468a11.523 11.523 0 0 1-1.697-.437 9.104 9.104 0 0 1-.594-.226l-.028-.012-.005-.002a.75.75 0 1 0-.626 1.363l.313-.682ZM49.305 58.263c0 .608-.33 1.101-.738 1.101-.407 0-.737-.493-.737-1.101s.33-1.101.737-1.101.738.493.738 1.101ZM55.834 58.263c0 .608-.33 1.101-.738 1.101-.407 0-.737-.493-.737-1.101s.33-1.101.737-1.101c.408 0 .739.493.739 1.101ZM46.702 55.035l-.55-.515a.748.748 0 0 0 .039 1.059.752.752 0 0 0 1.056-.023l.002-.002a1.864 1.864 0 0 1 .167-.14c.13-.096.325-.218.574-.313.478-.183 1.196-.285 2.133.167a.746.746 0 0 0 1-.346.754.754 0 0 0-.357-1.001c-1.352-.653-2.505-.534-3.325-.22a3.909 3.909 0 0 0-1.18.713 2.23 2.23 0 0 0-.095.092l-.008.008-.003.003-.001.002h-.001l.55.516ZM58.32 54.547l-.538.488.538-.487a.748.748 0 0 1-.057 1.058.752.752 0 0 1-1.057-.041l-.002-.002a1.853 1.853 0 0 0-.165-.143 2.42 2.42 0 0 0-.567-.323c-.474-.19-1.19-.304-2.135.132a.746.746 0 0 1-.994-.363.754.754 0 0 1 .375-.995c1.363-.63 2.514-.49 3.329-.163a3.897 3.897 0 0 1 1.166.733 2.373 2.373 0 0 1 .094.092l.008.009.003.003.001.002ZM57.889 47.985a.75.75 0 0 1 .75-.75h3.32c1.49 0 2.792 1.136 2.792 2.65v3.325a.75.75 0 0 1-1.5 0v-3.325c0-.585-.527-1.15-1.293-1.15h-3.32a.75.75 0 0 1-.75-.75ZM57.889 71.02c0 .414.335.75.75.75h3.32c1.49 0 2.792-1.136 2.792-2.65v-3.325a.75.75 0 0 0-1.5 0v3.325c0 .584-.527 1.15-1.293 1.15h-3.32a.75.75 0 0 0-.75.75ZM46.111 47.985a.75.75 0 0 0-.75-.75h-3.32c-1.49 0-2.792 1.136-2.792 2.65v3.325a.75.75 0 0 0 1.5 0v-3.325c0-.585.527-1.15 1.293-1.15h3.32a.75.75 0 0 0 .75-.75ZM46.111 71.02a.75.75 0 0 1-.75.75h-3.32c-1.49 0-2.792-1.136-2.792-2.65v-3.325a.75.75 0 0 1 1.5 0v3.325c0 .584.527 1.15 1.293 1.15h3.32a.75.75 0 0 1 .75.75ZM188 73c-5.514 0-10 4.299-10 9.583 0 2.573 1.051 4.989 2.955 6.8l6.69 6.475A.506.506 0 0 0 188 96a.506.506 0 0 0 .355-.142l6.687-6.472c1.907-1.814 2.958-4.23 2.958-6.803C198 77.3 193.514 73 188 73Zm0 13.143c-2.298 0-4.167-1.843-4.167-4.107 0-2.265 1.869-4.107 4.167-4.107s4.167 1.842 4.167 4.107c0 2.264-1.869 4.107-4.167 4.107ZM131.406 20.786a.49.49 0 0 0 .001-.67c-3-3.165-7.107-5.116-11.638-5.116-4.53 0-8.637 1.95-11.637 5.113a.49.49 0 0 0 .001.67l1.455 1.567c.2.215.542.211.747 0 2.446-2.535 5.771-4.094 9.435-4.094 3.663 0 6.989 1.559 9.435 4.095a.515.515 0 0 0 .747 0l1.454-1.565Zm-19.124 3.766a.485.485 0 0 0-.015.683l1.462 1.573a.525.525 0 0 0 .733.023c1.44-1.288 3.291-2.063 5.309-2.063 2.019 0 3.869.775 5.309 2.062.212.19.539.186.733-.022l1.46-1.572a.485.485 0 0 0-.015-.682c-1.998-1.893-4.619-3.041-7.489-3.041-2.869 0-5.49 1.147-7.487 3.04Zm10.991 4.99c.218-.235.162-.613-.128-.752a7.786 7.786 0 0 0-6.75 0 .472.472 0 0 0-.128.751l3.137 3.377a.5.5 0 0 0 .733 0l3.136-3.376Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#555",
              d: "M108.859 83.098c1.636 0 2.593-1.319 2.598-3.633-.005-2.3-.977-3.633-2.598-3.633-1.626 0-2.597 1.333-2.597 3.633 0 2.314.962 3.633 2.597 3.633Zm-1.523-3.633c0-1.758.571-2.72 1.523-2.725.948.005 1.524.967 1.524 2.725 0 1.763-.571 2.705-1.524 2.705-.957 0-1.528-.942-1.523-2.705ZM115.002 75.832c-1.538-.01-2.539 1.045-2.539 2.393 0 1.352 1.016 2.324 2.285 2.324.762 0 1.426-.362 1.807-.957h.088c-.01 1.616-.65 2.563-1.739 2.568-.713-.005-1.172-.42-1.318-1.016h-1.065c.171 1.148 1.08 1.954 2.383 1.954 1.695 0 2.764-1.407 2.764-3.887-.005-2.588-1.367-3.37-2.666-3.379Zm-1.494 2.373c-.005-.81.639-1.475 1.494-1.475.864 0 1.494.699 1.494 1.465 0 .782-.659 1.48-1.514 1.475-.859.005-1.469-.645-1.474-1.465ZM119.494 82.121a.706.706 0 0 0 .694-.693.703.703 0 0 0-.694-.694.692.692 0 1 0 0 1.387Zm-.693-4.228a.696.696 0 0 0 .693.693.706.706 0 0 0 .694-.694.703.703 0 0 0-.694-.693.692.692 0 0 0-.693.694ZM123.947 83.098c1.465 0 2.554-.865 2.549-2.041.005-.894-.557-1.543-1.523-1.68v-.049c.761-.19 1.259-.767 1.25-1.572.009-1.045-.865-1.924-2.256-1.924-1.319 0-2.383.781-2.412 1.934h1.035c.024-.64.659-1.036 1.367-1.036.747 0 1.231.44 1.231 1.084 0 .68-.562 1.128-1.368 1.123h-.605v.88h.605c1.011.004 1.592.502 1.592 1.2 0 .689-.62 1.153-1.474 1.153-.792 0-1.407-.396-1.446-1.016h-1.094c.044 1.157 1.084 1.944 2.549 1.944ZM130.139 83.098c1.635 0 2.592-1.319 2.597-3.633-.005-2.3-.976-3.633-2.597-3.633-1.626 0-2.598 1.333-2.598 3.633 0 2.314.962 3.633 2.598 3.633Zm-1.524-3.633c0-1.758.572-2.72 1.524-2.725.947.005 1.523.967 1.523 2.725 0 1.763-.571 2.705-1.523 2.705-.957 0-1.529-.942-1.524-2.705Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-attendance_svg__c",
              x1: 88,
              x2: 152,
              y1: 60,
              y2: 160,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-attendance_svg__e",
              x1: 98,
              x2: 142,
              y1: 2,
              y2: 46,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#4DC9AA" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4DC970" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-attendance_svg__g",
              x1: 166,
              x2: 210,
              y1: 62,
              y2: 106,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#59B2E4" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#5699D9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-attendance_svg__i",
              x1: 30,
              x2: 74,
              y1: 38,
              y2: 82,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#66B5FF" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#68F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-attendance_svg__b",
              width: 88,
              height: 124,
              x: 76,
              y: 56,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 6 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5181",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-attendance_svg__d",
              width: 60,
              height: 60,
              x: 90,
              y: 2,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5181",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-attendance_svg__f",
              width: 60,
              height: 60,
              x: 158,
              y: 62,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5181",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-attendance_svg__h",
              width: 60,
              height: 60,
              x: 22,
              y: 38,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5181"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5181",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingAttendance_default = createIcon(SvgImgSettingAttendance);
function SvgImgSettingBoard(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-board_svg__a",
            width: 240,
            height: 140,
            x: 0,
            y: 0,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("rect", { width: 240, height: 140, fill: "#F1F4F6", rx: 8 })
          }
        ),
        /* @__PURE__ */ jsxs("g", { mask: "url(#img-setting-board_svg__a)", children: [
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 192,
              height: 124,
              x: 24,
              y: 16,
              fill: "url(#img-setting-board_svg__b)",
              rx: 4
            }
          ),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-board_svg__c)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 64,
              height: 80,
              x: 12,
              y: 51,
              fill: "url(#img-setting-board_svg__d)",
              rx: 4
            }
          ) }),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-board_svg__e)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 64,
              height: 80,
              x: 88,
              y: 51,
              fill: "url(#img-setting-board_svg__f)",
              rx: 4
            }
          ) }),
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-board_svg__g)", children: /* @__PURE__ */ jsx(
            "rect",
            {
              width: 64,
              height: 80,
              x: 164,
              y: 51,
              fill: "url(#img-setting-board_svg__h)",
              rx: 4
            }
          ) }),
          /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 18, y: 57, fill: "#F66", rx: 6 }),
          /* @__PURE__ */ jsx("circle", { cx: 26.95, cy: 67.45, r: 1.35, fill: "#fff" }),
          /* @__PURE__ */ jsx("circle", { cx: 31.45, cy: 67.45, r: 1.35, fill: "#fff", opacity: 0.6 }),
          /* @__PURE__ */ jsx("circle", { cx: 35.95, cy: 67.45, r: 1.35, fill: "#fff", opacity: 0.3 }),
          /* @__PURE__ */ jsx("circle", { cx: 26, cy: 91, r: 8, fill: "#EAEAEA" }),
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "img-setting-board_svg__i",
              width: 16,
              height: 16,
              x: 18,
              y: 83,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ jsx("circle", { cx: 26, cy: 91, r: 8, fill: "#EAEAEA" })
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-board_svg__i)", children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#F9F9F9",
              fillRule: "evenodd",
              d: "M26 91.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.111c0 .49.398.888.889.888H31.11c.491 0 .889-.398.889-.888v-1.112a6 6 0 0 0-6-6Z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ jsx("rect", { width: 44, height: 2, x: 18, y: 103, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 44, height: 2, x: 18, y: 107, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 22, height: 2, x: 18, y: 111, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 94, y: 57, fill: "#3299FE", rx: 6 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              stroke: "#fff",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2.5,
              d: "m102 66.5 3.75 3.75L112 64"
            }
          ),
          /* @__PURE__ */ jsx("circle", { cx: 33, cy: 25, r: 3, fill: "#406588" }),
          /* @__PURE__ */ jsx("circle", { cx: 42, cy: 25, r: 3, fill: "#4DC9AA" }),
          /* @__PURE__ */ jsx("circle", { cx: 51, cy: 25, r: 3, fill: "#3299FE" }),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 118,
              height: 8,
              x: 30,
              y: 33,
              fill: "#8092AA",
              opacity: 0.3,
              rx: 2
            }
          ),
          /* @__PURE__ */ jsx("circle", { cx: 102, cy: 91, r: 8, fill: "#EAEAEA" }),
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "img-setting-board_svg__j",
              width: 16,
              height: 16,
              x: 94,
              y: 83,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ jsx("circle", { cx: 102, cy: 91, r: 8, fill: "#EAEAEA" })
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-board_svg__j)", children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#F9F9F9",
              fillRule: "evenodd",
              d: "M102 91.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.111c0 .49.398.888.889.888h10.222a.889.889 0 0 0 .889-.888v-1.112a6 6 0 0 0-6-6Z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ jsx("rect", { width: 44, height: 2, x: 94, y: 103, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 44, height: 2, x: 94, y: 107, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 22, height: 2, x: 94, y: 111, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 170, y: 57, fill: "#555", rx: 6 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M178.5 64.3a.9.9 0 0 0 0 1.8h5.4a.9.9 0 0 0 0-1.8h-5.4Zm0 3.6a.9.9 0 0 0 0 1.8h9a.9.9 0 0 0 0-1.8h-9Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("circle", { cx: 178, cy: 91, r: 8, fill: "#EAEAEA" }),
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "img-setting-board_svg__k",
              width: 16,
              height: 16,
              x: 170,
              y: 83,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ jsx("circle", { cx: 178, cy: 91, r: 8, fill: "#EAEAEA" })
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-board_svg__k)", children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#F9F9F9",
              fillRule: "evenodd",
              d: "M178 91.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.111c0 .49.398.888.889.888h10.222a.889.889 0 0 0 .889-.888v-1.112a6 6 0 0 0-6-6Z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ jsx("rect", { width: 44, height: 2, x: 170, y: 103, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 44, height: 2, x: 170, y: 107, fill: "#DDD", rx: 0.2 }),
          /* @__PURE__ */ jsx("rect", { width: 22, height: 2, x: 170, y: 111, fill: "#DDD", rx: 0.2 })
        ] }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-board_svg__b",
              x1: 24,
              x2: 242.776,
              y1: 16,
              y2: 258.846,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E3E8EB" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E3E8EB", stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-board_svg__d",
              x1: 44,
              x2: 44,
              y1: 51,
              y2: 131,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-board_svg__f",
              x1: 120,
              x2: 120,
              y1: 51,
              y2: 131,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-board_svg__h",
              x1: 196,
              x2: 196,
              y1: 51,
              y2: 131,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-board_svg__c",
              width: 72,
              height: 96,
              x: 8,
              y: 51,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5895"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 12 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 6 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5895"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5895",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-board_svg__e",
              width: 72,
              height: 96,
              x: 84,
              y: 51,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5895"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 12 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 6 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5895"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5895",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-board_svg__g",
              width: 72,
              height: 96,
              x: 160,
              y: 51,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5895"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 12 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 6 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5895"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5895",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingBoard_default = createIcon(SvgImgSettingBoard);
function SvgImgSettingChat(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 192,
            height: 124,
            x: 24,
            y: 16,
            fill: "url(#img-setting-chat_svg__a)",
            rx: 4
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 33, cy: 25, r: 3, fill: "#406588" }),
        /* @__PURE__ */ jsx("circle", { cx: 42, cy: 25, r: 3, fill: "#4DC9AA" }),
        /* @__PURE__ */ jsx("circle", { cx: 51, cy: 25, r: 3, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-chat_svg__b)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-setting-chat_svg__c)",
            d: "M92 16a8 8 0 0 1 8-8h80a8 8 0 0 1 8 8v104a8 8 0 0 1-8 8h-80a8 8 0 0 1-8-8V16Z"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F4F4F4",
            d: "M99 44a6 6 0 0 1 6-6h36a6 6 0 1 1 0 12h-36a6 6 0 0 1-6-6Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 30, height: 12, x: 152, y: 54, fill: "#D6E9FB", rx: 6 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F9F9F9",
            d: "M92 16a8 8 0 0 1 8-8h80a8 8 0 0 1 8 8v10H92V16Z"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-chat_svg__d)", children: /* @__PURE__ */ jsx("circle", { cx: 182, cy: 25, r: 20, fill: "#fff" }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M191.306 30.584a10.732 10.732 0 0 0 1.639-5.717c0-6.002-4.912-10.867-10.972-10.867S171 18.866 171 24.867c0 6.002 4.913 10.868 10.973 10.868 1.456 0 2.846-.281 4.117-.791l5.971 1.043a.8.8 0 0 0 .886-1.071l-1.641-4.332Zm-14.972-7.048a.65.65 0 0 1 .65-.65h9.976a.65.65 0 1 1 0 1.3h-9.976a.65.65 0 0 1-.65-.65Zm.65 2.194a.65.65 0 1 0 0 1.3h6.983a.65.65 0 1 0 0-1.3h-6.983Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 196, cy: 11, r: 4, fill: "#F66" }),
        /* @__PURE__ */ jsx("circle", { cx: 62, cy: 74, r: 8, fill: "#8092AA" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-chat_svg__e",
            width: 16,
            height: 16,
            x: 54,
            y: 66,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 62, cy: 74, r: 8, fill: "#8898A7" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-chat_svg__e)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M62 74.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.11c0 .491.398.89.889.89H67.11c.491 0 .889-.399.889-.89V83a6 6 0 0 0-6-6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-chat_svg__f)", children: /* @__PURE__ */ jsx("rect", { width: 52, height: 35, x: 74, y: 66, fill: "#fff", rx: 8 }) }),
        /* @__PURE__ */ jsx("circle", { cx: 84, cy: 92, r: 4, fill: "#FFDA75", opacity: 0.8 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 38,
            height: 4,
            x: 80,
            y: 73,
            fill: "#DDD",
            opacity: 0.6,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 21,
            height: 4,
            x: 80,
            y: 80,
            fill: "#DDD",
            opacity: 0.6,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 7,
            height: 4,
            x: 90,
            y: 90,
            fill: "#DDD",
            opacity: 0.3,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 194, cy: 105, r: 10, fill: "#406588" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-chat_svg__g",
            width: 20,
            height: 20,
            x: 184,
            y: 95,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 194, cy: 105, r: 10, fill: "#3299FE" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-chat_svg__g)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M194 106.249a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0 2.499a7.5 7.5 0 0 0-7.5 7.5v1.389c0 .613.497 1.111 1.111 1.111h12.778c.614 0 1.111-.498 1.111-1.111v-1.389a7.5 7.5 0 0 0-7.5-7.5Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-chat_svg__h)", children: /* @__PURE__ */ jsx("rect", { width: 32, height: 21, x: 148, y: 95, fill: "#3299FE", rx: 10.5 }) }),
        /* @__PURE__ */ jsx("circle", { cx: 159.5, cy: 105.5, r: 1.5, fill: "#fff" }),
        /* @__PURE__ */ jsx("circle", { cx: 164.5, cy: 105.5, r: 1.5, fill: "#fff" }),
        /* @__PURE__ */ jsx("circle", { cx: 169.5, cy: 105.5, r: 1.5, fill: "#fff" }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-chat_svg__b",
              width: 112,
              height: 136,
              x: 84,
              y: 2,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 4 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5856"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5856",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-chat_svg__d",
              width: 64,
              height: 64,
              x: 150,
              y: 1,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 6 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5856"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5856",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-chat_svg__f",
              width: 72,
              height: 55,
              x: 64,
              y: 60,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 5 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5856"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5856",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-chat_svg__h",
              width: 36,
              height: 27,
              x: 146,
              y: 95,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 2,
                    result: "effect1_dropShadow_286_5856"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.247059 0 0 0 0 0.556863 0 0 0 0 0.862745 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5856"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5856",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-chat_svg__a",
              x1: 24,
              x2: 242.776,
              y1: 16,
              y2: 258.846,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E3E8EB" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E3E8EB", stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-chat_svg__c",
              x1: 92,
              x2: 186.281,
              y1: 25.213,
              y2: 129.553,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingChat_default = createIcon(SvgImgSettingChat);
function SvgImgSettingDisplay(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 146",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsxs("g", { opacity: 0.8, children: [
          /* @__PURE__ */ jsx("path", { fill: "#E3E8EB", d: "M143 62h80v64h-80z" }),
          /* @__PURE__ */ jsx("rect", { width: 88, height: 4, x: 139, y: 62, fill: "#fff", rx: 1 }),
          /* @__PURE__ */ jsx("rect", { width: 88, height: 4, x: 139, y: 92, fill: "#fff", rx: 1 }),
          /* @__PURE__ */ jsx("rect", { width: 88, height: 4, x: 139, y: 122, fill: "#F7F9FA", rx: 1 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#8092AA",
              d: "M147 75a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v17h-15V75ZM147 105a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1v17h-34v-17ZM185 105a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1v17h-34v-17ZM168 75a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v17h-15V75ZM188 84a4 4 0 0 1 4-4h3a4 4 0 0 1 4 4v8h-11v-8ZM191 76.5a2.5 2.5 0 1 1 5 0V80h-5v-3.5ZM204 78a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v14h-15V78Z",
              opacity: 0.2
            }
          )
        ] }),
        /* @__PURE__ */ jsx("rect", { width: 64, height: 100, x: 83, y: 6, fill: "#D6E9FB", rx: 8 }),
        /* @__PURE__ */ jsx("rect", { width: 64, height: 100, x: 83, y: 6, fill: "#3299FE", rx: 8 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#EAEAEA",
            d: "M83 31h64v95a8 8 0 0 1-8 8H91a8 8 0 0 1-8-8V31Z"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-display_svg__a)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 84,
            height: 80,
            x: 73,
            y: 50,
            fill: "url(#img-setting-display_svg__b)",
            rx: 8
          }
        ) }),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-display_svg__c)", children: [
          /* @__PURE__ */ jsx("rect", { width: 76, height: 20, x: 77, y: 102, fill: "#3299FE", rx: 10 }),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 1.5,
              height: 7,
              x: 115.75,
              y: 116,
              fill: "#fff",
              rx: 0.5,
              transform: "rotate(-180 115.75 116)"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M114.47 107.47a.749.749 0 0 1 1.06 0l3 3a.749.749 0 1 1-1.06 1.06l-2.47-2.469-2.47 2.469a.749.749 0 1 1-1.06-1.06l3-3Z",
              clipRule: "evenodd"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("rect", { width: 68, height: 20, x: 81, y: 70, fill: "#F4F4F4", rx: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M112.32 83.078c1.278 0 2.196-.695 2.188-1.664.008-.707-.449-1.21-1.281-1.312v-.047c.632-.114 1.074-.563 1.07-1.196.004-.894-.781-1.593-1.961-1.593-1.16 0-2.035.675-2.055 1.648h1.125c.02-.433.43-.715.93-.71.5-.005.832.292.828.726.004.445-.387.75-.945.75h-.524v.867h.524c.664.004 1.074.328 1.07.789.004.457-.398.77-.961.773-.547-.003-.957-.28-.976-.703h-1.188c.024.988.914 1.672 2.156 1.672ZM117.43 83.078c1.277 0 2.195-.695 2.187-1.664.008-.707-.449-1.21-1.281-1.312v-.047c.633-.114 1.074-.563 1.07-1.196.004-.894-.781-1.593-1.961-1.593-1.16 0-2.035.675-2.054 1.648h1.125c.019-.433.429-.715.929-.71.5-.005.832.292.828.726.004.445-.386.75-.945.75h-.523v.867h.523c.664.004 1.074.328 1.07.789.004.457-.398.77-.96.773-.547-.003-.958-.28-.977-.703h-1.188c.024.988.915 1.672 2.157 1.672Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 139, cy: 80, r: 6, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M139.6 77.6a.6.6 0 0 0-1.2 0v1.8h-1.8a.6.6 0 0 0 0 1.2h1.8v1.8a.6.6 0 1 0 1.2 0v-1.8h1.8a.6.6 0 0 0 0-1.2h-1.8v-1.8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 91, cy: 80, r: 6, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M88 80a.6.6 0 0 1 .6-.6h4.8a.6.6 0 1 1 0 1.2h-4.8a.6.6 0 0 1-.6-.6Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 24, height: 4, x: 81, y: 58, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 56, height: 28, x: 87, y: 18, fill: "#fff", rx: 4 }),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 4, x: 107, y: 22, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M110.508 30.344h-1.11l-1.398.89v1.04l1.297-.813h.031V36h1.18v-5.656ZM114.016 36.078c1.414 0 2.273-1.047 2.273-2.906 0-1.848-.863-2.906-2.273-2.906-1.411 0-2.274 1.058-2.274 2.906 0 1.851.856 2.906 2.274 2.906Zm-1.071-2.906c0-1.293.418-1.941 1.071-1.945.652.003 1.074.652 1.07 1.945.004 1.305-.414 1.937-1.07 1.937-.657 0-1.078-.632-1.071-1.937ZM119.18 36.078c1.273 0 2.14-.816 2.14-1.96 0-1.087-.773-1.864-1.812-1.86-.496-.004-.926.199-1.133.476h-.047l.156-1.43H121v-.96h-3.484l-.305 3.258h1.062c.168-.317.465-.477.891-.477.594.004 1.02.422 1.016 1.023.004.59-.414 1.004-1 1-.492.004-.895-.3-.922-.742h-1.141c.02.977.883 1.672 2.063 1.672Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 52.364, height: 72, x: 12, y: 18, fill: "#fff", rx: 8 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#406588",
            d: "M57.818 44.182A19.637 19.637 0 0 0 38.18 24.545v19.637h19.637Z",
            opacity: 0.8
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#4DC9AA",
            d: "M24.296 58.067a19.636 19.636 0 0 0 33.522-13.885H38.18L24.296 58.067Z",
            opacity: 0.8
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            d: "M38.181 24.545a19.637 19.637 0 0 0-13.885 33.522l13.885-13.885V24.545Z",
            opacity: 0.8
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 19.797, cy: 78.159, r: 0.75, stroke: "#35485B" }),
        /* @__PURE__ */ jsx("circle", { cx: 23.25, cy: 82.25, r: 0.75, stroke: "#35485B" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.294,
            height: 0.409,
            x: 18.836,
            y: 82.467,
            stroke: "#35485B",
            strokeWidth: 0.409,
            rx: 0.205,
            transform: "rotate(-45 18.836 82.467)"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.545,
            height: 3.273,
            x: 43.727,
            y: 35.364,
            fill: "#fff",
            opacity: 0.4,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.545,
            height: 3.273,
            x: 25,
            y: 38,
            fill: "#fff",
            opacity: 0.4,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.545,
            height: 3.273,
            x: 38.182,
            y: 50.727,
            fill: "#fff",
            opacity: 0.4,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 48, cy: 72, r: 1.636, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("circle", { cx: 48, cy: 76.909, r: 1.636, fill: "#406588" }),
        /* @__PURE__ */ jsx("circle", { cx: 48, cy: 81.818, r: 1.636, fill: "#4DC9AA" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.545,
            height: 3.273,
            x: 51.273,
            y: 70.364,
            fill: "#8092AA",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.545,
            height: 3.273,
            x: 51.273,
            y: 75.273,
            fill: "#8092AA",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 6.545,
            height: 3.273,
            x: 51.273,
            y: 80.182,
            fill: "#8092AA",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 17, height: 3, x: 203, y: 76, fill: "#C0CCD5", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 14, height: 3, x: 195, y: 107, fill: "#C0CCD5", rx: 1.5 }),
        /* @__PURE__ */ jsx("rect", { width: 14, height: 3, x: 157, y: 107, fill: "#C0CCD5", rx: 1.5 }),
        /* @__PURE__ */ jsx("circle", { cx: 211.5, cy: 84.5, r: 3.5, fill: "#C0CCD4", opacity: 0.5 }),
        /* @__PURE__ */ jsx("rect", { width: 5, height: 2, x: 191, y: 74, fill: "#C0CCD4", rx: 0.5 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#C0CCD4",
            d: "M194 84.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-5Z",
            opacity: 0.5
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-display_svg__a",
              width: 100,
              height: 96,
              x: 65,
              y: 50,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5947"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5947"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5947",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-display_svg__c",
              width: 84,
              height: 28,
              x: 73,
              y: 102,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.247969 0 0 0 0 0.558247 0 0 0 0 0.8625 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5947"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5947",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-display_svg__b",
              x1: 73,
              x2: 160.856,
              y1: 50,
              y2: 125.514,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingDisplay_default = createIcon(SvgImgSettingDisplay);
function SvgImgSettingExpenses(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 153",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 13h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E1E8ED",
            d: "M31 21c-3.314 0-6 2.672-6 5.968v82.551c0 .783.152 1.532.428 2.217l2.229-2.217 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 3.5 3.481 3.5-3.481 2.001 1.99a5.909 5.909 0 0 0 .342-1.99V26.968c0-3.296-2.686-5.968-6-5.968H31Z",
            opacity: 0.6
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 26,
            height: 5,
            x: 33,
            y: 28,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 13,
            height: 5,
            x: 33,
            y: 58,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 21,
            height: 5,
            x: 33,
            y: 68,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 21,
            height: 5,
            x: 33,
            y: 78,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 34,
            height: 5,
            x: 66,
            y: 58,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 31,
            height: 5,
            x: 69,
            y: 68,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 36,
            height: 5,
            x: 64,
            y: 78,
            fill: "#8092AA",
            opacity: 0.15,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M35.855 40.344h-1.109l-1.398.89v1.04l1.297-.813h.03V46h1.18v-5.656ZM37.074 45h2.75v1h1.117v-1h.72v-.945h-.72v-3.711h-1.476l-2.39 3.726V45Zm1.188-.945v-.047l1.523-2.375h.055v2.422h-1.578ZM46.31 42.465V44.7c.002.408-.286.7-.728.703-.437-.002-.725-.295-.727-.703v-2.236h-.733v2.295c0 .774.581 1.291 1.46 1.289.877.002 1.465-.515 1.465-1.29v-2.294h-.737ZM49.562 43.476h.703c-.01-.625-.525-1.06-1.309-1.06-.774 0-1.34.427-1.338 1.07 0 .517.366.815.962.961l.386.093c.386.095.605.208.605.45 0 .263-.249.444-.634.444-.391 0-.674-.181-.699-.537h-.713c.022.759.567 1.154 1.421 1.152.862.002 1.365-.413 1.367-1.06-.002-.588-.454-.896-1.06-1.035l-.316-.078c-.306-.068-.57-.183-.567-.44.003-.234.21-.405.581-.405.36 0 .581.164.61.445ZM52.037 46c1.08 0 1.731-.666 1.729-1.773.002-1.1-.65-1.762-1.714-1.762h-1.26V46h1.245Zm-.513-.63v-2.275h.489c.669 0 1.02.346 1.02 1.133 0 .793-.351 1.142-1.025 1.142h-.484Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            fillRule: "evenodd",
            d: "M101 56H65a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1Zm-36-1a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H65ZM61 37H32a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h29a1 1 0 0 0 1-1V38a1 1 0 0 0-1-1Zm-29-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h29a2 2 0 0 0 2-2V38a2 2 0 0 0-2-2H32ZM101 76H62a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h39a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1Zm-39-1a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h39a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H62Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs(
          "g",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            opacity: 0.8,
            children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  stroke: "#CCC",
                  d: "M111 33v-8a8 8 0 0 0-8-8h-8M37 17h-8a8 8 0 0 0-8 8v8"
                }
              ),
              /* @__PURE__ */ jsx("path", { stroke: "#3299FE", d: "M95 98h8a8 8 0 0 0 8-8v-8" }),
              /* @__PURE__ */ jsx("path", { stroke: "#CCC", d: "M21 82v8a8 8 0 0 0 8 8h8" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 97,
            height: 125,
            x: 93,
            y: 27,
            fill: "url(#img-setting-expenses_svg__a)",
            rx: 12
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 58, height: 16, x: 101, y: 83, fill: "#F9F9F9", rx: 4 }),
        /* @__PURE__ */ jsx("rect", { width: 82, height: 16, x: 101, y: 118, fill: "#F9F9F9", rx: 4 }),
        /* @__PURE__ */ jsx("rect", { width: 82, height: 16, x: 101, y: 48, fill: "#F9F9F9", rx: 4 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 26,
            height: 5,
            x: 102,
            y: 109,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 26,
            height: 5,
            x: 102,
            y: 39,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 20,
            height: 5,
            x: 102,
            y: 74,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M108.883 88.344h-1.11l-1.398.89v1.04l1.297-.813h.031V94h1.18v-5.656ZM110.102 93h2.75v1h1.117v-1h.719v-.945h-.719v-3.711h-1.477l-2.39 3.726V93Zm1.187-.945v-.047l1.523-2.375h.055v2.422h-1.578ZM168.82 88.344v3.578c.004.652-.457 1.121-1.164 1.125-.699-.004-1.16-.473-1.164-1.125v-3.578h-1.172v3.672c0 1.238.93 2.066 2.336 2.062 1.403.004 2.344-.824 2.344-2.062v-3.672h-1.18ZM174.023 89.96h1.125c-.015-1-.839-1.694-2.093-1.694-1.239 0-2.145.683-2.141 1.71 0 .829.586 1.305 1.539 1.54l.617.148c.618.152.969.332.969.719 0 .422-.398.71-1.016.71-.625 0-1.078-.288-1.117-.859h-1.14c.035 1.215.906 1.848 2.273 1.844 1.379.004 2.184-.66 2.188-1.695-.004-.942-.727-1.434-1.696-1.656l-.508-.125c-.488-.11-.91-.293-.906-.704.004-.375.336-.648.93-.648.574 0 .93.262.976.71ZM177.984 94c1.727 0 2.77-1.066 2.766-2.836.004-1.762-1.039-2.82-2.742-2.82h-2.016V94h1.992Zm-.82-1.008v-3.64h.781c1.071 0 1.633.554 1.633 1.812 0 1.27-.562 1.828-1.64 1.828h-.774ZM108.523 59.078c1.274 0 2.141-.816 2.141-1.96 0-1.087-.773-1.864-1.812-1.86-.497-.004-.926.199-1.133.476h-.047l.156-1.43h2.516v-.96h-3.485l-.304 3.258h1.062c.168-.317.465-.477.891-.477.594.004 1.019.422 1.015 1.023.004.59-.414 1.004-1 1-.492.004-.894-.3-.921-.742h-1.141c.019.977.883 1.672 2.062 1.672ZM113.914 53.078h-1l-1.82 6.774h.992l1.828-6.774ZM116.523 59.078c1.278 0 2.196-.695 2.188-1.664.008-.707-.449-1.21-1.281-1.312v-.047c.632-.114 1.074-.563 1.07-1.196.004-.894-.781-1.593-1.961-1.593-1.16 0-2.035.675-2.055 1.648h1.125c.02-.434.43-.715.93-.71.5-.005.832.292.828.726.004.445-.387.75-.945.75h-.524v.867h.524c.664.004 1.074.328 1.07.789.004.457-.398.77-.961.773-.547-.004-.957-.28-.976-.703h-1.188c.024.989.914 1.672 2.156 1.672ZM121.977 53.344h-1.11l-1.398.89v1.04l1.297-.813h.031V59h1.18v-5.656ZM127.57 53.344h-1.109l-1.399.89v1.04l1.297-.813h.032V59h1.179v-5.656ZM131.078 59.078c1.414 0 2.274-1.047 2.274-2.906 0-1.848-.864-2.906-2.274-2.906-1.41 0-2.273 1.058-2.273 2.906 0 1.851.855 2.906 2.273 2.906Zm-1.07-2.906c0-1.293.418-1.941 1.07-1.945.652.004 1.074.652 1.07 1.945.004 1.305-.414 1.937-1.07 1.937-.656 0-1.078-.632-1.07-1.937ZM134.852 58.344a.652.652 0 0 0 0-1.305.642.642 0 0 0-.657.649.648.648 0 0 0 .657.656Zm-.657-3.438a.648.648 0 0 0 .657.657.652.652 0 0 0 0-1.305.642.642 0 0 0-.657.648ZM138.859 53.344h-1.109l-1.398.89v1.04l1.296-.813h.032V59h1.179v-5.656ZM142.266 59.078c1.277 0 2.195-.695 2.187-1.664.008-.707-.449-1.21-1.281-1.312v-.047c.633-.114 1.074-.563 1.07-1.196.004-.894-.781-1.593-1.961-1.593-1.16 0-2.035.675-2.054 1.648h1.125c.019-.434.429-.715.929-.71.5-.005.832.292.828.726.004.445-.386.75-.945.75h-.523v.867h.523c.664.004 1.074.328 1.07.789.004.457-.398.77-.961.773-.546-.004-.957-.28-.976-.703h-1.188c.024.989.914 1.672 2.157 1.672Z"
          }
        ),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-expenses_svg__b)", children: [
          /* @__PURE__ */ jsx("rect", { width: 74, height: 24, x: 144, y: 121, fill: "#3299FE", rx: 12 }),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 34,
              height: 6,
              x: 161,
              y: 130,
              fill: "#84C2FC",
              opacity: 0.6,
              rx: 2
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M208.53 132.47a.749.749 0 0 1 0 1.06l-4 4a.749.749 0 1 1-1.06-1.06l3.469-3.47-3.469-3.47a.749.749 0 1 1 1.06-1.06l4 4Z",
              clipRule: "evenodd"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("rect", { width: 26, height: 4, x: 106, y: 124, fill: "#D6E9FB", rx: 1 }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-expenses_svg__c)", children: /* @__PURE__ */ jsx("circle", { cx: 183.5, cy: 38.5, r: 22.5, fill: "#fff" }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M180 29.5a2 2 0 0 0-2 2h-2.33c-2.027 0-3.67 1.628-3.67 3.636v8.728c0 2.008 1.643 3.636 3.67 3.636h15.66c2.027 0 3.67-1.628 3.67-3.636v-8.728c0-2.008-1.643-3.636-3.67-3.636H189a2 2 0 0 0-2-2h-7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M188.5 39.501a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-8-.001a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("ellipse", { cx: 175.67, cy: 35.424, fill: "#fff", rx: 0.979, ry: 1.026 }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-expenses_svg__b",
              width: 82,
              height: 32,
              x: 140,
              y: 121,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.247969 0 0 0 0 0.558247 0 0 0 0 0.8625 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5590"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5590",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-expenses_svg__c",
              width: 85,
              height: 85,
              x: 141,
              y: 0,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 10 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5590"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5590",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-expenses_svg__a",
              x1: 141,
              x2: 190,
              y1: 90,
              y2: 152,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingExpenses_default = createIcon(SvgImgSettingExpenses);
function SvgImgSettingInventory(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 142",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 192,
            height: 124,
            x: 24,
            y: 8,
            fill: "#8092AA",
            opacity: 0.2,
            rx: 4
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 33, cy: 17, r: 3, fill: "#406588" }),
        /* @__PURE__ */ jsx("circle", { cx: 42, cy: 17, r: 3, fill: "#4DC9AA" }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-inventory_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 208, height: 110, x: 16, y: 26, fill: "#DDD", rx: 4 }) }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-inventory_svg__b",
            width: 208,
            height: 110,
            x: 16,
            y: 26,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("rect", { width: 208, height: 110, x: 16, y: 26, fill: "#D9D9D9", rx: 4 })
          }
        ),
        /* @__PURE__ */ jsxs("g", { mask: "url(#img-setting-inventory_svg__b)", children: [
          /* @__PURE__ */ jsx("path", { fill: "#E2E8EF", d: "M14.172-42.882h230.184v180.298H14.172z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#EFF4F8",
              fillRule: "evenodd",
              d: "M65.894 27.444 82.706.686l19.37 12.597-18.03 28.6-18.15-14.439ZM86.003 101.182l14.104-10.736 1.615 3.224 10.799 7.512-3.519 5.713 12.972 8.347 10.568-14.955 18.174 9.288-8.656 13.228 3.778 8.785v.992h-7.408l-22.374-3.015-31.99-26.789 1.937-1.594Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#CFE8D1",
              fillRule: "evenodd",
              d: "m187.133 92.225 13.775-12.89 30.077 25.987-4.831 8.888-10.523-6.214-28.498-15.77Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#EFF4F8",
              fillRule: "evenodd",
              d: "m79.577 103.857 15.644 3.578-3.137 6.445-2.44 1.386-2.245 4.84v4.222l-15.116-4.222-8.37 1.897-4.59-2.845-3.43-3.892 1.737-3.895 21.947-7.514Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#E8EAEB",
              fillRule: "evenodd",
              d: "M158.208 50.21s-1.003 1.223-1.272 1.916c-.248.638-1.91.824-.677 1.945.489.444 1.945-.444 2.568 0 2.659 1.897 10.756 7.045 10.756 7.045L157.537 76.29l-23.385-11.829s5.384-16.274 9.614-18.78c4.229-2.506 14.442 4.53 14.442 4.53Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#E8EAEB",
              fillRule: "evenodd",
              d: "m102.071 9.627 45.186 30.469-13.108 21.187-50.168-18.415 18.09-33.24Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#EFF4F8",
              fillRule: "evenodd",
              d: "m65.894 94.92 10.085-4.943V62.392l12.682 7.939v6.137l4.248 14.38-10.757 10.872-16.258-6.8Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#CFE8D1",
              fillRule: "evenodd",
              d: "m148.121 111.022 29.172 17.577 14.747 8.811-48.704.289-1.496-14.957 6.281-11.72Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#F6F7EF",
              fillRule: "evenodd",
              d: "m41.623-11.353-9.914-7.346-7.83-.733L40.626-6.695 36.7 11.623l24.693 18.124-14.465 19.392-5.453-4.658-14.448 15.512v6.11l14.448-15.9 2.868 2.402L23.879 80.04l4.667 1.305L47.922 55.6l32.89 27.532-3.001 5.197-7.615-3.811L52.27 109.12l-9.583-3.155-15.66-10.123v5.582l14.449 8.905 52.041 18.1-31.657 7.626-8.035 16.085 5.067 11.345h3.87l-4.946-11.345 7.777-14.845 29.473-7.148 25.621-19.818 85.772 52.004h8.739l-17.082-9.41-73.901-45.272 23.289-16.55 72.784 41.71-2.787 4.9h5.399l1.332-2.64 16.638 9.534 18.467 8.318v-5.294l-13.486-5.741-19.484-11.046 4.601-9.116-3.201-2.062-5.149 9.052-71.235-40.387L162.1 68.055l1.396-.566 92.222 4.406 3.619.792v-5.198h-10.115V36.081h10.115v-3.222h-10.115v-52.291h-3.371v52.291h-53.257V14.374l13.865-32.627h-3.426l-13.065 30.887v4.03h-26.472v-34.917h-4.686V59.993l-41.262-26.358 6.716-7.72-3.494-1.706-6.477 7.347-15.248-9.74 5.147-8.12-3.754-1.768-4.812 7.704-3.561-2.275-15.67-2.25L59.46 1.94v-20.193h-3.638v17.42L45.063-8.803l2.155-9.61-3.864-1.017-1.73 8.078Zm2.39 7.233L40.898 9.761l41.942 30.337 10.413-16.669-2.802-1.804-16.381-2.884-30.059-22.86Zm52.626 29.73L86.323 41.882l14.115 5.394 10.806-12.26-14.605-9.406Zm17.875 11.513-10.322 11.865 29.935 12.297-3.04 2.425-28.746-11.576-11.304 18.472L109.59 82.77l-3.031 2.937L68.637 60.4l4.011-1.851.477.313 8.135-15.694-15.674-11.04-15.093 20.054 36.283 30.989-5.964 10.499-9.026-4.337-14.837 20.995 38.117 13.989 25.621-20.334 24.542-16.781 12.102-22.504-42.817-27.576Zm-29.945 7.855L76.59 61.135l11.197 7.34 10.626-17.922-13.844-5.575ZM189.875 20H164v38.53l5.329 5.576 21.025.693L189.875 20Zm2.736 16.233h53.127V67.48l-53.127-2.772V36.233Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#DCE3E7",
              d: "m31.709-18.7.149-.2-.056-.042-.07-.006-.023.249Zm9.915 7.347-.15.201.313.231.08-.38-.243-.052Zm-17.745-8.08.023-.248-.87-.081.696.529.15-.2ZM40.626-6.694l.244.052.033-.155-.126-.096-.151.199ZM36.7 11.623l-.245-.053-.034.159.13.095.148-.201Zm24.693 18.124.2.15.151-.203-.203-.149-.148.202ZM46.929 49.139l-.162.19.203.173.16-.214-.2-.15Zm-5.453-4.658.162-.19-.182-.156-.163.175.183.17ZM27.028 59.993l-.183-.17-.067.072v.098h.25Zm0 6.11h-.25v.647l.435-.479-.185-.168Zm14.448-15.9.16-.191-.184-.154-.161.178.185.168Zm2.868 2.402.2.15.142-.19-.182-.152-.16.192ZM23.879 80.04l-.2-.15-.218.293.35.098.068-.24Zm4.667 1.305-.068.241.165.046.102-.136-.2-.15ZM47.922 55.6l.16-.192-.202-.17-.158.211.2.15Zm32.89 27.532.216.125.105-.182-.16-.135-.161.192Zm-3.001 5.197-.112.224.21.105.118-.204-.216-.125Zm-7.615-3.811.112-.224-.19-.094-.124.17.202.148ZM52.27 109.12l-.079.237.173.057.108-.147-.202-.147Zm-9.583-3.155-.135.21.027.017.03.01.078-.237Zm-15.66-10.123.137-.21-.386-.25v.46h.25Zm0 5.582h-.25v.14l.12.073.13-.213Zm14.449 8.905-.131.212.023.015.026.009.082-.236Zm52.041 18.1.059.243.828-.199-.805-.28-.082.236Zm-31.657 7.626-.059-.243-.113.027-.052.104.223.112Zm-8.035 16.085-.223-.111-.053.105.048.108.228-.102Zm5.067 11.345-.228.102.066.148h.163v-.25Zm3.87 0v.25h.381l-.152-.35-.23.1Zm-4.946-11.345-.222-.116-.056.106.048.11.23-.1Zm7.777-14.845-.059-.243-.11.027-.052.1.221.116Zm29.473-7.148.059.243.052-.012.042-.033-.153-.198Zm25.621-19.818.13-.214-.147-.089-.136.105.153.198Zm85.772 52.004-.129.214.059.036h.07v-.25Zm8.739 0v.25l.121-.469-.121.219Zm-17.082-9.41-.13.213.01.006.12-.219Zm-73.901-45.272-.144-.204-.309.219.323.198.13-.213Zm23.289-16.55.124-.216-.139-.08-.13.093.145.204Zm72.784 41.71.217.123.124-.216-.217-.124-.124.217Zm-2.787 4.9-.217-.124-.213.374h.43v-.25Zm5.399 0v.25h.154l.069-.138-.223-.112Zm1.332-2.64.125-.217-.229-.131-.119.236.223.112Zm16.638 9.534-.124.217.01.006.011.005.103-.228Zm18.467 8.318-.102.228.352.159v-.387h-.25Zm0-5.294h.25v-.166l-.152-.065-.098.231Zm-13.486-5.741-.124.217.013.007.013.006.098-.23Zm-19.484-11.046-.223-.113-.107.213.207.117.123-.217Zm4.601-9.116.223.113.102-.201-.189-.122-.136.21Zm-3.201-2.062.135-.211-.222-.143-.13.23.217.124Zm-5.149 9.052-.124.217.218.123.123-.217-.217-.123Zm-71.235-40.387-.221-.116-.113.214.211.12.123-.218ZM162.1 68.055l-.094-.231-.085.034-.042.08.221.117Zm1.396-.566.012-.25-.055-.002-.051.02.094.232Zm92.222 4.406.054-.244-.021-.004-.021-.001-.012.25Zm3.619.792-.053.244.303.067v-.311h-.25Zm0-5.198h.25v-.25h-.25v.25Zm-10.115 0h-.25v.25h.25v-.25Zm0-31.408v-.25h-.25v.25h.25Zm10.115 0v.25h.25v-.25h-.25Zm0-3.222h.25v-.25h-.25v.25Zm-10.115 0h-.25v.25h.25v-.25Zm0-52.291h.25v-.25h-.25v.25Zm-3.371 0v-.25h-.25v.25h.25Zm0 52.291v.25h.25v-.25h-.25Zm-53.257 0h-.25v.25h.25v-.25Zm0-18.485-.23-.098-.02.047v.051h.25Zm13.865-32.627.23.097.148-.347h-.378v.25Zm-3.426 0v-.25h-.165l-.065.152.23.098Zm-13.065 30.887-.23-.098-.02.047v.05h.25Zm0 4.03v.25h.25v-.25h-.25Zm-26.472 0h-.25v.25h.25v-.25Zm0-34.917h.25v-.25h-.25v.25Zm-4.686 0v-.25h-.25v.25h.25Zm0 78.246-.134.21.384.246v-.456h-.25Zm-41.262-26.358-.188-.164-.191.22.245.155.134-.21Zm6.716-7.72.189.165.213-.246-.292-.143-.11.225Zm-3.494-1.706.109-.225-.171-.084-.126.143.188.166Zm-6.477 7.347-.134.211.18.115.142-.16-.188-.166Zm-15.248-9.74-.211-.134-.134.21.21.134.135-.21Zm5.147-8.12.211.134.152-.239-.256-.12-.107.225Zm-3.754-1.768.106-.226-.2-.095-.118.189.212.132Zm-4.812 7.704-.135.21.213.136.134-.214-.212-.132Zm-3.561-2.275.135-.21-.046-.03-.053-.008-.036.248Zm-15.67-2.25-.154.198.053.04.065.01.036-.248ZM59.46 1.94h-.25v.122l.096.075.154-.197Zm0-20.193h.25v-.25h-.25v.25Zm-3.638 0v-.25h-.25v.25h.25Zm0 17.42-.15.202.4.295v-.496h-.25ZM45.063-8.803l-.244-.055-.036.159.131.097.149-.201Zm2.155-9.61.244.055.053-.235-.233-.062-.064.242Zm-3.864-1.017.064-.241-.253-.067-.055.256.244.052ZM40.9 9.761l-.244-.055-.036.161.133.097.147-.203Zm3.113-13.88.152-.2-.31-.235-.086.38.244.054Zm38.83 44.217-.147.203.217.156.141-.227-.212-.132Zm10.412-16.669.212.133.13-.21-.207-.133-.135.21Zm-2.802-1.804.136-.21-.043-.027-.05-.009-.043.246Zm-16.381-2.884-.152.2.049.036.06.01.043-.245Zm12.252 23.141-.211-.134-.164.258.285.11.09-.234ZM96.639 25.61l.136-.21-.212-.136-.135.212.211.134Zm3.799 21.666-.089.234.162.062.114-.13-.187-.166Zm10.806-12.26.187.166.193-.218-.245-.158-.135.21Zm-7.052 13.972-.188-.164-.229.263.322.133.095-.232Zm10.322-11.865.136-.21-.182-.117-.142.163.188.164Zm19.613 24.162.156.195.332-.265-.393-.162-.095.232Zm-3.04 2.425-.093.232.135.055.114-.091-.156-.196Zm-28.746-11.576.093-.232-.196-.079-.111.18.214.131ZM91.037 70.606l-.214-.13-.126.206.203.133.137-.21ZM109.59 82.77l.174.18.224-.218-.261-.171-.137.209Zm-3.031 2.937-.139.208.168.112.145-.14-.174-.18ZM68.637 60.4l-.105-.227-.406.187.372.248.139-.208Zm4.011-1.851.137-.21-.116-.075-.126.058.105.227Zm.477.313-.137.209.232.152.127-.246-.222-.115Zm8.135-15.694.222.115.1-.194-.178-.126-.144.205Zm-15.674-11.04.144-.205-.198-.14-.145.194.2.15ZM50.493 52.182l-.2-.15-.14.187.178.153.162-.19Zm36.283 30.989.218.123.102-.18-.157-.133-.163.19ZM80.812 93.67l-.108.225.21.1.115-.202-.217-.123Zm-9.026-4.337.108-.225-.19-.092-.123.173.204.144ZM56.948 110.33l-.204-.145-.188.267.306.112.086-.234Zm38.117 13.989-.086.234.131.049.11-.088-.155-.195Zm25.621-20.334-.141-.206-.007.005-.007.006.155.195Zm24.542-16.781.141.206.051-.034.028-.054-.22-.118Zm12.102-22.504.22.119.109-.204-.194-.125-.135.21Zm-80.74-3.564-.225-.111-.098.198.185.122.137-.21Zm7.978-16.157.094-.232-.215-.087-.103.208.224.11Zm3.218 23.497-.138.209.22.143.132-.225-.215-.127Zm10.626-17.922.215.127.148-.25-.27-.11-.093.233ZM164 20v-.25h-.25V20h.25Zm25.875 0 .25-.003-.003-.247h-.247V20ZM164 58.53h-.25v.1l.069.072.181-.173Zm5.329 5.576-.181.172.071.074.102.004.008-.25Zm21.025.693-.008.25.261.008-.003-.26-.25.002Zm55.384-28.566h.25v-.25h-.25v.25Zm-53.127 0v-.25h-.25v.25h.25Zm53.127 31.247-.013.25.263.013v-.263h-.25Zm-53.127-2.772h-.25v.237l.237.013.013-.25ZM31.56-18.498l9.915 7.346.297-.402-9.914-7.346-.298.402Zm-7.704-.685 7.83.733.046-.498-7.83-.733-.046.498Zm16.92 12.289L24.03-19.631l-.302.398L40.474-6.496l.303-.398Zm-3.831 18.57L40.87-6.644l-.489-.105-3.925 18.318.489.105Zm24.597 17.87L36.848 11.42l-.295.403 24.693 18.124.296-.403ZM47.13 49.287l14.464-19.392-.4-.299L46.729 48.99l.4.3Zm-5.817-4.617 5.454 4.658.325-.38-5.454-4.658-.325.38ZM27.211 60.164 41.659 44.65l-.366-.34-14.448 15.512.366.34Zm.067 5.94v-6.11h-.5v6.11h.5ZM41.29 50.034l-14.448 15.9.37.336 14.448-15.9-.37-.336Zm3.213 2.378-2.868-2.401-.32.383 2.867 2.401.321-.383ZM24.08 80.19l20.465-27.436-.4-.299-20.465 27.436.4.299Zm4.534.915L23.946 79.8l-.134.481 4.666 1.305.135-.481Zm19.11-25.656L28.345 81.195l.4.3L48.121 55.75l-.4-.3Zm33.25 27.491-32.89-27.532-.322.383 32.89 27.532.321-.383Zm-2.946 5.514 3.001-5.197-.433-.25-3 5.197.432.25Zm-7.943-3.713 7.615 3.812.224-.447-7.615-3.812-.224.447Zm-17.612 24.526 17.926-24.602-.404-.294-17.926 24.601.404.295Zm-9.863-3.065 9.582 3.155.157-.475-9.582-3.155-.157.475Zm-15.717-10.15 15.66 10.123.271-.42-15.66-10.123-.27.42Zm.386 5.372v-5.582h-.5v5.582h.5Zm14.329 8.692-14.448-8.905-.262.426 14.448 8.904.262-.425Zm51.992 18.077-52.041-18.101-.164.473 52.041 18.1.164-.472Zm-31.68 8.105 31.657-7.626-.117-.486-31.658 7.626.117.486Zm-7.87 15.954 8.034-16.085-.447-.224-8.034 16.086.447.223Zm5.072 11.131-5.067-11.345-.457.204 5.067 11.345.457-.204Zm3.64-.148h-3.869v.5h3.87v-.5Zm-5.175-10.995 4.946 11.345.459-.2-4.946-11.345-.459.2Zm7.786-15.061-7.778 14.845.443.232 7.778-14.845-.443-.232Zm29.635-7.275-29.473 7.148.118.486 29.473-7.148-.118-.486Zm25.527-19.773L94.913 129.95l.306.395 25.621-19.819-.306-.395Zm86.055 51.988-85.772-52.004-.259.427 85.772 52.005.259-.428Zm8.609-.036h-8.739v.5h8.739v-.5Zm-17.202-8.941 17.082 9.41.241-.438-17.082-9.41-.241.438Zm-73.911-45.278 73.901 45.272.261-.426-73.901-45.273-.261.427Zm23.274-16.966-23.288 16.549.289.407 23.289-16.549-.29-.407Zm73.053 41.696-72.784-41.71-.248.434 72.784 41.71.248-.434Zm-.341.093-2.787 4.9.434.247 2.787-4.9-.434-.247Zm-2.57 5.274h5.399v-.5h-5.399v.5Zm5.622-.138 1.333-2.639-.447-.225-1.332 2.639.446.225Zm17.871 6.566-16.637-9.535-.249.434 16.638 9.534.248-.433Zm18.446 8.306-18.467-8.317-.206.455 18.468 8.318.205-.456Zm-.353-5.066v5.294h.5v-5.294h-.5Zm-13.334-5.511 13.486 5.741.196-.461-13.486-5.74-.196.46Zm-19.509-11.059 19.483 11.046.247-.435-19.483-11.046-.247.435Zm.347-.105 4.6-9.115-.446-.225-4.601 9.115.447.225Zm4.513-9.438-3.202-2.063-.271.421 3.202 2.063.271-.421Zm-3.554-1.976-5.15 9.052.435.247 5.149-9.052-.434-.247Zm-76.29-30.993 71.234 40.386.247-.435-71.234-40.386-.247.435Zm10.619-20.609-10.717 20.275.443.233 10.716-20.274-.442-.234Zm1.523-.68-1.396.566.188.463 1.396-.566-.188-.463Zm92.328 4.388-92.222-4.406-.024.499 92.223 4.406.023-.5Zm3.661.797-3.619-.792-.107.489 3.619.791.107-.488Zm-.304-4.954v5.198h.5v-5.198h-.5Zm-9.865.25h10.115v-.5h-10.115v.5Zm-.25-31.658v31.408h.5V36.081h-.5Zm10.365-.25h-10.115v.5h10.115v-.5Zm-.25-2.972v3.222h.5v-3.222h-.5Zm-9.865.25h10.115v-.5h-10.115v.5Zm-.25-52.541v52.291h.5v-52.291h-.5Zm-3.121.25h3.371v-.5h-3.371v.5Zm.25 52.041v-52.291h-.5v52.291h.5Zm-53.507.25h53.257v-.5h-53.257v.5Zm-.25-18.735V32.86h.5V14.374h-.5Zm13.885-32.725-13.865 32.627.46.196 13.865-32.628-.46-.195Zm-3.196.348h3.426v-.5h-3.426v.5ZM190.198 12.73l13.066-30.887-.461-.195-13.065 30.887.46.195Zm.02 3.934v-4.031h-.5v4.03h.5Zm-26.722.25h26.472v-.5h-26.472v.5Zm-.25-35.168v34.918h.5v-34.918h-.5Zm-4.436.25h4.686v-.5h-4.686v.5Zm.25 76.45v-76.7h-.5v76.7h.5Zm0 1.546v-1.545h-.5v1.545h.5Zm-41.646-26.147 41.262 26.358.269-.422-41.262-26.357-.269.421Zm6.661-8.095-6.715 7.72.377.329 6.716-7.72-.378-.329Zm-3.415-1.318 3.494 1.707.22-.45-3.495-1.706-.219.45Zm-6.179 7.289 6.476-7.348-.375-.33-6.476 7.347.375.33Zm-15.57-9.696 15.248 9.741.269-.421-15.249-9.741-.269.421Zm5.07-8.463-5.147 8.119.422.268 5.147-8.12-.422-.267Zm-3.65-1.409 3.755 1.769.213-.453-3.755-1.768-.213.452Zm-4.493 7.61 4.812-7.704-.424-.264-4.812 7.703.424.265Zm-3.908-2.196 3.561 2.274.27-.421-3.561-2.275-.27.422Zm-15.57-2.213 15.67 2.25.07-.495-15.67-2.25-.07.495ZM59.305 2.137l16.935 13.168.307-.395L59.613 1.742l-.307.395Zm-.096-20.39V1.94h.5v-20.193h-.5Zm-3.388.25h3.638v-.5h-3.638v.5Zm.25 17.17v-17.42h-.5v17.42h.5Zm-11.158-7.77L55.673-.631l.297-.402-10.758-7.972-.298.402Zm2.06-9.866-2.155 9.61.488.11 2.155-9.61-.488-.11Zm-3.683-.72 3.864 1.017.127-.484-3.864-1.016-.127.483ZM41.868-11.3l1.73-8.078-.488-.105-1.731 8.078.489.105Zm-.725 21.116 3.113-13.88-.488-.11-3.113 13.88.488.11Zm41.845 30.08L41.046 9.558l-.294.405L82.695 40.3l.293-.406Zm10.053-16.6L82.63 39.967l.424.264 10.413-16.668-.425-.265Zm-2.724-1.46 2.801 1.804.27-.42-2.8-1.805-.271.42Zm-16.29-2.848L90.41 21.87l.087-.492-16.382-2.884-.087.493ZM43.861-3.921 73.919 18.94l.303-.397L44.164-4.32l-.303.398Zm42.673 45.937L96.85 25.744l-.422-.268-10.316 16.272.422.268Zm13.993 5.027-14.115-5.395-.179.467 14.116 5.395.178-.467Zm10.529-12.192-10.806 12.26.375.33 10.806-12.26-.375-.33Zm-14.552-9.03 14.604 9.405.271-.42L96.774 25.4l-.27.42Zm7.877 23.332 10.322-11.866-.377-.328-10.322 11.865.377.329Zm29.841 11.9-29.935-12.296-.19.463 29.935 12.296.19-.463Zm-2.979 2.853 3.04-2.426-.312-.39-3.04 2.425.312.39Zm-28.996-11.54 28.747 11.576.187-.464-28.747-11.576-.187.464ZM91.25 70.736l11.304-18.471-.427-.261-11.304 18.471.427.261Zm18.477 11.825L91.174 70.397l-.275.418 18.554 12.164.274-.418Zm-2.994 3.325 3.031-2.937-.348-.359-3.031 2.937.348.36ZM68.498 60.61l37.922 25.306.278-.416-37.922-25.306-.278.416Zm4.045-2.286-4.011 1.85.21.455 4.01-1.851-.209-.454Zm.72.33-.478-.312-.274.418.477.313.275-.418Zm7.775-15.6-8.135 15.695.444.23 8.135-15.694-.444-.23Zm-15.596-10.72 15.674 11.04.288-.409-15.674-11.04-.288.409Zm-14.749 20 15.093-20.054-.4-.301-15.092 20.054.4.301ZM86.94 82.982l-36.283-30.99-.325.38 36.283 30.99.325-.38Zm-5.91 10.812 5.965-10.499-.435-.247-5.965 10.5.435.246Zm-9.352-4.234 9.026 4.336.217-.45-9.026-4.337-.217.45Zm-14.524 20.913L71.99 89.478l-.409-.288-14.836 20.994.408.289Zm37.999 13.61-38.117-13.989-.172.469 38.117 13.989.172-.469Zm25.38-20.294-25.621 20.333.31.391 25.622-20.333-.311-.391Zm24.556-16.793-24.542 16.782.282.413 24.542-16.782-.282-.413Zm12.022-22.415-12.101 22.503.44.237 12.102-22.503-.441-.237Zm-42.731-27.248 42.816 27.577.271-.42-42.816-27.577-.271.42ZM76.815 61.245l7.978-16.156-.448-.222-7.979 16.157.449.221Zm11.109 7.02-11.197-7.34-.274.419 11.196 7.34.275-.418Zm10.273-17.84L87.572 68.347l.43.255L98.628 50.68l-.43-.255ZM84.477 45.21l13.843 5.574.187-.463-13.843-5.575-.187.464ZM164 20.25h25.875v-.5H164v.5Zm.25 38.28V20h-.5v38.53h.5Zm5.26 5.403-5.329-5.576-.362.345 5.329 5.576.362-.345Zm20.852.616-21.025-.693-.016.5 21.025.693.016-.5Zm-.737-44.546.479 44.799.5-.006-.479-44.799-.5.006Zm56.113 15.98h-53.127v.5h53.127v-.5Zm.25 31.497V36.233h-.5V67.48h.5Zm-53.39-2.522 53.127 2.772.026-.5-53.127-2.772-.026.5Zm-.237-28.725v28.475h.5V36.233h-.5Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#F7F5D8",
              fillRule: "evenodd",
              d: "m47.478 114.826 36.583-8.039.012-.045 4.713 2.675 24.423 20.864 25.306 3.255 87.858-11.419 18.84-34.151v-7.933l-21.118 37.725-85.58 11.957-24.191-3.828-21.249-18.759-7.948-4.35-.01.007.002-.005-38.845 8.252-28.227 15.939 11.865-44.91-19.006-12.495v6.38l12.982 8.11-12.982 51.513 36.572-20.743Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#EDE4C5",
              d: "m84.061 106.787.054.244.15-.033.038-.148-.242-.063Zm-36.583 8.039-.054-.244-.036.008-.033.019.123.217Zm36.595-8.084.124-.217-.283-.161-.082.314.241.064Zm4.713 2.675.163-.19-.019-.015-.02-.012-.124.217Zm24.423 20.864-.162.191.056.048.074.009.032-.248Zm25.306 3.255-.031.248.032.004.032-.004-.033-.248Zm87.858-11.419.033.248.125-.016.061-.111-.219-.121Zm18.84-34.151.219.12.031-.056v-.064h-.25Zm0-7.933h.25v-.958l-.468.836.218.122Zm-21.118 37.725.035.248.123-.017.061-.108-.219-.123Zm-85.58 11.957-.039.247.037.005.037-.005-.035-.247Zm-24.191-3.828-.166.187.055.049.072.011.039-.247Zm-21.249-18.759.165-.187-.02-.018-.025-.014-.12.219Zm-7.948-4.35.12-.22-.14-.077-.13.096.15.201Zm-.01.007-.241-.064-.182.691.573-.427-.15-.2Zm.002-.005.242.063.103-.392-.397.084.052.245Zm-38.845 8.252-.052-.245-.038.008-.033.019.123.218Zm-28.227 15.939-.242-.064-.15.573.515-.292-.123-.217Zm11.865-44.91.242.065.046-.174-.15-.099-.138.209ZM10.906 69.567l.138-.209-.388-.254v.463h.25Zm0 6.38h-.25v.139l.118.073.132-.212Zm12.982 8.11.243.061.044-.177-.154-.096-.133.212Zm-12.982 51.513-.242-.061-.143.567.509-.289-.124-.217Zm73.102-29.026-36.584 8.039.108.488 36.583-8.039-.107-.488Zm-.176.135-.012.045.483.127.012-.044-.483-.128Zm5.078 2.522-4.713-2.675-.247.434 4.713 2.676.247-.435Zm24.461 20.891-24.422-20.864-.325.38 24.423 20.865.324-.381Zm25.176 3.197-25.306-3.254-.064.495 25.307 3.255.063-.496Zm87.794-11.419-87.858 11.419.065.496 87.858-11.419-.065-.496Zm18.653-34.024-18.839 34.151.437.242 18.84-34.151-.438-.242Zm-.031-7.812v7.933h.5v-7.933h-.5Zm-20.649 37.848 21.117-37.726-.436-.244-21.118 37.725.437.245Zm-85.764 12.081 85.58-11.956-.069-.495-85.58 11.956.069.495Zm-24.265-3.828 24.191 3.828.078-.494-24.191-3.828-.078.494Zm-21.376-18.818 21.249 18.758.331-.374-21.249-18.759-.33.375Zm-7.902-4.319 7.948 4.351.24-.439-7.948-4.351-.24.439Zm.26-.012.01-.007-.3-.401-.009.007.299.401Zm-.39-.269-.001.005.483.127.002-.005-.484-.127Zm-38.551 8.561 38.845-8.253-.104-.489-38.845 8.252.104.49ZM18.17 127.188l28.227-15.938-.246-.436-28.227 15.939.246.435Zm11.5-45.19-11.865 44.909.484.127 11.865-44.908-.484-.128ZM10.77 69.775l19.006 12.496.274-.418-19.005-12.495-.275.417Zm.387 6.171v-6.38h-.5v6.38h.5Zm12.865 7.898-12.982-8.11-.265.424 12.982 8.11.265-.424ZM11.149 135.63 24.13 84.117l-.485-.122-12.982 51.513.485.122Zm36.206-21.021-36.572 20.742.247.435L47.6 115.044l-.246-.435Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#E8EAEB",
              fillRule: "evenodd",
              d: "m203.996 101.316 5.024-8.144 11.207 6.483-5.55 7.707-10.681-6.046Z",
              clipRule: "evenodd"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("circle", { cx: 51, cy: 17, r: 3, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M16 30a4 4 0 0 1 4-4h52v110H20a4 4 0 0 1-4-4V30Z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 36,
            height: 8,
            x: 22,
            y: 32,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 6,
            x: 22,
            y: 46,
            fill: "#8092AA",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-inventory_svg__c)", children: [
          /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 87, y: 81.5, fill: "#fff", rx: 4 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#F66",
              d: "M93.273 91.313c1.415 0 2.274-1.047 2.274-2.907 0-1.847-.863-2.906-2.274-2.906-1.41 0-2.273 1.059-2.273 2.906 0 1.852.856 2.906 2.273 2.906Zm-1.07-2.907c0-1.293.418-1.941 1.07-1.945.653.004 1.075.652 1.07 1.945.005 1.305-.413 1.938-1.07 1.938-.656 0-1.078-.633-1.07-1.938Z"
            }
          ),
          /* @__PURE__ */ jsx("rect", { width: 12, height: 2, x: 91, y: 94.313, fill: "#EAEAEA", rx: 1 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "M99.553 105.106a.5.5 0 0 0 .894 0L103 100h-6l2.553 5.106Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-inventory_svg__d)", children: [
          /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 184, y: 21, fill: "#fff", rx: 4 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#3299FE",
              d: "M190.508 25.078h-1.11l-1.398.89v1.04l1.297-.813h.031v4.54h1.18v-5.657ZM193.883 25c-1.278-.004-2.141.824-2.141 1.961.008 1.055.758 1.82 1.774 1.82.629 0 1.187-.297 1.453-.797h.047c-.004 1.13-.411 1.82-1.18 1.82-.453 0-.777-.245-.875-.663h-1.156c.113.957.894 1.672 2.031 1.672 1.422 0 2.332-1.133 2.328-3.055 0-2.055-1.109-2.754-2.281-2.758Zm-.992 1.93a.981.981 0 0 1 1-1.008c.578.004 1 .46 1.007 1 0 .543-.441 1-1.015 1-.582 0-.992-.434-.992-.992Z"
            }
          ),
          /* @__PURE__ */ jsx("rect", { width: 12, height: 2, x: 188, y: 34.813, fill: "#EAEAEA", rx: 1 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "M196.553 44.606a.5.5 0 0 0 .894 0L200 39.5h-6l2.553 5.106Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-inventory_svg__e)", children: [
          /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 175, y: 70, fill: "#fff", rx: 4 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#3299FE",
              d: "M181.508 74.078h-1.11l-1.398.89v1.04l1.297-.813h.031v4.54h1.18v-5.657ZM184.914 79.813c1.277 0 2.195-.696 2.188-1.665.007-.707-.45-1.21-1.282-1.312v-.047c.633-.113 1.075-.562 1.071-1.195.004-.895-.782-1.594-1.961-1.594-1.16 0-2.035.676-2.055 1.648H184c.02-.433.43-.714.93-.71.5-.004.832.293.828.726.004.445-.387.75-.946.75h-.523v.867h.523c.665.004 1.075.328 1.071.79.004.456-.399.769-.961.773-.547-.004-.957-.281-.977-.703h-1.187c.023.988.914 1.671 2.156 1.671Z"
            }
          ),
          /* @__PURE__ */ jsx("rect", { width: 12, height: 2, x: 179, y: 83.813, fill: "#EAEAEA", rx: 1 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "M187.553 93.606a.5.5 0 0 0 .894 0L191 88.5h-6l2.553 5.106Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M41.664 52h1.219l2.383-4.68v-.976h-3.993v.96h2.774v.04L41.664 52ZM45.5 51h2.75v1h1.117v-1h.719v-.945h-.719v-3.711h-1.476L45.5 50.07V51Zm1.188-.945v-.047l1.523-2.375h.055v2.422h-1.578Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 26, height: 3, x: 31, y: 68, fill: "#DDD", rx: 1 }),
        /* @__PURE__ */ jsx("circle", { cx: 26.5, cy: 69.5, r: 2.5, fill: "#DDD" }),
        /* @__PURE__ */ jsx("circle", { cx: 26.5, cy: 83.5, r: 2.5, fill: "#DDD" }),
        /* @__PURE__ */ jsx("circle", { cx: 26.5, cy: 97.5, r: 2.5, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx("circle", { cx: 26.5, cy: 111.5, r: 2.5, fill: "#FFEFEF" }),
        /* @__PURE__ */ jsx("rect", { width: 19, height: 3, x: 31, y: 82, fill: "#DDD", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 19, height: 3, x: 31, y: 96, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 19, height: 3, x: 31, y: 110, fill: "#FFEFEF", rx: 1 }),
        /* @__PURE__ */ jsx("circle", { cx: 100, cy: 112, r: 3, fill: "#F66" }),
        /* @__PURE__ */ jsx("rect", { width: 26, height: 20, x: 135, y: 42, fill: "#555", rx: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M139 50.734h2.75v1h1.117v-1h.719v-.945h-.719v-3.71h-1.476L139 49.804v.93Zm1.188-.945v-.047l1.523-2.375h.055v2.422h-1.578ZM146.445 51.813c1.278 0 2.196-.696 2.188-1.665.008-.707-.449-1.21-1.281-1.312v-.047c.632-.113 1.074-.562 1.07-1.195.004-.895-.781-1.594-1.961-1.594-1.16 0-2.035.676-2.055 1.648h1.125c.02-.433.43-.714.93-.71.5-.004.832.292.828.726.004.445-.387.75-.945.75h-.524v.867h.524c.664.004 1.074.328 1.07.79.004.456-.398.769-.961.773-.547-.004-.957-.282-.976-.703h-1.188c.023.988.914 1.672 2.156 1.672Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 2, x: 139, y: 55.813, fill: "#777", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M147.553 66.106a.5.5 0 0 0 .894 0L151 61h-6l2.553 5.106Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 148, cy: 72.5, r: 3, fill: "#555" }),
        /* @__PURE__ */ jsx("circle", { cx: 196, cy: 51.5, r: 3, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("circle", { cx: 188, cy: 100.5, r: 3, fill: "#3299FE" }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-inventory_svg__a",
              width: 216,
              height: 118,
              x: 12,
              y: 24,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5774"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5774",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-inventory_svg__c",
              width: 58,
              height: 56.5,
              x: 71,
              y: 73.5,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.12 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5774"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5774",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-inventory_svg__d",
              width: 58,
              height: 56.5,
              x: 168,
              y: 13,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.12 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5774"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5774",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-inventory_svg__e",
              width: 58,
              height: 56.5,
              x: 159,
              y: 62,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.12 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5774"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5774",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingInventory_default = createIcon(SvgImgSettingInventory);
function SvgImgSettingJp(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 144",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsxs("g", { opacity: 0.6, children: [
          /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-jp_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 167.389, height: 92, x: 13, y: 20, fill: "#DDD", rx: 8 }) }),
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "img-setting-jp_svg__b",
              width: 168,
              height: 92,
              x: 13,
              y: 20,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ jsx(
                "rect",
                {
                  width: 167.389,
                  height: 92,
                  x: 13,
                  y: 20,
                  fill: "#D9D9D9",
                  rx: 8
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs("g", { mask: "url(#img-setting-jp_svg__b)", children: [
            /* @__PURE__ */ jsx("path", { fill: "#E2E8EF", d: "M11.191-32.981h187.184v146.617H11.191z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#EFF4F8",
                fillRule: "evenodd",
                d: "m53.252 24.207 13.67-21.76 15.752 10.245-14.662 23.257-14.76-11.742ZM69.606 84.17l11.47-8.73 1.312 2.622 8.782 6.109-2.861 4.645 10.549 6.788 8.593-12.162 14.779 7.554-7.039 10.757 3.073 7.144v.806h-6.025l-18.194-2.452-26.014-21.784 1.575-1.296Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#CFE8D1",
                fillRule: "evenodd",
                d: "m151.844 76.886 11.202-10.482 24.458 21.133-3.929 7.227-8.557-5.053-23.174-12.825Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#EFF4F8",
                fillRule: "evenodd",
                d: "m64.38 86.346 12.72 2.91-2.55 5.24-1.984 1.128-1.826 3.936v3.433L58.448 99.56l-6.807 1.542-3.733-2.313-2.789-3.165 1.413-3.167 17.847-6.111Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#E8EAEB",
                fillRule: "evenodd",
                d: "M128.32 42.72s-.816.995-1.035 1.559c-.201.518-1.553.67-.55 1.581.397.361 1.581-.361 2.088 0 2.162 1.543 8.747 5.73 8.747 5.73l-9.796 12.339-19.016-9.62s4.378-13.234 7.817-15.271c3.44-2.038 11.745 3.683 11.745 3.683Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#E8EAEB",
                fillRule: "evenodd",
                d: "m82.67 9.719 36.745 24.777-10.659 17.229L67.959 36.75 82.67 9.72Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#EFF4F8",
                fillRule: "evenodd",
                d: "m53.252 79.078 8.201-4.019V52.627l10.312 6.456v4.99l3.455 11.695-8.747 8.84-13.221-5.53Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#CFE8D1",
                fillRule: "evenodd",
                d: "m120.119 92.172 23.723 14.294 11.992 7.165-39.605.235-1.217-12.163 5.107-9.53Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#F6F7EF",
                fillRule: "evenodd",
                d: "m33.514-7.342-8.063-5.974-6.367-.596L32.702-3.555 29.51 11.342 49.59 26.08 37.829 41.85l-4.434-3.789-11.75 12.615v4.968l11.75-12.929 2.332 1.953-16.642 22.31 3.795 1.062 15.756-20.937 26.746 22.389-2.44 4.227-6.192-3.1L42.17 90.625l-7.792-2.566-12.734-8.231v4.54l11.749 7.24 42.32 14.719-25.745 6.202-6.533 13.08 4.12 9.226h3.147l-4.022-9.226 6.325-12.072 23.967-5.812 20.835-16.117 69.749 42.29h7.106l-13.891-7.653-60.095-36.815 18.938-13.457 59.187 33.918-2.266 3.984h4.391l1.083-2.146 13.529 7.753 15.018 6.763v-4.305l-10.968-4.668-15.843-8.983 3.741-7.412-2.603-1.678-4.187 7.361-57.927-32.841 8.714-16.487 1.135-.46 74.995 3.583 2.943.643v-4.226h-8.226V31.23h8.226v-2.62h-8.226v-42.523h-2.742V28.61h-43.307V13.579l11.275-26.533h-2.786l-10.625 25.118v3.277h-21.527v-28.395h-3.81V50.676L95.255 29.242l5.461-6.278-2.841-1.388-5.267 5.975-12.4-7.92 4.186-6.603-3.053-1.438-3.913 6.264-2.896-1.85-12.742-1.83L48.017 3.468v-16.42h-2.959V1.212L36.312-5.27l1.752-7.814-3.142-.827-1.407 6.569Zm1.942 5.882L32.924 9.828l34.108 24.67 8.467-13.555-2.278-1.468-13.322-2.345L35.457-1.46Zm42.796 24.176-8.39 13.232 11.479 4.387 8.787-9.97-11.876-7.65Zm14.536 9.362-8.394 9.65 24.343 9.998-2.472 1.973-23.376-9.413-9.191 15.02 15.087 9.892-2.465 2.388-30.837-20.579 3.262-1.505.387.254 6.615-12.76L53 28.015 40.727 44.326l29.505 25.2-4.85 8.537-7.34-3.526-12.066 17.072 30.997 11.376 20.835-16.535 19.957-13.647 9.841-18.299-34.818-22.425Zm-24.35 6.388L61.95 51.604l9.105 5.969 8.64-14.574-11.257-4.533Zm85.632-20.313h-21.041v31.332l4.334 4.535 17.097.563-.39-36.43Zm2.225 13.201h43.202v25.41l-43.202-2.254V31.354Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#DCE3E7",
                d: "m25.451-13.316.15-.201-.057-.042-.07-.006-.023.249Zm8.063 5.974-.15.2.313.232.081-.38-.244-.052Zm-14.43-6.57.023-.249-.87-.082.696.53.151-.2ZM32.702-3.555l.245.053.033-.156-.127-.096-.15.2ZM29.51 11.342l-.244-.053-.034.159.13.095.148-.201ZM49.59 26.08l.201.15.15-.202-.202-.15-.148.202ZM37.829 41.85l-.162.19.203.173.16-.214-.2-.15Zm-4.434-3.789.162-.19-.182-.155-.163.175.183.17Zm-11.75 12.615-.182-.17-.067.072v.098h.25Zm0 4.968h-.25v.647l.436-.478-.185-.169Zm11.75-12.929.16-.192-.184-.154-.161.178.185.168Zm2.332 1.953.2.15.142-.19-.181-.152-.16.192Zm-16.642 22.31-.2-.15-.218.293.35.098.068-.24Zm3.795 1.062-.068.24.165.046.102-.136-.2-.15Zm15.756-20.937.161-.192-.202-.169-.158.21.2.151Zm26.746 22.389.217.125.105-.182-.161-.135-.16.192Zm-2.44 4.227-.112.223.21.106.118-.204-.216-.125Zm-6.192-3.1.112-.224-.19-.094-.124.17.202.148ZM42.17 90.625l-.078.237.173.057.107-.147-.202-.147Zm-7.792-2.566-.136.21.027.018.03.01.079-.237Zm-12.734-8.231.135-.21-.385-.25v.46h.25Zm0 4.54h-.25v.139l.119.073.13-.213Zm11.749 7.24-.132.213.024.014.026.01.082-.237Zm42.32 14.719.058.243.828-.199-.805-.28-.082.236Zm-25.745 6.202-.058-.243-.113.027-.052.104.223.112Zm-6.533 13.08-.223-.112-.053.106.048.108.228-.102Zm4.12 9.226-.227.101.066.149h.162v-.25Zm3.147 0v.25h.382l-.153-.35-.23.1Zm-4.022-9.226-.221-.116-.056.106.048.11.229-.1Zm6.325-12.072-.06-.243-.11.027-.052.1.222.116Zm23.967-5.812.058.243.052-.013.043-.033-.153-.197Zm20.835-16.117.13-.214-.148-.089-.135.105.153.198Zm69.749 42.29-.13.214.06.036h.07v-.25Zm7.106 0v.25l.121-.469-.121.219Zm-13.891-7.653-.13.214.01.005.12-.219ZM100.677 89.43l-.145-.203-.309.219.323.198.131-.214Zm18.938-13.457.124-.217-.139-.08-.13.093.145.204Zm59.187 33.918.218.123.123-.216-.216-.124-.125.217Zm-2.266 3.984-.217-.123-.213.373h.43v-.25Zm4.391 0v.25h.153l.07-.137-.223-.113Zm1.083-2.146.124-.217-.228-.131-.119.235.223.113Zm13.529 7.753-.124.217.011.006.011.005.102-.228Zm15.018 6.763-.103.228.353.159v-.387h-.25Zm0-4.305h.25v-.165l-.152-.065-.098.23Zm-10.968-4.668-.123.217.012.007.014.006.097-.23Zm-15.843-8.983-.223-.112-.107.212.207.118.123-.218Zm3.741-7.412.224.113.101-.201-.189-.122-.136.21Zm-2.603-1.678.135-.21-.222-.143-.13.23.217.123Zm-4.187 7.361-.123.218.217.123.123-.217-.217-.124ZM122.77 73.719l-.221-.117-.114.214.211.12.124-.217Zm8.714-16.487L131.39 57l-.084.034-.043.081.221.117Zm1.135-.46.012-.25-.055-.003-.051.021.094.232Zm74.995 3.583.053-.245-.02-.004-.021-.001-.012.25Zm2.943.643-.054.245.304.066v-.31h-.25Zm0-4.226h.25v-.25h-.25v.25Zm-8.226 0h-.25v.25h.25v-.25Zm0-25.541v-.25h-.25v.25h.25Zm8.226 0v.25h.25v-.25h-.25Zm0-2.62h.25v-.25h-.25v.25Zm-8.226 0h-.25v.25h.25v-.25Zm0-42.523h.25v-.25h-.25v.25Zm-2.742 0v-.25h-.25v.25h.25Zm0 42.523v.25h.25v-.25h-.25Zm-43.307 0h-.25v.25h.25v-.25Zm0-15.032-.23-.098-.02.047v.05h.25Zm11.275-26.533.23.098.148-.348h-.378v.25Zm-2.786 0v-.25h-.166l-.064.153.23.097Zm-10.625 25.117-.23-.097-.02.047v.05h.25Zm0 3.278v.25h.25v-.25h-.25Zm-21.527 0h-.25v.25h.25v-.25Zm0-28.395h.25v-.25h-.25v.25Zm-3.81 0v-.25h-.25v.25h.25Zm0 63.63-.135.21.385.246v-.456h-.25ZM95.255 29.242l-.188-.164-.19.219.244.156.134-.211Zm5.461-6.278.189.165.214-.246-.293-.143-.11.224Zm-2.841-1.388.11-.224-.172-.084-.126.143.188.165Zm-5.267 5.975-.134.211.18.115.142-.16-.188-.166Zm-12.4-7.92-.21-.135-.134.21.21.135.134-.21Zm4.186-6.603.211.134.152-.24-.256-.12-.107.226Zm-3.053-1.438.107-.226-.201-.095-.118.188.212.133Zm-3.913 6.264-.135.21.213.137.134-.214-.212-.133Zm-2.896-1.85.135-.21-.046-.03-.053-.007-.036.248Zm-12.742-1.83-.154.198.052.041.066.01.035-.248ZM48.017 3.468h-.25v.123l.096.075.154-.198Zm0-16.42h.25v-.25h-.25v.25Zm-2.959 0v-.25h-.25v.25h.25Zm0 14.166-.148.201.398.296v-.497h-.25ZM36.312-5.27l-.244-.054-.036.158.13.097.15-.2Zm1.752-7.814.244.055.053-.235-.233-.062-.064.242Zm-3.142-.827.064-.241-.253-.067-.055.256.244.052ZM32.925 9.828l-.244-.055-.036.16.133.097.147-.202ZM35.456-1.46l.152-.2-.31-.235-.086.38.244.055Zm31.576 35.958-.147.202.217.157.142-.227-.212-.133Zm8.467-13.555.212.132.13-.21-.207-.133-.135.21Zm-2.278-1.468.135-.21-.042-.027-.05-.009-.043.246ZM59.899 17.13l-.15.2.047.036.06.01.044-.246Zm9.964 18.818-.212-.134-.163.259.285.109.09-.234Zm8.389-13.232.135-.21-.211-.137-.135.213.211.134Zm3.089 17.619-.09.233.163.062.115-.13-.188-.165Zm8.787-9.97.188.165.192-.218-.244-.157-.136.21Zm-5.734 11.362-.189-.164-.228.263.322.132.095-.23Zm8.394-9.649.136-.21-.183-.117-.141.163.188.164Zm15.949 19.648.155.196.333-.265-.393-.162-.095.231Zm-2.472 1.973-.094.232.136.054.114-.09-.156-.196Zm-23.376-9.413.094-.232-.197-.08-.11.181.213.13Zm-9.191 15.02-.214-.13-.126.206.202.133.138-.21Zm15.087 9.892.174.18.224-.218-.26-.171-.138.209Zm-2.465 2.388-.138.208.167.112.145-.14-.174-.18ZM55.483 51.007l-.105-.227-.406.187.372.248.139-.208Zm3.262-1.505.137-.209-.116-.076-.126.058.105.227Zm.387.254-.137.21.232.151.127-.246-.222-.115Zm6.615-12.76.222.114.1-.194-.178-.125-.144.204ZM53 28.015l.144-.204-.198-.14-.146.194.2.15ZM40.727 44.326l-.2-.15-.141.187.178.153.163-.19Zm29.505 25.2.217.123.102-.18-.157-.134-.162.19Zm-4.85 8.537-.109.225.21.101.116-.203-.218-.123Zm-7.34-3.526.108-.226-.191-.091-.122.172.204.145ZM45.975 91.608l-.204-.144-.188.266.306.113.087-.235Zm30.997 11.376-.087.235.132.048.11-.087-.155-.196Zm20.835-16.535-.142-.206-.007.005-.007.005.156.196Zm19.957-13.647.141.207.05-.035.029-.053-.22-.119Zm9.841-18.299.22.118.109-.203-.194-.125-.135.21Zm-65.656-2.9-.224-.11-.098.198.185.122.137-.21Zm6.488-13.137.093-.232-.215-.086-.103.207.225.111Zm2.617 19.107-.138.209.22.143.133-.225-.215-.127Zm8.64-14.574.215.128.149-.25-.27-.11-.094.232Zm53.334-24.846v-.25h-.25v.25h.25Zm21.041 0 .25-.002-.002-.248h-.248v.25Zm-21.041 31.332h-.25v.1l.07.073.18-.173Zm4.334 4.535-.181.172.071.074.102.004.008-.25Zm17.097.563-.008.25.261.009-.003-.261-.25.002Zm45.037-23.229h.25v-.25h-.25v.25Zm-43.202 0v-.25h-.25v.25h.25Zm43.202 25.41-.013.25.263.014v-.264h-.25Zm-43.202-2.254h-.25v.237l.237.013.013-.25ZM25.302-13.115l8.063 5.974.297-.402-8.062-5.974-.298.402Zm-6.241-.548 6.367.596.046-.498-6.367-.596-.046.498Zm13.792 9.91L19.235-14.112l-.302.398L32.55-3.356l.302-.398Zm-3.098 15.147 3.192-14.896-.49-.105-3.191 14.896.489.105Zm19.984 14.484L29.659 11.14l-.297.403 20.081 14.739.296-.404Zm-11.71 16.12L49.79 26.23l-.4-.3L37.628 41.7l.4.299Zm-4.798-3.746 4.435 3.787.325-.38-4.435-3.788-.325.38ZM21.828 50.846l11.749-12.614-.366-.341-11.75 12.614.367.341Zm.067 4.799v-4.97h-.5v4.97h.5Zm11.314-13.098-11.75 12.93.37.336 11.75-12.93-.37-.336Zm2.677 1.929-2.332-1.953-.32.384 2.332 1.952.32-.383ZM19.284 67.128l16.642-22.31-.4-.3-16.642 22.31.4.3Zm3.662.67-3.795-1.06-.134.481 3.794 1.061.135-.481Zm15.49-20.845L22.679 67.889l.4.301 15.756-20.937-.4-.3ZM65.542 69.3 38.796 46.911l-.32.384L65.22 69.684l.32-.384Zm-2.385 4.544 2.44-4.227-.432-.25-2.44 4.227.432.25Zm-6.52-3.001 6.192 3.1.224-.448-6.192-3.1-.224.448Zm-14.264 19.93 14.578-20.007-.404-.294-14.578 20.006.404.294Zm-8.072-2.476 7.792 2.566.156-.475-7.792-2.566-.156.475Zm-12.792-8.26 12.734 8.232.272-.42-12.735-8.231-.271.42Zm.386 4.33v-4.54h-.5v4.54h.5Zm11.63 7.028-11.75-7.24-.261.425 11.748 7.241.263-.426Zm42.27 14.696-42.32-14.719-.163.472 42.32 14.72.163-.473Zm-25.767 6.681 25.744-6.202-.117-.486-25.744 6.202.117.486Zm-6.368 12.949 6.533-13.081-.447-.223-6.533 13.08.447.224Zm4.125 9.012-4.12-9.226-.457.204 4.12 9.225.457-.203Zm2.918-.148h-3.146v.5h3.146v-.5Zm-4.251-8.876 4.022 9.225.458-.199-4.022-9.226-.458.2Zm6.332-12.288-6.325 12.072.443.232 6.325-12.072-.443-.232Zm24.13-5.939-23.967 5.812.118.486 23.966-5.812-.117-.486Zm20.74-16.072L76.82 107.527l.306.395L97.96 91.806l-.305-.396Zm70.032 42.274-69.749-42.29-.259.428 69.749 42.29.259-.428Zm6.977-.036h-7.106v.5h7.106v-.5Zm-14.011-7.184 13.891 7.653.241-.438-13.891-7.653-.241.438Zm-60.106-36.82 60.096 36.815.261-.427-60.096-36.815-.261.427Zm18.924-13.875-18.938 13.458.29.407 18.938-13.457-.29-.408Zm59.457 33.905-59.188-33.918-.249.434 59.188 33.918.249-.434Zm-.342.093-2.266 3.985.434.247 2.267-3.985-.435-.247Zm-2.049 4.358h4.391v-.5h-4.391v.5Zm4.614-.137 1.083-2.147-.446-.225-1.084 2.147.447.225Zm14.514 5.277-13.53-7.753-.248.434 13.529 7.753.249-.434Zm14.995 6.752-15.017-6.763-.205.456 15.017 6.763.205-.456Zm-.352-4.077v4.305h.5v-4.305h-.5Zm-10.815-4.438 10.967 4.668.196-.46-10.968-4.668-.195.46Zm-15.869-8.995 15.843 8.982.247-.435-15.844-8.982-.246.435Zm.346-.105 3.742-7.412-.447-.226-3.741 7.413.446.225Zm3.654-7.735-2.604-1.678-.27.42 2.603 1.678.271-.42Zm-2.956-1.591-4.187 7.361.434.247 4.187-7.361-.434-.247Zm-62.021-25.14 57.928 32.842.246-.435-57.927-32.842-.247.435Zm8.617-16.821-8.714 16.487.442.233 8.714-16.486-.442-.234Zm1.262-.575-1.135.46.188.464 1.135-.46-.188-.464Zm75.101 3.565-74.995-3.583-.024.5 74.995 3.582.024-.5Zm2.984.65-2.943-.645-.107.489 2.943.644.107-.489Zm-.303-3.983v4.226h.5v-4.226h-.5Zm-7.976.25h8.226v-.5h-8.226v.5Zm-.25-25.791v25.54h.5v-25.54h-.5Zm8.476-.25h-8.226v.5h8.226v-.5Zm-.25-2.37v2.62h.5v-2.62h-.5Zm-7.976.25h8.226v-.5h-8.226v.5Zm-.25-42.773V28.61h.5v-42.523h-.5Zm-2.492.25h2.742v-.5h-2.742v.5Zm.25 42.273v-42.523h-.5V28.61h.5Zm-43.557.25h43.307v-.5h-43.307v.5Zm-.25-15.282V28.61h.5V13.579h-.5Zm11.295-26.63L156.052 13.48l.46.196 11.275-26.533-.46-.195Zm-2.556.347h2.786v-.5h-2.786v.5Zm-10.394 24.965 10.624-25.117-.46-.195-10.625 25.117.461.195Zm.019 3.18v-3.277h-.5v3.277h.5Zm-21.777.25h21.527v-.5h-21.527v.5Zm-.25-28.645v28.395h.5v-28.395h-.5Zm-3.56.25h3.81v-.5h-3.81v.5Zm.25 62.123v-62.373h-.5V49.42h.5Zm0 1.257v-1.257h-.5v1.257h.5ZM95.121 29.453l33.553 21.433.27-.42L95.39 29.03l-.27.422Zm5.407-6.653-5.461 6.278.377.328 5.461-6.277-.377-.329Zm-2.763-.999 2.842 1.388.219-.45-2.842-1.387-.219.449Zm-4.969 5.916 5.266-5.975-.375-.33-5.266 5.974.375.33ZM80.074 19.84l12.4 7.921.269-.421-12.4-7.922-.27.422Zm4.109-6.947-4.186 6.602.422.268 4.186-6.602-.422-.268Zm-2.949-1.078 3.054 1.438.213-.452-3.053-1.438-.213.452Zm-3.594 6.17 3.913-6.264-.424-.264-3.913 6.264.424.265Zm-3.242-1.77 2.895 1.849.27-.422-2.896-1.85-.27.422Zm-12.644-1.794 12.743 1.83.07-.495-12.742-1.83-.071.495ZM47.864 3.665l13.772 10.707.307-.394L48.171 3.27l-.306.395Zm-.096-16.619V3.467h.5v-16.42h-.5Zm-2.709.25h2.959v-.5h-2.959v.5Zm.25 13.917v-14.167h-.5V1.213h.5Zm-9.147-6.282 8.749 6.483.297-.402L36.46-5.47l-.298.401Zm1.657-8.07-1.752 7.815.488.11 1.752-7.815-.488-.11Zm-2.962-.53 3.143.827.127-.484-3.142-.826-.127.483Zm-1.099 6.38 1.408-6.57-.49-.104-1.407 6.569.49.104Zm-.59 17.172L35.7-1.405l-.488-.11-2.531 11.288.488.11Zm34.01 24.412L33.071 9.625l-.293.405L66.885 34.7l.293-.405Zm8.109-13.485-8.468 13.555.425.265 8.467-13.555-.424-.265Zm-2.202-1.124 2.279 1.467.27-.42-2.278-1.468-.27.42Zm-13.229-2.31 13.321 2.346.087-.493-13.321-2.345-.087.493ZM35.305-1.26l24.443 18.59.303-.398-24.443-18.59-.303.398Zm34.769 37.343 8.39-13.232-.423-.268-8.39 13.232.423.268Zm11.356 4.02-11.478-4.387-.179.467 11.479 4.386.178-.467Zm8.51-9.902-8.787 9.97.376.33 8.787-9.97-.375-.33Zm-11.823-7.274 11.876 7.65.27-.421-11.876-7.65-.27.42Zm6.466 18.965 8.394-9.649-.377-.328-8.394 9.65.377.327Zm24.249 9.604-24.343-10-.19.463 24.343 10 .19-.463Zm-2.411 2.4 2.471-1.973-.311-.391-2.472 1.972.312.391Zm-23.625-9.377 23.375 9.413.187-.464-23.375-9.413-.187.464ZM73.91 59.436l9.192-15.02-.427-.26-9.192 15.02.427.26Zm15.011 9.553-15.087-9.892-.275.418 15.088 9.892.274-.418Zm-2.428 2.776 2.465-2.388-.348-.359-2.465 2.388.348.36Zm-31.15-20.55 30.838 20.579.277-.416-30.838-20.579-.277.416Zm3.296-1.94-3.262 1.505.21.454 3.261-1.505-.21-.454Zm.63.272-.389-.254-.274.418.388.254.274-.418Zm6.255-12.667L58.91 49.641l.444.23 6.615-12.76-.444-.231Zm-12.669-8.659L65.603 37.2l.288-.41-12.747-8.978-.288.409Zm-11.93 16.254L53.2 28.167l-.4-.3-12.273 16.307.4.3Zm29.468 24.86-29.505-25.2-.325.38 29.505 25.2.325-.38Zm-4.795 8.85 4.85-8.537-.435-.247-4.85 8.538.435.247Zm-7.666-3.424 7.34 3.526.217-.45-7.34-3.527-.217.451ZM46.18 91.752 58.245 74.68l-.408-.289-12.065 17.073.409.288Zm30.878 10.997L46.063 91.373l-.173.47 30.996 11.376.173-.47Zm20.593-16.496-20.835 16.535.311.392 20.835-16.535-.31-.392Zm19.972-13.657L97.667 86.243l.282.413 19.957-13.647-.282-.413Zm9.762-18.212-9.841 18.3.44.237 9.841-18.3-.44-.236ZM92.653 32.288l34.817 22.425.271-.42-34.817-22.425-.271.42ZM62.174 51.714l6.488-13.137-.449-.221-6.487 13.137.448.221Zm9.018 5.65-9.105-5.97-.274.419 9.105 5.969.274-.418Zm8.288-14.492-8.64 14.573.43.255 8.64-14.573-.43-.255Zm-11.136-4.174 11.258 4.533.186-.464-11.257-4.533-.187.464Zm64.685-20.295h21.041v-.5h-21.041v.5Zm.25 31.082V18.153h-.5v31.332h.5Zm4.265 4.362-4.334-4.535-.361.346 4.333 4.535.362-.346Zm16.924.486-17.097-.563-.016.5 17.097.563.016-.5Zm-.648-36.177.39 36.43.5-.005-.39-36.43-.5.005Zm45.677 12.948h-43.202v.5h43.202v-.5Zm.25 25.66v-25.41h-.5v25.41h.5Zm-43.465-2.005 43.202 2.255.026-.5-43.202-2.254-.026.5Zm-.237-23.405V54.51h.5V31.354h-.5Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#F7F5D8",
                fillRule: "evenodd",
                d: "m38.277 95.266 29.75-6.538.009-.036 3.832 2.175 19.86 16.967 20.579 2.646 71.446-9.285 15.32-27.772v-6.45L181.9 97.65l-69.593 9.723-19.672-3.113-17.28-15.254-6.462-3.538-.008.005.001-.003-31.588 6.71-22.954 12.961 9.648-36.519L8.537 58.461v5.188l10.557 6.595-10.557 41.889 29.74-16.867Z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#EDE4C5",
                d: "m68.026 88.728.054.244.149-.032.039-.148-.242-.064Zm-29.749 6.538-.054-.244-.036.008-.033.018.123.218Zm29.759-6.574.123-.217-.282-.16-.083.313.242.064Zm3.832 2.175.163-.19-.019-.015-.02-.012-.124.217Zm19.86 16.967-.162.19.057.048.074.01.031-.248Zm20.579 2.646-.031.248.032.004.032-.004-.033-.248Zm71.446-9.285.032.248.126-.017.061-.111-.219-.12Zm15.32-27.772.219.121.031-.056v-.065h-.25Zm0-6.45h.25v-.96l-.468.837.218.122ZM181.9 97.65l.035.248.123-.017.061-.109-.219-.122Zm-69.593 9.723-.039.247.037.006.037-.006-.035-.247Zm-19.672-3.113-.165.188.054.048.072.011.04-.247Zm-17.28-15.254.166-.187-.02-.019-.025-.013-.12.219Zm-6.462-3.538.12-.22-.141-.076-.129.095.15.2Zm-.008.005-.242-.063-.182.69.573-.426-.149-.2Zm.001-.003.242.063.103-.392-.397.084.052.245Zm-31.588 6.71-.052-.244-.038.008-.033.019.123.217Zm-22.954 12.961-.242-.063-.151.572.516-.291-.123-.218Zm9.648-36.519.242.064.046-.174-.15-.099-.138.21ZM8.537 58.461l.137-.21-.387-.254v.464h.25Zm0 5.188h-.25v.138l.118.074.132-.212Zm10.557 6.595.243.06.044-.176-.154-.096-.133.212ZM8.537 112.133l-.242-.061-.143.567.508-.288-.123-.218Zm59.436-23.65-29.75 6.539.108.488 29.749-6.538-.107-.488Zm-.179.145-.01.036.484.128.01-.036-.484-.128Zm4.198 2.022-3.833-2.175-.247.434 3.833 2.176.247-.435Zm19.899 16.994L72.03 90.677l-.325.38 19.86 16.967.325-.38Zm20.448 2.588-20.579-2.646-.063.496 20.579 2.646.063-.496Zm71.382-9.285-71.446 9.286.065.495 71.445-9.285-.064-.496Zm15.133-27.645-15.32 27.772.438.241 15.32-27.771-.438-.242Zm-.031-6.33v6.451h.5v-6.45h-.5Zm-16.704 30.8 17.172-30.678-.436-.244-17.173 30.678.437.244Zm-69.777 9.848 69.593-9.722-.069-.495-69.593 9.722.069.495Zm-19.746-3.113 19.672 3.113.079-.494-19.673-3.113-.078.494ZM75.19 89.193l17.28 15.255.33-.375-17.279-15.254-.33.374Zm-6.417-3.506 6.463 3.538.24-.438-6.463-3.538-.24.438Zm.261-.013.008-.006-.299-.4-.007.005.298.401Zm-.39-.268v.004l.483.127v-.004l-.483-.127ZM37.35 92.425l31.589-6.71-.104-.49-31.588 6.71.103.49Zm-22.882 12.934L37.42 92.398l-.245-.435-22.954 12.961.246.435Zm9.284-36.8-9.649 36.519.484.127 9.648-36.52-.483-.127ZM8.4 58.668l15.455 10.162.275-.418L8.674 58.252l-.274.418Zm.387 4.98V58.46h-.5v5.188h.5Zm10.44 6.383L8.67 63.437l-.265.424 10.557 6.595.265-.424ZM8.78 112.194l10.557-41.89-.485-.121-10.557 41.889.485.122Zm29.374-17.146-29.74 16.868.246.435L38.4 95.483l-.246-.435Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#E8EAEB",
                fillRule: "evenodd",
                d: "m165.557 84.28 4.085-6.624 9.113 5.273-4.513 6.267-8.685-4.917Z",
                clipRule: "evenodd"
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            "path",
            {
              stroke: "#406588",
              strokeLinecap: "round",
              strokeWidth: 1.5,
              d: "m41.77 38.84 57.564 29.575a.5.5 0 0 0 .347.041l52.984-12.877"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#406588",
              fillRule: "evenodd",
              d: "M41.674 28c-6.007 0-10.895 4.645-10.895 10.356 0 2.78 1.145 5.39 3.22 7.347l7.288 6.997a.557.557 0 0 0 .387.154.557.557 0 0 0 .388-.154l7.285-6.994c2.078-1.96 3.223-4.57 3.223-7.35C52.57 32.646 47.682 28 41.674 28Zm0 14.202c-2.503 0-4.54-1.99-4.54-4.438 0-2.447 2.037-4.438 4.54-4.438 2.504 0 4.54 1.99 4.54 4.438 0 2.447-2.036 4.438-4.54 4.438Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 41.678,
              cy: 38.849,
              r: 8.393,
              fill: "#fff",
              stroke: "#406588"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#406588",
              d: "M42.908 35.156h-1.66L39.56 36.19v1.545l1.51-.91h.037v5.197h1.801v-6.866Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#4DC9AA",
              fillRule: "evenodd",
              d: "M98.895 58C92.888 58 88 62.645 88 68.356c0 2.78 1.145 5.39 3.22 7.347l7.288 6.997a.557.557 0 0 0 .387.154.557.557 0 0 0 .387-.154l7.285-6.994c2.078-1.96 3.223-4.57 3.223-7.35 0-5.71-4.888-10.356-10.895-10.356Zm0 14.202c-2.504 0-4.54-1.99-4.54-4.438 0-2.447 2.036-4.438 4.54-4.438s4.54 1.99 4.54 4.438c0 2.447-2.036 4.438-4.54 4.438Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 98.982,
              cy: 68.491,
              r: 8.393,
              fill: "#fff",
              stroke: "#4DC9AA"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#4DC9AA",
              d: "M96.496 71.638h5.196v-1.451h-2.697v-.038l.688-.597c1.542-1.305 1.934-1.973 1.934-2.77 0-1.266-1.033-2.105-2.65-2.105-1.57 0-2.599.882-2.594 2.314h1.707c-.005-.583.358-.92.886-.92.524 0 .901.327.906.863-.005.498-.32.82-.84 1.261l-2.536 2.144v1.3Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#3299FE",
              fillRule: "evenodd",
              d: "M152.581 44.065c-6.008 0-10.895 4.645-10.895 10.356 0 2.78 1.144 5.39 3.219 7.347l7.288 6.997a.56.56 0 0 0 .388.154.558.558 0 0 0 .387-.154l7.285-6.994c2.078-1.96 3.223-4.57 3.223-7.35 0-5.71-4.888-10.356-10.895-10.356Zm0 14.202c-2.504 0-4.54-1.99-4.54-4.438 0-2.447 2.036-4.438 4.54-4.438 2.503 0 4.539 1.99 4.539 4.438 0 2.447-2.036 4.438-4.539 4.438Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: 152.584,
              cy: 54.605,
              r: 8.393,
              fill: "#fff",
              stroke: "#3299FE"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#3299FE",
              d: "M152.492 58.04c1.655 0 2.825-.854 2.82-2.059.005-.844-.557-1.441-1.641-1.565v-.057c.806-.09 1.391-.616 1.386-1.384.005-1.148-1.047-1.992-2.546-1.992-1.533 0-2.627.877-2.631 2.125h1.716c.01-.427.392-.73.915-.73.481 0 .816.293.811.71.005.432-.391.74-.962.74h-.688v1.252h.688c.627.005 1.056.313 1.056.75 0 .44-.372.749-.915.749-.546 0-.938-.294-.952-.702h-1.811c.014 1.266 1.156 2.162 2.754 2.162Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-jp_svg__c)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 85,
            height: 124,
            x: 141,
            y: 8,
            fill: "url(#img-setting-jp_svg__d)",
            rx: 8
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#EAEAEA",
            fillRule: "evenodd",
            d: "M156 22a.5.5 0 0 1 .5.5v82a.5.5 0 0 1-1 0v-82a.5.5 0 0 1 .5-.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-jp_svg__e)", children: /* @__PURE__ */ jsx("rect", { width: 46, height: 44, x: 88, y: 88, fill: "#fff", rx: 8 }) }),
        /* @__PURE__ */ jsx("circle", { cx: 111, cy: 110, r: 16, stroke: "#EAF5FF", strokeWidth: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#3299FE",
            strokeLinecap: "round",
            strokeWidth: 4,
            d: "M111 94a16 16 0 1 1-16 16"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M105.161 113.088c1.486 0 2.567-.774 2.567-1.811 0-.791-.642-1.432-1.433-1.555v-.044c.69-.132 1.195-.703 1.195-1.407 0-.993-.989-1.722-2.329-1.722-1.349 0-2.338.725-2.338 1.722 0 .699.492 1.275 1.196 1.407v.044c-.805.123-1.437.764-1.433 1.555-.004 1.037 1.077 1.811 2.575 1.811Zm-1.002-1.969c-.004-.505.418-.87 1.002-.87.571 0 .993.369.993.87s-.404.857-.993.861c-.598-.004-1.006-.36-1.002-.861Zm.132-2.689c-.004-.453.356-.774.87-.774.506 0 .866.321.861.774.005.461-.36.791-.861.791-.51 0-.874-.33-.87-.791ZM111.006 113.088c1.481 0 2.47-.932 2.47-2.241 0-1.213-.857-2.079-2.013-2.075-.593-.004-1.094.251-1.31.598h-.044l.15-1.52h2.839v-1.213h-4.07l-.316 3.726h1.345c.171-.338.479-.518.931-.518.611 0 1.042.426 1.037 1.046.005.619-.421 1.041-1.019 1.037-.519.004-.936-.312-.958-.782h-1.459c.022 1.133 1.024 1.942 2.417 1.942ZM115.588 110.58c.769.003 1.193-.547 1.196-1.36-.003-.81-.417-1.371-1.196-1.367-.749-.004-1.186.557-1.183 1.367-.003.803.414 1.363 1.183 1.36Zm-.417-1.36c-.003-.407.14-.698.417-.698.297-.003.427.284.431.698-.004.417-.144.69-.431.69-.267 0-.42-.273-.417-.69Zm.014 3.78h.834l3.404-4.949h-.834L115.185 113Zm2.672-1.169c-.003.803.414 1.364 1.183 1.367.766-.003 1.19-.553 1.19-1.367 0-.81-.414-1.371-1.19-1.367-.752-.004-1.186.557-1.183 1.367Zm.759 0c.004-.407.147-.697.424-.697.297-.004.427.283.431.697-.004.417-.147.69-.431.69-.27 0-.42-.273-.424-.69Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 31, height: 4, x: 184, y: 62, fill: "#EAF5FF", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 31, height: 4, x: 184, y: 102, fill: "#EAF5FF", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 24, height: 4, x: 184, y: 75, fill: "#F4F4F4", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 24, height: 4, x: 184, y: 115, fill: "#F4F4F4", rx: 1 }),
        /* @__PURE__ */ jsx("circle", { cx: 156, cy: 64, r: 4, fill: "#D8F2EB" }),
        /* @__PURE__ */ jsx("circle", { cx: 174, cy: 77, r: 5, fill: "#F4F4F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 174, cy: 117, r: 5, fill: "#F4F4F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 156, cy: 104, r: 4, fill: "#84C2FC" }),
        /* @__PURE__ */ jsx("rect", { width: 31, height: 6, x: 184, y: 19, fill: "#D6E9FB", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 24, height: 6, x: 184, y: 35, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M170 18.4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v7.2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-7.2Zm1.6.4h1.6v1.6h-1.6v-1.6Zm0 2.4h1.6v1.6h-1.6v-1.6Zm4-2.4H174v1.6h1.6v-1.6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M174 43.6a5.6 5.6 0 1 0 0-11.2 5.6 5.6 0 0 0 0 11.2Zm.6-4.903V35.6h-1.2v2.662l-1.461 1.754.922.768 1.739-2.087Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 156, cy: 22, r: 5.5, fill: "#406588", stroke: "#406588" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M156.881 19.8h-1.031l-1.049.642v.96l.937-.565h.024v3.229h1.119V19.8Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 10, x: 169, y: 59, fill: "#EAF5FF", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 10, x: 169, y: 99, fill: "#EAF5FF", rx: 2 }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-jp_svg__a",
              width: 175.389,
              height: 104,
              x: 9,
              y: 20,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 12,
                    result: "effect1_dropShadow_286_5640"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5640"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5640",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-jp_svg__c",
              width: 93,
              height: 136,
              x: 137,
              y: 8,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 12,
                    result: "effect1_dropShadow_286_5640"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5640"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5640",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-jp_svg__e",
              width: 54,
              height: 56,
              x: 84,
              y: 88,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 12,
                    result: "effect1_dropShadow_286_5640"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5640"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5640",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-jp_svg__d",
              x1: 141,
              x2: 361.716,
              y1: 8,
              y2: 254.784,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingJp_default = createIcon(SvgImgSettingJp);
function SvgImgSettingNs(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 150",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-ns_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 120, height: 30, x: 45, y: 8, fill: "#fff", rx: 8 }) }),
        /* @__PURE__ */ jsx("rect", { width: 50, height: 6, x: 64, y: 23, fill: "#E3E8EB", rx: 2 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 27,
            height: 4,
            x: 64,
            y: 15,
            fill: "#DDD",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-ns_svg__b)", children: /* @__PURE__ */ jsx("circle", { cx: 39, cy: 23, r: 20, fill: "url(#img-setting-ns_svg__c)" }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M48.25 17.295a.75.75 0 0 1-.513.929l-1.5.433a.75.75 0 1 1-.416-1.441l1.5-.434a.75.75 0 0 1 .93.513Zm-3.22 3.925a.75.75 0 0 1 .75-.75h2.638a.75.75 0 0 1 0 1.5h-2.639a.75.75 0 0 1-.75-.75Zm1.207 2.563a.75.75 0 0 0-.416 1.44l1.5.434a.75.75 0 0 0 .416-1.441l-1.5-.434Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 4, x: 29, y: 19, fill: "#fff", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 3, height: 8, x: 32, y: 24, fill: "#fff", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "m40 14.47-8.606 2.134c-.821.204-1.394.908-1.394 1.712v5.368c0 .804.573 1.508 1.394 1.712L40 27.53V14.47Zm1 13.308.661.164c1.183.293 2.339-.553 2.339-1.713V15.771c0-1.16-1.156-2.006-2.339-1.713l-.661.164v13.556Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 147, cy: 22, r: 8, fill: "#8092AA", opacity: 0.5 }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-ns_svg__d",
            width: 16,
            height: 16,
            x: 139,
            y: 14,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 147, cy: 22, r: 8, fill: "#8898A7" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-ns_svg__d)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E3E8EB",
            fillRule: "evenodd",
            d: "M147 22.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.11c0 .491.398.89.889.89h10.222a.889.889 0 0 0 .889-.89V31a6 6 0 0 0-6-6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-ns_svg__e)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 132,
            height: 89,
            x: 68,
            y: 45,
            fill: "url(#img-setting-ns_svg__f)",
            rx: 8
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 47, height: 6, x: 99, y: 57, fill: "#E3E8EB", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 31, height: 6, x: 99, y: 69, fill: "#EAF5FF", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 96, height: 8, x: 86, y: 92, fill: "#FFF7DD", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 96, height: 8, x: 86, y: 114, fill: "#FFF7DD", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 70, height: 8, x: 86, y: 92, fill: "#FFD335", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 24, height: 8, x: 86, y: 114, fill: "#FFD335", rx: 2 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 24,
            height: 4,
            x: 86,
            y: 83,
            fill: "#DDD",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 24,
            height: 4,
            x: 86,
            y: 105,
            fill: "#DDD",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#777",
            d: "m88.983 59.745.867 1.11-.163.006c-1.05-.005-1.628-.74-1.628-2.09 0-1.353.578-2.088 1.628-2.088 1.04 0 1.623.735 1.618 2.089 0 .618-.121 1.11-.352 1.46l-.405-.487h-1.565ZM86 58.772c.005 2.428 1.612 3.772 3.687 3.772.462 0 .903-.066 1.313-.203l.578.659h1.785l-1.15-1.349c.71-.638 1.15-1.607 1.15-2.88 0-2.443-1.623-3.771-3.676-3.771-2.075 0-3.682 1.328-3.687 3.772ZM94.981 62.554c.536 0 1.014-.436 1.019-.984-.005-.537-.483-.973-1.019-.973-.562 0-1.024.436-1.019.973-.005.548.457.984 1.02.984Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            d: "m88.032 74.895.424-1.352h2.391l.43 1.352h2.02L90.932 68h-2.554L86 74.895h2.032Zm.858-2.724.73-2.314h.058l.735 2.314H88.89ZM95.043 75c.503 0 .952-.41.957-.924-.005-.505-.454-.914-.957-.914-.527 0-.961.41-.956.914-.005.515.429.924.956.924Z"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-ns_svg__g)", children: /* @__PURE__ */ jsx("circle", { cx: 200, cy: 58, r: 20, fill: "url(#img-setting-ns_svg__h)" }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M193 49a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V51a2 2 0 0 0-2-2h-14Zm3.177 6c-.443 0-.802.336-.802.75s.359.75.802.75h7.621c.443 0 .802-.336.802-.75s-.359-.75-.802-.75h-7.621Zm-.089 3c-.394 0-.713.336-.713.75s.319.75.713.75h6.774c.394 0 .713-.336.713-.75s-.319-.75-.713-.75h-6.774Zm-.713 3.75c0-.414.315-.75.704-.75h4.742c.389 0 .704.336.704.75s-.315.75-.704.75h-4.742c-.389 0-.704-.336-.704-.75Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            stroke: "#FB0",
            d: "M197 46.5a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5h-6Z"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-ns_svg__a",
              width: 136,
              height: 46,
              x: 37,
              y: 8,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5469",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-ns_svg__b",
              width: 56,
              height: 60,
              x: 11,
              y: 3,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 12 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5469",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-ns_svg__e",
              width: 148,
              height: 105,
              x: 60,
              y: 45,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5469",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-ns_svg__g",
              width: 56,
              height: 60,
              x: 172,
              y: 38,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 12 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5469"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5469",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-ns_svg__c",
              x1: 19,
              x2: 59,
              y1: 3,
              y2: 43,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#4FA7FD" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4E8FF0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-ns_svg__f",
              x1: 134,
              x2: 200,
              y1: 90,
              y2: 134,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-ns_svg__h",
              x1: 180,
              x2: 252.5,
              y1: 38,
              y2: 107.5,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#FFD335" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F90" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingNs_default = createIcon(SvgImgSettingNs);
function SvgImgSettingPrice(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 192,
            height: 124,
            x: 17,
            y: 16,
            fill: "url(#img-setting-price_svg__a)",
            rx: 4
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 26, cy: 25, r: 3, fill: "#406588" }),
        /* @__PURE__ */ jsx("circle", { cx: 35, cy: 25, r: 3, fill: "#4DC9AA" }),
        /* @__PURE__ */ jsx("circle", { cx: 44, cy: 25, r: 3, fill: "#3299FE" }),
        /* @__PURE__ */ jsxs("g", { opacity: 0.8, children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#3299FE",
              fillRule: "evenodd",
              d: "M62.16 59.54C51.534 43.015 39.577 41.776 35.265 42.965l-.532-1.928c5.355-1.477 18.132.35 29.108 17.423 6.621 10.301 14.463 14.412 21.525 14.354 7.082-.06 13.663-4.31 17.771-11.319 4.327-7.382 9.462-11.608 16.029-11.744 6.454-.133 13.95 3.712 22.986 11.492 8.963 7.719 15.581 10.506 22.164 8.37 3.348-1.087 6.808-3.48 10.64-7.397 3.83-3.915 7.979-9.296 12.716-16.276l1.655 1.123c-4.763 7.02-8.99 12.513-12.941 16.552-3.949 4.036-7.676 6.674-11.453 7.9-7.668 2.489-15.05-.975-24.086-8.756-8.965-7.72-15.969-11.125-21.64-11.008-5.557.115-10.173 3.638-14.345 10.756-4.392 7.492-11.562 12.24-19.48 12.307-7.937.066-16.346-4.573-23.224-15.272Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#3299FE", d: "M37 42a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M39 42a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#3299FE", d: "M89 74a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M91 74a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#3299FE", d: "M146 62a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#E3E8EB",
              fillRule: "evenodd",
              d: "M148 62a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#3299FE", d: "M193 42a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M195 42a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#406588",
              fillRule: "evenodd",
              d: "M100.605 50.734c-1.054 1.66-2.08 3.153-3.085 4.206-3.821 4.001-7.673 6.343-12.462 6.448-4.72.103-10.152-1.975-17.139-6.288-8.075-4.983-16.342-4.047-22.68-1.807-3.169 1.12-5.83 2.559-7.699 3.719a36.152 36.152 0 0 0-2.163 1.448 23.644 23.644 0 0 0-.703.53l-.033.027-.007.006h-.001a1 1 0 0 1-1.266-1.548l.633.774-.632-.774v-.001l.005-.003.012-.01.043-.035.162-.127c.14-.108.346-.264.611-.457a38.108 38.108 0 0 1 2.285-1.53c1.956-1.214 4.748-2.725 8.086-3.904 6.672-2.359 15.626-3.423 24.398 1.99 6.902 4.26 11.921 6.08 16.044 5.99 4.053-.088 7.433-2.032 11.06-5.83.856-.896 1.79-2.24 2.843-3.896.51-.803 1.038-1.664 1.592-2.566l.036-.06c.565-.92 1.155-1.882 1.771-2.853 2.444-3.856 5.36-7.988 8.934-10.57 1.802-1.301 3.802-2.232 6.017-2.52 2.222-.288 4.594.08 7.119 1.271 5.005 2.362 10.637 7.974 17.126 18.256 6.391 10.126 12.826 15.82 18.824 18.729 5.985 2.903 11.612 3.073 16.473 2.014 4.879-1.062 9-3.367 11.914-5.424a37.164 37.164 0 0 0 3.377-2.684c.389-.349.686-.633.883-.827l.222-.222.053-.055.011-.012.002-.002h.001a1 1 0 0 1 1.457 1.37l-.729-.685c.729.684.728.685.728.685l-.002.002-.005.006-.019.019a27.34 27.34 0 0 1-1.266 1.21 39.263 39.263 0 0 1-3.559 2.829c-3.049 2.152-7.417 4.607-12.642 5.745-5.242 1.141-11.334.953-17.771-2.17-6.425-3.116-13.115-9.116-19.643-19.46-6.43-10.19-11.809-15.401-16.289-17.515-2.217-1.047-4.205-1.33-6.008-1.096-1.81.235-3.501 1.001-5.103 2.158-3.232 2.335-5.974 6.166-8.416 10.019-.606.956-1.19 1.906-1.756 2.829l-.04.066c-.551.897-1.086 1.77-1.604 2.585Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#406588", d: "M37 57a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M39 57a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#406588", d: "M89 60a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M91 60a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#406588", d: "M141 48a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M143 48a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#FFDA75",
              fillRule: "evenodd",
              d: "M34.014 72.225h.101a33.228 33.228 0 0 1 1.632.06c1.139.07 2.8.218 4.867.534 4.136.633 9.89 1.936 16.346 4.615 4.259 1.768 7.463 3.24 10.341 4.562 5.877 2.7 10.396 4.775 19.763 7.473 7.117 2.05 15.882 2.303 26.296 1.181 10.422-1.122 22.561-3.628 36.457-7.146 13.732-3.476 24.697-2.982 32.208-1.633 3.757.675 6.653 1.565 8.601 2.281.974.358 1.711.673 2.2.896a17.639 17.639 0 0 1 .676.325l.03.016.005.002a.975.975 0 0 0 .926-1.715l-.463.858c.463-.858.463-.858.462-.859h-.001l-.004-.002-.013-.007-.043-.023a19.374 19.374 0 0 0-.767-.37 33.819 33.819 0 0 0-2.335-.95c-2.045-.752-5.05-1.674-8.929-2.37-7.761-1.395-19.008-1.888-33.031 1.661-13.86 3.509-25.899 5.99-36.188 7.098-10.297 1.109-18.776.835-25.548-1.116-9.228-2.659-13.573-4.656-19.37-7.32-2.888-1.328-6.135-2.82-10.526-4.642-6.626-2.75-12.537-4.09-16.798-4.742a56.33 56.33 0 0 0-5.043-.553 35.385 35.385 0 0 0-1.744-.064h-.134s-.002 0 .012.975l-.014-.975a.975.975 0 0 0 .028 1.95Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#FFDA75", d: "M37 71a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M39 71a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#FFDA75", d: "M89 89a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M91 89a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#4DC9AA", d: "M146 84a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#E3E8EB",
              fillRule: "evenodd",
              d: "M148 84a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
              clipRule: "evenodd"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("g", { opacity: 0.8, children: [
          /* @__PURE__ */ jsx("circle", { cx: 35, cy: 122, r: 2, fill: "#3299FE" }),
          /* @__PURE__ */ jsx("circle", { cx: 65, cy: 122, r: 2, fill: "#406588" }),
          /* @__PURE__ */ jsx("circle", { cx: 95, cy: 122, r: 2, fill: "#FFDA75" }),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 16,
              height: 4,
              x: 39,
              y: 120,
              fill: "#8092AA",
              opacity: 0.2,
              rx: 1
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 16,
              height: 4,
              x: 69,
              y: 120,
              fill: "#8092AA",
              opacity: 0.2,
              rx: 1
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 16,
              height: 4,
              x: 99,
              y: 120,
              fill: "#8092AA",
              opacity: 0.2,
              rx: 1
            }
          )
        ] }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-price_svg__b)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-setting-price_svg__c)",
            d: "M115 62a8 8 0 0 1 8-8h92a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8h-92a8 8 0 0 1-8-8V62Z"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M128.668 84h6.07v-1.453h-3.621V82.5l1.289-1.254c1.746-1.582 2.215-2.373 2.215-3.34 0-1.47-1.207-2.508-3.023-2.508-1.787 0-3.018 1.061-3.012 2.72h1.676c-.006-.815.515-1.32 1.312-1.313.78-.006 1.348.463 1.348 1.218 0 .674-.428 1.143-1.219 1.899l-3.047 2.8.012 1.278ZM139.285 84.117c2.121 0 3.41-1.57 3.41-4.36 0-2.77-1.295-4.359-3.41-4.359s-3.41 1.588-3.41 4.36c0 2.777 1.283 4.36 3.41 4.36Zm-1.605-4.36c0-1.939.627-2.911 1.605-2.917.979.006 1.612.978 1.606 2.918.006 1.957-.621 2.906-1.606 2.906-.984 0-1.617-.95-1.605-2.906ZM149.988 78.344v3.578c.004.652-.457 1.121-1.164 1.125-.699-.004-1.16-.473-1.164-1.125v-3.578h-1.172v3.672c0 1.238.93 2.066 2.336 2.062 1.403.004 2.344-.824 2.344-2.062v-3.672h-1.18ZM155.191 79.96h1.125c-.015-1-.839-1.694-2.093-1.694-1.239 0-2.145.683-2.141 1.71 0 .829.586 1.305 1.539 1.54l.617.148c.617.152.969.332.969.719 0 .422-.398.71-1.016.71-.625 0-1.078-.288-1.117-.859h-1.14c.035 1.215.906 1.848 2.273 1.844 1.379.004 2.184-.66 2.188-1.695-.004-.942-.727-1.434-1.696-1.656l-.508-.125c-.488-.11-.91-.293-.906-.704.004-.375.336-.648.93-.648.574 0 .93.262.976.71ZM159.152 84c1.727 0 2.77-1.066 2.766-2.836.004-1.762-1.039-2.82-2.742-2.82h-2.016V84h1.992Zm-.82-1.008v-3.64h.781c1.071 0 1.633.554 1.633 1.812 0 1.27-.562 1.828-1.641 1.828h-.773Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            d: "M129.445 71h4.047v-.969h-2.414V70l.86-.836c1.164-1.055 1.476-1.582 1.476-2.227 0-.98-.805-1.671-2.016-1.671-1.191 0-2.011.707-2.007 1.812h1.117c-.004-.543.344-.879.875-.875.519-.004.898.309.898.813 0 .449-.285.761-.812 1.265l-2.031 1.867.007.852ZM134.109 70h2.75v1h1.118v-1h.718v-.945h-.718v-3.711H136.5l-2.391 3.726V70Zm1.188-.945v-.047l1.523-2.375h.055v2.422h-1.578ZM143.77 68.172v1.789c.001.326-.229.56-.582.562-.35-.001-.581-.236-.583-.562v-1.79h-.585v1.837c0 .619.464 1.033 1.168 1.031.701.002 1.171-.412 1.171-1.031v-1.836h-.589ZM146.371 68.98h.563c-.008-.5-.42-.847-1.047-.847-.619 0-1.073.342-1.071.855 0 .414.293.653.77.77l.309.074c.308.076.484.166.484.36 0 .21-.199.355-.508.355-.312 0-.539-.145-.558-.43h-.571c.018.608.453.924 1.137.922.689.002 1.092-.33 1.094-.848-.002-.47-.364-.716-.848-.828l-.254-.062c-.244-.055-.455-.147-.453-.352.002-.187.168-.324.465-.324.287 0 .465.13.488.356ZM148.352 71c.863 0 1.384-.533 1.382-1.418.002-.88-.519-1.41-1.371-1.41h-1.008V71h.997Zm-.411-.504v-1.82h.391c.535 0 .816.277.816.906 0 .635-.281.914-.82.914h-.387Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 22, height: 4, x: 128, y: 90, fill: "#DDD", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 27, height: 1, x: 126, y: 68, fill: "#F66", rx: 0.5 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#777",
            d: "M185 76h4.034v9H185zM190.379 76h1.793v9h-1.793zM193.518 76h1.345v9h-1.345zM196.207 76h3.138v9h-3.138zM200.689 76h3.138v9h-3.138zM205.172 76h1.345v9h-1.345zM207.861 76h3.138v9h-3.138z"
          }
        ),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-price_svg__d)", children: [
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 70.8,
              height: 24,
              x: 152.199,
              y: 98,
              fill: "#3299FE",
              rx: 12
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 34.8,
              height: 4.8,
              x: 177.398,
              y: 107.6,
              fill: "#84C2FC",
              opacity: 0.6,
              rx: 2
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 1.8,
              height: 8.4,
              x: 168.699,
              y: 114.8,
              fill: "#fff",
              rx: 0.5,
              transform: "rotate(-180 168.699 114.8)"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M167.269 104.67a.75.75 0 0 1 1.061 0l3.6 3.6a.75.75 0 0 1-1.061 1.06l-3.07-3.069-3.069 3.069a.75.75 0 0 1-1.061-1.06l3.6-3.6Z",
              clipRule: "evenodd"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-price_svg__a",
              x1: 17,
              x2: 209,
              y1: 16,
              y2: 140,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-price_svg__c",
              x1: 115,
              x2: 223,
              y1: 54,
              y2: 106,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-price_svg__b",
              width: 128,
              height: 72,
              x: 105,
              y: 48,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 5 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5517"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5517",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-price_svg__d",
              width: 78.801,
              height: 32,
              x: 148.199,
              y: 98,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.247969 0 0 0 0 0.558247 0 0 0 0 0.8625 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5517"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5517",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingPrice_default = createIcon(SvgImgSettingPrice);
function SvgImgSettingReport(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 192,
            height: 114,
            x: 28,
            y: 26,
            fill: "url(#img-setting-report_svg__a)",
            rx: 4
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 74, y: 53, fill: "#EBD89D", rx: 6 }),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 55, y: 53, fill: "#E9C0C0", rx: 6 }),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 55, y: 34, fill: "#B1B7F4", rx: 6 }),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 36, y: 53, fill: "#B9D6A4", rx: 6 }),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 36, y: 34, fill: "#C5C5C5", rx: 6 }),
        /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 74, y: 34, fill: "#A8CDFC", rx: 6 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 122,
            height: 132,
            x: 98,
            y: 5,
            fill: "url(#img-setting-report_svg__b)",
            rx: 8
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 106, height: 33, x: 106, y: 85, fill: "#F6F6F6", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 87, height: 4, x: 115, y: 97, fill: "#EAEAEA", rx: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#B3B2ED",
            fillRule: "evenodd",
            d: "M106 87a2 2 0 0 1 2-2h102a2 2 0 0 1 2 2v2H106v-2ZM98 13a8 8 0 0 1 8-8h106a8 8 0 0 1 8 8v22H98V13Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 65,
            height: 8,
            x: 135,
            y: 16,
            fill: "#6979F8",
            opacity: 0.5,
            rx: 4
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 117, cy: 20, r: 10, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#CCC",
            fillRule: "evenodd",
            d: "M113 15a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8Zm1.521 2a.51.51 0 0 0-.521.5c0 .276.233.5.521.5h4.958a.51.51 0 0 0 .521-.5.51.51 0 0 0-.521-.5h-4.958Zm-.086 2c-.24 0-.435.224-.435.5s.195.5.435.5h4.13c.24 0 .435-.224.435-.5s-.195-.5-.435-.5h-4.13ZM114 21.5c0-.276.205-.5.458-.5h3.084c.253 0 .458.224.458.5s-.205.5-.458.5h-3.084c-.253 0-.458-.224-.458-.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 106, height: 34, x: 106, y: 43, fill: "#F6F6F6", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 30, height: 7, x: 115, y: 49, fill: "#DDD", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 36, height: 3, x: 115, y: 60, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("circle", { cx: 198, cy: 63, r: 8, fill: "#8092AA", opacity: 0.5 }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-report_svg__c",
            width: 16,
            height: 16,
            x: 190,
            y: 55,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 198, cy: 63, r: 8, fill: "#8898A7" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-report_svg__c)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E3E8EB",
            fillRule: "evenodd",
            d: "M198 63.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.11c0 .491.398.89.889.89h10.222a.889.889 0 0 0 .889-.89V72a6 6 0 0 0-6-6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 64, height: 61, x: 20, y: 75, fill: "#fff", rx: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#DDD",
            fillRule: "evenodd",
            d: "m27 92.732.5-.865A.991.991 0 0 0 28 92h1v1h-1a1.99 1.99 0 0 1-1-.268ZM75 93v-1h1a.991.991 0 0 0 .5-.133l.5.865A1.99 1.99 0 0 1 76 93h-1Zm3-9.111h-1V83a.991.991 0 0 0-.133-.5l.865-.5c.17.294.268.636.268 1v.889ZM29 81h-1a1.99 1.99 0 0 0-1 .268l.5.865A.991.991 0 0 1 28 82h1v-1Zm-3 9.111h1V91c0 .184.049.353.133.5l-.865.5A1.99 1.99 0 0 1 26 91v-.889Zm0-.889h1v-1.778h-1v1.778Zm0-2.666h1v-1.778h-1v1.778Zm0-2.667h1V83c0-.184.049-.353.133-.5l-.865-.5A1.99 1.99 0 0 0 26 83v.889ZM30 81v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h2v-1h-2Zm3 0v1h1c.184 0 .353.049.5.133l.5-.865A1.99 1.99 0 0 0 76 81h-1Zm3 3.778h-1v1.778h1v-1.778Zm0 2.666h-1v1.778h1v-1.778Zm0 2.667h-1V91a.991.991 0 0 1-.133.5l.865.5A1.99 1.99 0 0 0 78 91v-.889ZM74 93v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Zm-3 0v-1h-2v1h2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 52, height: 6, x: 26, y: 124, fill: "#F4F4F4", rx: 2 }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-report_svg__d)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M32 101a4 4 0 0 1 4-4h51a4 4 0 0 1 4 4v15a4 4 0 0 1-4 4H36a4 4 0 0 1-4-4v-15Z"
          }
        ) }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-report_svg__e)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#DDD",
            fillRule: "evenodd",
            d: "M36 96h51a5 5 0 0 1 5 5v15a5 5 0 0 1-5 5H36a5 5 0 0 1-5-5v-15a5 5 0 0 1 5-5Zm0 1a4 4 0 0 0-4 4v15a4 4 0 0 0 4 4h51a4 4 0 0 0 4-4v-15a4 4 0 0 0-4-4H36Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 12, x: 38, y: 102.5, fill: "#555", rx: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M47.513 105.953a.75.75 0 0 1 .034 1.06l-3.75 4a.751.751 0 0 1-1.094 0l-2.25-2.4a.75.75 0 0 1 1.094-1.026l1.703 1.816 3.203-3.416a.75.75 0 0 1 1.06-.034Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 29, height: 4, x: 55, y: 106.5, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M66.513 39.453a.75.75 0 0 1 .034 1.06l-3.75 4a.75.75 0 0 1-1.094 0l-2.25-2.4a.75.75 0 0 1 1.094-1.026l1.703 1.816 3.203-3.416a.75.75 0 0 1 1.06-.034Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-report_svg__a",
              x1: 28,
              x2: 226.691,
              y1: 26,
              y2: 265.897,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E3E8EB" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E3E8EB", stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-report_svg__b",
              x1: 159,
              x2: 221.116,
              y1: 71,
              y2: 135.932,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-report_svg__d",
              width: 75,
              height: 39,
              x: 24,
              y: 97,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 4 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5722"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5722",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-report_svg__e",
              width: 77,
              height: 41,
              x: 23,
              y: 96,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 4 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5722"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5722",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingReport_default = createIcon(SvgImgSettingReport);
function SvgImgSettingSales(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-setting-sales_svg__a)",
            d: "M24 20a4 4 0 0 1 4-4h184a4 4 0 0 1 4 4v116a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V20Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 33, cy: 25, r: 3, fill: "#406588" }),
        /* @__PURE__ */ jsx("circle", { cx: 42, cy: 25, r: 3, fill: "#4DC9AA" }),
        /* @__PURE__ */ jsx("circle", { cx: 51, cy: 25, r: 3, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-sales_svg__b)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 72,
            height: 116,
            x: 84,
            y: 8,
            fill: "url(#img-setting-sales_svg__c)",
            rx: 8
          }
        ) }),
        /* @__PURE__ */ jsxs("g", { opacity: 0.8, children: [
          /* @__PURE__ */ jsx("rect", { width: 8, height: 32, x: 174, y: 88, fill: "#84C2FC", rx: 1 }),
          /* @__PURE__ */ jsx("rect", { width: 8, height: 64, x: 196, y: 56, fill: "#406588", rx: 1 }),
          /* @__PURE__ */ jsx("rect", { width: 24, height: 14, x: 188, y: 33, fill: "#406588", rx: 4 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "M195.079 35.078h-1.362l-1.717.89v1.04l1.592-.813h.039v4.54h1.448v-5.657ZM196.691 40.734h4.968v-.968h-2.964v-.032l1.056-.836c1.429-1.054 1.813-1.582 1.813-2.226 0-.98-.988-1.672-2.475-1.672-1.463 0-2.47.707-2.466 1.813h1.372c-.005-.544.422-.88 1.075-.876.637-.003 1.103.31 1.103.813 0 .45-.35.762-.998 1.266l-2.494 1.867.01.851ZM205.372 40.813c1.568.003 2.633-.82 2.628-1.97.005-1.066-.926-1.827-2.177-1.827-.768 0-1.454.293-1.775.797h-.067c.009-1.114.503-1.805 1.448-1.805.561 0 .959.246 1.075.64h1.419c-.139-.93-1.098-1.648-2.494-1.648-1.736 0-2.853 1.129-2.858 3.04-.005 2.07 1.367 2.769 2.801 2.773Zm-1.247-1.938c.009-.55.546-1.004 1.256-1.008.705.004 1.219.442 1.219 1.008 0 .57-.523 1.012-1.238 1.008-.71.004-1.228-.453-1.237-1.008Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#406588",
              d: "M199.553 50.606a.5.5 0 0 0 .894 0L203 45.5h-6l2.553 5.106Z"
            }
          ),
          /* @__PURE__ */ jsx("rect", { width: 20, height: 14, x: 168, y: 65, fill: "#84C2FC", rx: 4 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              d: "M174.796 72.813c1.624 0 2.795-.68 2.795-1.602 0-.711-.699-1.29-1.565-1.398v-.04c.748-.117 1.295-.629 1.3-1.25-.005-.879-1.073-1.523-2.53-1.523-1.457 0-2.525.644-2.52 1.523-.005.621.526 1.133 1.299 1.25v.04c-.886.109-1.575.687-1.575 1.398 0 .922 1.167 1.602 2.796 1.602Zm-1.25-1.72c-.005-.491.526-.847 1.25-.85.723.003 1.255.363 1.25.85.005.485-.497.825-1.25.821-.753.004-1.255-.336-1.25-.82Zm.177-2.452c-.005-.442.433-.75 1.073-.75.635 0 1.078.308 1.083.75-.005.453-.458.77-1.083.773-.63-.004-1.078-.32-1.073-.773ZM181.244 72.813c1.609 0 2.766-.696 2.756-1.665.01-.707-.566-1.21-1.615-1.312v-.047c.798-.113 1.354-.562 1.349-1.195.005-.895-.984-1.594-2.471-1.594-1.462 0-2.564.676-2.589 1.648h1.418c.024-.433.541-.714 1.171-.71.63-.004 1.049.293 1.044.726.005.445-.488.75-1.191.75h-.66v.867h.66c.836.004 1.353.328 1.348.79.005.456-.502.769-1.211.773-.689-.004-1.206-.281-1.23-.703h-1.496c.029.988 1.151 1.671 2.717 1.671Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#84C2FC",
              d: "M177.553 82.606a.5.5 0 0 0 .894 0L181 77.5h-6l2.553 5.106Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-setting-sales_svg__d)", children: [
          /* @__PURE__ */ jsx("rect", { width: 84, height: 20, x: 78, y: 108, fill: "#3299FE", rx: 10 }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M120.53 113.47a.749.749 0 0 0-1.06 0l-3 3a.749.749 0 1 0 1.06 1.06l1.72-1.719v5.689a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5.689l1.72 1.719a.749.749 0 1 0 1.06-1.06l-3-3Z",
              clipRule: "evenodd"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("rect", { width: 52, height: 20, x: 94, y: 84, fill: "#F4F4F4", rx: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M117.227 97.078c1.273 0 2.14-.816 2.14-1.96 0-1.087-.773-1.864-1.812-1.86-.496-.004-.926.199-1.133.476h-.047l.156-1.43h2.516v-.96h-3.485l-.304 3.258h1.062c.168-.317.465-.477.891-.477.594.004 1.019.422 1.016 1.023.003.59-.415 1.004-1 1-.493.004-.895-.3-.922-.742h-1.141c.02.977.883 1.672 2.063 1.672ZM122.359 97.078c1.414 0 2.274-1.047 2.274-2.906 0-1.848-.863-2.906-2.274-2.906-1.41 0-2.273 1.058-2.273 2.906 0 1.851.855 2.906 2.273 2.906Zm-1.07-2.906c0-1.293.418-1.941 1.07-1.945.653.004 1.075.652 1.071 1.945.004 1.305-.414 1.937-1.071 1.937-.656 0-1.078-.632-1.07-1.937Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 136, cy: 94, r: 6, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M136.6 91.6a.6.6 0 0 0-1.2 0v1.8h-1.8a.6.6 0 0 0 0 1.2h1.8v1.8a.6.6 0 0 0 1.2 0v-1.8h1.8a.6.6 0 0 0 0-1.2h-1.8v-1.8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 104, cy: 94, r: 6, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M101 94a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 0 1.2h-4.8a.6.6 0 0 1-.6-.6Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 29, height: 4, x: 94, y: 76, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 52, height: 52, x: 94, y: 18, fill: "#EAEAEA", rx: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M106.75 22a.75.75 0 0 0-.75-.75h-4.952c-2.064 0-3.798 1.606-3.798 3.66V30a.75.75 0 0 0 1.5 0v-5.09c0-1.16.995-2.16 2.298-2.16H106a.75.75 0 0 0 .75-.75ZM106.75 66a.75.75 0 0 1-.75.75h-4.952c-2.064 0-3.798-1.606-3.798-3.66V58a.75.75 0 0 1 1.5 0v5.09c0 1.16.995 2.16 2.298 2.16H106a.75.75 0 0 1 .75.75ZM133.25 22a.75.75 0 0 1 .75-.75h4.952c2.064 0 3.798 1.606 3.798 3.66V30a.75.75 0 0 1-1.5 0v-5.09c0-1.16-.995-2.16-2.298-2.16H134a.75.75 0 0 1-.75-.75ZM133.25 66c0 .414.336.75.75.75h4.952c2.064 0 3.798-1.606 3.798-3.66V58a.75.75 0 0 0-1.5 0v5.09c0 1.16-.995 2.16-2.298 2.16H134a.75.75 0 0 0-.75.75Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M102 34h5.586v20H102zM109.449 34h2.483v20h-2.483zM113.793 34h1.862v20h-1.862zM117.518 34h4.345v20h-4.345zM123.725 34h4.345v20h-4.345zM129.93 34h1.862v20h-1.862zM133.656 34h4.345v20h-4.345z"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-sales_svg__e)", children: /* @__PURE__ */ jsx("circle", { cx: 55, cy: 68, r: 20, fill: "url(#img-setting-sales_svg__f)" }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M49.011 57.111c.5 0 .939.318 1.1.78l.044.158.557 2.784h13.375a1 1 0 0 1 .943 1.333L62.442 69.5a1 1 0 0 1-.943.667H49.167v1.555H62c.59 0 1.079.44 1.156 1.009l.01.158c0 .59-.438 1.079-1.008 1.156l-.158.01H46.834V62.833a2 2 0 0 1 1.51-1.94l-.29-1.449h-2.776c-.59 0-1.079-.439-1.156-1.008l-.01-.158c0-.59.438-1.079 1.008-1.156l.158-.01h3.733Zm2.49 20.056a2.333 2.333 0 1 1-4.668 0 2.333 2.333 0 0 1 4.667 0Zm12.444 0a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-sales_svg__a",
              x1: 24,
              x2: 242.776,
              y1: 16,
              y2: 258.846,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#E3E8EB" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E3E8EB", stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-sales_svg__c",
              x1: 84,
              x2: 150.325,
              y1: 8,
              y2: 116.955,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-sales_svg__f",
              x1: 35,
              x2: 75,
              y1: 48,
              y2: 88,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#4DC9AA" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4FC94D" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-sales_svg__b",
              width: 88,
              height: 132,
              x: 76,
              y: 8,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5271"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5271"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5271",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-sales_svg__d",
              width: 92,
              height: 28,
              x: 74,
              y: 108,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 4 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.247969 0 0 0 0 0.558247 0 0 0 0 0.8625 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5271"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5271",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-sales_svg__e",
              width: 56,
              height: 56,
              x: 27,
              y: 48,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5271"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5271"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5271",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingSales_default = createIcon(SvgImgSettingSales);
function SvgImgSettingSchedule(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 148",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-schedule_svg__a)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 208,
            height: 112,
            x: 12,
            y: 14,
            fill: "url(#img-setting-schedule_svg__b)",
            rx: 4
          }
        ) }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 64,
            height: 8,
            x: 24,
            y: 22,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 64, y: 43, fill: "#D8F2EB", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 98, y: 43, fill: "#EAEAEA", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 132, y: 43, fill: "#FFF7DD", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 64, y: 67, fill: "#EAF5FF", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 98, y: 67, fill: "#EFF1FF", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 132, y: 67, fill: "#EAEAEA", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 64, y: 91, fill: "#FFEFEF", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 98, y: 91, fill: "#EAEAEA", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 32, height: 22, x: 132, y: 91, fill: "#EAEAEA", rx: 2 }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-schedule_svg__c)", children: /* @__PURE__ */ jsx("rect", { width: 64, height: 124, x: 164, y: 8, fill: "#fff", rx: 4 }) }),
        /* @__PURE__ */ jsx("circle", { cx: 32, cy: 54, r: 8, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-schedule_svg__d",
            width: 16,
            height: 16,
            x: 24,
            y: 46,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 32, cy: 54, r: 8, fill: "#EAEAEA" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-schedule_svg__d)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F9F9F9",
            fillRule: "evenodd",
            d: "M32 55a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.112c0 .49.398.889.889.889H37.11c.491 0 .889-.398.889-.89v-1.11a6 6 0 0 0-6-6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("circle", { cx: 175, cy: 33, r: 5, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-schedule_svg__e",
            width: 10,
            height: 10,
            x: 170,
            y: 28,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 175, cy: 33, r: 5, fill: "#EAEAEA" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-schedule_svg__e)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F9F9F9",
            fillRule: "evenodd",
            d: "M175 33.625a1.875 1.875 0 1 0 0-3.749 1.875 1.875 0 0 0 0 3.75Zm0 1.25a3.75 3.75 0 0 0-3.75 3.75v.695c0 .307.249.555.556.555h6.388a.556.556 0 0 0 .556-.555v-.695a3.75 3.75 0 0 0-3.75-3.75Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("circle", { cx: 32, cy: 78, r: 8, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-schedule_svg__f",
            width: 16,
            height: 16,
            x: 24,
            y: 70,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 32, cy: 78, r: 8, fill: "#EAEAEA" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-schedule_svg__f)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F9F9F9",
            fillRule: "evenodd",
            d: "M32 79a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.112c0 .49.398.889.889.889H37.11c.491 0 .889-.398.889-.89v-1.11a6 6 0 0 0-6-6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("circle", { cx: 32, cy: 102, r: 8, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-schedule_svg__g",
            width: 16,
            height: 16,
            x: 24,
            y: 94,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 32, cy: 102, r: 8, fill: "#EAEAEA" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-schedule_svg__g)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F9F9F9",
            fillRule: "evenodd",
            d: "M32 103.001a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 0-6 6v1.111c0 .491.398.889.889.889H37.11c.491 0 .889-.398.889-.889v-1.111a6 6 0 0 0-6-6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 3, x: 44, y: 50, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 183, y: 31, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 44, height: 3, x: 178, y: 45.5, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 74, y: 52, fill: "#4DC9AA", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 74, y: 76, fill: "#3299FE", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 108, y: 76, fill: "#6979F8", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 142, y: 76, fill: "#CCC", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 74, y: 100, fill: "#FF7979", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 108, y: 100, fill: "#CCC", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 142, y: 100, fill: "#CCC", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 108, y: 52, fill: "#CCC", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 142, y: 52, fill: "#FB0", rx: 2 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 3, x: 44, y: 74, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 3, x: 44, y: 98, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 8, height: 3, x: 44, y: 55, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 8, height: 3, x: 44, y: 79, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 8, height: 3, x: 44, y: 103, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 36,
            height: 8,
            x: 170,
            y: 14,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 178, cy: 70, r: 8, fill: "#77D5BB" }),
        /* @__PURE__ */ jsx("circle", { cx: 178, cy: 88, r: 8, fill: "#CCC" }),
        /* @__PURE__ */ jsx("circle", { cx: 178, cy: 106, r: 8, fill: "#F4F4F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 196, cy: 70, r: 8, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("circle", { cx: 196, cy: 88, r: 8, fill: "#FF7979" }),
        /* @__PURE__ */ jsx("circle", { cx: 196, cy: 106, r: 8, fill: "#F4F4F4" }),
        /* @__PURE__ */ jsx("circle", { cx: 214, cy: 70, r: 8, fill: "#6979F8" }),
        /* @__PURE__ */ jsx("circle", { cx: 214, cy: 88, r: 8, fill: "#FFDA75" }),
        /* @__PURE__ */ jsx("circle", { cx: 214, cy: 106, r: 8, fill: "#F4F4F4" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#CCC",
            fillRule: "evenodd",
            d: "M172.63 44c-1.45 0-2.63 1.121-2.63 2.5 0 .671.276 1.301.777 1.774l1.76 1.689a.137.137 0 0 0 .187 0l1.758-1.688a2.422 2.422 0 0 0 .778-1.775c0-1.379-1.18-2.5-2.63-2.5Zm0 3.429c-.604 0-1.096-.481-1.096-1.072 0-.59.492-1.071 1.096-1.071.605 0 1.096.48 1.096 1.071 0 .59-.491 1.072-1.096 1.072Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M198.825 68.148a.525.525 0 0 1 .02.764l-3.207 3.239a.574.574 0 0 1-.82-.005l-1.668-1.728a.525.525 0 0 1 .03-.763.58.58 0 0 1 .795.03l1.26 1.305 2.795-2.822a.579.579 0 0 1 .795-.02Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-schedule_svg__a",
              width: 216,
              height: 128,
              x: 8,
              y: 14,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5400"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 12 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 6 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5400"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5400",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-schedule_svg__c",
              width: 80,
              height: 140,
              x: 156,
              y: 8,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5400"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5400"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5400",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-schedule_svg__b",
              x1: 116,
              x2: 317,
              y1: 70,
              y2: 185.5,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D8D8D8" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingSchedule_default = createIcon(SvgImgSettingSchedule);
function SvgImgSettingTarget(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 140",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 88,
            height: 30,
            x: 138,
            y: 95,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 4
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M148 115.5a1.5 1.5 0 0 1 1.5-1.5h58a1.5 1.5 0 0 1 0 3h-58a1.5 1.5 0 0 1-1.5-1.5Z",
            opacity: 0.2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M148 115.5a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 24,
            height: 2,
            x: 154,
            y: 108,
            fill: "#8092AA",
            opacity: 0.3,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 150, cy: 109, r: 2, fill: "#6979F8", opacity: 0.5 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#406588",
            d: "M130 25c0-5.523 4.477-10 10-10h68c5.523 0 10 4.477 10 10v68c0 5.523-4.477 10-10 10h-68c-5.523 0-10-4.477-10-10V25Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 34,
            height: 6,
            x: 142,
            y: 27,
            fill: "#fff",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 6,
            x: 142,
            y: 85,
            fill: "#fff",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 6,
            x: 192,
            y: 85,
            fill: "#fff",
            opacity: 0.2,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M173.511 46.5c-12.709 0-23.011 10.302-23.011 23.011a2.5 2.5 0 1 1-5 0c0-15.47 12.541-28.011 28.011-28.011 15.47 0 28.011 12.541 28.011 28.011a2.5 2.5 0 1 1-5 0c0-12.709-10.302-23.011-23.011-23.011Z",
            clipRule: "evenodd",
            opacity: 0.3
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M173.506 46.5C160.8 46.5 150.5 56.802 150.5 69.511a2.5 2.5 0 1 1-5 0c0-15.47 12.538-28.011 28.006-28.011 10.937 0 20.406 6.272 25.015 15.405a2.5 2.5 0 0 1-4.464 2.252c-3.792-7.513-11.573-12.657-20.551-12.657Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFDA75",
            fillRule: "evenodd",
            d: "m170.539 53.644 2.181 1.612 1.604-2.15 1.595 2.15 2.144-1.612-.538 4.299h-6.449l-.537-4.3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 170.813, cy: 53.919, r: 0.813, fill: "#FFDA75" }),
        /* @__PURE__ */ jsx("circle", { cx: 174.305, cy: 52.813, r: 0.813, fill: "#FFDA75" }),
        /* @__PURE__ */ jsx("circle", { cx: 177.801, cy: 53.625, r: 0.813, fill: "#FFDA75" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M175.324 61.516h-1.664l-2.098 1.336v1.558l1.946-1.219h.047V70h1.769v-8.484Z"
          }
        ),
        /* @__PURE__ */ jsxs("g", { opacity: 0.7, children: [
          /* @__PURE__ */ jsxs("g", { opacity: 0.4, children: [
            /* @__PURE__ */ jsx("circle", { cx: 76.6, cy: 115.6, r: 8.6, fill: "#E3E8EB" }),
            /* @__PURE__ */ jsx(
              "mask",
              {
                id: "img-setting-target_svg__a",
                width: 18,
                height: 18,
                x: 68,
                y: 107,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ jsx("circle", { cx: 76.6, cy: 115.6, r: 8.6, fill: "#EAF5FF" })
              }
            ),
            /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-target_svg__a)", children: /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#8092AA",
                fillRule: "evenodd",
                d: "M76.6 116.676a3.225 3.225 0 1 0 0-6.45 3.225 3.225 0 0 0 0 6.45Zm0 2.149a6.45 6.45 0 0 0-6.45 6.45v1.195c0 .528.428.955.956.955h10.989a.955.955 0 0 0 .956-.955v-1.195a6.45 6.45 0 0 0-6.45-6.45Z",
                clipRule: "evenodd"
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 10,
              height: 4,
              x: 89.193,
              y: 110.206,
              fill: "#E3E8EB",
              rx: 1
            }
          ),
          /* @__PURE__ */ jsx("rect", { width: 23, height: 4, x: 89, y: 117, fill: "#E3E8EB", rx: 1 })
        ] }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-target_svg__b)", children: /* @__PURE__ */ jsx("rect", { width: 92, height: 29, x: 26, y: 71, fill: "#F6F6F6", rx: 4 }) }),
        /* @__PURE__ */ jsx("circle", { cx: 45.2, cy: 85.4, r: 9.6, fill: "#E3E8EB" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-target_svg__c",
            width: 20,
            height: 20,
            x: 35,
            y: 75,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 45.2, cy: 85.4, r: 9.6, fill: "#EAF5FF" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-target_svg__c)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            fillRule: "evenodd",
            d: "M45.2 86.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Zm0 2.4a7.2 7.2 0 0 0-7.2 7.2v1.334c0 .589.478 1.066 1.067 1.066h12.266c.59 0 1.067-.477 1.067-1.066V96.2a7.2 7.2 0 0 0-7.2-7.2Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 4, x: 60, y: 80, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 40, height: 4, x: 60, y: 87, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-target_svg__d)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 116,
            height: 36,
            x: 20,
            y: 30,
            fill: "url(#img-setting-target_svg__e)",
            rx: 6
          }
        ) }),
        /* @__PURE__ */ jsx("circle", { cx: 40, cy: 48, r: 10, fill: "#EAF5FF" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-target_svg__f",
            width: 20,
            height: 20,
            x: 30,
            y: 38,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 40, cy: 48, r: 10, fill: "#EAF5FF" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-target_svg__f)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            fillRule: "evenodd",
            d: "M40 49.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0 2.5a7.5 7.5 0 0 0-7.5 7.5v1.39c0 .613.498 1.11 1.111 1.11H46.39c.613 0 1.111-.497 1.111-1.11v-1.39a7.5 7.5 0 0 0-7.5-7.5Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 10, height: 5, x: 56, y: 42, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 27, height: 4, x: 56, y: 51, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("circle", { cx: 26, cy: 28, r: 12, fill: "url(#img-setting-target_svg__g)" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "m19.87 25.655 3.522 2.604 2.59-3.472 2.576 3.472 3.462-2.604-.868 6.943H20.737l-.868-6.943Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 20.313, cy: 26.1, r: 1.313, fill: "#fff" }),
        /* @__PURE__ */ jsx("circle", { cx: 25.955, cy: 24.313, r: 1.313, fill: "#fff" }),
        /* @__PURE__ */ jsx("circle", { cx: 31.6, cy: 25.625, r: 1.313, fill: "#fff" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            d: "M94.076 42.682c-2.075-.007-3.478 1.339-3.478 3.186.012 1.714 1.231 2.958 2.882 2.958 1.021 0 1.93-.482 2.36-1.295h.077c-.006 1.835-.666 2.958-1.917 2.958-.736 0-1.263-.4-1.422-1.079H90.7c.184 1.555 1.454 2.717 3.301 2.717 2.31 0 3.79-1.84 3.783-4.964 0-3.339-1.802-4.475-3.707-4.481Zm-1.612 3.135c-.013-.914.685-1.63 1.625-1.637.94.006 1.625.749 1.638 1.625 0 .882-.718 1.625-1.65 1.625-.947 0-1.613-.705-1.613-1.613ZM98.578 52h6.576v-1.574h-3.923v-.051l1.397-1.358c1.892-1.714 2.399-2.571 2.399-3.619 0-1.593-1.307-2.716-3.275-2.716-1.936 0-3.27 1.149-3.263 2.945h1.816c-.007-.882.558-1.428 1.422-1.422.844-.006 1.46.502 1.46 1.32 0 .73-.464 1.238-1.321 2.057l-3.3 3.034.012 1.384ZM107.13 52.114a1.07 1.07 0 0 0 1.054-1.066 1.06 1.06 0 0 0-1.054-1.054 1.043 1.043 0 0 0-1.067 1.054c-.012.59.47 1.066 1.067 1.066ZM109.029 50.375h4.469V52h1.815v-1.625h1.168v-1.536h-1.168v-6.03h-2.399l-3.885 6.055v1.511Zm1.93-1.536v-.076l2.476-3.86h.088v3.936h-2.564Z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 120.6, cy: 46.6, r: 1.1, stroke: "#3299FE" }),
        /* @__PURE__ */ jsx("circle", { cx: 124.25, cy: 51.25, r: 1, stroke: "#3299FE" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 7.693,
            height: 0.5,
            x: 119.354,
            y: 51.793,
            fill: "#DDD",
            stroke: "#3299FE",
            strokeWidth: 0.5,
            rx: 0.25,
            transform: "rotate(-45 119.354 51.793)"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-target_svg__e",
              x1: 20,
              x2: 136,
              y1: 30,
              y2: 66,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-target_svg__g",
              x1: 14,
              x2: 38,
              y1: 16,
              y2: 40,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#FFD335" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFAE35" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-target_svg__b",
              width: 132,
              height: 69,
              x: 6,
              y: 51,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", {}),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 10 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5332"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5332",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-target_svg__d",
              width: 156,
              height: 76,
              x: 0,
              y: 10,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", {}),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 10 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5332"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5332",
                    result: "shape"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingTarget_default = createIcon(SvgImgSettingTarget);
function SvgImgSettingTodo(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 240 144",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#F1F4F6", d: "M0 0h240v140H0z" }),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-todo_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 56, height: 56, x: 112, y: 12, fill: "#F9F9F9", rx: 8 }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#D1D1D1",
            fillRule: "evenodd",
            d: "M140 35c-7.18 0-13 5.82-13 13a3 3 0 1 1-6 0c0-10.493 8.507-19 19-19s19 8.507 19 19a3 3 0 1 1-6 0c0-7.18-5.82-13-13-13Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#406588",
            fillRule: "evenodd",
            d: "M140 35c-7.18 0-13 5.82-13 13a3 3 0 1 1-6 0c0-10.493 8.507-19 19-19 7.422 0 13.845 4.257 16.97 10.448a3 3 0 1 1-5.356 2.704A12.999 12.999 0 0 0 140 35Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-todo_svg__b)", children: /* @__PURE__ */ jsx("rect", { width: 48, height: 18, x: 176, y: 50, fill: "#fff", rx: 4 }) }),
        /* @__PURE__ */ jsx("rect", { width: 8, height: 4, x: 212, y: 57, fill: "#3299FE", rx: 2 }),
        /* @__PURE__ */ jsx("circle", { cx: 185, cy: 59, r: 5, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "mask",
          {
            id: "img-setting-todo_svg__c",
            width: 10,
            height: 10,
            x: 180,
            y: 54,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ jsx("circle", { cx: 185, cy: 59, r: 5, fill: "#EAEAEA" })
          }
        ),
        /* @__PURE__ */ jsx("g", { mask: "url(#img-setting-todo_svg__c)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F9F9F9",
            fillRule: "evenodd",
            d: "M185 59.625a1.875 1.875 0 1 0 0-3.749 1.875 1.875 0 0 0 0 3.75Zm0 1.25a3.75 3.75 0 0 0-3.75 3.75v.695c0 .307.249.555.556.555h6.388a.556.556 0 0 0 .556-.555v-.695a3.75 3.75 0 0 0-3.75-3.75Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { width: 12, height: 4, x: 193, y: 57, fill: "#EAEAEA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 64, height: 100, x: 26, y: 8, fill: "#D6E9FB", rx: 8 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-setting-todo_svg__d)",
            d: "M26 26h64v98a8 8 0 0 1-8 8H34a8 8 0 0 1-8-8V26Z"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-todo_svg__e)", children: /* @__PURE__ */ jsx(
          "rect",
          {
            width: 84,
            height: 96,
            x: 16,
            y: 22,
            fill: "url(#img-setting-todo_svg__f)",
            rx: 8
          }
        ) }),
        /* @__PURE__ */ jsx("circle", { cx: 88, cy: 34, r: 4, fill: "#E3E8EB" }),
        /* @__PURE__ */ jsx("rect", { width: 24, height: 4, x: 24, y: 32, fill: "#8092AA", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 30, height: 8, x: 24, y: 52, fill: "#E3E8EB", rx: 1 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 30,
            height: 8,
            x: 24,
            y: 70,
            fill: "#E3E8EB",
            opacity: 0.4,
            rx: 1
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 71, cy: 57, r: 7, fill: "#3299FE" }),
        /* @__PURE__ */ jsx("circle", { cx: 71, cy: 75, r: 7, fill: "#3299FE", opacity: 0.4 }),
        /* @__PURE__ */ jsx("circle", { cx: 87, cy: 57, r: 7, fill: "#DDD" }),
        /* @__PURE__ */ jsx("circle", { cx: 87, cy: 75, r: 7, fill: "#DDD", opacity: 0.4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "m68.133 54.344 2.062 3.64V60h1.172v-2.016l2.063-3.64h-1.32l-1.297 2.437h-.055l-1.305-2.437h-1.32ZM89.195 54.344h-1.164v3.593h-.054l-2.47-3.593h-1.03V60h1.171v-3.594h.047L88.18 60h1.015v-5.656Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 69, height: 20, x: 25, y: 94, fill: "#3299FE", rx: 10 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M65.492 100.293c.444.405.462 1.079.04 1.506l-6.327 6.39a1.133 1.133 0 0 1-.812.331 1.131 1.131 0 0 1-.807-.341l-3.29-3.408a1.035 1.035 0 0 1 .06-1.505c.45-.4 1.151-.374 1.568.057l2.486 2.576 5.513-5.568a1.143 1.143 0 0 1 1.569-.038Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("g", { filter: "url(#img-setting-todo_svg__g)", children: /* @__PURE__ */ jsx("rect", { width: 96, height: 48, x: 112, y: 80, fill: "#D6E9FB", rx: 8 }) }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 76,
            height: 6,
            x: 122,
            y: 114,
            fill: "#3299FE",
            opacity: 0.3,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 60,
            height: 6,
            x: 122,
            y: 114,
            fill: "#3299FE",
            opacity: 0.6,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsxs("g", { fill: "#3299FE", opacity: 0.6, children: [
          /* @__PURE__ */ jsx("circle", { cx: 139.201, cy: 94, r: 2.4, opacity: 0.65 }),
          /* @__PURE__ */ jsx("circle", { cx: 132, cy: 94, r: 2.4, opacity: 0.85 }),
          /* @__PURE__ */ jsx("circle", { cx: 124.8, cy: 94, r: 2.4 })
        ] }),
        /* @__PURE__ */ jsx("g", { fill: "#3299FE", opacity: 0.7, children: /* @__PURE__ */ jsx("path", { d: "M167.188 104.156c2.578 0 4.437-1.359 4.437-3.203 0-1.422-1.109-2.578-2.484-2.797v-.078a2.548 2.548 0 0 0 2.062-2.5c-.008-1.758-1.703-3.047-4.015-3.047-2.313 0-4.008 1.29-4 3.047-.008 1.242.835 2.266 2.062 2.5v.078c-1.406.219-2.5 1.375-2.5 2.797 0 1.844 1.852 3.203 4.438 3.203Zm-1.985-3.437c-.008-.985.836-1.696 1.985-1.703 1.148.007 1.992.726 1.984 1.703.008.969-.789 1.648-1.984 1.64-1.196.008-1.993-.671-1.985-1.64Zm.281-4.906c-.007-.883.688-1.5 1.704-1.5 1.007 0 1.71.617 1.718 1.5-.008.906-.726 1.539-1.718 1.546-1-.007-1.711-.64-1.704-1.546ZM177.484 104.156c2.578 0 4.438-1.359 4.438-3.203 0-1.422-1.11-2.578-2.484-2.797v-.078a2.548 2.548 0 0 0 2.062-2.5c-.008-1.758-1.703-3.047-4.016-3.047-2.312 0-4.007 1.29-4 3.047-.007 1.242.836 2.266 2.063 2.5v.078c-1.406.219-2.5 1.375-2.5 2.797 0 1.844 1.851 3.203 4.437 3.203Zm-1.984-3.437c-.008-.985.836-1.696 1.984-1.703 1.149.007 1.993.726 1.985 1.703.008.969-.789 1.648-1.985 1.64-1.195.008-1.992-.671-1.984-1.64Zm.281-4.906c-.008-.883.688-1.5 1.703-1.5 1.008 0 1.711.617 1.719 1.5-.008.906-.726 1.539-1.719 1.546-1-.007-1.711-.64-1.703-1.546ZM186.5 98.344c1.672 0 2.602-1.219 2.609-3.016-.007-1.789-.914-3.031-2.609-3.031-1.648 0-2.609 1.242-2.609 3.031 0 1.781.914 3.016 2.609 3.016Zm-1.016-3.016c.008-.96.352-1.633 1.016-1.64.703 0 1.008.664 1.016 1.64-.008.977-.344 1.617-1.016 1.625-.656-.008-1.008-.648-1.016-1.625Zm.032 8.672h1.75l7.781-11.313h-1.75L185.516 104Zm6.015-2.641c0 1.782.914 3.016 2.594 3.016 1.687 0 2.617-1.219 2.625-3.016-.008-1.789-.914-3.023-2.625-3.03-1.633.007-2.594 1.241-2.594 3.03Zm1.594 0c.008-.961.344-1.632 1-1.625.711-.015 1.023.649 1.031 1.625-.008.977-.344 1.625-1.031 1.625-.641 0-.992-.648-1-1.625Z" }) }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-todo_svg__a",
              width: 72,
              height: 72,
              x: 104,
              y: 12,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5225",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-todo_svg__b",
              width: 64,
              height: 34,
              x: 168,
              y: 50,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5225",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-todo_svg__e",
              width: 100,
              height: 112,
              x: 8,
              y: 22,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5225",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-setting-todo_svg__g",
              width: 112,
              height: 64,
              x: 104,
              y: 80,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feMorphology",
                  {
                    in: "SourceAlpha",
                    radius: 8,
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 8 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 8 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_286_5225"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_286_5225",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-todo_svg__d",
              x1: 58,
              x2: 133.098,
              y1: 82.5,
              y2: 179.556,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-setting-todo_svg__f",
              x1: 16,
              x2: 100,
              y1: 22,
              y2: 118,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#fff" }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9F9F9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgSettingTodo_default = createIcon(SvgImgSettingTodo);
function SvgImgUpgradeBasic(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 48 48",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 48, height: 48, fill: "#FFF7DD", opacity: 0.6, rx: 16 }),
        /* @__PURE__ */ jsx("path", { fill: "#F9DA7C", d: "M13 28.4h11v13l-11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#F4BE41", d: "M35 28.4H24v13l11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#F5CA54", d: "M13.2 25.2 24 23.8v4.6l-10.8-3.2Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#F8D97C", d: "M34.8 25.2 24 23.8v4.6l10.8-3.2Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-upgrade-basic_svg__a)",
            d: "M13 7.6h22l-5.6 20.8H18.6L13 7.6Z",
            opacity: 0.6
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFDA75",
            d: "M21.024 10.72a.2.2 0 0 1 .351 0l.928 1.697a.199.199 0 0 0 .08.08l1.696.927a.2.2 0 0 1 0 .351l-1.696.928a.199.199 0 0 0-.08.08l-.928 1.696a.2.2 0 0 1-.35 0l-.928-1.696a.199.199 0 0 0-.08-.08l-1.696-.928a.2.2 0 0 1 0-.35l1.696-.928a.199.199 0 0 0 .08-.08l.927-1.696ZM26.824 17.12a.2.2 0 0 1 .351 0l.645 1.18a.2.2 0 0 0 .08.08l1.179.645a.2.2 0 0 1 0 .35l-1.18.645a.2.2 0 0 0-.079.08l-.645 1.18a.2.2 0 0 1-.35 0l-.646-1.18a.2.2 0 0 0-.08-.08l-1.179-.645a.2.2 0 0 1 0-.35l1.18-.645a.2.2 0 0 0 .08-.08l.644-1.18Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#FCEDBF", d: "M13.2 25.2 24 28.4l-3.2 4-10.4-3.6 2.8-3.6Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#FBE49E", d: "M34.8 25.2 24 28.4l3.2 4 10.4-3.6-2.8-3.6Z" }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-upgrade-basic_svg__a",
            x1: 24,
            x2: 24,
            y1: 7.6,
            y2: 28.4,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F9D66E", stopOpacity: 0 }),
              /* @__PURE__ */ jsx("stop", { offset: 0.989, stopColor: "#F8D56E" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgUpgradeBasic_default = createIcon(SvgImgUpgradeBasic);
function SvgImgUpgradeEnterprise(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 48 48",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 48, height: 48, fill: "#D8F2EB", opacity: 0.6, rx: 16 }),
        /* @__PURE__ */ jsx("path", { fill: "#8DE8D1", d: "M13 28.4h11v13l-11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#4DC9AA", d: "M35 28.4H24v13l11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#48CEAD", d: "M13.2 25.2 24 23.8v4.6l-10.8-3.2Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#8CEDD5", d: "M34.8 25.2 24 23.8v4.6l10.8-3.2Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-upgrade-enterprise_svg__a)",
            d: "M13 7.6h22l-5.6 20.8H18.6L13 7.6Z",
            opacity: 0.6
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#77D5BB",
            d: "M21.024 10.72a.2.2 0 0 1 .351 0l.928 1.697a.199.199 0 0 0 .08.08l1.696.927a.2.2 0 0 1 0 .351l-1.696.928a.199.199 0 0 0-.08.08l-.928 1.696a.2.2 0 0 1-.35 0l-.928-1.696a.199.199 0 0 0-.08-.08l-1.696-.928a.2.2 0 0 1 0-.35l1.696-.928a.199.199 0 0 0 .08-.08l.927-1.696ZM26.824 17.12a.2.2 0 0 1 .351 0l.645 1.18a.2.2 0 0 0 .08.08l1.179.645a.2.2 0 0 1 0 .35l-1.18.645a.2.2 0 0 0-.079.08l-.645 1.18a.2.2 0 0 1-.35 0l-.646-1.18a.2.2 0 0 0-.08-.08l-1.179-.645a.2.2 0 0 1 0-.35l1.18-.645a.2.2 0 0 0 .08-.08l.644-1.18Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#C8FEF0", d: "M13.2 25.2 24 28.4l-3.2 4-10.4-3.6 2.8-3.6Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#A1F9E3", d: "M34.8 25.2 24 28.4l3.2 4 10.4-3.6-2.8-3.6Z" }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-upgrade-enterprise_svg__a",
            x1: 24,
            x2: 24,
            y1: 7.6,
            y2: 28.4,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#64DFC0", stopOpacity: 0 }),
              /* @__PURE__ */ jsx("stop", { offset: 0.989, stopColor: "#64DFC0" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgUpgradeEnterprise_default = createIcon(SvgImgUpgradeEnterprise);
function SvgImgUpgradePro(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 48 48",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 48, height: 48, fill: "#EFF1FF", opacity: 0.6, rx: 16 }),
        /* @__PURE__ */ jsx("path", { fill: "#7F8DFC", d: "M13 28.4h11v13l-11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#6979F8", d: "M35 28.4H24v13l11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#5669FA", d: "M13.2 25.2 24 23.8v4.6l-10.8-3.2Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#7E8CFC", d: "M34.8 25.2 24 23.8v4.6l10.8-3.2Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-upgrade-pro_svg__a)",
            d: "M13 7.6h22l-5.6 20.8H18.6L13 7.6Z",
            opacity: 0.6
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#7584FF",
            d: "M21.024 10.72a.2.2 0 0 1 .351 0l.928 1.697a.199.199 0 0 0 .08.08l1.696.927a.2.2 0 0 1 0 .351l-1.696.928a.199.199 0 0 0-.08.08l-.928 1.696a.2.2 0 0 1-.35 0l-.928-1.696a.199.199 0 0 0-.08-.08l-1.696-.928a.2.2 0 0 1 0-.35l1.696-.928a.199.199 0 0 0 .08-.08l.927-1.696ZM26.824 17.12a.2.2 0 0 1 .351 0l.645 1.18a.2.2 0 0 0 .08.08l1.179.645a.2.2 0 0 1 0 .35l-1.18.645a.2.2 0 0 0-.079.08l-.645 1.18a.2.2 0 0 1-.35 0l-.646-1.18a.2.2 0 0 0-.08-.08l-1.179-.645a.2.2 0 0 1 0-.35l1.18-.645a.2.2 0 0 0 .08-.08l.644-1.18Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#C2C9FF", d: "M13.2 25.2 24 28.4l-3.2 4-10.4-3.6 2.8-3.6Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#A0ABFF", d: "M34.8 25.2 24 28.4l3.2 4 10.4-3.6-2.8-3.6Z" }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-upgrade-pro_svg__a",
            x1: 24,
            x2: 24,
            y1: 7.6,
            y2: 28.4,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#707FFD", stopOpacity: 0 }),
              /* @__PURE__ */ jsx("stop", { offset: 0.989, stopColor: "#707FFD" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgUpgradePro_default = createIcon(SvgImgUpgradePro);
function SvgImgUpgradeStandard(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 48 48",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 48, height: 48, fill: "#EAF5FF", opacity: 0.6, rx: 16 }),
        /* @__PURE__ */ jsx("path", { fill: "#7FBFFE", d: "M13 28.4h11v13l-11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#3299FE", d: "M35 28.4H24v13l11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#55A8FA", d: "M13.2 25.2 24 23.8v4.6l-10.8-3.2Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#7EBDFC", d: "M34.8 25.2 24 23.8v4.6l10.8-3.2Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-upgrade-standard_svg__a)",
            d: "M13 7.6h22l-5.6 20.8H18.6L13 7.6Z",
            opacity: 0.6
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#3299FE",
            d: "M21.024 10.72a.2.2 0 0 1 .351 0l.928 1.697a.199.199 0 0 0 .08.08l1.696.927a.2.2 0 0 1 0 .351l-1.696.928a.199.199 0 0 0-.08.08l-.928 1.696a.2.2 0 0 1-.35 0l-.928-1.696a.199.199 0 0 0-.08-.08l-1.696-.928a.2.2 0 0 1 0-.35l1.696-.928a.199.199 0 0 0 .08-.08l.927-1.696ZM26.824 17.12a.2.2 0 0 1 .351 0l.645 1.18a.2.2 0 0 0 .08.08l1.179.645a.2.2 0 0 1 0 .35l-1.18.645a.2.2 0 0 0-.079.08l-.645 1.18a.2.2 0 0 1-.35 0l-.646-1.18a.2.2 0 0 0-.08-.08l-1.179-.645a.2.2 0 0 1 0-.35l1.18-.645a.2.2 0 0 0 .08-.08l.644-1.18Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#C2E1FF", d: "M13.2 25.2 24 28.4l-3.2 4-10.4-3.6 2.8-3.6Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#9FCEFC", d: "M34.8 25.2 24 28.4l3.2 4 10.4-3.6-2.8-3.6Z" }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-upgrade-standard_svg__a",
            x1: 24,
            x2: 24,
            y1: 7.6,
            y2: 28.4,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#6FB5FB", stopOpacity: 0 }),
              /* @__PURE__ */ jsx("stop", { offset: 0.989, stopColor: "#6FB5FB" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgUpgradeStandard_default = createIcon(SvgImgUpgradeStandard);

export { IcAbnormalA_default as AbnormalAIcon, IcAbnormalD_default as AbnormalDIcon, IcAbnormalEarlyleave_default as AbnormalEarlyleaveIcon, IcAbnormalLate_default as AbnormalLateIcon, IcAbnormalM_default as AbnormalMIcon, IcAbnormalN_default as AbnormalNIcon, IcAbnormalW_default as AbnormalWIcon, IcAdd_default as AddIcon, IcAddXsmall_default as AddXsmallIcon, IcAdminLarge_default as AdminLargeIcon, IcAiChatBot_default as AiChatBotIcon, IcAlbumXlarge_default as AlbumXlargeIcon, IcAlert_default as AlertIcon, IcAlertLine_default as AlertLineIcon, IcAlertPopupXlarge_default as AlertPopupXlargeIcon, IcAnnualMedium_default as AnnualMediumIcon, IcApprovalMedium_default as ApprovalMediumIcon, IcArticleMedium_default as ArticleMediumIcon, IcAsc_default as AscIcon, IcAttachment_default as AttachmentIcon, IcAttendanceMedium_default as AttendanceMediumIcon, IcBackMedium_default as BackMediumIcon, IcBadgeAdminLarge_default as BadgeAdminLargeIcon, IcBadgeLeaderAppovalLarge_default as BadgeLeaderAppovalLargeIcon, IcBadgeLeaderLarge_default as BadgeLeaderLargeIcon, IcBellMedium_default as BellMediumIcon, IcBmMedium_default as BmMediumIcon, IcBoardMedium_default as BoardMediumIcon, IcBoardProfile_default as BoardProfileIcon, IcBoardProfileXlarge_default as BoardProfileXlargeIcon, IcBookmarkFilledMedium_default as BookmarkFilledMediumIcon, IcBookmarkMedium_default as BookmarkMediumIcon, IcByEmployeeMedium_default as ByEmployeeMediumIcon, IcByPlaceOfWorkMedium_default as ByPlaceOfWorkMediumIcon, IcCamera_default as CameraIcon, IcCategory_default as CategoryIcon, IcChannel_default as ChannelIcon, IcChanneltalkMedium_default as ChanneltalkMediumIcon, IcChatActivityMedium_default as ChatActivityMediumIcon, IcChatLarge_default as ChatLargeIcon, IcChattingMedium_default as ChattingMediumIcon, IcChattingSolidMedium_default as ChattingSolidMediumIcon, IcCheck_default as CheckIcon, IcCheckXlarge_default as CheckXlargeIcon, IcCheckXsmall_default as CheckXsmallIcon, IcCheckbox_default as CheckboxIcon, IcClose_default as CloseIcon, IcCloseMedium_default as CloseMediumIcon, IcCloseSmall_default as CloseSmallIcon, IcClosingMedium_default as ClosingMediumIcon, IcCloudMedium_default as CloudMediumIcon, IcComment_default as CommentIcon, IcConfirmPopupXlarge_default as ConfirmPopupXlargeIcon, IcCopy_default as CopyIcon, IcCustomText_default as CustomTextIcon, IcDeadline_default as DeadlineIcon, IcDelete_default as DeleteIcon, IcDeleteLine_default as DeleteLineIcon, IcDesc_default as DescIcon, IcDisplayMedium_default as DisplayMediumIcon, IcDocMedium_default as DocMediumIcon, IcDownArrow_default as DownArrowIcon, IcDownArrowSolidXsmall_default as DownArrowSolidXsmallIcon, IcDownArrowXsmall_default as DownArrowXsmallIcon, IcDownload_default as DownloadIcon, IcDownloadMedium_default as DownloadMediumIcon, IcDraftsave_default as DraftsaveIcon, IcDrag_default as DragIcon, IcDrawer_default as DrawerIcon, IcEdit_default as EditIcon, IcEditLarge_default as EditLargeIcon, IcEditLine_default as EditLineIcon, IcEditSolid_default as EditSolidIcon, IcEditXsmall_default as EditXsmallIcon, IcEmailXlarge_default as EmailXlargeIcon, IcEmojiMedium_default as EmojiMediumIcon, IcEmojiPlusMedium_default as EmojiPlusMediumIcon, IcEndPage_default as EndPageIcon, IcExclamationXlarge_default as ExclamationXlargeIcon, IcExitFullScreenMedium_default as ExitFullScreenMediumIcon, IcExpected_default as ExpectedIcon, IcExpenseMedium_default as ExpenseMediumIcon, IcFeedView_default as FeedViewIcon, IcFilter_default as FilterIcon, IcFilterdeleteXsmall_default as FilterdeleteXsmallIcon, IcFirstPage_default as FirstPageIcon, IcFullScreenMedium_default as FullScreenMediumIcon, IcFullscreen_default as FullscreenIcon, IcGps_default as GpsIcon, IcGrade1_default as Grade1Icon, IcGrade2_default as Grade2Icon, IcGrade31_default as Grade31Icon, IcGrade32_default as Grade32Icon, IcGrade3_default as Grade3Icon, IcGrade41_default as Grade41Icon, IcGrade42_default as Grade42Icon, IcGrade4_default as Grade4Icon, IcGrade51_default as Grade51Icon, IcGrade52_default as Grade52Icon, IcGrade5_default as Grade5Icon, IcGradeBadge_default as GradeBadgeIcon, IcGradientAttendance_default as GradientAttendanceIcon, IcGradientBoard_default as GradientBoardIcon, IcGradientDisplay_default as GradientDisplayIcon, IcGradientDoc_default as GradientDocIcon, IcGradientGps_default as GradientGpsIcon, IcGradientInventory_default as GradientInventoryIcon, IcGradientJp_default as GradientJpIcon, IcGradientMobile_default as GradientMobileIcon, IcGradientNotice_default as GradientNoticeIcon, IcGradientOvertime_default as GradientOvertimeIcon, IcGradientPrice_default as GradientPriceIcon, IcGradientReport_default as GradientReportIcon, IcGradientSales_default as GradientSalesIcon, IcGradientSchedule_default as GradientScheduleIcon, IcGradientStaff_default as GradientStaffIcon, IcGradientTarget_default as GradientTargetIcon, IcGradientTodo_default as GradientTodoIcon, IcGradientWifi_default as GradientWifiIcon, IcGradientWorkplace_default as GradientWorkplaceIcon, IcGraph_default as GraphIcon, IcGroupMedium_default as GroupMediumIcon, IcGroupSolidMedium_default as GroupSolidMediumIcon, IcHelpCenterMedium_default as HelpCenterMediumIcon, IcHelp_default as HelpIcon, IcHelpLine_default as HelpLineIcon, IcHelpMedium_default as HelpMediumIcon, IcHideMedium_default as HideMediumIcon, IcHistory_default as HistoryIcon, IcHomeMedium_default as HomeMediumIcon, IcImport_default as ImportIcon, IcInactiveBell_default as InactiveBellIcon, IcInfo1_default as Info1Icon, IcInfoAlbum_default as InfoAlbumIcon, IcInfoApp_default as InfoAppIcon, IcInfoBreaktime_default as InfoBreaktimeIcon, IcInfoCity_default as InfoCityIcon, IcInfoDate_default as InfoDateIcon, IcInfoDaysoff_default as InfoDaysoffIcon, IcInfoDistributor_default as InfoDistributorIcon, IcInfoDocs_default as InfoDocsIcon, IcInfoEmail_default as InfoEmailIcon, IcInfoEmployee_default as InfoEmployeeIcon, IcInfoEmployeeno_default as InfoEmployeenoIcon, IcInfoGrade_default as InfoGradeIcon, IcInfoGroup_default as InfoGroupIcon, IcInfo_default as InfoIcon, IcInfoLeader_default as InfoLeaderIcon, IcInfoLogin_default as InfoLoginIcon, IcInfoPhoneCheck_default as InfoPhoneCheckIcon, IcInfoPhone_default as InfoPhoneIcon, IcInfoPhoneNoCheck_default as InfoPhoneNoCheckIcon, IcInfoPosition_default as InfoPositionIcon, IcInfoProperties_default as InfoPropertiesIcon, IcInfoPunch_default as InfoPunchIcon, IcInfoRadius_default as InfoRadiusIcon, IcInfoRegion_default as InfoRegionIcon, IcInfoStarBadge_default as InfoStarBadgeIcon, IcInfoState_default as InfoStateIcon, IcInfoVisit_default as InfoVisitIcon, IcInfoWorking_default as InfoWorkingIcon, IcInfoWorkplace_default as InfoWorkplaceIcon, IcInventoryMedium_default as InventoryMediumIcon, IcInvitation_default as InvitationIcon, IcInviteBefore_default as InviteBeforeIcon, IcInviteCompleted_default as InviteCompletedIcon, IcIssue_default as IssueIcon, IcJpMedium_default as JpMediumIcon, IcLanguageMedium_default as LanguageMediumIcon, IcLeaderAppovalLarge_default as LeaderAppovalLargeIcon, IcLeaderLarge_default as LeaderLargeIcon, IcLeave_default as LeaveIcon, IcLeaveMedium_default as LeaveMediumIcon, IcLeftArrow_default as LeftArrowIcon, IcLeftArrowXsmall_default as LeftArrowXsmallIcon, IcLink_default as LinkIcon, IcListEdit_default as ListEditIcon, IcListMove_default as ListMoveIcon, IcListview_default as ListviewIcon, IcLocation_default as LocationIcon, IcMap_default as MapIcon, IcMemberMedium_default as MemberMediumIcon, IcMemberSmall_default as MemberSmallIcon, IcMemo_default as MemoIcon, IcMention_default as MentionIcon, IcMinus_default as MinusIcon, IcMinusMedium_default as MinusMediumIcon, IcMore_default as MoreIcon, IcMother_default as MotherIcon, IcMove_default as MoveIcon, IcMoveSolid_default as MoveSolidIcon, IcMovie01_default as Movie01Icon, IcNoGrade_default as NoGradeIcon, IcNormal_default as NormalIcon, IcNotice_default as NoticeIcon, IcNoticeMedium_default as NoticeMediumIcon, IcNoticeSolidMedium_default as NoticeSolidMediumIcon, IcOvertimeMedium_default as OvertimeMediumIcon, IcPasswordErrorXlarge_default as PasswordErrorXlargeIcon, IcPaste_default as PasteIcon, IcPaymentMedium_default as PaymentMediumIcon, IcPhoto_default as PhotoIcon, IcPin_default as PinIcon, IcPinXlarge_default as PinXlargeIcon, IcPlayXlarge_default as PlayXlargeIcon, IcPlusMedium_default as PlusMediumIcon, IcPopup_default as PopupIcon, IcPreview_default as PreviewIcon, IcPriceMedium_default as PriceMediumIcon, IcProceeding_default as ProceedingIcon, IcPush_default as PushIcon, IcQrcode_default as QrcodeIcon, IcRatioMedium_default as RatioMediumIcon, IcReceiverMedium_default as ReceiverMediumIcon, IcRefresh_default as RefreshIcon, IcRepeat_default as RepeatIcon, IcReply_default as ReplyIcon, IcReportMedium_default as ReportMediumIcon, IcRequired_default as RequiredIcon, IcResendPush_default as ResendPushIcon, IcResendPushMedium_default as ResendPushMediumIcon, IcReturn_default as ReturnIcon, IcRightArrow_default as RightArrowIcon, IcRightArrowXsmall_default as RightArrowXsmallIcon, IcSalesMedium_default as SalesMediumIcon, IcScheduleMedium_default as ScheduleMediumIcon, IcSearch_default as SearchIcon, IcSend_default as SendIcon, ImgSettingAttendance_default as SettingAttendanceIllustration, ImgSettingBoard_default as SettingBoardIllustration, ImgSettingChat_default as SettingChatIllustration, ImgSettingDisplay_default as SettingDisplayIllustration, ImgSettingExpenses_default as SettingExpensesIllustration, IcSetting_default as SettingIcon, ImgSettingInventory_default as SettingInventoryIllustration, ImgSettingJp_default as SettingJpIllustration, IcSettingMedium_default as SettingMediumIcon, ImgSettingNs_default as SettingNsIllustration, ImgSettingPrice_default as SettingPriceIllustration, ImgSettingReport_default as SettingReportIllustration, ImgSettingSales_default as SettingSalesIllustration, ImgSettingSchedule_default as SettingScheduleIllustration, ImgSettingTarget_default as SettingTargetIllustration, ImgSettingTodo_default as SettingTodoIllustration, IcShortcutXsmall_default as ShortcutXsmallIcon, IcShowMedium_default as ShowMediumIcon, IcSign_default as SignIcon, IcSignature_default as SignatureIcon, IcSolved_default as SolvedIcon, IcSortingAtoz_default as SortingAtozIcon, IcSortingEarly_default as SortingEarlyIcon, IcSortingLate_default as SortingLateIcon, IcSortingZtoa_default as SortingZtoaIcon, IcStamp_default as StampIcon, IcStar_default as StarIcon, IcSubtract_default as SubtractIcon, IcSummeryView_default as SummeryViewIcon, IcSympathyMedium_default as SympathyMediumIcon, IcTack_default as TackIcon, IcTag_default as TagIcon, IcTargetMedium_default as TargetMediumIcon, IcText_default as TextIcon, IcTodoMedium_default as TodoMediumIcon, IcToggleMedium_default as ToggleMediumIcon, IcTrash_default as TrashIcon, IcUpArrow_default as UpArrowIcon, IcUpArrowSolidXsmall_default as UpArrowSolidXsmallIcon, IcUpArrowXsmall_default as UpArrowXsmallIcon, ImgUpgradeBasic_default as UpgradeBasicIllustration, ImgUpgradeEnterprise_default as UpgradeEnterpriseIllustration, ImgUpgradePro_default as UpgradeProIllustration, ImgUpgradeStandard_default as UpgradeStandardIllustration, IcVideo_default as VideoIcon, IcViewOff_default as ViewOffIcon, IcViewOn_default as ViewOnIcon, IcWaitingMedium_default as WaitingMediumIcon, IcWhatsappLarge_default as WhatsappLargeIcon, IcWifi_default as WifiIcon, IcWindowed_default as WindowedIcon, IcWorkStatus_default as WorkStatusIcon, IcWorkplaceMedium_default as WorkplaceMediumIcon, IcZoomInMedium_default as ZoomInMediumIcon, IcZoomOutMedium_default as ZoomOutMediumIcon, createIcon, isShoplIcon };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map